/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: unknown; output: unknown; }
  /**
   * Date represents a date in YYYY-MM-DD format (e.g., "2020-12-31").
   * This is used for date-only values without time information.
   */
  Date: { input: string; output: string; }
  /**
   * DateTime represents a date-time in RFC3339 format (e.g., "2006-01-02T15:04:05Z07:00").
   * This includes both date and time information with timezone.
   */
  DateTime: { input: string; output: string; }
  /**
   * DateTimeMillis represents a date-time in RFC3339 format with millisecond precision (e.g., "2006-01-02T15:04:05.999Z07:00").
   * This includes both date and time information with timezone and millisecond precision.
   */
  DateTimeMillis: { input: string; output: string; }
  /**
   * DateTimeNanos represents a date-time in RFC3339Nano format (e.g., "2006-01-02T15:04:05.999999999Z07:00").
   * This includes both date and time information with timezone and nanosecond precision.
   */
  DateTimeNanos: { input: string; output: string; }
  /** Google Protobuf Duration - represents a time duration */
  GoogleProtobuf_Duration: { input: string; output: string; }
  GoogleProtobuf_DurationInput: { input: string; output: string; }
  /** Google Protobuf Empty - represents an empty message */
  GoogleProtobuf_Empty: { input: Record<string, never>; output: Record<string, never>; }
  GoogleProtobuf_EmptyInput: { input: Record<string, never>; output: Record<string, never>; }
  /** Google Protobuf Struct - represents a structured data value */
  GoogleProtobuf_Struct: { input: Record<string, unknown>; output: Record<string, unknown>; }
  GoogleProtobuf_StructInput: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /** Google Protobuf Timestamp - represents a point in time */
  GoogleProtobuf_Timestamp: { input: string; output: string; }
  GoogleProtobuf_TimestampInput: { input: string; output: string; }
  Int64: { input: string; output: string; }
  /**
   * Map represents an arbitrary map with any key and value types.
   * This is used for proto map types.
   */
  Map: { input: any; output: any; }
  /**
   * TimestampProto represents a Protocol Buffer timestamp with full nanosecond precision.
   * Serializes to/from RFC3339Nano format (e.g., "2006-01-02T15:04:05.123456789Z").
   * Use this for proto Timestamp (timestamppb.Timestamp) to preserve precision during conversion.
   */
  TimestampProto: { input: string; output: string; }
};

export type AccountRemuneration = {
  __typename?: 'AccountRemuneration';
  id: Scalars['ID']['output'];
  remuneratedMonthStartDate: Scalars['String']['output'];
};

export enum ActivityTag {
  Atm = 'ATM',
  DirectDebitHold = 'DIRECT_DEBIT_HOLD',
  Fallback = 'FALLBACK',
  Fees = 'FEES',
  Finance = 'FINANCE',
  FoodAndGrocery = 'FOOD_AND_GROCERY',
  GasStation = 'GAS_STATION',
  HardwareAndEquipment = 'HARDWARE_AND_EQUIPMENT',
  HotelAndLodging = 'HOTEL_AND_LODGING',
  Insurance = 'INSURANCE',
  ItAndElectronics = 'IT_AND_ELECTRONICS',
  LegalAndAccounting = 'LEGAL_AND_ACCOUNTING',
  Logistics = 'LOGISTICS',
  Manufacturing = 'MANUFACTURING',
  Marketing = 'MARKETING',
  OfficeRental = 'OFFICE_RENTAL',
  OfficeSupply = 'OFFICE_SUPPLY',
  OnlineService = 'ONLINE_SERVICE',
  OtherExpense = 'OTHER_EXPENSE',
  OtherIncome = 'OTHER_INCOME',
  OtherService = 'OTHER_SERVICE',
  Pending = 'PENDING',
  Refund = 'REFUND',
  RestaurantAndBar = 'RESTAURANT_AND_BAR',
  Salary = 'SALARY',
  Sales = 'SALES',
  Subscription = 'SUBSCRIPTION',
  Tax = 'TAX',
  Transport = 'TRANSPORT',
  TreasuryAndInterco = 'TREASURY_AND_INTERCO',
  Utility = 'UTILITY',
  Voucher = 'VOUCHER'
}

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  firstLine?: Maybe<Scalars['String']['output']>;
  secondLine?: Maybe<Scalars['String']['output']>;
  thirdLine?: Maybe<Scalars['String']['output']>;
  type: CompanyAddressType;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Amount = {
  __typename?: 'Amount';
  currency: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AttachedFile = {
  __typename?: 'AttachedFile';
  contentType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Attachment = {
  __typename?: 'Attachment';
  attachmentType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  file?: Maybe<AttachedFile>;
  id: Scalars['ID']['output'];
  probativeAttachment?: Maybe<ProbativeAttachment>;
  slug: Scalars['String']['output'];
  thumbnail?: Maybe<Thumbnail>;
};

export enum AuthorizationType {
  Full = 'FULL',
  Remaining = 'REMAINING'
}

export type AvailableActions = {
  __typename?: 'AvailableActions';
  archive: Scalars['Boolean']['output'];
  delete: Scalars['Boolean']['output'];
  pay: Scalars['Boolean']['output'];
  reasons?: Maybe<AvailableActionsReasons>;
  unarchive: Scalars['Boolean']['output'];
};

export type AvailableActionsReasons = {
  __typename?: 'AvailableActionsReasons';
  archive?: Maybe<Array<Scalars['String']['output']>>;
  delete?: Maybe<Array<Scalars['String']['output']>>;
  pay?: Maybe<Array<Scalars['String']['output']>>;
  unarchive?: Maybe<Array<Scalars['String']['output']>>;
};

export type AvatarFile = {
  __typename?: 'AvatarFile';
  url: Scalars['String']['output'];
};

export type BankAccount = {
  __typename?: 'BankAccount';
  bankName?: Maybe<Scalars['String']['output']>;
  bic: Scalars['String']['output'];
  iban: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<Logo>;
  name: Scalars['String']['output'];
};

export type Beneficiary = {
  __typename?: 'Beneficiary';
  accountNumber?: Maybe<Scalars['String']['output']>;
  accountType: Scalars['String']['output'];
  activityTag: Scalars['String']['output'];
  address?: Maybe<BeneficiaryAddress>;
  avatar: File;
  avatarThumb: File;
  b2b: Scalars['Boolean']['output'];
  bankName?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  core: Scalars['Boolean']['output'];
  country?: Maybe<Scalars['String']['output']>;
  creditBankAccountId?: Maybe<Scalars['String']['output']>;
  creditorIdentifier?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  defaultAvatar: File;
  defaultAvatarThumb: File;
  email?: Maybe<Scalars['String']['output']>;
  fx: Scalars['Boolean']['output'];
  hidden: Scalars['Boolean']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  labelIds: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  qontoBankAccount: Scalars['Boolean']['output'];
  routingNumber?: Maybe<Scalars['String']['output']>;
  sct: Scalars['Boolean']['output'];
  sortCode?: Maybe<Scalars['String']['output']>;
  transferTransactionsCount?: Maybe<Scalars['Int']['output']>;
  trusted: Scalars['Boolean']['output'];
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export type BeneficiaryAddress = {
  __typename?: 'BeneficiaryAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  firstLine?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
};

export type BillingTransfer = {
  __typename?: 'BillingTransfer';
  amount: Amount;
  enrichmentData: BillingTransferEnrichmentData;
  id: Scalars['ID']['output'];
  movementId: Scalars['ID']['output'];
  operationSubtype: Scalars['String']['output'];
  operationType: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  totalAmount: Amount;
  vatAmount: Amount;
  vatRate: Scalars['Float']['output'];
};

export type BillingTransferEnrichmentData = {
  __typename?: 'BillingTransferEnrichmentData';
  isRecurring: Scalars['Boolean']['output'];
  logo?: Maybe<Logo>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  recurrence?: Maybe<Scalars['String']['output']>;
};

export type Card = {
  __typename?: 'Card';
  activeDays: Array<Scalars['Int']['output']>;
  appearance?: Maybe<CardAppearance>;
  atmDailyLimit: Scalars['Float']['output'];
  atmDailyLimitOption: Scalars['Boolean']['output'];
  atmDailySpent: Scalars['Float']['output'];
  atmMonthlyLimit: Scalars['Float']['output'];
  atmMonthlySpent: Scalars['Float']['output'];
  atmOption: Scalars['Boolean']['output'];
  bankAccountId: Scalars['String']['output'];
  cardDesign?: Maybe<Scalars['String']['output']>;
  cardLevel: CardLevel;
  cardType: CardType;
  categoryTags: Array<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  cvv: Scalars['String']['output'];
  ddcUpgrade: Scalars['Boolean']['output'];
  ddcUpgraded: Scalars['Boolean']['output'];
  deferredDebitCreditProductDetails?: Maybe<DdcProductDetails>;
  discardOn?: Maybe<Scalars['String']['output']>;
  eligibleForDDCUpgrade: EligibleForDdcUpgrade;
  eligibleForPhysicalOrder: Scalars['Boolean']['output'];
  eligibleForRenewal: Scalars['Boolean']['output'];
  eligibleForUpsell: Scalars['Boolean']['output'];
  embossedName?: Maybe<Scalars['String']['output']>;
  expDate?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['String']['output']>;
  expYear?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  expirationDateShort?: Maybe<Scalars['String']['output']>;
  foreignOption: Scalars['Boolean']['output'];
  forwardedAt?: Maybe<Scalars['String']['output']>;
  hadOperation: Scalars['Boolean']['output'];
  hadPinOperation: Scalars['Boolean']['output'];
  hasOnlyUserLiftableLocks: Scalars['Boolean']['output'];
  holder?: Maybe<LegacyMembership>;
  holderId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isQcp: Scalars['Boolean']['output'];
  last4: Scalars['String']['output'];
  lastActivityAt?: Maybe<Scalars['String']['output']>;
  lockReason?: Maybe<Scalars['String']['output']>;
  maskPan?: Maybe<Scalars['String']['output']>;
  nfcOption: Scalars['Boolean']['output'];
  nickname: Scalars['String']['output'];
  onlineOption: Scalars['Boolean']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  parentCardSummary?: Maybe<ParentCardSummary>;
  paymentDailyLimit: Scalars['Int']['output'];
  paymentDailyLimitOption: Scalars['Boolean']['output'];
  paymentDailySpent: Scalars['Float']['output'];
  paymentLifespanLimit?: Maybe<Scalars['Int']['output']>;
  paymentLifespanSpent: Scalars['Float']['output'];
  paymentMode: PaymentMode;
  paymentMonthlyLimit: Scalars['Int']['output'];
  paymentMonthlySpent: Scalars['Float']['output'];
  paymentTransactionLimit: Scalars['Int']['output'];
  paymentTransactionLimitOption: Scalars['Boolean']['output'];
  physical: Scalars['Boolean']['output'];
  pinSet: Scalars['Boolean']['output'];
  preExpiresAt?: Maybe<Scalars['String']['output']>;
  renewal: Scalars['Boolean']['output'];
  renewed: Scalars['Boolean']['output'];
  reordered: Scalars['Boolean']['output'];
  sequentialId?: Maybe<Scalars['Int']['output']>;
  shipToBusiness: Scalars['Boolean']['output'];
  shippedAt?: Maybe<Scalars['String']['output']>;
  status: CardStatus;
  statusReasons: Array<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  upsell: Scalars['Boolean']['output'];
  upsold: Scalars['Boolean']['output'];
};

export type CardAcquirerPayout = {
  __typename?: 'CardAcquirerPayout';
  amount: Amount;
  bookTransferMovementId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  status: Status;
};

export type CardAppearance = {
  __typename?: 'CardAppearance';
  assets: CardAppearanceAssets;
  gradientHexColor?: Maybe<Scalars['String']['output']>;
  theme: CardAppearanceTheme;
};

export type CardAppearanceAssets = {
  __typename?: 'CardAppearanceAssets';
  frontLarge: Scalars['String']['output'];
  frontSmall: Scalars['String']['output'];
  frontSmallWallet: Scalars['String']['output'];
};

export enum CardAppearanceTheme {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export enum CardLevel {
  Advertising = 'ADVERTISING',
  Flash = 'FLASH',
  Metal = 'METAL',
  Mirror = 'MIRROR',
  Plus = 'PLUS',
  Standard = 'STANDARD',
  Unknown = 'UNKNOWN',
  Virtual = 'VIRTUAL'
}

export enum CardStatus {
  Abusive = 'ABUSIVE',
  Deleted = 'DELETED',
  Discarded = 'DISCARDED',
  Expired = 'EXPIRED',
  Live = 'LIVE',
  Lost = 'LOST',
  Onhold = 'ONHOLD',
  Ordered = 'ORDERED',
  OrderCanceled = 'ORDER_CANCELED',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  PinBlocked = 'PIN_BLOCKED',
  PreExpired = 'PRE_EXPIRED',
  Received = 'RECEIVED',
  Shipped = 'SHIPPED',
  ShippedLost = 'SHIPPED_LOST',
  Stolen = 'STOLEN',
  Unknown = 'UNKNOWN'
}

export enum CardStatusFilter {
  Abusive = 'ABUSIVE',
  Discarded = 'DISCARDED',
  Expired = 'EXPIRED',
  Live = 'LIVE',
  Lost = 'LOST',
  Onhold = 'ONHOLD',
  OrderCanceled = 'ORDER_CANCELED',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  PinBlocked = 'PIN_BLOCKED',
  PreExpired = 'PRE_EXPIRED',
  ShippedLost = 'SHIPPED_LOST',
  Stolen = 'STOLEN'
}

export type CardTransaction = {
  __typename?: 'CardTransaction';
  computedStatus: Scalars['String']['output'];
  movementId: Scalars['ID']['output'];
  refusalReason?: Maybe<Scalars['String']['output']>;
  refusalReasonCategory?: Maybe<Scalars['String']['output']>;
  refusalReasonGroup?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type CardTransactionStatus = {
  __typename?: 'CardTransactionStatus';
  computedStatus: Scalars['String']['output'];
  movementId: Scalars['ID']['output'];
};

export enum CardType {
  Debit = 'DEBIT',
  Flex = 'FLEX',
  Prepaid = 'PREPAID',
  Unknown = 'UNKNOWN'
}

export type CardsSearch = {
  filters?: InputMaybe<CardsSearchFilters>;
  pagination?: InputMaybe<Pagination>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
};

export type CardsSearchFilters = {
  bankAccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  cardLevels?: InputMaybe<Array<CardLevel>>;
  holderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<CardStatusFilter>>;
};

export type CashFlowCategory = {
  __typename?: 'CashFlowCategory';
  colorKey: Scalars['String']['output'];
  iconKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nameKey?: Maybe<Scalars['String']['output']>;
  parentCategory?: Maybe<CashFlowParentCategory>;
  ruleId?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  vatRate?: Maybe<Scalars['String']['output']>;
};

export type CashFlowParentCategory = {
  __typename?: 'CashFlowParentCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Cashback = {
  __typename?: 'Cashback';
  amount: Amount;
  id: Scalars['ID']['output'];
  movementId: Scalars['ID']['output'];
  referenceMonthStartDate: Scalars['String']['output'];
};

export type CategoryAssignment = {
  __typename?: 'CategoryAssignment';
  id: Scalars['String']['output'];
  ruleId?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};

export type Check = {
  __typename?: 'Check';
  amount: Amount;
  canceledAt?: Maybe<Scalars['String']['output']>;
  cmc7: Cmc7;
  createdAt: Scalars['String']['output'];
  creditDelayDays: Scalars['String']['output'];
  creditExpectedAt?: Maybe<Scalars['String']['output']>;
  declinedAt?: Maybe<Scalars['String']['output']>;
  declinedReason?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  emittedDate?: Maybe<Scalars['String']['output']>;
  emitterName?: Maybe<Scalars['String']['output']>;
  enrichmentData?: Maybe<EnrichmentData>;
  id: Scalars['ID']['output'];
  initiatorId?: Maybe<Scalars['ID']['output']>;
  movementId: Scalars['ID']['output'];
  receivedAt?: Maybe<Scalars['String']['output']>;
  refundedAt?: Maybe<Scalars['String']['output']>;
  rlmc?: Maybe<Scalars['String']['output']>;
  shippingAddress: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  validatedAt?: Maybe<Scalars['String']['output']>;
};

export type Claim = {
  __typename?: 'Claim';
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Cmc7 = {
  __typename?: 'Cmc7';
  a: Scalars['String']['output'];
  b: Scalars['String']['output'];
  c: Scalars['String']['output'];
};

export type Company = {
  __typename?: 'Company';
  activityDescription?: Maybe<Scalars['String']['output']>;
  addresses?: Maybe<Array<Maybe<Address>>>;
  contactEmail: Scalars['String']['output'];
  financialDetail?: Maybe<FinancialDetail>;
  legalCode?: Maybe<Scalars['String']['output']>;
  legalCountry: Scalars['String']['output'];
  legalForm?: Maybe<Scalars['String']['output']>;
  legalName: Scalars['String']['output'];
  legalNumber?: Maybe<Scalars['String']['output']>;
  legalRegistrationDate?: Maybe<Scalars['String']['output']>;
  legalSector?: Maybe<Scalars['String']['output']>;
  legalTvaNumber?: Maybe<Scalars['String']['output']>;
  taxResidence?: Maybe<CompanyTaxResidence>;
  tradeName?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export enum CompanyAddressType {
  Headquarter = 'HEADQUARTER',
  Standard = 'STANDARD'
}

export type CompanyTaxResidence = {
  __typename?: 'CompanyTaxResidence';
  country?: Maybe<Scalars['String']['output']>;
  taxIdentificationNumber?: Maybe<Scalars['String']['output']>;
};

export type CostCenterAllocation = {
  __typename?: 'CostCenterAllocation';
  category?: Maybe<CostCenterCategory>;
  costCenterCode: Scalars['String']['output'];
  costCenterId: Scalars['String']['output'];
  costCenterIsActive: Scalars['Boolean']['output'];
  costCenterLabel: Scalars['String']['output'];
};

export type CostCenterCategory = {
  __typename?: 'CostCenterCategory';
  code: Scalars['String']['output'];
  colorToken: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type Counterparty = {
  __typename?: 'Counterparty';
  accountNumber: Scalars['String']['output'];
  bic: Scalars['String']['output'];
  iban: Scalars['String']['output'];
};

export type Customer = {
  __typename?: 'Customer';
  contractSignedAt?: Maybe<Scalars['DateTimeNanos']['output']>;
  natureOfOperations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DdcLimits = {
  __typename?: 'DDCLimits';
  total: Amount;
  used: Amount;
};

export type DdcProductDetails = {
  __typename?: 'DDCProductDetails';
  deferredDebitCreditAccountId: Scalars['String']['output'];
  dueAmount: Amount;
  financingId?: Maybe<Scalars['String']['output']>;
  limit: DdcLimits;
  nextPayment: Scalars['String']['output'];
  repaymentStatus?: Maybe<Scalars['String']['output']>;
};

export enum DdcStatus {
  Declined = 'DECLINED',
  NotPaid = 'NOT_PAID',
  Paid = 'PAID',
  Pending = 'PENDING',
  Scheduled = 'SCHEDULED',
  Unknown = 'UNKNOWN'
}

export enum DeclinedReason {
  AccountInactive = 'ACCOUNT_INACTIVE',
  CannotVerifyPin = 'CANNOT_VERIFY_PIN',
  CardholderToContactIssuer = 'CARDHOLDER_TO_CONTACT_ISSUER',
  CustomerCancellation = 'CUSTOMER_CANCELLATION',
  DirectDebitPostponed = 'DIRECT_DEBIT_POSTPONED',
  DoNotHonor = 'DO_NOT_HONOR',
  ExceedsWithdrawalAmountLimit = 'EXCEEDS_WITHDRAWAL_AMOUNT_LIMIT',
  ExceedsWithdrawalFrequencyLimit = 'EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT',
  ExpiredCard = 'EXPIRED_CARD',
  IncorrectPin = 'INCORRECT_PIN',
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  InvalidAmount = 'INVALID_AMOUNT',
  InvalidCardNumber = 'INVALID_CARD_NUMBER',
  InvalidMerchant = 'INVALID_MERCHANT',
  IssuerOrSwitchIsInoperative = 'ISSUER_OR_SWITCH_IS_INOPERATIVE',
  LostCard = 'LOST_CARD',
  MerchantNameAndCountryUnknown = 'MERCHANT_NAME_AND_COUNTRY_UNKNOWN',
  NotPermittedToCardholder = 'NOT_PERMITTED_TO_CARDHOLDER',
  NotPermittedToTerminal = 'NOT_PERMITTED_TO_TERMINAL',
  OpsCanceled = 'OPS_CANCELED',
  PinTriesExceeded = 'PIN_TRIES_EXCEEDED',
  ResponseReceivedTooLate = 'RESPONSE_RECEIVED_TOO_LATE',
  RestrictedCard = 'RESTRICTED_CARD',
  SecurityViolation = 'SECURITY_VIOLATION',
  StolenCard = 'STOLEN_CARD',
  SystemMalfunction = 'SYSTEM_MALFUNCTION',
  Timeout = 'TIMEOUT',
  UnableToRouteTransaction = 'UNABLE_TO_ROUTE_TRANSACTION',
  UserCanceled = 'USER_CANCELED'
}

/** This type represents the repayment status of an individual DDC transaction */
export type DeferredDebitCardRepayment = {
  __typename?: 'DeferredDebitCardRepayment';
  id: Scalars['String']['output'];
  movementId: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['String']['output']>;
  repaymentStatus: DdcStatus;
  scheduledAt?: Maybe<Scalars['String']['output']>;
};

/** This type represents the details of a DDC repayment, and is not associated with individual DDC transactions */
export type DeferredDebitCardRepaymentDetails = {
  __typename?: 'DeferredDebitCardRepaymentDetails';
  accumulatedFeesAmount: Amount;
  capitalAmount: Amount;
  id: Scalars['String']['output'];
  movementId: Scalars['String']['output'];
  periodEnd: Scalars['DateTimeNanos']['output'];
  periodStart: Scalars['DateTimeNanos']['output'];
  totalTransactionsCount: Scalars['Int']['output'];
};

export type DirectDebit = {
  __typename?: 'DirectDebit';
  amount: Scalars['Float']['output'];
  amountCents: Scalars['Int']['output'];
  amountCurrency: Scalars['String']['output'];
  amountV2: Amount;
  emitterBic?: Maybe<Scalars['String']['output']>;
  emitterIban?: Maybe<Scalars['String']['output']>;
  emitterName?: Maybe<Scalars['String']['output']>;
  enrichmentData?: Maybe<EnrichmentData>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  executionDate?: Maybe<Scalars['String']['output']>;
  governmentOrder?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  mandate?: Maybe<QontoTransfersSddMandatesFirstpartyV2_Mandate>;
  reference?: Maybe<Scalars['String']['output']>;
  refundRequestedAt?: Maybe<Scalars['String']['output']>;
  refundable: Scalars['Boolean']['output'];
  refundedAt?: Maybe<Scalars['String']['output']>;
  sepaMandateId?: Maybe<Scalars['ID']['output']>;
  sequentialId?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DirectDebitCollection = {
  __typename?: 'DirectDebitCollection';
  amount: Amount;
  collectionDate: Scalars['String']['output'];
  creditorSchemeId: Scalars['String']['output'];
  debitorBic?: Maybe<Scalars['String']['output']>;
  debitorIban: Scalars['String']['output'];
  debitorName: Scalars['String']['output'];
  executedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initiatorId: Scalars['ID']['output'];
  onHoldAmount?: Maybe<Amount>;
  onHoldRate?: Maybe<Scalars['String']['output']>;
  onHoldReleaseDate?: Maybe<Scalars['String']['output']>;
  rTransactionExecutedAt?: Maybe<Scalars['String']['output']>;
  rTransactionType?: Maybe<Scalars['String']['output']>;
  recurrenceType: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  statusReason?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  uniqueMandateReference: Scalars['String']['output'];
};

export type DirectDebitHold = {
  __typename?: 'DirectDebitHold';
  amount: Amount;
  debitorName: Scalars['String']['output'];
  executionDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  onHoldRate: Scalars['String']['output'];
  releaseDate: Scalars['String']['output'];
  releasedAt?: Maybe<Scalars['String']['output']>;
};

export type Discrepancy = {
  __typename?: 'Discrepancy';
  attachmentId: Scalars['String']['output'];
  fieldName: Scalars['String']['output'];
  pdfValue: Scalars['String']['output'];
  xmlValue: Scalars['String']['output'];
};

export type Dispute = {
  __typename?: 'Dispute';
  claim: Claim;
  transactionId: Scalars['ID']['output'];
};

export type EinvoicingCompanySearch = {
  _note?: InputMaybe<Scalars['String']['input']>;
};

export type EinvoicingLifecycleEvent = {
  __typename?: 'EinvoicingLifecycleEvent';
  createdAt: Scalars['String']['output'];
  invoiceId: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  reasonMessage?: Maybe<Scalars['String']['output']>;
  statusCode: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
};

export type EligibleForDdcUpgrade = {
  __typename?: 'EligibleForDDCUpgrade';
  replacementFlow: Scalars['Boolean']['output'];
  requiresAccountSwitch: Scalars['Boolean']['output'];
  upsellFlow: Scalars['Boolean']['output'];
};

export type EnrichmentData = {
  __typename?: 'EnrichmentData';
  logo?: Maybe<Logo>;
};

export type ExpenseItem = {
  __typename?: 'ExpenseItem';
  amount: Amount;
  arrival?: Maybe<MileageAddress>;
  attachment?: Maybe<Attachment>;
  /** Attachment ID of the expense item. `null` if attachment for mileage is pending. */
  attachmentId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  /** Date of the expense item or trip. Format: YYYY-MM-DD. Not available for legacy reimbursements. */
  date?: Maybe<Scalars['String']['output']>;
  /** Per-day allowance breakdown. Inline in API response — no separate fetch needed. */
  days?: Maybe<Array<PerDiemDay>>;
  departure?: Maybe<MileageAddress>;
  /** Trip distance in meters */
  distanceMeters?: Maybe<Scalars['Int']['output']>;
  /** Trip return location and datetime. */
  finalLocation?: Maybe<PerDiemLocation>;
  id: Scalars['String']['output'];
  /** Trip departure location and datetime. */
  initialLocation?: Maybe<PerDiemLocation>;
  /** Merchant name for receipt items. `null` for legacy reimbursements. */
  merchantName?: Maybe<Scalars['String']['output']>;
  mileageCalculation?: Maybe<MileageCalculation>;
  multiVat: Array<ExpenseItemMultiVat>;
  note: Scalars['String']['output'];
  /** Whether the trip was a round trip */
  roundTrip?: Maybe<Scalars['Boolean']['output']>;
  totalVatAmount: Amount;
  /** Type of the expense item (`receipt`, `mileage`, or `per_diem`) */
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  vatAmount?: Maybe<Amount>;
  vatRate?: Maybe<Scalars['Float']['output']>;
  /** Vehicle used for the trip */
  vehicle?: Maybe<Vehicle>;
};

export type ExpenseItemMultiVat = {
  __typename?: 'ExpenseItemMultiVat';
  amount?: Maybe<Amount>;
  amountExcludingVat?: Maybe<Amount>;
  rate?: Maybe<Scalars['Float']['output']>;
};

export type ExpenseReport = {
  __typename?: 'ExpenseReport';
  /** Total amount of the expense report */
  amount: Amount;
  createdAt: Scalars['String']['output'];
  /** Feedback from the approver if changes were requested */
  feedback?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the expense report */
  id: Scalars['ID']['output'];
  /** ID of the membership who created the expense report */
  initiatorID: Scalars['String']['output'];
  /** List of expense report items */
  items: Array<ExpenseItem>;
  /** True if any per diem item in this report has dates overlapping with another per diem item. */
  overlappingTrip?: Maybe<Scalars['Boolean']['output']>;
  /** Current status of the expense report (`draft`, `changes_requested`, `submitted`) */
  status: Scalars['String']['output'];
  /** Expense report title */
  title: Scalars['String']['output'];
  totalVatAmount: Amount;
  updatedAt: Scalars['String']['output'];
};

export type F24Payment = {
  __typename?: 'F24Payment';
  bankAccountId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  proxied: Scalars['Boolean']['output'];
};

export type Fee = {
  __typename?: 'Fee';
  /** Base amount of the fees (all fee items summed up) */
  amount: Amount;
  /** Comment Customer Support wrote on the fee. Currently not exposed by BE. */
  comment?: Maybe<Scalars['String']['output']>;
  /** Datetime in ISO 8601 */
  createdAt: Scalars['String']['output'];
  /** A superset of `feeType`; includes more specific domain fee types */
  eventType: Scalars['String']['output'];
  /** Translated, human readable variant of what this fee is */
  feeLabel: Scalars['String']['output'];
  /** Sums provided for a single fee's fee payments */
  feePaymentSums: FeePaymentSums;
  feeStatus: FeeStatus;
  feeType: FeeType;
  id: Scalars['ID']['output'];
  /** Base amount of the fee with discounts applied */
  totalAmount: Amount;
  /** Total amount of fee with discounts applied, including VAT */
  totalAmountVatIncluded: Amount;
  /** Datetime in ISO 8601 */
  updatedAt: Scalars['String']['output'];
  /** VAT amount of the fee, based on the totalAmount */
  vatAmount: Amount;
  /** The fees VAT, where e.g. 20% VAT is represented as 20.0 in this field. 0.0 is a valid value. */
  vatRate: Scalars['Float']['output'];
};

export type FeePaymentSums = {
  __typename?: 'FeePaymentSums';
  /** Amount that was forgiven (without VAT) */
  cancelledAmount: Amount;
  /** Convenience to detect zero amounts without comparing money objects */
  cancelledAmountIsZero: Scalars['Boolean']['output'];
  /** Amount that was forgiven (with VAT) */
  cancelledAmountVatIncluded: Amount;
  /** Amount that was forgiven (VAT only) */
  cancelledVatAmount: Amount;
  /** Amount that was already paid (without VAT) */
  completedAmount: Amount;
  /** Convenience to detect zero amounts without comparing money objects */
  completedAmountIsZero: Scalars['Boolean']['output'];
  /** Amount that was already paid (with VAT) */
  completedAmountVatIncluded: Amount;
  /** Amount that was already paid (VAT only) */
  completedVatAmount: Amount;
  /** Total amount the customer has paid or will pay (without VAT) */
  expectedAmount: Amount;
  /** Convenience to detect zero amounts without comparing money objects */
  expectedAmountIsZero: Scalars['Boolean']['output'];
  /** Total amount the customer has paid or will pay (with VAT) */
  expectedAmountVatIncluded: Amount;
  /** Total amount the customer has paid or will pay (VAT only) */
  expectedVatAmount: Amount;
  /** Amount we are currently collecting (without VAT, transitional state) */
  orderedAmount: Amount;
  /** Convenience to detect zero amounts without comparing money objects (transitional state) */
  orderedAmountIsZero: Scalars['Boolean']['output'];
  /** Amount we are currently collecting (with VAT, transitional state) */
  orderedAmountVatIncluded: Amount;
  /** Amount we are currently collecting (VAT only, transitional state) */
  orderedVatAmount: Amount;
  /** Amount we will attempt to collect soon (without VAT, transitional state) */
  pendingAmount: Amount;
  /** Convenience to detect zero amounts without comparing money objects (transition state) */
  pendingAmountIsZero: Scalars['Boolean']['output'];
  /** Amount we will attempt to collect soon (with VAT, transitional state) */
  pendingAmountVatIncluded: Amount;
  /** Amount we will attempt to collect soon (VAT only, transitional state) */
  pendingVatAmount: Amount;
  /** Total amount that we still expect to collect (without VAT) */
  unsettledAmount: Amount;
  /** Convenience to detect zero amounts without comparing money objects */
  unsettledAmountIsZero: Scalars['Boolean']['output'];
  /** Total amount that we still expect to collect (with VAT) */
  unsettledAmountVatIncluded: Amount;
  /** Total amount that we still expect to collect (VAT only) */
  unsettledVatAmount: Amount;
  /** Amount that we are waiting to collect (without VAT; use unsettledAmount for user presentation to avoid race conditions) */
  waitingFundsAmount: Amount;
  /** Convenience to detect zero amounts without comparing money objects (transitional state) */
  waitingFundsAmountIsZero: Scalars['Boolean']['output'];
  /** Amount that we are waiting to collect (with VAT; use unsettledAmountVatIncluded for user presentation to avoid race conditions) */
  waitingFundsAmountVatIncluded: Amount;
  /** Amount that we are waiting to collect (VAT only; use unsettledVatAmount for user presentation to avoid race conditions) */
  waitingFundsVatAmount: Amount;
};

export enum FeeStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  CompletedOffered = 'COMPLETED_OFFERED',
  Pending = 'PENDING',
  WaitingFunds = 'WAITING_FUNDS'
}

export enum FeeType {
  Accounting = 'ACCOUNTING',
  AccountsPayable = 'ACCOUNTS_PAYABLE',
  AccountsReceivable = 'ACCOUNTS_RECEIVABLE',
  AccountClosed = 'ACCOUNT_CLOSED',
  AdditionalUser = 'ADDITIONAL_USER',
  AdvertisingCard = 'ADVERTISING_CARD',
  Atm = 'ATM',
  AtmPlus = 'ATM_PLUS',
  CapitalIncrease = 'CAPITAL_INCREASE',
  CardAcquirerPayout = 'CARD_ACQUIRER_PAYOUT',
  CashFlowManagement = 'CASH_FLOW_MANAGEMENT',
  Cheque = 'CHEQUE',
  ConfirmationLetter = 'CONFIRMATION_LETTER',
  DebtCollection = 'DEBT_COLLECTION',
  DepositInterest = 'DEPOSIT_INTEREST',
  DirectDebitCollectionActivation = 'DIRECT_DEBIT_COLLECTION_ACTIVATION',
  DirectDebitCollectionRefund = 'DIRECT_DEBIT_COLLECTION_REFUND',
  DirectDebitCollectionRefundLate = 'DIRECT_DEBIT_COLLECTION_REFUND_LATE',
  DirectDebitCollectionReturn = 'DIRECT_DEBIT_COLLECTION_RETURN',
  DirectDebitCollectionSend = 'DIRECT_DEBIT_COLLECTION_SEND',
  EckertLaw = 'ECKERT_LAW',
  ExpenseSpendManagement = 'EXPENSE_SPEND_MANAGEMENT',
  FlashCard = 'FLASH_CARD',
  Fraud = 'FRAUD',
  FxCard = 'FX_CARD',
  FxCardPlus = 'FX_CARD_PLUS',
  FxInboundTransfer = 'FX_INBOUND_TRANSFER',
  FxOutboundTransfer = 'FX_OUTBOUND_TRANSFER',
  FxOutboundTransferEurSwiftOur = 'FX_OUTBOUND_TRANSFER_EUR_SWIFT_OUR',
  FxOutboundTransferEurSwiftSha = 'FX_OUTBOUND_TRANSFER_EUR_SWIFT_SHA',
  FxOutboundTransferLocalNonStandardCurrency = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY',
  FxOutboundTransferLocalNonStandardCurrencyReduced_10 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_10',
  FxOutboundTransferLocalNonStandardCurrencyReduced_20 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_20',
  FxOutboundTransferLocalNonStandardCurrencyReduced_40 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_40',
  FxOutboundTransferLocalNonStandardCurrencyReduced_50 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_50',
  FxOutboundTransferLocalStandardCurrency = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY',
  FxOutboundTransferLocalStandardCurrencyReduced_10 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_10',
  FxOutboundTransferLocalStandardCurrencyReduced_20 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_20',
  FxOutboundTransferLocalStandardCurrencyReduced_40 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_40',
  FxOutboundTransferLocalStandardCurrencyReduced_50 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_50',
  FxOutboundTransferOnlyVariableSwiftOur = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR',
  FxOutboundTransferOnlyVariableSwiftOurReduced_10 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_10',
  FxOutboundTransferOnlyVariableSwiftOurReduced_20 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_20',
  FxOutboundTransferOnlyVariableSwiftOurReduced_40 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_40',
  FxOutboundTransferOnlyVariableSwiftOurReduced_50 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_50',
  FxOutboundTransferOnlyVariableSwiftSha = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA',
  FxOutboundTransferOnlyVariableSwiftShaReduced_10 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_10',
  FxOutboundTransferOnlyVariableSwiftShaReduced_20 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_20',
  FxOutboundTransferOnlyVariableSwiftShaReduced_40 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_40',
  FxOutboundTransferOnlyVariableSwiftShaReduced_50 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_50',
  FxOutboundTransferSwiftOur = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR',
  FxOutboundTransferSwiftOurReduced_10 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_10',
  FxOutboundTransferSwiftOurReduced_20 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_20',
  FxOutboundTransferSwiftOurReduced_40 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_40',
  FxOutboundTransferSwiftOurReduced_50 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_50',
  FxOutboundTransferSwiftSha = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA',
  FxOutboundTransferSwiftShaReduced_10 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_10',
  FxOutboundTransferSwiftShaReduced_20 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_20',
  FxOutboundTransferSwiftShaReduced_40 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_40',
  FxOutboundTransferSwiftShaReduced_50 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_50',
  FxRefund = 'FX_REFUND',
  GenericFee = 'GENERIC_FEE',
  InvoiceAutomation = 'INVOICE_AUTOMATION',
  JudicialRequisition = 'JUDICIAL_REQUISITION',
  Other = 'OTHER',
  Pagopa = 'PAGOPA',
  PhysicalCard = 'PHYSICAL_CARD',
  PhysicalCardDelivery = 'PHYSICAL_CARD_DELIVERY',
  PhysicalCardMetal = 'PHYSICAL_CARD_METAL',
  PhysicalCardMirror = 'PHYSICAL_CARD_MIRROR',
  PhysicalCardPlus = 'PHYSICAL_CARD_PLUS',
  ProjectTracking = 'PROJECT_TRACKING',
  RejectedDebit = 'REJECTED_DEBIT',
  RejectedFxTransfer = 'REJECTED_FX_TRANSFER',
  RejectedTransfer = 'REJECTED_TRANSFER',
  ReturnedCheque = 'RETURNED_CHEQUE',
  Satd = 'SATD',
  SciNumberObtention = 'SCI_NUMBER_OBTENTION',
  SeizureForeclosure = 'SEIZURE_FORECLOSURE',
  SepaInboundTransfer = 'SEPA_INBOUND_TRANSFER',
  SepaOutboundTransfer = 'SEPA_OUTBOUND_TRANSFER',
  Shortfall = 'SHORTFALL',
  Subscription = 'SUBSCRIPTION',
  SwiftIncome = 'SWIFT_INCOME',
  SwiftIncomeFree = 'SWIFT_INCOME_FREE',
  TeamSpendControls = 'TEAM_SPEND_CONTROLS',
  ThirdPartyNotice = 'THIRD_PARTY_NOTICE',
  UnpaidCheque = 'UNPAID_CHEQUE',
  UpvestMmfFeeCancellation = 'UPVEST_MMF_FEE_CANCELLATION',
  VirtualCard = 'VIRTUAL_CARD'
}

export type File = {
  __typename?: 'File';
  fileUrl: Scalars['String']['output'];
};

export type Filter = {
  operator: Scalars['String']['input'];
  property: Scalars['String']['input'];
  values: Array<Scalars['Any']['input']>;
};

export type FilterGroup = {
  conditional?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<FilterOrGroupOneFilters>>;
};

export type FilterGroupOne = {
  conditional?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<FilterGroupOrExpressionOne>>;
};

export type FilterGroupOrExpressionOne = {
  conditional?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<FilterGroupOrExpressionTwo>>;
  operator?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['Any']['input']>>;
};

export type FilterGroupOrExpressionTwo = {
  conditional?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<FilterGroupThree>>;
  operator?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
  values?: InputMaybe<Array<Scalars['Any']['input']>>;
};

export type FilterGroupThree = {
  operator?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
  values: Array<Scalars['Any']['input']>;
};

export type FilterOrGroupOneFilters = {
  filter?: InputMaybe<Filter>;
  group?: InputMaybe<GroupOneFilters>;
};

export type FilterOrGroupTwoFilters = {
  filter?: InputMaybe<Filter>;
  group?: InputMaybe<GroupTwoFilters>;
};

export type FinancialDetail = {
  __typename?: 'FinancialDetail';
  annualTurnover?: Maybe<Scalars['String']['output']>;
  estimatedAnnualTurnover?: Maybe<Scalars['String']['output']>;
  estimatedYearlyIncome?: Maybe<Scalars['String']['output']>;
  maxSinglePaymentAmount?: Maybe<Scalars['String']['output']>;
  yearlyTransactionVolume?: Maybe<Scalars['String']['output']>;
};

export type FinancingInstallment = {
  __typename?: 'FinancingInstallment';
  accumulatedFeesAmount: Amount;
  capitalAmount: Amount;
  createdAt: Scalars['String']['output'];
  currentInstallmentNumber: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  interestAmount: Amount;
  movementId: Scalars['ID']['output'];
  totalInstallmentsNumber: Scalars['Int']['output'];
};

export enum FixedAmountType {
  Amount = 'AMOUNT',
  LocalAmount = 'LOCAL_AMOUNT'
}

export enum FlexKybStatus {
  Accepted = 'ACCEPTED',
  Archived = 'ARCHIVED',
  Eligible = 'ELIGIBLE',
  Rejected = 'REJECTED',
  Reviewable = 'REVIEWABLE',
  Waiting = 'WAITING'
}

export enum Frequency {
  FrequencyAnnually = 'FREQUENCY_ANNUALLY',
  FrequencyBiannually = 'FREQUENCY_BIANNUALLY',
  FrequencyBiweekly = 'FREQUENCY_BIWEEKLY',
  FrequencyDaily = 'FREQUENCY_DAILY',
  FrequencyMonthly = 'FREQUENCY_MONTHLY',
  FrequencyQuarterly = 'FREQUENCY_QUARTERLY',
  FrequencyUnspecified = 'FREQUENCY_UNSPECIFIED',
  FrequencyWeekly = 'FREQUENCY_WEEKLY'
}

export type GroupOneFilters = {
  conditional?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<FilterOrGroupTwoFilters>>;
};

export type GroupThreeFilter = {
  filter?: InputMaybe<Filter>;
};

export type GroupTwoFilters = {
  conditional?: InputMaybe<Scalars['String']['input']>;
  expressions?: InputMaybe<Array<GroupThreeFilter>>;
};

export type Income = {
  __typename?: 'Income';
  amount: Scalars['Float']['output'];
  amountCents: Scalars['Int']['output'];
  amountCurrency: Scalars['String']['output'];
  amountV2: Amount;
  bankAccountId: Scalars['String']['output'];
  bic: Scalars['String']['output'];
  emitterBic: Scalars['String']['output'];
  emitterIban: Scalars['String']['output'];
  emitterIdentification: Scalars['String']['output'];
  emitterName: Scalars['String']['output'];
  enrichmentData?: Maybe<EnrichmentData>;
  iban: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  sequentialId?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
};

export type Invite = {
  __typename?: 'Invite';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  flow: InviteFlow;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  recipientId: Scalars['String']['output'];
};

export enum InviteFlow {
  Invite = 'INVITE',
  Reactivation = 'REACTIVATION',
  RoleChange = 'ROLE_CHANGE'
}

export type InvoiceTax = {
  __typename?: 'InvoiceTax';
  taxAmount?: Maybe<Amount>;
  taxRate?: Maybe<Scalars['String']['output']>;
};

export type JournalEntry = {
  __typename?: 'JournalEntry';
  id: Scalars['String']['output'];
  journalEntryLines: Array<JournalEntryLine>;
  label?: Maybe<Scalars['String']['output']>;
  qontoAttachmentId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type JournalEntryLine = {
  __typename?: 'JournalEntryLine';
  accountingCodeId?: Maybe<Scalars['String']['output']>;
  amount: Amount;
  costCenterAllocations: Array<CostCenterAllocation>;
  id: Scalars['String']['output'];
  taxFinancialAccount?: Maybe<TaxFinancialAccount>;
  taxFinancialAccountId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum KycStatus {
  Accepted = 'ACCEPTED',
  KycNotApplicable = 'KYC_NOT_APPLICABLE',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Refused = 'REFUSED',
  Reviewable = 'REVIEWABLE',
  SubmissionError = 'SUBMISSION_ERROR',
  Submitted = 'SUBMITTED',
  WaitingDocument = 'WAITING_DOCUMENT'
}

export enum KybStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Refused = 'REFUSED'
}

export type Label = {
  __typename?: 'Label';
  id: Scalars['ID']['output'];
  labelList: LabelList;
  listId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LabelList = {
  __typename?: 'LabelList';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
};

export type LegacyMembership = {
  __typename?: 'LegacyMembership';
  avatar: AvatarFile;
  avatarThumb: AvatarFile;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  role: Scalars['String']['output'];
  team?: Maybe<Team>;
  teamId: Scalars['String']['output'];
};

export type Logo = {
  __typename?: 'Logo';
  medium: Scalars['String']['output'];
  small: Scalars['String']['output'];
};

export type MatchedTransaction = {
  __typename?: 'MatchedTransaction';
  subjectId: Scalars['ID']['output'];
  subjectType: Scalars['String']['output'];
  transactionId: Scalars['ID']['output'];
};

export type Membership = {
  __typename?: 'Membership';
  avatar?: Maybe<UserAvatar>;
  id: Scalars['ID']['output'];
  invitation?: Maybe<Invite>;
  kyc: MembershipKycStatus;
  organizationId: Scalars['String']['output'];
  person?: Maybe<Person>;
  role: MembershipRole;
  status: MembershipStatus;
  teamId?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MembershipKycStatus = {
  __typename?: 'MembershipKycStatus';
  kycStatus: KycStatus;
  membershipId: Scalars['String']['output'];
};

export enum MembershipRole {
  Accountant = 'ACCOUNTANT',
  Admin = 'ADMIN',
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER',
  Owner = 'OWNER'
}

export enum MembershipStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  Revoked = 'REVOKED'
}

export type MembershipsSearch = {
  filterGroup?: InputMaybe<FilterGroup>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type Message = {
  __typename?: 'Message';
  author?: Maybe<Participant>;
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  editedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type MileageAddress = {
  __typename?: 'MileageAddress';
  formattedAddress: Scalars['String']['output'];
  googlePlaceId: Scalars['String']['output'];
};

export type MileageCalculation = {
  __typename?: 'MileageCalculation';
  /** Bonus amount for electric vehicles */
  ElectricBonusAmount?: Maybe<Amount>;
  /** Number of metrics driven in the current trip */
  distanceMeters: Scalars['Int']['output'];
  /** List of rates applied to the trip */
  rates: Array<MileageRate>;
  /** Number of metrics driven in a year's trip for the vehicle when item was created */
  yearlyDistanceMeters?: Maybe<Scalars['Int']['output']>;
};

export type MileageRate = {
  __typename?: 'MileageRate';
  distanceMeters: Scalars['Int']['output'];
  endMeters?: Maybe<Scalars['Int']['output']>;
  startMeters: Scalars['Int']['output'];
  unit: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MyBankDetails = {
  __typename?: 'MyBankDetails';
  createdAt: Scalars['String']['output'];
  iban: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type MyBankDetailsResult = {
  __typename?: 'MyBankDetailsResult';
  /** Bank details of the current user */
  bankDetails?: Maybe<MyBankDetails>;
};

export type MyBankDetailsSearch = {
  _note?: InputMaybe<Scalars['String']['input']>;
};

export type NrcPayment = {
  __typename?: 'NrcPayment';
  id: Scalars['ID']['output'];
  movementId: Scalars['ID']['output'];
  nrc: Scalars['String']['output'];
  taxCode: Scalars['String']['output'];
  taxDescription: Scalars['String']['output'];
};

export type OnboardingPartner = {
  __typename?: 'OnboardingPartner';
  code: Scalars['String']['output'];
  type: OnboardingPartnerType;
};

export enum OnboardingPartnerType {
  Accountant = 'ACCOUNTANT',
  BylawProvider = 'BYLAW_PROVIDER',
  ExistingCompanyProvider = 'EXISTING_COMPANY_PROVIDER',
  Shelf = 'SHELF'
}

export enum OperationMethod {
  Biller = 'BILLER',
  Card = 'CARD',
  CardAcquirerPayout = 'CARD_ACQUIRER_PAYOUT',
  Cashback = 'CASHBACK',
  Cheque = 'CHEQUE',
  Ddc = 'DDC',
  DirectDebit = 'DIRECT_DEBIT',
  DirectDebitHold = 'DIRECT_DEBIT_HOLD',
  Investment = 'INVESTMENT',
  Other = 'OTHER',
  Overdraft = 'OVERDRAFT',
  PagopaPayment = 'PAGOPA_PAYMENT',
  PayLater = 'PAY_LATER',
  Remuneration = 'REMUNERATION',
  RibaPayment = 'RIBA_PAYMENT',
  Tax = 'TAX',
  Transfer = 'TRANSFER'
}

export enum OperationType {
  AccountRemuneration = 'ACCOUNT_REMUNERATION',
  Biller = 'BILLER',
  Card = 'CARD',
  CardAcquirerPayout = 'CARD_ACQUIRER_PAYOUT',
  CashbackAdjustment = 'CASHBACK_ADJUSTMENT',
  CashbackPayout = 'CASHBACK_PAYOUT',
  Cheque = 'CHEQUE',
  DirectDebit = 'DIRECT_DEBIT',
  DirectDebitCollection = 'DIRECT_DEBIT_COLLECTION',
  DirectDebitHold = 'DIRECT_DEBIT_HOLD',
  ExternalFees = 'EXTERNAL_FEES',
  F24 = 'F24',
  FinancingInstallment = 'FINANCING_INSTALLMENT',
  Income = 'INCOME',
  Investment = 'INVESTMENT',
  InvestmentPromo = 'INVESTMENT_PROMO',
  NrcPayment = 'NRC_PAYMENT',
  Other = 'OTHER',
  PagopaPayment = 'PAGOPA_PAYMENT',
  PayLater = 'PAY_LATER',
  Recall = 'RECALL',
  RibaPayment = 'RIBA_PAYMENT',
  SwiftIncome = 'SWIFT_INCOME',
  Transfer = 'TRANSFER'
}

export type Organization = {
  __typename?: 'Organization';
  avatar: OrganizationAvatar;
  company: Company;
  createdAt: Scalars['DateTimeNanos']['output'];
  customer: Customer;
  features?: Maybe<OrganizationFeature>;
  id: Scalars['ID']['output'];
  kyb?: Maybe<OrganizationKyb>;
  name: Scalars['String']['output'];
  onboardingPartner?: Maybe<OnboardingPartner>;
  slug: Scalars['String']['output'];
  status: OrganizationStatus;
  suspensionReason?: Maybe<Scalars['String']['output']>;
};

export type OrganizationAvatar = {
  __typename?: 'OrganizationAvatar';
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  thumbUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type OrganizationFeature = {
  __typename?: 'OrganizationFeature';
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type OrganizationKyb = {
  __typename?: 'OrganizationKyb';
  associationTypeformFileFilledAt?: Maybe<Scalars['DateTimeNanos']['output']>;
  associationTypeformUrl?: Maybe<Scalars['String']['output']>;
  flexKybStatus?: Maybe<FlexKybStatus>;
  kybStatus: KybStatus;
  ongoingKycKybUpdateProcessId?: Maybe<Scalars['ID']['output']>;
  typeformUrl?: Maybe<Scalars['String']['output']>;
  unreferenced: Scalars['Boolean']['output'];
};

export enum OrganizationStatus {
  Activated = 'ACTIVATED',
  Deactivated = 'DEACTIVATED',
  KybWaiting = 'KYB_WAITING',
  Suspended = 'SUSPENDED'
}

export type OrganizationsSearch = {
  _note?: InputMaybe<Scalars['String']['input']>;
};

export type OverdraftInterestPayment = {
  __typename?: 'OverdraftInterestPayment';
  id: Scalars['ID']['output'];
  movementId: Scalars['ID']['output'];
  periodEndDate: Scalars['String']['output'];
  periodStartDate: Scalars['String']['output'];
};

export type Pagination = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type PagopaPayment = {
  __typename?: 'PagopaPayment';
  amount: Amount;
  creditorName?: Maybe<Scalars['String']['output']>;
  fiscalCode?: Maybe<Scalars['String']['output']>;
  iuv?: Maybe<Scalars['String']['output']>;
  movementId: Scalars['ID']['output'];
  noticeNumber?: Maybe<Scalars['String']['output']>;
};

export type ParentCardSummary = {
  __typename?: 'ParentCardSummary';
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
};

export type Participant = {
  __typename?: 'Participant';
  id: Scalars['ID']['output'];
  lastReadAt?: Maybe<Scalars['String']['output']>;
  membership: LegacyMembership;
  membershipId: Scalars['ID']['output'];
};

export type PayableAmountFilter = {
  currency: Scalars['String']['input'];
  operator: PayableAmountOperator;
  value: Scalars['String']['input'];
};

export enum PayableAmountOperator {
  Gte = 'GTE',
  Lte = 'LTE'
}

export enum PaymentMode {
  DeferredDebit = 'DEFERRED_DEBIT',
  ImmediateDebit = 'IMMEDIATE_DEBIT',
  Unknown = 'UNKNOWN'
}

export type PerDiemCalculationComponents = {
  __typename?: 'PerDiemCalculationComponents';
  /** Base allowance for the day (full or partial rate) */
  baseRate: Amount;
  /** Deduction applied when breakfast is reimbursed */
  breakfastRate: Amount;
  /** Type of day: `first`, `last`, `middle`, or `single` */
  dayType: Scalars['String']['output'];
  /** Deduction applied when dinner is reimbursed */
  dinnerRate: Amount;
  /** Deduction applied when lunch is reimbursed */
  lunchRate: Amount;
  /** Supplement added when overnight stay is not covered by the employer */
  overnightRate: Amount;
  /** Translated city/country name used for the rate lookup */
  rateSource: Scalars['String']['output'];
};

export type PerDiemDay = {
  __typename?: 'PerDiemDay';
  /** Whether breakfast is reimbursed through a separate expense (deducted from per diem). */
  breakfastReimbursed: Scalars['Boolean']['output'];
  /** Rate breakdown used to calculate this day's allowance */
  calculationComponents: PerDiemCalculationComponents;
  /** Calendar date (YYYY-MM-DD) */
  date: Scalars['String']['output'];
  /** Destination(s) visited on this day */
  destinationLocations: Array<PerDiemLocation>;
  /** Whether dinner is reimbursed through a separate expense (deducted from per diem). */
  dinnerReimbursed: Scalars['Boolean']['output'];
  /** Whether lunch is reimbursed through a separate expense (deducted from per diem). */
  lunchReimbursed: Scalars['Boolean']['output'];
  /** Whether an overnight stay was not covered by the employer (adds the overnight supplement). */
  overnightStayNotCovered: Scalars['Boolean']['output'];
};

export type PerDiemLocation = {
  __typename?: 'PerDiemLocation';
  /** UUID of the city; null when the employee entered a free-text city name */
  cityId?: Maybe<Scalars['String']['output']>;
  /** City name — always present; free-text input or BE translation of cityId */
  cityName: Scalars['String']['output'];
  /** ISO 3166-1 alpha-2 country code */
  country: Scalars['String']['output'];
  /** Local date of arrival at this location (ISO 8601, e.g. 2025-06-11) */
  date: Scalars['String']['output'];
  /** Local time of arrival. Optional — absent means the time is unspecified. */
  time?: Maybe<PerDiemTime>;
};

export type PerDiemTime = {
  __typename?: 'PerDiemTime';
  hours: Scalars['Int']['output'];
  minutes: Scalars['Int']['output'];
};

export type Person = {
  __typename?: 'Person';
  displayName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ProbativeAttachment = {
  __typename?: 'ProbativeAttachment';
  downloadUrl: Scalars['String']['output'];
  fileContentType: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export enum Purpose {
  Payroll = 'PAYROLL'
}

export type QrCodeExtracted = {
  __typename?: 'QRCodeExtracted';
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  format: Scalars['String']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Amount>;
};

/** Enum for authentication methods (used by both OTP and MFA). */
export enum QontoAccountManagementUsersFirstpartyV2_AuthMethod {
  /** Unspecified authentication method. */
  AuthMethodUnspecified = 'AUTH_METHOD_UNSPECIFIED',
  /**
   * Authentication by app.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  ByApp = 'by_app',
  /**
   * Authentication by SMS.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  BySms = 'by_sms'
}

/** Message for avatar/image objects. */
export type QontoAccountManagementUsersFirstpartyV2_Avatar = {
  __typename?: 'QontoAccountManagementUsersFirstpartyV2_Avatar';
  /** The URL of the file. */
  fileUrl: Scalars['String']['output'];
};

/** Message for avatar/image objects. */
export type QontoAccountManagementUsersFirstpartyV2_AvatarInput = {
  /** The URL of the file. */
  fileUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Enum for gender. */
export enum QontoAccountManagementUsersFirstpartyV2_Gender {
  /** Unspecified gender. */
  GenderUnspecified = 'GENDER_UNSPECIFIED',
  /**
   * Female gender.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Female = 'female',
  /**
   * Male gender.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Male = 'male',
  /**
   * Other gender.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Other = 'other'
}

/** Message for the user. */
export type QontoAccountManagementUsersFirstpartyV2_User = {
  __typename?: 'QontoAccountManagementUsersFirstpartyV2_User';
  /** Avatar of the user. */
  avatar?: Maybe<QontoAccountManagementUsersFirstpartyV2_Avatar>;
  /** Avatar thumbnail of the user. */
  avatarThumb?: Maybe<QontoAccountManagementUsersFirstpartyV2_Avatar>;
  /** Birth city of the user. */
  birthCity?: Maybe<Scalars['String']['output']>;
  /** Birth country of the user. */
  birthCountry?: Maybe<Scalars['String']['output']>;
  /** Birth zipcode of the user. */
  birthZipcode?: Maybe<Scalars['String']['output']>;
  /** Birth date of the user (YYYY-MM-DD format). */
  birthdate?: Maybe<Scalars['String']['output']>;
  /** Whether the user can enroll trusted device using SMS OTP. */
  canEnrollTrustedDeviceUsingSmsOtp: Scalars['Boolean']['output'];
  /** Default avatar of the user. */
  defaultAvatar?: Maybe<QontoAccountManagementUsersFirstpartyV2_Avatar>;
  /** Default avatar thumbnail of the user. */
  defaultAvatarThumb?: Maybe<QontoAccountManagementUsersFirstpartyV2_Avatar>;
  /** Email address of the user. */
  email: Scalars['String']['output'];
  /** First name of the user. */
  firstName: Scalars['String']['output'];
  /** User flags containing additional boolean settings. */
  flags: QontoAccountManagementUsersFirstpartyV2_UserFlags;
  /** Full name of the user. */
  fullName: Scalars['String']['output'];
  /** Futurae user identifier. */
  futuraeUserId?: Maybe<Scalars['String']['output']>;
  /** Gender of the user. */
  gender?: Maybe<QontoAccountManagementUsersFirstpartyV2_Gender>;
  /** Whether the user has a default avatar. */
  hasDefaultAvatar: Scalars['Boolean']['output'];
  /** Unique identifier for the user. */
  id: Scalars['String']['output'];
  /** Last name of the user. */
  lastName: Scalars['String']['output'];
  /** Locale preference of the user. */
  locale: Scalars['String']['output'];
  /** Whether MFA is enabled. */
  mfaEnabled: Scalars['Boolean']['output'];
  /** MFA method preference. */
  mfaMethod?: Maybe<QontoAccountManagementUsersFirstpartyV2_AuthMethod>;
  /** Whether the user has completed onboarding. */
  onboarded: Scalars['Boolean']['output'];
  /** Whether OTP is enabled. */
  otpEnabled: Scalars['Boolean']['output'];
  /** OTP method preference. */
  otpMethod?: Maybe<QontoAccountManagementUsersFirstpartyV2_AuthMethod>;
  /** Pending email change. */
  pendingEmail?: Maybe<Scalars['String']['output']>;
  /** Pending phone number change. */
  pendingPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** Phone number of the user. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Whether the phone number is verified. */
  phoneNumberVerified: Scalars['Boolean']['output'];
  /** Whether SCA is enabled. */
  scaEnabled: Scalars['Boolean']['output'];
  /** Whether SCA enrollment is available. */
  scaEnrollmentAvailable: Scalars['Boolean']['output'];
  /** Segment identifier for analytics. */
  segmentId: Scalars['String']['output'];
  /** Timezone of the user. */
  timezone: Scalars['String']['output'];
  /** Whether tougher SCA approach is enabled. */
  tougherScaApproachEnabled: Scalars['Boolean']['output'];
  /** Zendesk integration data. */
  zendesk: QontoAccountManagementUsersFirstpartyV2_Zendesk;
};

/** Message for user flags. */
export type QontoAccountManagementUsersFirstpartyV2_UserFlags = {
  __typename?: 'QontoAccountManagementUsersFirstpartyV2_UserFlags';
  /**
   * Severity level of credential exposure detected for the user, if any.
   * 0 = not compromised or out of scope (default/absent).
   * 1 = both email and password leaked.
   * 2 = password only leaked.
   */
  credentialExposureLevel?: Maybe<Scalars['Int']['output']>;
  /** Whether the user has a password set. */
  hasPassword: Scalars['Boolean']['output'];
};

/** Message for user flags. */
export type QontoAccountManagementUsersFirstpartyV2_UserFlagsInput = {
  /**
   * Severity level of credential exposure detected for the user, if any.
   * 0 = not compromised or out of scope (default/absent).
   * 1 = both email and password leaked.
   * 2 = password only leaked.
   */
  credentialExposureLevel?: InputMaybe<Scalars['Int']['input']>;
  /** Whether the user has a password set. */
  hasPassword?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Message for the user. */
export type QontoAccountManagementUsersFirstpartyV2_UserInput = {
  /** Avatar of the user. */
  avatar?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_AvatarInput>;
  /** Avatar thumbnail of the user. */
  avatarThumb?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_AvatarInput>;
  /** Birth city of the user. */
  birthCity?: InputMaybe<Scalars['String']['input']>;
  /** Birth country of the user. */
  birthCountry?: InputMaybe<Scalars['String']['input']>;
  /** Birth zipcode of the user. */
  birthZipcode?: InputMaybe<Scalars['String']['input']>;
  /** Birth date of the user (YYYY-MM-DD format). */
  birthdate?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user can enroll trusted device using SMS OTP. */
  canEnrollTrustedDeviceUsingSmsOtp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default avatar of the user. */
  defaultAvatar?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_AvatarInput>;
  /** Default avatar thumbnail of the user. */
  defaultAvatarThumb?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_AvatarInput>;
  /** Email address of the user. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name of the user. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User flags containing additional boolean settings. */
  flags: QontoAccountManagementUsersFirstpartyV2_UserFlagsInput;
  /** Full name of the user. */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Futurae user identifier. */
  futuraeUserId?: InputMaybe<Scalars['String']['input']>;
  /** Gender of the user. */
  gender?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_Gender>;
  /** Whether the user has a default avatar. */
  hasDefaultAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique identifier for the user. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the user. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Locale preference of the user. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Whether MFA is enabled. */
  mfaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** MFA method preference. */
  mfaMethod?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_AuthMethod>;
  /** Whether the user has completed onboarding. */
  onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether OTP is enabled. */
  otpEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** OTP method preference. */
  otpMethod?: InputMaybe<QontoAccountManagementUsersFirstpartyV2_AuthMethod>;
  /** Pending email change. */
  pendingEmail?: InputMaybe<Scalars['String']['input']>;
  /** Pending phone number change. */
  pendingPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the user. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Whether the phone number is verified. */
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether SCA is enabled. */
  scaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether SCA enrollment is available. */
  scaEnrollmentAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Segment identifier for analytics. */
  segmentId?: InputMaybe<Scalars['String']['input']>;
  /** Timezone of the user. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** Whether tougher SCA approach is enabled. */
  tougherScaApproachEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Zendesk integration data. */
  zendesk: QontoAccountManagementUsersFirstpartyV2_ZendeskInput;
};

/** Message for Zendesk integration data. */
export type QontoAccountManagementUsersFirstpartyV2_Zendesk = {
  __typename?: 'QontoAccountManagementUsersFirstpartyV2_Zendesk';
  /** JWT token for messaging widget. */
  messagingWidgetJwt: Scalars['String']['output'];
  /** JWT token for SSO. */
  ssoJwt: Scalars['String']['output'];
};

/** Message for Zendesk integration data. */
export type QontoAccountManagementUsersFirstpartyV2_ZendeskInput = {
  /** JWT token for messaging widget. */
  messagingWidgetJwt?: InputMaybe<Scalars['String']['input']>;
  /** JWT token for SSO. */
  ssoJwt?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One organization's accounting setup plus its onboarding progress, for the
 * accountant clients table. Pairing them per item (rather than a separate
 * accounting_setups list plus a map keyed by organization_id) avoids making
 * FE correlate two collections by ID for what is always rendered as a single
 * table row. This endpoint has no live caller yet, so reshaping the response
 * here is not a breaking change in practice — see the discussion on #1646.
 */
export type QontoAccountingAccountancyPracticesFirstpartyV2_AccountancyPracticeAccountingSetupListItem = {
  __typename?: 'QontoAccountingAccountancyPracticesFirstpartyV2_AccountancyPracticeAccountingSetupListItem';
  /** The organization's accounting setup. */
  accountingSetup: QontoAccountingAccountingSetupsFirstpartyV2_AccountingSetup;
  /**
   * Every configured onboarding step's status, not just completed ones, so
   * FE can render the full picture (done, actionable, locked) without a
   * second per-organization fetch. Not the full checklist: phase_code,
   * completed_at, confirmed_by and action still come from
   * GetOnboardingChecklist when the accountant opens a single organization.
   */
  onboardingSteps: Array<QontoAccountingAccountancyPracticesFirstpartyV2_OnboardingStepProgress>;
};

/** Represents an accountant conversation associated with a managed organization. */
export type QontoAccountingAccountancyPracticesFirstpartyV2_Conversation = {
  __typename?: 'QontoAccountingAccountancyPracticesFirstpartyV2_Conversation';
  /** Timestamp when the conversation was closed. Absent when the conversation is still open. */
  closedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Unique identifier of the conversation. */
  conversationId: Scalars['String']['output'];
  /** Is the last message from the accountant */
  isLastMessageFromAccountant?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the last message has been seen by the accountant. */
  isLastMessageSeen: Scalars['Boolean']['output'];
  /** Timestamp of the last message in the conversation. Absent when no messages have been sent. */
  lastMessageAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Text content of the last message in the conversation. */
  lastMessageText: Scalars['String']['output'];
  /**
   * Qonto account data for this conversation's organization (status, company, stakeholders).
   * Batched via GET /v5/accountancy_practices/organizations keyed on organizationId.
   */
  organization?: Maybe<QontoRegistrationApiOrganizationsFirstpartyV5_Organization>;
  /** Identifier of the organization this conversation belongs to. */
  organizationId: Scalars['String']['output'];
  /** Title of the conversation. */
  title: Scalars['String']['output'];
  /** Identifier of the Qonto user involved in this conversation. Absent when no user is associated. */
  userId?: Maybe<Scalars['String']['output']>;
};

/**
 * Request to list accounting setups for all organizations managed by an accountancy practice.
 * The accountancy practice is resolved from the PASETO token of the authenticated caller — no accountancy_practice_id is exposed in the request.
 */
export type QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeAccountingSetupsRequestInput = {
  /** Filter by archived state. */
  archived?: InputMaybe<QontoAccountingAccountingSetupsFirstpartyV2_ArchivedFilter>;
  /** Only organizations I managed */
  myPortfolio?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Filter by onboarding completion. When true, returns only organizations
   * whose onboarding checklist is fully complete (all required_for_completion
   * steps have a completion row). When false, returns only organizations whose
   * checklist is not yet complete. Unset returns all organizations regardless
   * of onboarding state.
   *
   * What "complete" means is owned entirely by the backend (accounting SQL
   * predicate) and may internally fold in setup status alongside step
   * completion — the exact rule is pending confirmation. This field is
   * intentionally self-contained: do not use status to re-express this split.
   */
  onboardingCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by organization UUIDs (comma-separated). */
  organizationIds?: InputMaybe<Scalars['String']['input']>;
  /**
   * Page number to be fetched.
   * Default: 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Number of records per page.
   * Default: 25, Maximum: 100.
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by accounting setup status. */
  status?: InputMaybe<QontoAccountingAccountingSetupsFirstpartyV2_AccountingSetupStatus>;
};

/**
 * Response containing a list of accounting setups (with onboarding progress)
 * and pagination metadata.
 */
export type QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeAccountingSetupsResponse = {
  __typename?: 'QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeAccountingSetupsResponse';
  /** List of items matching the request criteria. */
  items: Array<QontoAccountingAccountancyPracticesFirstpartyV2_AccountancyPracticeAccountingSetupListItem>;
  /** Pagination metadata. */
  meta: QontoCommon_PaginationMeta;
};

/**
 * Request to list accountant conversations for all organizations managed by an accountancy practice.
 * The organizations are resolved from the PASETO token of the authenticated caller — no organization_id is exposed in the request.
 * Results are ordered by last_message_at descending.
 */
export type QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeConversationsRequestInput = {
  /** Comma-separated list of conversation UUIDs to fetch. When provided, only conversations with matching IDs are returned. */
  conversationIds?: InputMaybe<Scalars['String']['input']>;
  /** Page number to be fetched. Default: 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Number of records per page. Default: 25, Maximum: 100. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Response containing the list of accountant conversations for all organizations managed by an accountancy practice. */
export type QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeConversationsResponse = {
  __typename?: 'QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeConversationsResponse';
  /** The list of conversations matching the request criteria. */
  conversations: Array<QontoAccountingAccountancyPracticesFirstpartyV2_Conversation>;
  /** Pagination metadata. */
  meta: QontoCommon_PaginationMeta;
};

/**
 * Request to list obligations for all organizations managed by an accountancy practice.
 * The accountancy practice and its managed organizations are resolved from the AP PASETO token
 * of the authenticated caller — no `accountancy_practice_id` is exposed in the request.
 * Results are always ordered by due_date ascending.
 */
export type QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeObligationsRequestInput = {
  /**
   * Filter by organization UUID. When provided, restricts results to obligations
   * belonging to that specific organization managed by the accountancy practice.
   */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Page number to be fetched. Default: 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Number of records per page. Default: 25, Maximum: 100. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Filter by obligation status. Comma-separated list of ObligationStatus values
   * (e.g. "OBLIGATION_STATUS_OPEN,OBLIGATION_STATUS_PENDING"). Defaults to ongoing
   * statuses (OPEN, PENDING, OVERDUE) when unset.
   */
  statuses?: InputMaybe<Scalars['String']['input']>;
};

/** Response containing the list of obligations for all organizations managed by an accountancy practice. */
export type QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeObligationsResponse = {
  __typename?: 'QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeObligationsResponse';
  /** Pagination metadata. */
  meta: QontoCommon_PaginationMeta;
  /** The list of obligations matching the request criteria. */
  obligations: Array<QontoAccountingObligationsFirstpartyV2_Obligation>;
};

/**
 * A single step's status for a single organization, mirroring
 * qonto.accounting.onboarding.firstparty.v2.OnboardingChecklistItem but
 * trimmed to what a list/table pill needs.
 */
export type QontoAccountingAccountancyPracticesFirstpartyV2_OnboardingStepProgress = {
  __typename?: 'QontoAccountingAccountancyPracticesFirstpartyV2_OnboardingStepProgress';
  /**
   * Reuses the full per-step status model (LOCKED / PENDING /
   * WAITING_FOR_OWNER / COMPLETED) rather than a coarser rollup, so FE
   * decides how to collapse statuses into pill colors instead of the
   * backend baking that display choice into the contract.
   */
  status: QontoAccountingOnboardingFirstpartyV2_OnboardingStepStatus;
  /**
   * Stable step code (e.g. "impots_gouv_delegation_confirmed"). Kept as a
   * plain string, not an enum: the step set is config-driven per country
   * (see internal/app/obligations/onboarding/config in the accounting repo)
   * and can change independently of this contract, same as
   * OnboardingChecklistItem.step_code.
   */
  stepCode: Scalars['String']['output'];
};

/**
 * Represents an accounting setup for an organization with an accountancy practice.
 * Contains fiscal configuration validated by the accountant.
 */
export type QontoAccountingAccountingSetupsFirstpartyV2_AccountingSetup = {
  __typename?: 'QontoAccountingAccountingSetupsFirstpartyV2_AccountingSetup';
  /** UUID of the accountancy practice managing this setup. */
  accountancyPracticeId: Scalars['String']['output'];
  /**
   * Qonto account data for this organization (status, company, stakeholders).
   * Batched via GET /v5/accountancy_practices/organizations keyed on organizationId.
   * Note: a generic `organization` field (v1, user-facing) already exists on this type.
   */
  accountancyPracticeOrganization?: Maybe<QontoRegistrationApiOrganizationsFirstpartyV5_Organization>;
  /** When the setup was activated. */
  activatedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** UUID of the accountant who validated and activated the setup. */
  activatedBy?: Maybe<Scalars['String']['output']>;
  /** When the setup was archived (soft delete). */
  archivedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Creation timestamp. */
  createdAt: Scalars['TimestampProto']['output'];
  /** End of the first fiscal period (YYYY-MM-DD). */
  firstAccountingPeriodEndAt?: Maybe<Scalars['String']['output']>;
  /** Beginning of the first fiscal period (YYYY-MM-DD). */
  firstAccountingPeriodStartAt?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the organization has already filed a declaration. Once it has, the fiscal
   * configuration is frozen: the parameters a filed declaration was computed from can no
   * longer be changed, so patching vat_regime, vat_exigibility or tax_regime is refused.
   * Organization-scoped, and VAT is the only kind of declaration filed today, so it says
   * nothing about which period or obligation was declared.
   */
  hasCompletedDeclaration: Scalars['Boolean']['output'];
  /** Unique identifier for the accounting setup. */
  id: Scalars['String']['output'];
  organization?: Maybe<QontoRegistrationApiOrganizationsFirstpartyV1_Organization>;
  /** UUID of the organization this setup belongs to. */
  organizationId: Scalars['String']['output'];
  /** Bank account ID used for VAT/EDI direct-debit payments (must match the one declared on impots.gouv). */
  paymentBankAccountId?: Maybe<Scalars['String']['output']>;
  /** IBAN used for VAT/EDI direct-debit payments (must match the one declared on impots.gouv). */
  paymentIban?: Maybe<Scalars['String']['output']>;
  /**
   * When the first accounting period dates were confirmed through
   * POST /v2/accounting_setup/validate_period_dates, the call that provisions the accounting
   * period from them. Unset while they are still to be confirmed.
   *
   * It reports that confirmation, not whether the dates are still editable: an organization
   * migrated from another tool already has an accounting period, opened by the migration rather
   * than by the accountant, so its dates are frozen while this stays unset.
   */
  periodDatesValidatedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** EDI ROF reference for corporate property tax (CFE) obligations. */
  rofCfe?: Maybe<Scalars['String']['output']>;
  /** EDI ROF reference for corporate income tax (IS) obligations. */
  rofCorporateTax?: Maybe<Scalars['String']['output']>;
  /** EDI ROF reference for tax return package obligations. */
  rofTaxReturnPackage?: Maybe<Scalars['String']['output']>;
  /** EDI ROF reference for VAT (CA3) obligations. */
  rofVat?: Maybe<Scalars['String']['output']>;
  /** Current status of the accounting setup. */
  status: QontoAccountingAccountingSetupsFirstpartyV2_AccountingSetupStatus;
  /** UUID of the tax memo attachment uploaded by the accountant. */
  taxMemoAttachmentId?: Maybe<Scalars['String']['output']>;
  /** Tax regime (corporate or income). */
  taxRegime: QontoAccountingAccountingSetupsFirstpartyV2_TaxRegime;
  /** Last update timestamp. */
  updatedAt: Scalars['TimestampProto']['output'];
  /** When VAT becomes due. */
  vatExigibility: QontoAccountingAccountingSetupsFirstpartyV2_VatExigibility;
  /** VAT collection regime. */
  vatRegime: QontoAccountingAccountingSetupsFirstpartyV2_VatRegime;
};

/** Status of an accounting setup in its lifecycle. */
export enum QontoAccountingAccountingSetupsFirstpartyV2_AccountingSetupStatus {
  /** Approved status - setup has been validated by accountant. */
  AccountingSetupStatusApproved = 'ACCOUNTING_SETUP_STATUS_APPROVED',
  /** Deprecated status - setup is no longer active. */
  AccountingSetupStatusDeprecated = 'ACCOUNTING_SETUP_STATUS_DEPRECATED',
  /** Pending status - setup is awaiting validation. */
  AccountingSetupStatusPending = 'ACCOUNTING_SETUP_STATUS_PENDING',
  /** Unspecified status. */
  AccountingSetupStatusUnspecified = 'ACCOUNTING_SETUP_STATUS_UNSPECIFIED'
}

/**
 * Request to archive an accounting setup.
 * The organization_id is resolved from the PASETO token.
 */
export type QontoAccountingAccountingSetupsFirstpartyV2_ArchiveAccountingSetupRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response when an accounting setup is successfully archived. */
export type QontoAccountingAccountingSetupsFirstpartyV2_ArchiveAccountingSetupResponse = {
  __typename?: 'QontoAccountingAccountingSetupsFirstpartyV2_ArchiveAccountingSetupResponse';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Filter for archived state. */
export enum QontoAccountingAccountingSetupsFirstpartyV2_ArchivedFilter {
  /** Return only archived setups. */
  ArchivedFilterArchived = 'ARCHIVED_FILTER_ARCHIVED',
  /** Return only non-archived (active) setups. */
  ArchivedFilterNotArchived = 'ARCHIVED_FILTER_NOT_ARCHIVED',
  /** Unspecified - return all setups regardless of archived state. */
  ArchivedFilterUnspecified = 'ARCHIVED_FILTER_UNSPECIFIED'
}

/**
 * Request to create an accounting setup for an organization.
 * If a non-archived setup (pending or approved) already exists for the
 * organization, its fiscal configuration is updated instead of creating
 * a new one (idempotent, mirrors the accounting.accounting-setups Kafka
 * upsert event).
 */
export type QontoAccountingAccountingSetupsFirstpartyV2_CreateAccountingSetupRequestInput = {
  /** UUID of the accountancy practice managing this setup. */
  accountancyPracticeId?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the organization the setup belongs to. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Tax regime (corporate or income). */
  taxRegime?: InputMaybe<QontoAccountingAccountingSetupsFirstpartyV2_TaxRegime>;
  /** When VAT becomes due. */
  vatExigibility?: InputMaybe<QontoAccountingAccountingSetupsFirstpartyV2_VatExigibility>;
  /** VAT collection regime. */
  vatRegime?: InputMaybe<QontoAccountingAccountingSetupsFirstpartyV2_VatRegime>;
};

/** Response when an accounting setup is successfully created or upserted. */
export type QontoAccountingAccountingSetupsFirstpartyV2_CreateAccountingSetupResponse = {
  __typename?: 'QontoAccountingAccountingSetupsFirstpartyV2_CreateAccountingSetupResponse';
  /** The created (or updated) accounting setup. */
  accountingSetup: QontoAccountingAccountingSetupsFirstpartyV2_AccountingSetup;
};

/**
 * Request to retrieve the active accounting setup.
 * No parameters — the organization ID is resolved from the PASETO token.
 */
export type QontoAccountingAccountingSetupsFirstpartyV2_GetActiveAccountingSetupRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response containing the organization's active accounting setup. */
export type QontoAccountingAccountingSetupsFirstpartyV2_GetActiveAccountingSetupResponse = {
  __typename?: 'QontoAccountingAccountingSetupsFirstpartyV2_GetActiveAccountingSetupResponse';
  /** The active accounting setup for the organization resolved from the PASETO token. */
  accountingSetup: QontoAccountingAccountingSetupsFirstpartyV2_AccountingSetup;
};

/** Request to list accounting setups with filters. */
export type QontoAccountingAccountingSetupsFirstpartyV2_ListAccountingSetupsRequestInput = {
  /** Filter by accountancy practice UUID. */
  accountancyPracticeId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by archived state. */
  archived?: InputMaybe<QontoAccountingAccountingSetupsFirstpartyV2_ArchivedFilter>;
  /** Filter by organization UUIDs (comma-separated). */
  organizationIds?: InputMaybe<Scalars['String']['input']>;
  /**
   * Page number to be fetched.
   * Default: 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Number of records per page.
   * Default: 25, Maximum: 100.
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by accounting setup status. */
  status?: InputMaybe<QontoAccountingAccountingSetupsFirstpartyV2_AccountingSetupStatus>;
};

/** Response containing a list of accounting setups and pagination metadata. */
export type QontoAccountingAccountingSetupsFirstpartyV2_ListAccountingSetupsResponse = {
  __typename?: 'QontoAccountingAccountingSetupsFirstpartyV2_ListAccountingSetupsResponse';
  /** List of accounting setups matching the request criteria. */
  accountingSetups: Array<QontoAccountingAccountingSetupsFirstpartyV2_AccountingSetup>;
  /** Pagination metadata. */
  meta: QontoCommon_PaginationMeta;
};

/**
 * Request to partially update an accounting setup.
 * All fields are optional — only provided fields are updated.
 * The tax-setup fields below are editable regardless of setup status, while the
 * fiscal ones (vat_regime, vat_exigibility, tax_regime) remain editable past approval,
 * until the organization files its first declaration; patching one sends the setup
 * back to pending, so revalidating it rebuilds the obligations calendar. The first
 * accounting period bounds follow their own rule: they stay editable until
 * ValidatePeriodDates provisions the accounting period from them, since a provisioned
 * period cannot be moved. Patching either past its window is refused with 422
 * accounting_setup_already_declared and accounting_period_already_provisioned
 * respectively.
 */
export type QontoAccountingAccountingSetupsFirstpartyV2_PatchAccountingSetupRequestInput = {
  /** End of the first fiscal period (YYYY-MM-DD). */
  firstAccountingPeriodEndAt?: InputMaybe<Scalars['String']['input']>;
  /** Beginning of the first fiscal period (YYYY-MM-DD). */
  firstAccountingPeriodStartAt?: InputMaybe<Scalars['String']['input']>;
  /** Bank account ID used for direct-debit payments (must match the one declared on impots.gouv). */
  paymentBankAccountId?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: use payment_bank_account_id instead. */
  paymentIban?: InputMaybe<Scalars['String']['input']>;
  /** EDI ROF reference for corporate property tax (CFE) obligations. */
  rofCfe?: InputMaybe<Scalars['String']['input']>;
  /** EDI ROF reference for corporate income tax (IS) obligations. */
  rofCorporateTax?: InputMaybe<Scalars['String']['input']>;
  /** EDI ROF reference for tax return package obligations. */
  rofTaxReturnPackage?: InputMaybe<Scalars['String']['input']>;
  /** EDI ROF reference for VAT (CA3) obligations. */
  rofVat?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the tax memo attachment uploaded by the accountant. */
  taxMemoAttachmentId?: InputMaybe<Scalars['String']['input']>;
  /** Tax regime (corporate or income). */
  taxRegime?: InputMaybe<QontoAccountingAccountingSetupsFirstpartyV2_TaxRegime>;
  /** When VAT becomes due. */
  vatExigibility?: InputMaybe<QontoAccountingAccountingSetupsFirstpartyV2_VatExigibility>;
  /** VAT collection regime. */
  vatRegime?: InputMaybe<QontoAccountingAccountingSetupsFirstpartyV2_VatRegime>;
};

/** Response when an accounting setup is successfully patched. */
export type QontoAccountingAccountingSetupsFirstpartyV2_PatchAccountingSetupResponse = {
  __typename?: 'QontoAccountingAccountingSetupsFirstpartyV2_PatchAccountingSetupResponse';
  /** The updated accounting setup. */
  accountingSetup: QontoAccountingAccountingSetupsFirstpartyV2_AccountingSetup;
};

/**
 * Request to partially update the caller's accounting setup with the mémento
 * fiscal attachment. Called by the organization owner with a membership-scoped
 * PASETO, so the organization is resolved from the token and no organization_id
 * is passed. Solo counterpart of PatchAccountingSetupRequest, restricted to the
 * only field the owner is allowed to write.
 */
export type QontoAccountingAccountingSetupsFirstpartyV2_PatchSoloAccountingSetupRequestInput = {
  /** UUID of the tax memo (mémento fiscal) attachment uploaded by the owner. */
  taxMemoAttachmentId?: InputMaybe<Scalars['String']['input']>;
};

/** Response when the accounting setup is successfully patched. */
export type QontoAccountingAccountingSetupsFirstpartyV2_PatchSoloAccountingSetupResponse = {
  __typename?: 'QontoAccountingAccountingSetupsFirstpartyV2_PatchSoloAccountingSetupResponse';
  /** The updated accounting setup. */
  accountingSetup: QontoAccountingAccountingSetupsFirstpartyV2_AccountingSetup;
};

/** Tax regime for an organization. */
export enum QontoAccountingAccountingSetupsFirstpartyV2_TaxRegime {
  /** Corporate tax (Impôt sur les Sociétés). */
  TaxRegimeCorporate = 'TAX_REGIME_CORPORATE',
  /** Income tax (Impôt sur le Revenu). */
  TaxRegimeIncome = 'TAX_REGIME_INCOME',
  /** Unspecified tax regime. */
  TaxRegimeUnspecified = 'TAX_REGIME_UNSPECIFIED'
}

/**
 * Request to update an accounting setup's fiscal configuration.
 * All fields are required since this is a full replacement (PUT).
 */
export type QontoAccountingAccountingSetupsFirstpartyV2_UpdateAccountingSetupRequestInput = {
  /** End of the first fiscal period (YYYY-MM-DD). */
  firstAccountingPeriodEndAt?: InputMaybe<Scalars['String']['input']>;
  /** Beginning of the first fiscal period (YYYY-MM-DD). */
  firstAccountingPeriodStartAt?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the organization. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Bank account ID used for direct-debit payments (must match the one declared on impots.gouv). */
  paymentBankAccountId?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: use payment_bank_account_id instead. */
  paymentIban?: InputMaybe<Scalars['String']['input']>;
  /** EDI ROF reference for corporate property tax (CFE) obligations. */
  rofCfe?: InputMaybe<Scalars['String']['input']>;
  /** EDI ROF reference for corporate income tax (IS) obligations. */
  rofCorporateTax?: InputMaybe<Scalars['String']['input']>;
  /** EDI ROF reference for tax return package obligations. */
  rofTaxReturnPackage?: InputMaybe<Scalars['String']['input']>;
  /** EDI ROF reference for VAT (CA3) obligations. */
  rofVat?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the tax memo attachment uploaded by the accountant. */
  taxMemoAttachmentId?: InputMaybe<Scalars['String']['input']>;
  /** Tax regime (corporate or income). */
  taxRegime?: InputMaybe<QontoAccountingAccountingSetupsFirstpartyV2_TaxRegime>;
  /** When VAT becomes due. */
  vatExigibility?: InputMaybe<QontoAccountingAccountingSetupsFirstpartyV2_VatExigibility>;
  /** VAT collection regime. */
  vatRegime?: InputMaybe<QontoAccountingAccountingSetupsFirstpartyV2_VatRegime>;
};

/** Response when an accounting setup is successfully updated. */
export type QontoAccountingAccountingSetupsFirstpartyV2_UpdateAccountingSetupResponse = {
  __typename?: 'QontoAccountingAccountingSetupsFirstpartyV2_UpdateAccountingSetupResponse';
  /** The updated accounting setup. */
  accountingSetup: QontoAccountingAccountingSetupsFirstpartyV2_AccountingSetup;
};

/** Request to validate an accounting setup. */
export type QontoAccountingAccountingSetupsFirstpartyV2_ValidateAccountingSetupRequestInput = {
  /** UUID of the organization. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/** Response when an accounting setup is successfully validated. */
export type QontoAccountingAccountingSetupsFirstpartyV2_ValidateAccountingSetupResponse = {
  __typename?: 'QontoAccountingAccountingSetupsFirstpartyV2_ValidateAccountingSetupResponse';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Request to validate the first accounting period dates of a setup.
 * The dates themselves are not carried here: they are saved beforehand through
 * UpdateAccountingSetup or PatchAccountingSetup, and this call validates and applies
 * the stored ones. A setup carrying no dates has nothing to validate and is refused
 * with 422 accounting_setup_missing_dates.
 */
export type QontoAccountingAccountingSetupsFirstpartyV2_ValidatePeriodDatesRequestInput = {
  /** UUID of the organization. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/** Response when the first accounting period dates are successfully validated. */
export type QontoAccountingAccountingSetupsFirstpartyV2_ValidatePeriodDatesResponse = {
  __typename?: 'QontoAccountingAccountingSetupsFirstpartyV2_ValidatePeriodDatesResponse';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** When VAT becomes due for an organization. */
export enum QontoAccountingAccountingSetupsFirstpartyV2_VatExigibility {
  /** Accrual basis - VAT is due when invoice is issued. */
  VatExigibilityAccrual = 'VAT_EXIGIBILITY_ACCRUAL',
  /** Cash basis - VAT is due when payment is received. */
  VatExigibilityCashBasis = 'VAT_EXIGIBILITY_CASH_BASIS',
  /** Unspecified VAT exigibility. */
  VatExigibilityUnspecified = 'VAT_EXIGIBILITY_UNSPECIFIED'
}

/** VAT collection regime for an organization. */
export enum QontoAccountingAccountingSetupsFirstpartyV2_VatRegime {
  /** Standard monthly - VAT collected and reported monthly. */
  VatRegimeStandardMonthly = 'VAT_REGIME_STANDARD_MONTHLY',
  /** Standard quarterly - VAT collected and reported quarterly. */
  VatRegimeStandardQuarterly = 'VAT_REGIME_STANDARD_QUARTERLY',
  /** Tax exemption - organization is exempt from VAT. */
  VatRegimeTaxExemption = 'VAT_REGIME_TAX_EXEMPTION',
  /** Unspecified VAT regime. */
  VatRegimeUnspecified = 'VAT_REGIME_UNSPECIFIED'
}

/** Represents a single accounting account. */
export type QontoAccountingAccountsFirstpartyV2_Account = {
  __typename?: 'QontoAccountingAccountsFirstpartyV2_Account';
  /**
   * Category of the account.
   * -- For non auxiliary accounts, e.g. "Asset", "Liability", "Equity", "Revenue", "Expense"
   * -- For auxiliary accounts: "Revenue" for a customer account, "Expense" for a supplier/employee account
   */
  category: Scalars['String']['output'];
  /**
   * Code of the account.
   * -- For non auxiliary accounts, e.g.: "401000","411000","606100"
   * -- For auxiliary accounts, e.g.: "S-SupplierName", '401-SupplierName'
   */
  code: Scalars['String']['output'];
  /** Creation timestamp. */
  createdAt: Scalars['TimestampProto']['output'];
  /** Unique identifier for the account. */
  id: Scalars['String']['output'];
  integrationStatus?: Maybe<QontoAccountingIntegrationsAccountsFirstpartyV1_Account>;
  /** Whether the account is auxiliary */
  isAuxiliary: Scalars['Boolean']['output'];
  /** Deprecated. Whether the account is postable -- FALSE for header/roll-up nodes */
  isPostable: Scalars['Boolean']['output'];
  /**
   * Label of the account.
   * -- For non auxiliary accounts, e.g.: "Suppliers","Clients","Unstocked Purchases"
   * -- For auxiliary accounts, e.g.: "Supplier/customer Name"
   */
  label: Scalars['String']['output'];
  /** Origin of the account. */
  source: QontoAccountingAccountsFirstpartyV2_AccountSource;
  /** Update timestamp. */
  updatedAt: Scalars['TimestampProto']['output'];
};

/** Represents a single accounting account. */
export type QontoAccountingAccountsFirstpartyV2_AccountInput = {
  /**
   * Category of the account.
   * -- For non auxiliary accounts, e.g. "Asset", "Liability", "Equity", "Revenue", "Expense"
   * -- For auxiliary accounts: "Revenue" for a customer account, "Expense" for a supplier/employee account
   */
  category?: InputMaybe<Scalars['String']['input']>;
  /**
   * Code of the account.
   * -- For non auxiliary accounts, e.g.: "401000","411000","606100"
   * -- For auxiliary accounts, e.g.: "S-SupplierName", '401-SupplierName'
   */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Creation timestamp. */
  createdAt: Scalars['TimestampProto']['input'];
  /** Unique identifier for the account. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Whether the account is auxiliary */
  isAuxiliary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated. Whether the account is postable -- FALSE for header/roll-up nodes */
  isPostable?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Label of the account.
   * -- For non auxiliary accounts, e.g.: "Suppliers","Clients","Unstocked Purchases"
   * -- For auxiliary accounts, e.g.: "Supplier/customer Name"
   */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Origin of the account. */
  source?: InputMaybe<QontoAccountingAccountsFirstpartyV2_AccountSource>;
  /** Update timestamp. */
  updatedAt: Scalars['TimestampProto']['input'];
};

/** Indicates the origin of an account. */
export enum QontoAccountingAccountsFirstpartyV2_AccountSource {
  /** Account created via automatic provisioning. */
  AccountSourceProvisioning = 'ACCOUNT_SOURCE_PROVISIONING',
  /** Account created from a default template. */
  AccountSourceTemplate = 'ACCOUNT_SOURCE_TEMPLATE',
  /** No source specified or unknown. */
  AccountSourceUnspecified = 'ACCOUNT_SOURCE_UNSPECIFIED',
  /** Account created manually by the user. */
  AccountSourceUser = 'ACCOUNT_SOURCE_USER'
}

/**
 * Request to list accounts for the given active accounting period with filter 'is_auxiliary' and pagination.
 * Organization ID is extracted from PASETO of the authenticated user.
 * If there is no active accounting period, returns an empty list.
 */
export type QontoAccountingAccountsFirstpartyV2_ListAccountsRequest = {
  __typename?: 'QontoAccountingAccountsFirstpartyV2_ListAccountsRequest';
  /** Filter by category. Is string format since is coming from query params. */
  category?: Maybe<Scalars['String']['output']>;
  /** Filter by given account ids. */
  ids?: Maybe<Scalars['String']['output']>;
  /** Whether the account is auxiliary. */
  isAuxiliary?: Maybe<Scalars['String']['output']>;
  /**
   * Page number to be fetched.
   * Default: 1.
   */
  page?: Maybe<Scalars['Int']['output']>;
  /**
   * Number of records per page.
   * Default: 25, Maximum: 100.
   */
  perPage?: Maybe<Scalars['Int']['output']>;
  /** Search query for code or label (case and accent insensitive, min 2 chars). */
  search?: Maybe<Scalars['String']['output']>;
};

/**
 * Request to list accounts for the given active accounting period with filter 'is_auxiliary' and pagination.
 * Organization ID is extracted from PASETO of the authenticated user.
 * If there is no active accounting period, returns an empty list.
 */
export type QontoAccountingAccountsFirstpartyV2_ListAccountsRequestInput = {
  /** Filter by category. Is string format since is coming from query params. */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Filter by given account ids. */
  ids?: InputMaybe<Scalars['String']['input']>;
  /** Whether the account is auxiliary. */
  isAuxiliary?: InputMaybe<Scalars['String']['input']>;
  /**
   * Page number to be fetched.
   * Default: 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Number of records per page.
   * Default: 25, Maximum: 100.
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Search query for code or label (case and accent insensitive, min 2 chars). */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Response containing a list of accounts and pagination metadata. */
export type QontoAccountingAccountsFirstpartyV2_ListAccountsResponse = {
  __typename?: 'QontoAccountingAccountsFirstpartyV2_ListAccountsResponse';
  /** List of accounting accounts matching the request criteria. */
  accounts: Array<QontoAccountingAccountsFirstpartyV2_Account>;
  /** Pagination metadata. */
  meta: QontoAccountingAccountsFirstpartyV2_Meta;
};

/** Response containing a list of accounts and pagination metadata. */
export type QontoAccountingAccountsFirstpartyV2_ListAccountsResponseInput = {
  /** List of accounting accounts matching the request criteria. */
  accounts?: InputMaybe<Array<QontoAccountingAccountsFirstpartyV2_AccountInput>>;
  /** Pagination metadata. */
  meta: QontoAccountingAccountsFirstpartyV2_MetaInput;
};

/** Metadata for pagination. */
export type QontoAccountingAccountsFirstpartyV2_Meta = {
  __typename?: 'QontoAccountingAccountsFirstpartyV2_Meta';
  /** Current page number. */
  currentPage: Scalars['Int']['output'];
  /** Next page number (null if last page). */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** Number of records per page. */
  perPage: Scalars['Int']['output'];
  /** Previous page number (null if first page). */
  prevPage?: Maybe<Scalars['Int']['output']>;
  /** Total number of records matching the filters. */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** Metadata for pagination. */
export type QontoAccountingAccountsFirstpartyV2_MetaInput = {
  /** Current page number. */
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  /** Next page number (null if last page). */
  nextPage?: InputMaybe<Scalars['Int']['input']>;
  /** Number of records per page. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Previous page number (null if first page). */
  prevPage?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of records matching the filters. */
  totalCount?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of pages. */
  totalPages?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Minimal Account information returned in responses.
 * Avoids additional fetches for UI display.
 */
export type QontoAccountingEntriesFirstpartyV2_Account = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_Account';
  /** Account category (e.g., "asset", "liability", "equity", "revenue", "expense"). */
  category: Scalars['String']['output'];
  /** Account code (e.g., "411FOO", "401BAR"). */
  code: Scalars['String']['output'];
  /** Timestamp when this account was created. */
  createdAt: Scalars['TimestampProto']['output'];
  /** Unique identifier for the account (UUID). */
  id: Scalars['String']['output'];
  /** Indicates if this is an auxiliary account. TRUE when third_party is required (e.g., AR/AP) */
  isAuxiliary: Scalars['Boolean']['output'];
  /** Indicates if this account was soft-deleted. TRUE if the account is deleted but kept for historical integrity, FALSE otherwise. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Deprecated. Indicates if this account can be used for posting entries. DEFAULT TRUE, FALSE for header/roll-up nodes */
  isPostable: Scalars['Boolean']['output'];
  /** Account label/name (e.g., "FOO SARL", "BAR SAS"). */
  label: Scalars['String']['output'];
  /** Timestamp when this account was last updated. */
  updatedAt: Scalars['TimestampProto']['output'];
};

/**
 * Minimal Account information returned in responses.
 * Avoids additional fetches for UI display.
 */
export type QontoAccountingEntriesFirstpartyV2_AccountInput = {
  /** Account category (e.g., "asset", "liability", "equity", "revenue", "expense"). */
  category?: InputMaybe<Scalars['String']['input']>;
  /** Account code (e.g., "411FOO", "401BAR"). */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when this account was created. */
  createdAt: Scalars['TimestampProto']['input'];
  /** Unique identifier for the account (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if this is an auxiliary account. TRUE when third_party is required (e.g., AR/AP) */
  isAuxiliary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if this account was soft-deleted. TRUE if the account is deleted but kept for historical integrity, FALSE otherwise. */
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated. Indicates if this account can be used for posting entries. DEFAULT TRUE, FALSE for header/roll-up nodes */
  isPostable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Account label/name (e.g., "FOO SARL", "BAR SAS"). */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when this account was last updated. */
  updatedAt: Scalars['TimestampProto']['input'];
};

/** Filter balance status. */
export enum QontoAccountingEntriesFirstpartyV2_BalanceStatusFilter {
  /** Filter by balanced entries. */
  BalanceStatusFilterBalanced = 'BALANCE_STATUS_FILTER_BALANCED',
  /** Filter by unbalanced entries. */
  BalanceStatusFilterUnbalanced = 'BALANCE_STATUS_FILTER_UNBALANCED',
  /** Default - no filter applied. */
  BalanceStatusFilterUnspecified = 'BALANCE_STATUS_FILTER_UNSPECIFIED'
}

/** Cash-flow direction of a ledger entry. */
export enum QontoAccountingEntriesFirstpartyV2_CashFlow {
  /** Money flowing into the organization (e.g., customer invoices, supplier credit notes). */
  CashFlowInflow = 'CASH_FLOW_INFLOW',
  /** Money flowing out of the organization (e.g., supplier invoices, expenses). */
  CashFlowOutflow = 'CASH_FLOW_OUTFLOW',
  /** Unspecified or unknown cash-flow direction. */
  CashFlowUnspecified = 'CASH_FLOW_UNSPECIFIED'
}

/** State of a ledger entry in its lifecycle. */
export enum QontoAccountingEntriesFirstpartyV2_EntryStatus {
  /** Draft status. */
  EntryStatusDraft = 'ENTRY_STATUS_DRAFT',
  /** Exported status. */
  EntryStatusExported = 'ENTRY_STATUS_EXPORTED',
  /** Exporting status. */
  EntryStatusExporting = 'ENTRY_STATUS_EXPORTING',
  /** Rejected status - the export was attempted but failed. */
  EntryStatusRejected = 'ENTRY_STATUS_REJECTED',
  /** Unspecified status. */
  EntryStatusUnspecified = 'ENTRY_STATUS_UNSPECIFIED',
  /** Validated status. TODO - MVP transition - This status will be removed in the future (once the contract is fully implemented). */
  EntryStatusValidated = 'ENTRY_STATUS_VALIDATED',
  /** Verified status - replacing VALIDATED status. */
  EntryStatusVerified = 'ENTRY_STATUS_VERIFIED'
}

/** Filter by document type. */
export enum QontoAccountingEntriesFirstpartyV2_ExcludeDocumentTypes {
  /** Filter for manual entries. */
  ExcludeDocumentTypesManual = 'EXCLUDE_DOCUMENT_TYPES_MANUAL',
  /** Unspecified document type filter. */
  ExcludeDocumentTypesUnspecified = 'EXCLUDE_DOCUMENT_TYPES_UNSPECIFIED'
}

/** Custom errors for the GetEntries endpoint. */
export enum QontoAccountingEntriesFirstpartyV2_GetEntriesError {
  /** Invalid pagination parameters (page < 1 or per_page > 100). */
  GetEntriesErrorInvalidPagination = 'GET_ENTRIES_ERROR_INVALID_PAGINATION',
  /** invalid status filter. */
  GetEntriesErrorInvalidStatusFilter = 'GET_ENTRIES_ERROR_INVALID_STATUS_FILTER',
  /** The user does not have permission to view entries for this organization. */
  GetEntriesErrorPermissionDenied = 'GET_ENTRIES_ERROR_PERMISSION_DENIED',
  /** Unspecified error. */
  GetEntriesErrorUnspecified = 'GET_ENTRIES_ERROR_UNSPECIFIED'
}

/**
 * Request to retrieve ledger entries with enriched data.
 * Organization ID is extracted from PASETO of the authenticated user.
 */
export type QontoAccountingEntriesFirstpartyV2_GetEntriesRequest = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_GetEntriesRequest';
  /** Filter by given account ids. */
  accountIds?: Maybe<Scalars['String']['output']>;
  /** Exclude document types from the results. */
  excludeDocumentTypes?: Maybe<QontoAccountingEntriesFirstpartyV2_ExcludeDocumentTypes>;
  /**
   * Include only entries matching the given document types. Comma separated.
   * Allowed values: transaction, supplier_invoice, customer_credit_note,
   * expense, receivable_invoice, supplier_credit_note, manual_correction,
   * uncategorized.
   * Mutually exclusive with exclude_document_types — do not set both.
   */
  includeDocumentTypes?: Maybe<Scalars['String']['output']>;
  /** Filter by reconciliation status. */
  isReconciled?: Maybe<QontoAccountingEntriesFirstpartyV2_ReconciliationStatusFilter>;
  /** Filter by given journal ids. */
  journalIds?: Maybe<Scalars['String']['output']>;
  /** Comma separated ids to filter by ledger entry ids */
  ledgerEntryIds?: Maybe<Scalars['String']['output']>;
  /**
   * Page number to be fetched.
   * Default: 1.
   */
  page?: Maybe<Scalars['Int']['output']>;
  /**
   * Number of records per page.
   * Default: 25, Maximum: 100.
   */
  perPage?: Maybe<Scalars['Int']['output']>;
  /** Filter by record date range start (YYYY-MM-DD). Inclusive. */
  recordDateFrom?: Maybe<Scalars['String']['output']>;
  /** Filter by record date range end (YYYY-MM-DD). Inclusive. */
  recordDateTo?: Maybe<Scalars['String']['output']>;
  /** Sorting option for the entries. */
  sortBy?: Maybe<QontoAccountingEntriesFirstpartyV2_SortBy>;
  /** Filter by entries status. */
  status?: Maybe<QontoAccountingEntriesFirstpartyV2_StatusFilter>;
  /** Comma separated statuses to filter from */
  statuses?: Maybe<Scalars['String']['output']>;
};

/**
 * Request to retrieve ledger entries with enriched data.
 * Organization ID is extracted from PASETO of the authenticated user.
 */
export type QontoAccountingEntriesFirstpartyV2_GetEntriesRequestInput = {
  /** Filter by given account ids. */
  accountIds?: InputMaybe<Scalars['String']['input']>;
  /** Exclude document types from the results. */
  excludeDocumentTypes?: InputMaybe<QontoAccountingEntriesFirstpartyV2_ExcludeDocumentTypes>;
  /**
   * Include only entries matching the given document types. Comma separated.
   * Allowed values: transaction, supplier_invoice, customer_credit_note,
   * expense, receivable_invoice, supplier_credit_note, manual_correction,
   * uncategorized.
   * Mutually exclusive with exclude_document_types — do not set both.
   */
  includeDocumentTypes?: InputMaybe<Scalars['String']['input']>;
  /** Filter by reconciliation status. */
  isReconciled?: InputMaybe<QontoAccountingEntriesFirstpartyV2_ReconciliationStatusFilter>;
  /** Filter by given journal ids. */
  journalIds?: InputMaybe<Scalars['String']['input']>;
  /** Comma separated ids to filter by ledger entry ids */
  ledgerEntryIds?: InputMaybe<Scalars['String']['input']>;
  /**
   * Page number to be fetched.
   * Default: 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Number of records per page.
   * Default: 25, Maximum: 100.
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by record date range start (YYYY-MM-DD). Inclusive. */
  recordDateFrom?: InputMaybe<Scalars['String']['input']>;
  /** Filter by record date range end (YYYY-MM-DD). Inclusive. */
  recordDateTo?: InputMaybe<Scalars['String']['input']>;
  /** Sorting option for the entries. */
  sortBy?: InputMaybe<QontoAccountingEntriesFirstpartyV2_SortBy>;
  /** Filter by entries status. */
  status?: InputMaybe<QontoAccountingEntriesFirstpartyV2_StatusFilter>;
  /** Comma separated statuses to filter from */
  statuses?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response containing ledger entries with enriched data.
 * All entries include embedded Account and Journal objects.
 */
export type QontoAccountingEntriesFirstpartyV2_GetEntriesResponse = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_GetEntriesResponse';
  /**
   * List of ledger entries with enriched data.
   * Each entry includes:
   * - Embedded Journal object (id, code, name, type)
   * - Embedded Account objects in all lines (id, code, label, category)
   */
  entries: Array<QontoAccountingEntriesFirstpartyV2_LedgerEntryEnriched>;
  /** Pagination metadata. */
  meta: QontoAccountingEntriesFirstpartyV2_Meta;
};

/**
 * Response containing ledger entries with enriched data.
 * All entries include embedded Account and Journal objects.
 */
export type QontoAccountingEntriesFirstpartyV2_GetEntriesResponseInput = {
  /**
   * List of ledger entries with enriched data.
   * Each entry includes:
   * - Embedded Journal object (id, code, name, type)
   * - Embedded Account objects in all lines (id, code, label, category)
   */
  entries?: InputMaybe<Array<QontoAccountingEntriesFirstpartyV2_LedgerEntryEnrichedInput>>;
  /** Pagination metadata. */
  meta: QontoAccountingEntriesFirstpartyV2_MetaInput;
};

/** Custom errors for the GetReconciledEntries endpoint. */
export enum QontoAccountingEntriesFirstpartyV2_GetReconciledEntriesError {
  /** Invalid filter. */
  GetReconciledEntriesErrorInvalidFilter = 'GET_RECONCILED_ENTRIES_ERROR_INVALID_FILTER',
  /** Invalid pagination parameters (page < 1 or per_page > 100). */
  GetReconciledEntriesErrorInvalidPagination = 'GET_RECONCILED_ENTRIES_ERROR_INVALID_PAGINATION',
  /** The user does not have permission to view entries for this organization. */
  GetReconciledEntriesErrorPermissionDenied = 'GET_RECONCILED_ENTRIES_ERROR_PERMISSION_DENIED',
  /** Unspecified error. */
  GetReconciledEntriesErrorUnspecified = 'GET_RECONCILED_ENTRIES_ERROR_UNSPECIFIED'
}

/**
 * Request to retrieve ledger entries grouped by reconciliations with enriched data.
 * Organization ID is extracted from PASETO of the authenticated user.
 */
export type QontoAccountingEntriesFirstpartyV2_GetReconciledEntriesRequest = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_GetReconciledEntriesRequest';
  /**
   * Filter by given account ids.
   * Comma separated account IDs.
   */
  accountIds?: Maybe<Scalars['String']['output']>;
  /** Filter by accounting date range start (YYYY-MM-DD). Inclusive. */
  accountingDateFrom?: Maybe<Scalars['String']['output']>;
  /** Filter by accounting date range end (YYYY-MM-DD). Inclusive. */
  accountingDateTo?: Maybe<Scalars['String']['output']>;
  /** Filter by balance status. */
  isBalanced?: Maybe<QontoAccountingEntriesFirstpartyV2_BalanceStatusFilter>;
  /** Filter by reconciliation status. */
  isReconciled?: Maybe<QontoAccountingEntriesFirstpartyV2_ReconciliationStatusFilter>;
  /**
   * Filter by given journal ids.
   * Comma separated journal IDs.
   */
  journalIds?: Maybe<Scalars['String']['output']>;
  /** Filter by obligation id. */
  obligationId?: Maybe<Scalars['String']['output']>;
  /**
   * Page number to be fetched.
   * Default: 1.
   */
  page?: Maybe<Scalars['Int']['output']>;
  /**
   * Number of records per page.
   * Default: 25, Maximum: 100.
   */
  perPage?: Maybe<Scalars['Int']['output']>;
  /** Filter by free text search */
  search?: Maybe<Scalars['String']['output']>;
  /**
   * Filter by entries status (draft, verified, exported, etc.).
   * Comma separated statuses to filter from
   */
  statuses?: Maybe<Scalars['String']['output']>;
};

/**
 * Request to retrieve ledger entries grouped by reconciliations with enriched data.
 * Organization ID is extracted from PASETO of the authenticated user.
 */
export type QontoAccountingEntriesFirstpartyV2_GetReconciledEntriesRequestInput = {
  /**
   * Filter by given account ids.
   * Comma separated account IDs.
   */
  accountIds?: InputMaybe<Scalars['String']['input']>;
  /** Filter by accounting date range start (YYYY-MM-DD). Inclusive. */
  accountingDateFrom?: InputMaybe<Scalars['String']['input']>;
  /** Filter by accounting date range end (YYYY-MM-DD). Inclusive. */
  accountingDateTo?: InputMaybe<Scalars['String']['input']>;
  /** Filter by balance status. */
  isBalanced?: InputMaybe<QontoAccountingEntriesFirstpartyV2_BalanceStatusFilter>;
  /** Filter by reconciliation status. */
  isReconciled?: InputMaybe<QontoAccountingEntriesFirstpartyV2_ReconciliationStatusFilter>;
  /**
   * Filter by given journal ids.
   * Comma separated journal IDs.
   */
  journalIds?: InputMaybe<Scalars['String']['input']>;
  /** Filter by obligation id. */
  obligationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Page number to be fetched.
   * Default: 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Number of records per page.
   * Default: 25, Maximum: 100.
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by free text search */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter by entries status (draft, verified, exported, etc.).
   * Comma separated statuses to filter from
   */
  statuses?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response containing reconciled ledger entries with enriched data.
 * All entries include embedded Account, Journal objects and reconciliation status.
 */
export type QontoAccountingEntriesFirstpartyV2_GetReconciledEntriesResponse = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_GetReconciledEntriesResponse';
  /** List of ledger entries grouped by reconciliations with enriched data. */
  entries: Array<QontoAccountingEntriesFirstpartyV2_LedgerEntryReconciled>;
  /** Pagination metadata. */
  meta: QontoAccountingEntriesFirstpartyV2_Meta;
};

/**
 * Response containing reconciled ledger entries with enriched data.
 * All entries include embedded Account, Journal objects and reconciliation status.
 */
export type QontoAccountingEntriesFirstpartyV2_GetReconciledEntriesResponseInput = {
  /** List of ledger entries grouped by reconciliations with enriched data. */
  entries?: InputMaybe<Array<QontoAccountingEntriesFirstpartyV2_LedgerEntryReconciledInput>>;
  /** Pagination metadata. */
  meta: QontoAccountingEntriesFirstpartyV2_MetaInput;
};

/**
 * Minimal Journal information returned in responses.
 * Avoids additional fetches for UI display.
 */
export type QontoAccountingEntriesFirstpartyV2_Journal = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_Journal';
  /** Journal code (e.g., "VE", "AC"). */
  code: Scalars['String']['output'];
  /** Timestamp when this journal was created. */
  createdAt: Scalars['TimestampProto']['output'];
  /** Unique identifier for the Journal (UUID). */
  id: Scalars['String']['output'];
  /** Indicates if this journal was soft-deleted. TRUE if the account is deleted but kept for historical integrity, FALSE otherwise. */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Journal name (e.g., "Ventes"). */
  name: Scalars['String']['output'];
  /** Journal type (e.g., "sales","purchases","cash_bank","general","misc", "cash"). */
  type: Scalars['String']['output'];
  /** Timestamp when this journal was last updated. */
  updatedAt: Scalars['TimestampProto']['output'];
};

/**
 * Minimal Journal information returned in responses.
 * Avoids additional fetches for UI display.
 */
export type QontoAccountingEntriesFirstpartyV2_JournalInput = {
  /** Journal code (e.g., "VE", "AC"). */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when this journal was created. */
  createdAt: Scalars['TimestampProto']['input'];
  /** Unique identifier for the Journal (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if this journal was soft-deleted. TRUE if the account is deleted but kept for historical integrity, FALSE otherwise. */
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Journal name (e.g., "Ventes"). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Journal type (e.g., "sales","purchases","cash_bank","general","misc", "cash"). */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when this journal was last updated. */
  updatedAt: Scalars['TimestampProto']['input'];
};

/**
 * Enriched ledger entry with embedded Journal and Account objects.
 * Used in responses for new endpoints that provide GraphQL-ready data.
 * Facilitates frontend consumption and future GraphQL migration.
 */
export type QontoAccountingEntriesFirstpartyV2_LedgerEntryEnriched = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_LedgerEntryEnriched';
  /**
   * Accounting date (FEC EcritureDate). Drives period recognition.
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented) - replaced by record_date.
   */
  accountingDate: Scalars['String']['output'];
  /** Accounting gross amount (total including tax) in accounting currency. */
  accountingIncludingTaxAmount: QontoCommon_CurrencyAmount;
  /**
   * Accounting period this entry belongs to (e.g., "2025 Fiscal Year").
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  accountingPeriodId: Scalars['String']['output'];
  /** Total VAT amount in accounting currency. */
  accountingTaxAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /**
   * Optional: Attachment (PDF/image) linked to this entry.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  attachmentId?: Maybe<Scalars['String']['output']>;
  /** Cash-flow direction of the entry (inflow, outflow, or unspecified). */
  cashFlow: QontoAccountingEntriesFirstpartyV2_CashFlow;
  /** Counter party name, either third party name or bank account name. */
  counterPartyName: Scalars['String']['output'];
  /** Timestamp when this entry was created. */
  createdAt: Scalars['TimestampProto']['output'];
  /**
   * Accounts shown in the UI "Account" column for this entry.
   * Derived from non-deleted entry lines (lines[].account), filtered by journal type and account category:
   * - journal.type = "cash_bank": asset/liability/equity
   * - otherwise: expense/revenue
   */
  displayedAccounts: Array<QontoAccountingEntriesFirstpartyV2_Account>;
  /**
   * Optional: Document currency (ISO 4217). Example: "EUR".
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentCurrency?: Maybe<Scalars['String']['output']>;
  /**
   * Optional: Date on the original document.
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentDate?: Maybe<Scalars['String']['output']>;
  /**
   * Optional: Due date from the original document (for AR/AP tracking).
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentDueDate?: Maybe<Scalars['String']['output']>;
  /**
   * Optional: Document gross amount (total including tax).
   * Snapshot from original document for display/export.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented) - replaced by document_including_tax_amount.
   */
  documentGrossAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Including tax amount (total including tax) - signed amount. */
  documentIncludingTaxAmount: QontoCommon_CurrencyAmount;
  /**
   * Optional: Document net amount (total excluding tax).
   * Snapshot from original document for display/export.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentNetAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /**
   * Optional: Document reference number (e.g., invoice number "INV-2025-042").
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Total VAT amount for this entry (sum of all tax amounts from lines).
   * Required for UI display and export (e.g., FEC, IDEA).
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentTaxAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Type of document this entry is based on (e.g., "invoice", "receipt"). */
  documentType: Scalars['String']['output'];
  /**
   * Entry title shown in the UI, derived from counter_party_name or transaction_title of bank operation.
   * TODO: remove nullability in the Post-QA phase of https://www.notion.so/qonto/VE-Entries-detail-view-iteration-31e31ee4c6968023a4b6dac0c3012e84?source=copy_link
   */
  entryTitle?: Maybe<Scalars['String']['output']>;
  /** Optional: Timestamp when the entry transitioned to ENTRY_STATUS_EXPORTED. */
  exportedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Unique identifier for the ledger entry (UUID). */
  id: Scalars['String']['output'];
  integrationStatus?: Maybe<QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntry>;
  /**
   * Internal reference within the period (e.g., "2025-001", "2025-002").
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  internalReference?: Maybe<Scalars['String']['output']>;
  /**
   * Journal this entry belongs to.
   * Embedded journal object with code, name, type, etc.
   */
  journal: QontoAccountingEntriesFirstpartyV2_Journal;
  /**
   * Optional: Timestamp of the last verification attempt.
   * NULL = never attempted
   * NON-NULL = at least one attempt was made
   */
  lastVerifiedAttemptAt?: Maybe<Scalars['TimestampProto']['output']>;
  /**
   * All accounting lines (postings) with embedded account details.
   * In double-entry bookkeeping: sum(debit lines) = sum(credit lines).
   */
  lines: Array<QontoAccountingEntriesFirstpartyV2_LedgerEntryLineEnriched>;
  /** Organization that owns this entry. */
  organizationId: Scalars['String']['output'];
  /**
   * Validation/booking date (FEC ValidDate). Must be filled when state='completed' (DB check below).
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  postingDate?: Maybe<Scalars['String']['output']>;
  /** Reconciliation items for the ledger entries. */
  reconciliations: Array<QontoAccountingEntriesFirstpartyV2_ReconciliationItem>;
  /**
   * Record date (FEC EcritureDate). Drives period recognition.
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   */
  recordDate: Scalars['String']['output'];
  /**
   * Reference content based on entry type, generated in the following way:
   *  - Bank entries == Transaction title + Operation date + Total amount in original Currency
   *  - Sales entry == Client name + Invoice date + Total amount in original Currency
   *  - Purchase entry == Supplier name + Invoice date + Total amount in original Currency
   *  - Expense entry == Expense title + Request date + Total amount in original Currency
   * Can be modified by the user.
   */
  reference?: Maybe<Scalars['String']['output']>;
  /**
   * Current status of the entry (draft, verified, exporting, exported).
   * Reuses EntryStatus enum from ledger_entry.proto
   */
  status: QontoAccountingEntriesFirstpartyV2_EntryStatus;
  /** Timestamp when this entry was last updated. */
  updatedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /**
   * Optional: Timestamp when completion occurred.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented)
   */
  validatedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /**
   * Optional: Who completed (user/email/system).
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented)
   */
  validatedBy?: Maybe<Scalars['String']['output']>;
  /** Optional note attached during verification. */
  verificationNote?: Maybe<Scalars['String']['output']>;
};

/**
 * Enriched ledger entry with embedded Journal and Account objects.
 * Used in responses for new endpoints that provide GraphQL-ready data.
 * Facilitates frontend consumption and future GraphQL migration.
 */
export type QontoAccountingEntriesFirstpartyV2_LedgerEntryEnrichedInput = {
  /**
   * Accounting date (FEC EcritureDate). Drives period recognition.
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented) - replaced by record_date.
   */
  accountingDate?: InputMaybe<Scalars['String']['input']>;
  /** Accounting gross amount (total including tax) in accounting currency. */
  accountingIncludingTaxAmount: QontoCommon_CurrencyAmountInput;
  /**
   * Accounting period this entry belongs to (e.g., "2025 Fiscal Year").
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  accountingPeriodId?: InputMaybe<Scalars['String']['input']>;
  /** Total VAT amount in accounting currency. */
  accountingTaxAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /**
   * Optional: Attachment (PDF/image) linked to this entry.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  /** Cash-flow direction of the entry (inflow, outflow, or unspecified). */
  cashFlow?: InputMaybe<QontoAccountingEntriesFirstpartyV2_CashFlow>;
  /** Counter party name, either third party name or bank account name. */
  counterPartyName?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when this entry was created. */
  createdAt: Scalars['TimestampProto']['input'];
  /**
   * Accounts shown in the UI "Account" column for this entry.
   * Derived from non-deleted entry lines (lines[].account), filtered by journal type and account category:
   * - journal.type = "cash_bank": asset/liability/equity
   * - otherwise: expense/revenue
   */
  displayedAccounts?: InputMaybe<Array<QontoAccountingEntriesFirstpartyV2_AccountInput>>;
  /**
   * Optional: Document currency (ISO 4217). Example: "EUR".
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentCurrency?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional: Date on the original document.
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional: Due date from the original document (for AR/AP tracking).
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentDueDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional: Document gross amount (total including tax).
   * Snapshot from original document for display/export.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented) - replaced by document_including_tax_amount.
   */
  documentGrossAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Including tax amount (total including tax) - signed amount. */
  documentIncludingTaxAmount: QontoCommon_CurrencyAmountInput;
  /**
   * Optional: Document net amount (total excluding tax).
   * Snapshot from original document for display/export.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentNetAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /**
   * Optional: Document reference number (e.g., invoice number "INV-2025-042").
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * Total VAT amount for this entry (sum of all tax amounts from lines).
   * Required for UI display and export (e.g., FEC, IDEA).
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  documentTaxAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Type of document this entry is based on (e.g., "invoice", "receipt"). */
  documentType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Entry title shown in the UI, derived from counter_party_name or transaction_title of bank operation.
   * TODO: remove nullability in the Post-QA phase of https://www.notion.so/qonto/VE-Entries-detail-view-iteration-31e31ee4c6968023a4b6dac0c3012e84?source=copy_link
   */
  entryTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Timestamp when the entry transitioned to ENTRY_STATUS_EXPORTED. */
  exportedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** Unique identifier for the ledger entry (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * Internal reference within the period (e.g., "2025-001", "2025-002").
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  internalReference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Journal this entry belongs to.
   * Embedded journal object with code, name, type, etc.
   */
  journal: QontoAccountingEntriesFirstpartyV2_JournalInput;
  /**
   * Optional: Timestamp of the last verification attempt.
   * NULL = never attempted
   * NON-NULL = at least one attempt was made
   */
  lastVerifiedAttemptAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /**
   * All accounting lines (postings) with embedded account details.
   * In double-entry bookkeeping: sum(debit lines) = sum(credit lines).
   */
  lines?: InputMaybe<Array<QontoAccountingEntriesFirstpartyV2_LedgerEntryLineEnrichedInput>>;
  /** Organization that owns this entry. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Validation/booking date (FEC ValidDate). Must be filled when state='completed' (DB check below).
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented).
   */
  postingDate?: InputMaybe<Scalars['String']['input']>;
  /** Reconciliation items for the ledger entries. */
  reconciliations?: InputMaybe<Array<QontoAccountingEntriesFirstpartyV2_ReconciliationItemInput>>;
  /**
   * Record date (FEC EcritureDate). Drives period recognition.
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   */
  recordDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Reference content based on entry type, generated in the following way:
   *  - Bank entries == Transaction title + Operation date + Total amount in original Currency
   *  - Sales entry == Client name + Invoice date + Total amount in original Currency
   *  - Purchase entry == Supplier name + Invoice date + Total amount in original Currency
   *  - Expense entry == Expense title + Request date + Total amount in original Currency
   * Can be modified by the user.
   */
  reference?: InputMaybe<Scalars['String']['input']>;
  /**
   * Current status of the entry (draft, verified, exporting, exported).
   * Reuses EntryStatus enum from ledger_entry.proto
   */
  status?: InputMaybe<QontoAccountingEntriesFirstpartyV2_EntryStatus>;
  /** Timestamp when this entry was last updated. */
  updatedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /**
   * Optional: Timestamp when completion occurred.
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented)
   */
  validatedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /**
   * Optional: Who completed (user/email/system).
   * TODO - MVP transition - This field will be removed in the future (once the contract is fully implemented)
   */
  validatedBy?: InputMaybe<Scalars['String']['input']>;
  /** Optional note attached during verification. */
  verificationNote?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Enriched ledger entry line with embedded Account objects.
 * Used in responses to provide immediate account details without additional fetches.
 */
export type QontoAccountingEntriesFirstpartyV2_LedgerEntryLineEnriched = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_LedgerEntryLineEnriched';
  /**
   * Account this line posts to (charge account from chart of accounts).
   * Optional in response to cover cases where account cannot be assigned.
   * Embedded account object with code, label, category, etc.
   */
  account?: Maybe<QontoAccountingEntriesFirstpartyV2_Account>;
  /** Amount for this line. */
  amount: QontoCommon_CurrencyAmount;
  /**
   * Auxiliary account (subledger account, e.g., for AR/AP tracking).
   * Optional in response as some lines may not have an auxiliary account.
   * Embedded account object with code, label, category, etc.
   */
  auxiliaryAccount?: Maybe<QontoAccountingEntriesFirstpartyV2_Account>;
  /**
   * Optional: Category key associated with the line's account (e.g., "office_supplies").
   * Expected on expense and revenue lines.
   */
  categoryKey?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the line (UUID). */
  id: Scalars['String']['output'];
  /**
   * Optional: Line label (used as FEC EcritureLib when present). Example: "Translations French to Italian"
   * TODO - MVP transition - this field will be removed in the future (once the contract is fully implemented).
   */
  label?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the line represents a tax, balance sheet, or expense/revenue posting. */
  lineType?: Maybe<QontoAccountingEntriesFirstpartyV2_LineType>;
  /** Optional: Tax base amount for this line. */
  taxBaseAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /**
   * Optional: VAT/withholding/other tax code for this line (nullable)
   * TODO - MVP transition - this field will be removed in the future (once the contract is fully implemented).
   */
  taxCodeId?: Maybe<Scalars['String']['output']>;
  /**
   * Optional: Tax deductibility rate percent for the line - only for tax lines.
   * Represents the percentage of the tax amount that is deductible (e.g., "100.00" for fully deductible).
   */
  taxDeductibilityRatePercent?: Maybe<Scalars['String']['output']>;
  /** Used to determine the tax rate percent for the line - only for tax lines. */
  taxRatePercent?: Maybe<Scalars['String']['output']>;
  /** Used to determine the way of the line (D - for debit or C - for credit). */
  way: Scalars['String']['output'];
};

/**
 * Enriched ledger entry line with embedded Account objects.
 * Used in responses to provide immediate account details without additional fetches.
 */
export type QontoAccountingEntriesFirstpartyV2_LedgerEntryLineEnrichedInput = {
  /**
   * Account this line posts to (charge account from chart of accounts).
   * Optional in response to cover cases where account cannot be assigned.
   * Embedded account object with code, label, category, etc.
   */
  account?: InputMaybe<QontoAccountingEntriesFirstpartyV2_AccountInput>;
  /** Amount for this line. */
  amount: QontoCommon_CurrencyAmountInput;
  /**
   * Auxiliary account (subledger account, e.g., for AR/AP tracking).
   * Optional in response as some lines may not have an auxiliary account.
   * Embedded account object with code, label, category, etc.
   */
  auxiliaryAccount?: InputMaybe<QontoAccountingEntriesFirstpartyV2_AccountInput>;
  /**
   * Optional: Category key associated with the line's account (e.g., "office_supplies").
   * Expected on expense and revenue lines.
   */
  categoryKey?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the line (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional: Line label (used as FEC EcritureLib when present). Example: "Translations French to Italian"
   * TODO - MVP transition - this field will be removed in the future (once the contract is fully implemented).
   */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the line represents a tax, balance sheet, or expense/revenue posting. */
  lineType?: InputMaybe<QontoAccountingEntriesFirstpartyV2_LineType>;
  /** Optional: Tax base amount for this line. */
  taxBaseAmount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /**
   * Optional: VAT/withholding/other tax code for this line (nullable)
   * TODO - MVP transition - this field will be removed in the future (once the contract is fully implemented).
   */
  taxCodeId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional: Tax deductibility rate percent for the line - only for tax lines.
   * Represents the percentage of the tax amount that is deductible (e.g., "100.00" for fully deductible).
   */
  taxDeductibilityRatePercent?: InputMaybe<Scalars['String']['input']>;
  /** Used to determine the tax rate percent for the line - only for tax lines. */
  taxRatePercent?: InputMaybe<Scalars['String']['input']>;
  /** Used to determine the way of the line (D - for debit or C - for credit). */
  way?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Ledger entry with reconciliation status flag.
 * Extends LedgerEntryEnriched with reconciliation information.
 */
export type QontoAccountingEntriesFirstpartyV2_LedgerEntryReconciled = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_LedgerEntryReconciled';
  /**
   * Oldest accounting date of the entries
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   */
  accountingDate: Scalars['String']['output'];
  /** Accounting period this entry belongs to (e.g., "2025 Fiscal Year"). */
  accountingPeriodId: Scalars['String']['output'];
  /** Optional: Attachment (PDF/image) linked to this entry. */
  attachmentId?: Maybe<Scalars['String']['output']>;
  /** Number of attachments (justificatifs) linked to this reconciliation group. */
  attachmentsCount?: Maybe<Scalars['Int']['output']>;
  /** Balance between paid and invoiced amounts (total payments - total invoices) */
  balanceAmount: QontoCommon_CurrencyAmount;
  /** Third party name */
  counterPartyName: Scalars['String']['output'];
  /** Timestamp when this first entry was created. */
  createdAt: Scalars['TimestampProto']['output'];
  /** Optional: Document reference number (e.g., invoice number "INV-2025-042"). */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** True if obligation_id is passed and the entry is excluded from the current obligation. */
  isExcluded?: Maybe<Scalars['Boolean']['output']>;
  /** Reconciliation status flag. */
  isReconciled: Scalars['Boolean']['output'];
  /** Journals (e.g., "ACH" + "BQ" if reconciled). */
  journals: Array<QontoAccountingEntriesFirstpartyV2_Journal>;
  /** Number of ledger entries in this reconciliation group. */
  ledgerEntriesCount?: Maybe<Scalars['Int']['output']>;
  /** Unique identifiers of the ledger entries (UUIDs). */
  ledgerEntryIds: Array<Scalars['String']['output']>;
  /** Lock date of the entry if applicable */
  lockedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Organization that owns this entry. */
  organizationId: Scalars['String']['output'];
  /**
   * Deprecated: use attachments_count and ledger_entries_count instead.
   * @deprecated No longer supported
   */
  reconciledEntriesCount?: Maybe<Scalars['Int']['output']>;
  /** Reference content based on entry type */
  reference: Scalars['String']['output'];
  /** Current verification status (draft if one of the entries is not verified) */
  status: QontoAccountingEntriesFirstpartyV2_EntryStatus;
  /** Sum of all invoice amounts (including taxes) */
  totalInvoicesAmount: QontoCommon_CurrencyAmount;
  /** Sum of the taxes amounts of all invoices */
  totalInvoicesTaxAmount: QontoCommon_CurrencyAmount;
  /** Sum of all payments amounts */
  totalPaymentsAmount: QontoCommon_CurrencyAmount;
  /** Timestamp when one entry was last updated. */
  updatedAt: Scalars['TimestampProto']['output'];
};

/**
 * Ledger entry with reconciliation status flag.
 * Extends LedgerEntryEnriched with reconciliation information.
 */
export type QontoAccountingEntriesFirstpartyV2_LedgerEntryReconciledInput = {
  /**
   * Oldest accounting date of the entries
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   */
  accountingDate?: InputMaybe<Scalars['String']['input']>;
  /** Accounting period this entry belongs to (e.g., "2025 Fiscal Year"). */
  accountingPeriodId?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Attachment (PDF/image) linked to this entry. */
  attachmentId?: InputMaybe<Scalars['String']['input']>;
  /** Number of attachments (justificatifs) linked to this reconciliation group. */
  attachmentsCount?: InputMaybe<Scalars['Int']['input']>;
  /** Balance between paid and invoiced amounts (total payments - total invoices) */
  balanceAmount: QontoCommon_CurrencyAmountInput;
  /** Third party name */
  counterPartyName?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when this first entry was created. */
  createdAt: Scalars['TimestampProto']['input'];
  /** Optional: Document reference number (e.g., invoice number "INV-2025-042"). */
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /** True if obligation_id is passed and the entry is excluded from the current obligation. */
  isExcluded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reconciliation status flag. */
  isReconciled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Journals (e.g., "ACH" + "BQ" if reconciled). */
  journals?: InputMaybe<Array<QontoAccountingEntriesFirstpartyV2_JournalInput>>;
  /** Number of ledger entries in this reconciliation group. */
  ledgerEntriesCount?: InputMaybe<Scalars['Int']['input']>;
  /** Unique identifiers of the ledger entries (UUIDs). */
  ledgerEntryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Lock date of the entry if applicable */
  lockedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** Organization that owns this entry. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: use attachments_count and ledger_entries_count instead. */
  reconciledEntriesCount?: InputMaybe<Scalars['Int']['input']>;
  /** Reference content based on entry type */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Current verification status (draft if one of the entries is not verified) */
  status?: InputMaybe<QontoAccountingEntriesFirstpartyV2_EntryStatus>;
  /** Sum of all invoice amounts (including taxes) */
  totalInvoicesAmount: QontoCommon_CurrencyAmountInput;
  /** Sum of the taxes amounts of all invoices */
  totalInvoicesTaxAmount: QontoCommon_CurrencyAmountInput;
  /** Sum of all payments amounts */
  totalPaymentsAmount: QontoCommon_CurrencyAmountInput;
  /** Timestamp when one entry was last updated. */
  updatedAt: Scalars['TimestampProto']['input'];
};

/** LineType describes the accounting purpose of a ledger entry line. */
export enum QontoAccountingEntriesFirstpartyV2_LineType {
  /** Balance sheet line (asset, liability, or equity account). */
  LineTypeBalanceSheet = 'LINE_TYPE_BALANCE_SHEET',
  /** Bank line (e.g., bank transfer). */
  LineTypeBank = 'LINE_TYPE_BANK',
  /** Counterparty line (e.g., counterparty name). */
  LineTypeCounterparty = 'LINE_TYPE_COUNTERPARTY',
  /** Expense or revenue line (income statement account). */
  LineTypeExpenseRevenue = 'LINE_TYPE_EXPENSE_REVENUE',
  /** FX exchange line (e.g., FX exchange rate). */
  LineTypeFxExchange = 'LINE_TYPE_FX_EXCHANGE',
  /** Tax line (e.g., VAT, withholding tax). */
  LineTypeTax = 'LINE_TYPE_TAX',
  /** Default — type not specified or unknown. */
  LineTypeUnspecified = 'LINE_TYPE_UNSPECIFIED'
}

/** Metadata for pagination. */
export type QontoAccountingEntriesFirstpartyV2_Meta = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_Meta';
  /** Current page number. */
  currentPage: Scalars['Int']['output'];
  /** Next page number (null if last page). */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** Number of records per page. */
  perPage: Scalars['Int']['output'];
  /** Previous page number (null if first page). */
  prevPage?: Maybe<Scalars['Int']['output']>;
  /** Total number of records matching the filters. */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** Metadata for pagination. */
export type QontoAccountingEntriesFirstpartyV2_MetaInput = {
  /** Current page number. */
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  /** Next page number (null if last page). */
  nextPage?: InputMaybe<Scalars['Int']['input']>;
  /** Number of records per page. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Previous page number (null if first page). */
  prevPage?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of records matching the filters. */
  totalCount?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of pages. */
  totalPages?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A reconciliation item is a link between a ledger entry and another resource
 * (document, bank transaction, expense, etc.)
 */
export type QontoAccountingEntriesFirstpartyV2_ReconciliationItem = {
  __typename?: 'QontoAccountingEntriesFirstpartyV2_ReconciliationItem';
  /**
   * Amount associated with this reconciliation line.
   * Optional until Q3 is confirmed; safe to include now as optional.
   */
  amount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Deep link for click-through navigation to the linked resource. */
  deepLinkUrl: Scalars['String']['output'];
  /** Display name for the linked resource. */
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * The date of the linked resource (invoice date / transaction date).
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   */
  documentDate: Scalars['String']['output'];
  /**
   * Human reference for the linked resource.
   * Optional because bank transactions do not have an invoice/document number.
   */
  documentNumber?: Maybe<Scalars['String']['output']>;
  /** The type of the reconciliation item. */
  type: QontoAccountingEntriesFirstpartyV2_ReconciliationItemType;
};

/**
 * A reconciliation item is a link between a ledger entry and another resource
 * (document, bank transaction, expense, etc.)
 */
export type QontoAccountingEntriesFirstpartyV2_ReconciliationItemInput = {
  /**
   * Amount associated with this reconciliation line.
   * Optional until Q3 is confirmed; safe to include now as optional.
   */
  amount?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Deep link for click-through navigation to the linked resource. */
  deepLinkUrl?: InputMaybe<Scalars['String']['input']>;
  /** Display name for the linked resource. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The date of the linked resource (invoice date / transaction date).
   * Format: "YYYY-MM-DD" (e.g., "2025-01-13")
   */
  documentDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Human reference for the linked resource.
   * Optional because bank transactions do not have an invoice/document number.
   */
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  /** The type of the reconciliation item. */
  type?: InputMaybe<QontoAccountingEntriesFirstpartyV2_ReconciliationItemType>;
};

/** Kind of resource linked in a reconciliation row (UI / navigation). */
export enum QontoAccountingEntriesFirstpartyV2_ReconciliationItemType {
  /** Accounts payable document. */
  ReconciliationItemTypeAp = 'RECONCILIATION_ITEM_TYPE_AP',
  /** Accounts receivable document. */
  ReconciliationItemTypeAr = 'RECONCILIATION_ITEM_TYPE_AR',
  /** Customer (sales) credit note. */
  ReconciliationItemTypeCustomerCreditNote = 'RECONCILIATION_ITEM_TYPE_CUSTOMER_CREDIT_NOTE',
  /** Expense request or expense-backed document. */
  ReconciliationItemTypeExpense = 'RECONCILIATION_ITEM_TYPE_EXPENSE',
  /** Supplier (purchase) credit note. */
  ReconciliationItemTypeSupplierCreditNote = 'RECONCILIATION_ITEM_TYPE_SUPPLIER_CREDIT_NOTE',
  /** Bank transaction paying/linked to a document. */
  ReconciliationItemTypeTransaction = 'RECONCILIATION_ITEM_TYPE_TRANSACTION',
  /** Default; do not use. */
  ReconciliationItemTypeUnspecified = 'RECONCILIATION_ITEM_TYPE_UNSPECIFIED'
}

/** Filter reconciliation status. */
export enum QontoAccountingEntriesFirstpartyV2_ReconciliationStatusFilter {
  /** Filter by unreconciled entries. */
  ReconciliationStatusFilterNotReconciled = 'RECONCILIATION_STATUS_FILTER_NOT_RECONCILED',
  /** Filter by reconciled entries. */
  ReconciliationStatusFilterReconciled = 'RECONCILIATION_STATUS_FILTER_RECONCILED',
  /** Default - no filter applied. */
  ReconciliationStatusFilterUnspecified = 'RECONCILIATION_STATUS_FILTER_UNSPECIFIED'
}

/** SortBy enum - describes the sort order of the ledger entries. */
export enum QontoAccountingEntriesFirstpartyV2_SortBy {
  /** sort entries by account_code:asc */
  SortByAccountCodeAsc = 'SORT_BY_ACCOUNT_CODE_ASC',
  /** sort entries by account_code:desc */
  SortByAccountCodeDesc = 'SORT_BY_ACCOUNT_CODE_DESC',
  /** sort entries by journal_code:asc */
  SortByJournalCodeAsc = 'SORT_BY_JOURNAL_CODE_ASC',
  /** sort entries by journal_code:desc */
  SortByJournalCodeDesc = 'SORT_BY_JOURNAL_CODE_DESC',
  /** sort entries by record_date:asc */
  SortByRecordDateAsc = 'SORT_BY_RECORD_DATE_ASC',
  /** sort entries by record_date:desc */
  SortByRecordDateDesc = 'SORT_BY_RECORD_DATE_DESC',
  /** default */
  SortByUnspecified = 'SORT_BY_UNSPECIFIED'
}

/** Filter metadata. */
export enum QontoAccountingEntriesFirstpartyV2_StatusFilter {
  /** Filter by draft entries. */
  StatusFilterDraft = 'STATUS_FILTER_DRAFT',
  /** Filter by exported entries. */
  StatusFilterExported = 'STATUS_FILTER_EXPORTED',
  /** Filter by exporting entries. */
  StatusFilterExporting = 'STATUS_FILTER_EXPORTING',
  /** Filter by rejected entries. */
  StatusFilterRejected = 'STATUS_FILTER_REJECTED',
  /** Default - no filter applied. */
  StatusFilterUnspecified = 'STATUS_FILTER_UNSPECIFIED',
  /** Filter by verified entries (Exporting entries are considered as verified) */
  StatusFilterVerified = 'STATUS_FILTER_VERIFIED'
}

/**
 * CompleteTaskErrors enumerates the custom application error codes
 * returned by the CompleteTask method.
 */
export type QontoAccountingHubTaskEngineFirstpartyV3_CompleteTaskErrors = {
  __typename?: 'QontoAccountingHubTaskEngineFirstpartyV3_CompleteTaskErrors';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * CompleteTaskErrors enumerates the custom application error codes
 * returned by the CompleteTask method.
 */
export type QontoAccountingHubTaskEngineFirstpartyV3_CompleteTaskErrorsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Custom error codes for HTTP 404 Not Found. */
export enum QontoAccountingHubTaskEngineFirstpartyV3_CompleteTaskErrors_NotFoundError {
  /**
   * The requested task does not exist. Cross-organization access is
   * surfaced as 403 with a generic permission error — not 404 — to
   * avoid leaking cross-org resource existence.
   */
  NotFoundErrorTaskNotFound = 'NOT_FOUND_ERROR_TASK_NOT_FOUND',
  /**
   * No or unknown application specific error code was given, fallback
   * using the error's status field as guidance.
   */
  NotFoundErrorUnspecified = 'NOT_FOUND_ERROR_UNSPECIFIED'
}

/** Custom error codes for HTTP 422 Unprocessable Entity. */
export enum QontoAccountingHubTaskEngineFirstpartyV3_CompleteTaskErrors_UnprocessableEntityError {
  /**
   * The task exists but is not in pending status (already completed or
   * expired); completion is rejected.
   */
  UnprocessableEntityErrorTaskNotPending = 'UNPROCESSABLE_ENTITY_ERROR_TASK_NOT_PENDING',
  /**
   * No or unknown application specific error code was given, fallback
   * using the error's status field as guidance.
   */
  UnprocessableEntityErrorUnspecified = 'UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED'
}

/**
 * CompleteTaskRequest is the request message for the CompleteTask method.
 * The completing membership is taken from the PASETO token; it is not
 * supplied by the caller. Authorization requires the tasks.write scope
 * and that the caller is the task's initiator_membership_id.
 */
export type QontoAccountingHubTaskEngineFirstpartyV3_CompleteTaskRequestInput = {
  /** UUID of the task to complete. */
  id?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CompleteTaskResponse is the response message for the CompleteTask
 * method. Empty by design — the HTTP layer returns 204 No Content.
 */
export type QontoAccountingHubTaskEngineFirstpartyV3_CompleteTaskResponse = {
  __typename?: 'QontoAccountingHubTaskEngineFirstpartyV3_CompleteTaskResponse';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * GetTaskErrors enumerates the custom application error codes returned by
 * the GetTask method.
 */
export type QontoAccountingHubTaskEngineFirstpartyV3_GetTaskErrors = {
  __typename?: 'QontoAccountingHubTaskEngineFirstpartyV3_GetTaskErrors';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * GetTaskErrors enumerates the custom application error codes returned by
 * the GetTask method.
 */
export type QontoAccountingHubTaskEngineFirstpartyV3_GetTaskErrorsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Custom error codes for HTTP 404 Not Found. */
export enum QontoAccountingHubTaskEngineFirstpartyV3_GetTaskErrors_NotFoundError {
  /**
   * The requested task does not exist. Cross-organization access is
   * surfaced as 403 with a generic permission error — not 404 — to
   * avoid leaking cross-org resource existence.
   */
  NotFoundErrorTaskNotFound = 'NOT_FOUND_ERROR_TASK_NOT_FOUND',
  /**
   * No or unknown application specific error code was given, fallback
   * using the error's status field as guidance.
   */
  NotFoundErrorUnspecified = 'NOT_FOUND_ERROR_UNSPECIFIED'
}

/** GetTaskRequest is the request message for the GetTask method. */
export type QontoAccountingHubTaskEngineFirstpartyV3_GetTaskRequestInput = {
  /** UUID of the task to retrieve. */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** GetTaskResponse is the response message for the GetTask method. */
export type QontoAccountingHubTaskEngineFirstpartyV3_GetTaskResponse = {
  __typename?: 'QontoAccountingHubTaskEngineFirstpartyV3_GetTaskResponse';
  /** The requested task. */
  task: QontoAccountingHubTaskEngineFirstpartyV3_Task;
};

/**
 * ListAccountancyPracticeTasksRequest is the request message for the
 * ListAccountancyPracticeTasks method. The managed_organization_ids are
 * resolved server-side from the accountancy practice token; they are
 * never supplied by the caller.
 */
export type QontoAccountingHubTaskEngineFirstpartyV3_ListAccountancyPracticeTasksRequestInput = {
  /** Page number to retrieve (1-based). Defaults to 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Number of items per page. Defaults to 25. Maximum is 100. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * ListAccountancyPracticeTasksResponse is the response message for the
 * ListAccountancyPracticeTasks method.
 */
export type QontoAccountingHubTaskEngineFirstpartyV3_ListAccountancyPracticeTasksResponse = {
  __typename?: 'QontoAccountingHubTaskEngineFirstpartyV3_ListAccountancyPracticeTasksResponse';
  /** Pagination metadata. */
  meta: QontoCommon_PaginationMeta;
  /**
   * Tasks across all organizations managed by the accountancy practice,
   * regardless of lifecycle status.
   */
  tasks: Array<QontoAccountingHubTaskEngineFirstpartyV3_Task>;
};

/**
 * ListTaskGroupsRequest is the request message for the ListTaskGroups
 * method. The organization is always derived from the PASETO token; it
 * is never supplied by the caller.
 */
export type QontoAccountingHubTaskEngineFirstpartyV3_ListTaskGroupsRequestInput = {
  /** Page number to retrieve (1-based). Defaults to 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Number of items per page. Defaults to 25. Maximum is 100. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Optional sort order. When unspecified, the server defaults to
   * min_deadline ascending with NULLs last.
   */
  sort?: InputMaybe<QontoAccountingHubTaskEngineFirstpartyV3_TaskGroupSortOrder>;
  /**
   * Filter groups by status (multi-value). A group is included when at
   * least one of its tasks matches any of the requested statuses.
   * Reuses the StatusFilter enum from list_tasks.proto so the JSON
   * wire shape (STATUS_FILTER_PENDING, ...) matches the OpenAPI spec.
   */
  status?: InputMaybe<Array<QontoAccountingHubTaskEngineFirstpartyV3_StatusFilter>>;
};

/**
 * ListTaskGroupsResponse is the response message for the ListTaskGroups
 * method.
 */
export type QontoAccountingHubTaskEngineFirstpartyV3_ListTaskGroupsResponse = {
  __typename?: 'QontoAccountingHubTaskEngineFirstpartyV3_ListTaskGroupsResponse';
  /**
   * Pagination metadata. total_count counts groups, not tasks. Reuses
   * the Meta message defined in list_tasks.proto since the shape is
   * identical to the shared Meta in the OpenAPI spec.
   */
  meta: QontoAccountingHubTaskEngineFirstpartyV3_Meta;
  /** The list of task groups for the current page. */
  taskGroups: Array<QontoAccountingHubTaskEngineFirstpartyV3_TaskGroup>;
};

/**
 * ListTasksRequest is the request message for the ListTasks method.
 * The organization is always derived from the PASETO token; it is never
 * supplied by the caller.
 */
export type QontoAccountingHubTaskEngineFirstpartyV3_ListTasksRequestInput = {
  /**
   * Optional filter on the membership that initiated the task.
   * Must be a valid UUID.
   */
  initiatorMembershipId?: InputMaybe<Scalars['String']['input']>;
  /** Page number to retrieve (1-based). Defaults to 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Number of items per page. Defaults to 25. Maximum is 100. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Optional filter on the task lifecycle status. */
  status?: InputMaybe<QontoAccountingHubTaskEngineFirstpartyV3_StatusFilter>;
};

/** ListTasksResponse is the response message for the ListTasks method. */
export type QontoAccountingHubTaskEngineFirstpartyV3_ListTasksResponse = {
  __typename?: 'QontoAccountingHubTaskEngineFirstpartyV3_ListTasksResponse';
  /** Pagination metadata. */
  meta: QontoAccountingHubTaskEngineFirstpartyV3_Meta;
  /** The list of tasks for the current page. */
  tasks: Array<QontoAccountingHubTaskEngineFirstpartyV3_Task>;
};

/** Meta carries pagination information for a ListTasks response. */
export type QontoAccountingHubTaskEngineFirstpartyV3_Meta = {
  __typename?: 'QontoAccountingHubTaskEngineFirstpartyV3_Meta';
  /** Current page number (1-based). */
  currentPage: Scalars['Int']['output'];
  /** Next page number. Null when the caller is on the last page. */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** Previous page number. Null when the caller is on the first page. */
  prevPage?: Maybe<Scalars['Int']['output']>;
  /** Total number of tasks matching the applied filters. */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** Status represents the lifecycle state of a task. */
export enum QontoAccountingHubTaskEngineFirstpartyV3_Status {
  /** The task has been completed by a membership. */
  StatusCompleted = 'STATUS_COMPLETED',
  /** The task has expired (deadline passed or 90-day TTL reached). */
  StatusExpired = 'STATUS_EXPIRED',
  /** The task is waiting to be completed or expired. */
  StatusPending = 'STATUS_PENDING',
  /** Default sentinel value — treat as absent or unknown. */
  StatusUnspecified = 'STATUS_UNSPECIFIED'
}

/** StatusFilter narrows ListTasks results to a single lifecycle status. */
export enum QontoAccountingHubTaskEngineFirstpartyV3_StatusFilter {
  /** Return only tasks whose status is STATUS_COMPLETED. */
  StatusFilterCompleted = 'STATUS_FILTER_COMPLETED',
  /** Return only tasks whose status is STATUS_EXPIRED. */
  StatusFilterExpired = 'STATUS_FILTER_EXPIRED',
  /** Return only tasks whose status is STATUS_PENDING. */
  StatusFilterPending = 'STATUS_FILTER_PENDING',
  /**
   * Default value — no status filter is applied and tasks in every
   * lifecycle state are returned.
   */
  StatusFilterUnspecified = 'STATUS_FILTER_UNSPECIFIED'
}

/**
 * Task represents a unit of work tracked by the task-engine coordination layer.
 * The engine stores pointers to downstream flows and enforces lifecycle
 * transitions; it does not execute the underlying business logic.
 */
export type QontoAccountingHubTaskEngineFirstpartyV3_Task = {
  __typename?: 'QontoAccountingHubTaskEngineFirstpartyV3_Task';
  /**
   * Timestamp when the task was completed. Non-null only when status
   * is STATUS_COMPLETED.
   */
  completedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /**
   * Membership ID of the person who completed the task. Non-null only
   * when status is STATUS_COMPLETED.
   */
  completedByMembershipId?: Maybe<Scalars['String']['output']>;
  /**
   * Conversation linked to this task via flowEntityId (= conversation_id).
   * Batched via GET /v2/accountancy_practices/conversations.
   */
  conversation?: Maybe<QontoAccountingAccountancyPracticesFirstpartyV2_Conversation>;
  /** Timestamp when the task was created. */
  createdAt: Scalars['TimestampProto']['output'];
  /**
   * Optional deadline. Tasks past their deadline are expired by the
   * cron job.
   */
  deadline?: Maybe<Scalars['TimestampProto']['output']>;
  /**
   * Timestamp when the task was expired. Non-null only when status
   * is STATUS_EXPIRED.
   */
  expiredAt?: Maybe<Scalars['TimestampProto']['output']>;
  /**
   * Producer-defined identifier of the entity in the downstream flow.
   * May be a UUID or a deterministic composite string.
   */
  flowEntityId: Scalars['String']['output'];
  /**
   * Identifies the downstream flow this task points to. Open registry —
   * not an enum. Together with `flow_entity_id` it forms the idempotency
   * key used to deduplicate repeated creation commands.
   */
  flowType: Scalars['String']['output'];
  /** Unique task identifier (UUID). */
  id: Scalars['String']['output'];
  /**
   * Membership ID of the initiator. Null when initiated by the system
   * or any actor without a membership.
   */
  initiatorMembershipId?: Maybe<Scalars['String']['output']>;
  /**
   * Type of actor that created the task. Open registry — not an enum.
   * Known values produced today: `membership`, `system`.
   */
  initiatorType: Scalars['String']['output'];
  /**
   * Organization that owns this task. Always matches the organization
   * carried in the caller's PASETO token.
   */
  organizationId: Scalars['String']['output'];
  /**
   * Opaque JSON payload provided by the caller at creation time.
   * Per-flow schema validation is the caller's responsibility.
   */
  payload: Scalars['GoogleProtobuf_Struct']['output'];
  /** Current lifecycle status of the task. */
  status: QontoAccountingHubTaskEngineFirstpartyV3_Status;
  /**
   * Timestamp of the last update. Auto-updated by the database on every
   * change.
   */
  updatedAt: Scalars['TimestampProto']['output'];
};

/**
 * TaskGroup aggregates all tasks sharing the same (flow_type, flow_entity_id)
 * pair. Even flows with a single task are returned as a group; clients
 * decide whether to render as a single task or a group via total_count.
 * Individual tasks are not embedded in full — UI copy/icon/CTA are keyed by
 * the (flow_type, domain) translation key — but their ids are exposed via
 * task_ids for clients that need to fetch or act on the underlying tasks.
 */
export type QontoAccountingHubTaskEngineFirstpartyV3_TaskGroup = {
  __typename?: 'QontoAccountingHubTaskEngineFirstpartyV3_TaskGroup';
  /**
   * Caller-supplied variant identifier within a flow_type. The engine
   * rejects creating a group whose tasks have different domain values,
   * so the value is uniform across the group and surfaced at the group
   * level. Callers without variants send the literal "default".
   * Frontend maps (flow_type, domain) to a translation/icon/CTA key.
   */
  domain: Scalars['String']['output'];
  /**
   * Producer-defined identifier of the entity in the downstream flow.
   * Together with flow_type, it forms the group key.
   */
  flowEntityId: Scalars['String']['output'];
  /** Identifies the downstream flow type. Open registry — not an enum. */
  flowType: Scalars['String']['output'];
  /**
   * Most recent completion timestamp among completed tasks in the
   * group. Null when the group has no completed tasks. Drives the
   * completed_at_asc / completed_at_desc sort options on the Resolved
   * tab.
   */
  maxCompletedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /**
   * Earliest deadline among pending tasks in the group. Null when the
   * group has no pending tasks, or none of its pending tasks have a
   * deadline. Drives the min_deadline_asc / min_deadline_desc sort
   * options.
   */
  minDeadline?: Maybe<Scalars['TimestampProto']['output']>;
  /** Number of pending tasks in this group. */
  pendingCount: Scalars['Int']['output'];
  /**
   * Caller-visible task identifiers in this group, across all statuses.
   * Tasks assigned to other members are excluded. Order is not guaranteed.
   */
  taskIds: Array<Scalars['String']['output']>;
  /** Total number of tasks in this group across all statuses. */
  totalCount: Scalars['Int']['output'];
};

/** TaskGroupSortOrder controls the ordering of returned groups. */
export enum QontoAccountingHubTaskEngineFirstpartyV3_TaskGroupSortOrder {
  /**
   * Order by most recent completion timestamp ascending; NULLs sort
   * last. Used by the Resolved tab.
   */
  TaskGroupSortOrderCompletedAtAsc = 'TASK_GROUP_SORT_ORDER_COMPLETED_AT_ASC',
  /**
   * Order by most recent completion timestamp descending; NULLs sort
   * first. Used by the Resolved tab.
   */
  TaskGroupSortOrderCompletedAtDesc = 'TASK_GROUP_SORT_ORDER_COMPLETED_AT_DESC',
  /** Order by group creation time ascending. */
  TaskGroupSortOrderCreatedAtAsc = 'TASK_GROUP_SORT_ORDER_CREATED_AT_ASC',
  /** Order by group creation time descending. */
  TaskGroupSortOrderCreatedAtDesc = 'TASK_GROUP_SORT_ORDER_CREATED_AT_DESC',
  /** Order by flow_type ascending. */
  TaskGroupSortOrderFlowTypeAsc = 'TASK_GROUP_SORT_ORDER_FLOW_TYPE_ASC',
  /** Order by flow_type descending. */
  TaskGroupSortOrderFlowTypeDesc = 'TASK_GROUP_SORT_ORDER_FLOW_TYPE_DESC',
  /** Order by earliest pending deadline ascending; NULLs sort last. */
  TaskGroupSortOrderMinDeadlineAsc = 'TASK_GROUP_SORT_ORDER_MIN_DEADLINE_ASC',
  /** Order by earliest pending deadline descending; NULLs sort first. */
  TaskGroupSortOrderMinDeadlineDesc = 'TASK_GROUP_SORT_ORDER_MIN_DEADLINE_DESC',
  /**
   * Default value — server applies its default ordering
   * (min_deadline ascending, NULLs last).
   */
  TaskGroupSortOrderUnspecified = 'TASK_GROUP_SORT_ORDER_UNSPECIFIED'
}

/** Account representing a synchronized accounting account */
export type QontoAccountingIntegrationsAccountsFirstpartyV1_Account = {
  __typename?: 'QontoAccountingIntegrationsAccountsFirstpartyV1_Account';
  /** Creation timestamp */
  createdAt: Scalars['TimestampProto']['output'];
  /** Account identifier */
  id: Scalars['String']['output'];
  /** Account number (e.g., "401000", "512000") */
  number: Scalars['String']['output'];
  /** Rejection log message */
  rejectionLog?: Maybe<Scalars['String']['output']>;
  /** Rejection type identifier */
  rejectionType?: Maybe<QontoAccountingIntegrationsAccountsFirstpartyV1_AccountRejectionType>;
  /** Current state of the account */
  state: QontoAccountingIntegrationsAccountsFirstpartyV1_AccountState;
};

/** Account representing a synchronized accounting account */
export type QontoAccountingIntegrationsAccountsFirstpartyV1_AccountInput = {
  /** Creation timestamp */
  createdAt: Scalars['TimestampProto']['input'];
  /** Account identifier */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Account number (e.g., "401000", "512000") */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Rejection log message */
  rejectionLog?: InputMaybe<Scalars['String']['input']>;
  /** Rejection type identifier */
  rejectionType?: InputMaybe<QontoAccountingIntegrationsAccountsFirstpartyV1_AccountRejectionTypeInput>;
  /** Current state of the account */
  state?: InputMaybe<QontoAccountingIntegrationsAccountsFirstpartyV1_AccountState>;
};

/** Rejection information for the account */
export type QontoAccountingIntegrationsAccountsFirstpartyV1_AccountRejectionType = {
  __typename?: 'QontoAccountingIntegrationsAccountsFirstpartyV1_AccountRejectionType';
  /** Howtofix indication to handle the rejection */
  howToFix?: Maybe<Scalars['String']['output']>;
  /** Description of the rejection */
  label: Scalars['String']['output'];
};

/** Rejection information for the account */
export type QontoAccountingIntegrationsAccountsFirstpartyV1_AccountRejectionTypeInput = {
  /** Howtofix indication to handle the rejection */
  howToFix?: InputMaybe<Scalars['String']['input']>;
  /** Description of the rejection */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** State for the Account */
export enum QontoAccountingIntegrationsAccountsFirstpartyV1_AccountState {
  /** Account was processed successfully */
  AccountStateProcessed = 'ACCOUNT_STATE_PROCESSED',
  /** Account is being processed by the accounting software */
  AccountStateProcessing = 'ACCOUNT_STATE_PROCESSING',
  /** Account was rejected */
  AccountStateRejected = 'ACCOUNT_STATE_REJECTED',
  /** Account will soon be processed */
  AccountStateToSync = 'ACCOUNT_STATE_TO_SYNC',
  /** Not possible */
  AccountStateUnspecified = 'ACCOUNT_STATE_UNSPECIFIED'
}

/** Ledger entry representing a synchronization batch */
export type QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntry = {
  __typename?: 'QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntry';
  /** ACK validation status (reconciled) */
  ackValidation: Scalars['Boolean']['output'];
  /** Creation timestamp */
  createdAt: Scalars['TimestampProto']['output'];
  /** Ledger entry identifier */
  id: Scalars['String']['output'];
  /** Rejection log message */
  rejectionLog?: Maybe<Scalars['String']['output']>;
  /** Rejection type identifier */
  rejectionType?: Maybe<QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryRejectionType>;
  /** Current state of the batch */
  state: QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryState;
};

/** Ledger entry representing a synchronization batch */
export type QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryInput = {
  /** ACK validation status (reconciled) */
  ackValidation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Creation timestamp */
  createdAt: Scalars['TimestampProto']['input'];
  /** Ledger entry identifier */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Rejection log message */
  rejectionLog?: InputMaybe<Scalars['String']['input']>;
  /** Rejection type identifier */
  rejectionType?: InputMaybe<QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryRejectionTypeInput>;
  /** Current state of the batch */
  state?: InputMaybe<QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryState>;
};

/** Rejection information for the ledger entry */
export type QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryRejectionType = {
  __typename?: 'QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryRejectionType';
  /** Howtofix indication to handle the rejection */
  howToFix?: Maybe<Scalars['String']['output']>;
  /** Description of the rejection */
  label: Scalars['String']['output'];
};

/** Rejection information for the ledger entry */
export type QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryRejectionTypeInput = {
  /** Howtofix indication to handle the rejection */
  howToFix?: InputMaybe<Scalars['String']['input']>;
  /** Description of the rejection */
  label?: InputMaybe<Scalars['String']['input']>;
};

/** State for the LedgerEntry */
export enum QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryState {
  /** Ledger entry is pre-filetered */
  LedgerEntryStatePrefiltered = 'LEDGER_ENTRY_STATE_PREFILTERED',
  /** Ledger entry was processed successfully */
  LedgerEntryStateProcessed = 'LEDGER_ENTRY_STATE_PROCESSED',
  /** Ledger entry is being processed by the accouting software */
  LedgerEntryStateProcessing = 'LEDGER_ENTRY_STATE_PROCESSING',
  /** Ledger entry was rejected */
  LedgerEntryStateRejected = 'LEDGER_ENTRY_STATE_REJECTED',
  /** Ledger entry will soon be processed */
  LedgerEntryStateToSync = 'LEDGER_ENTRY_STATE_TO_SYNC',
  /** Not possible */
  LedgerEntryStateUnspecified = 'LEDGER_ENTRY_STATE_UNSPECIFIED'
}

/** Represents a journal entity. */
export type QontoAccountingJournalsFirstpartyV2_Journal = {
  __typename?: 'QontoAccountingJournalsFirstpartyV2_Journal';
  account?: Maybe<QontoAccountingAccountsFirstpartyV2_Account>;
  /** Optional: Account ID associated with this journal (for cash_bank journal type only). */
  accountId?: Maybe<Scalars['String']['output']>;
  bankAccount?: Maybe<BankAccount>;
  /** Optional: Bank account ID associated with this journal (for cash_bank journal type only). */
  bankAccountId?: Maybe<Scalars['String']['output']>;
  /** Journal code (e.g., "VE", "AC"). */
  code: Scalars['String']['output'];
  /** Timestamp when this journal was created. */
  createdAt: Scalars['TimestampProto']['output'];
  /** Tell whether a Journal has been soft-deleted. */
  deletedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Unique identifier for the Journal (UUID). */
  id: Scalars['String']['output'];
  /** Journal name (e.g., "Ventes"). */
  name: Scalars['String']['output'];
  /** Journal type (e.g., "sales","purchases","cash_bank","general","misc", "cash"). */
  type: Scalars['String']['output'];
  /** Timestamp when this journal was last updated. */
  updatedAt: Scalars['TimestampProto']['output'];
};

/** Represents a journal entity. */
export type QontoAccountingJournalsFirstpartyV2_JournalInput = {
  /** Optional: Account ID associated with this journal (for cash_bank journal type only). */
  accountId?: InputMaybe<Scalars['String']['input']>;
  /** Optional: Bank account ID associated with this journal (for cash_bank journal type only). */
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  /** Journal code (e.g., "VE", "AC"). */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when this journal was created. */
  createdAt: Scalars['TimestampProto']['input'];
  /** Tell whether a Journal has been soft-deleted. */
  deletedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** Unique identifier for the Journal (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Journal name (e.g., "Ventes"). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Journal type (e.g., "sales","purchases","cash_bank","general","misc", "cash"). */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp when this journal was last updated. */
  updatedAt: Scalars['TimestampProto']['input'];
};

/**
 * Request to list journals for the given organization.
 * Organization ID is extracted from PASETO of the authenticated user.
 */
export type QontoAccountingJournalsFirstpartyV2_ListJournalsRequest = {
  __typename?: 'QontoAccountingJournalsFirstpartyV2_ListJournalsRequest';
  /** When true, includes soft-deleted journals in the response. */
  includeDeleted?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Request to list journals for the given organization.
 * Organization ID is extracted from PASETO of the authenticated user.
 */
export type QontoAccountingJournalsFirstpartyV2_ListJournalsRequestInput = {
  /** When true, includes soft-deleted journals in the response. */
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response containing a list of journals for organization. */
export type QontoAccountingJournalsFirstpartyV2_ListJournalsResponse = {
  __typename?: 'QontoAccountingJournalsFirstpartyV2_ListJournalsResponse';
  /** List of journals for organization. */
  journals: Array<QontoAccountingJournalsFirstpartyV2_Journal>;
};

/** Response containing a list of journals for organization. */
export type QontoAccountingJournalsFirstpartyV2_ListJournalsResponseInput = {
  /** List of journals for organization. */
  journals?: InputMaybe<Array<QontoAccountingJournalsFirstpartyV2_JournalInput>>;
};

/**
 * An issue detected on an obligation period.
 * The frontend uses code + the oneof case for i18n interpolation
 * (e.g. "You still have 8 unverified entries on this period").
 */
export type QontoAccountingObligationsFirstpartyV2_Anomaly = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_Anomaly';
  /**
   * Machine-readable anomaly identifier (e.g. "unverified_entries").
   * Used by the frontend as a translation key.
   */
  code: Scalars['String']['output'];
  /** Present when code = "missing_justifications". */
  missingJustifications?: Maybe<QontoAccountingObligationsFirstpartyV2_MissingJustificationsAnomaly>;
  /** Severity level — errors block submission, warnings are informational. */
  severity: QontoAccountingObligationsFirstpartyV2_AnomalySeverity;
  /** Present when code = "unverified_entries". */
  unverifiedEntries?: Maybe<QontoAccountingObligationsFirstpartyV2_UnverifiedEntriesAnomaly>;
};

/** Severity of an anomaly detected on an obligation. */
export enum QontoAccountingObligationsFirstpartyV2_AnomalySeverity {
  /** Blocks submission of the obligation to the tax authority. */
  AnomalySeverityError = 'ANOMALY_SEVERITY_ERROR',
  /** Unspecified severity — used as default value. */
  AnomalySeverityUnspecified = 'ANOMALY_SEVERITY_UNSPECIFIED',
  /** Informational — does not block submission. */
  AnomalySeverityWarning = 'ANOMALY_SEVERITY_WARNING'
}

/** Custom errors for the ClarifyOperation endpoint. */
export type QontoAccountingObligationsFirstpartyV2_ClarifyOperationErrors = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_ClarifyOperationErrors';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Custom errors for the ClarifyOperation endpoint. */
export type QontoAccountingObligationsFirstpartyV2_ClarifyOperationErrorsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Custom error codes for HTTP 422 Unprocessable Entity */
export enum QontoAccountingObligationsFirstpartyV2_ClarifyOperationErrors_UnprocessableEntityError {
  /** No or unknown application specific error code was given */
  UnprocessableEntityErrorUnspecified = 'UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED',
  /**
   * No answer was given, or an answer is not one of the options offered for
   * the clarification type
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  InvalidAnswer = 'invalid_answer',
  /**
   * The clarification type is not a supported question for this operation
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  InvalidQuestion = 'invalid_question'
}

/**
 * Request to answer the clarification questions of one operation.
 *
 * The whole set of answers is sent at once: the answers are stored together, so
 * a partial request would drop the answers already given. Answers are validated
 * before anything is written, meaning a single invalid clarification leaves the
 * operation untouched.
 */
export type QontoAccountingObligationsFirstpartyV2_ClarifyOperationRequestInput = {
  /**
   * Clarification answers to store for this operation. Every answered question
   * is marked as completed and stops being returned by GetOperation.
   *
   * @gotags: validate:"required,min=1,dive"
   */
  clarifications?: InputMaybe<Array<QontoAccountingObligationsFirstpartyV2_OperationClarificationAnswerInput>>;
  /**
   * UUID of the operation.
   * Route param: :id — the operation identifier, not the obligation's.
   *
   * @gotags: validate:"required,uuid"
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * UUID of the obligation.
   * Route param: :obligation_id
   *
   * @gotags: validate:"required,uuid"
   */
  obligationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Empty response: the answered clarifications are no longer returned by
 * GetOperation, and the operation's action is recomputed server-side.
 */
export type QontoAccountingObligationsFirstpartyV2_ClarifyOperationResponse = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_ClarifyOperationResponse';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Request to declare an obligation
 *
 * The organization is always resolved from the PASETO of the authenticated
 * caller — there is no `organization_id` field in the request.
 *
 * Deprecated: use AccountancyPracticeDeclarationService.DeclareObligation instead,
 * which is secured with an AP token.
 */
export type QontoAccountingObligationsFirstpartyV2_DeclareObligationRequestInput = {
  /** When true, submits a nil (zero-amount) declaration. */
  nilDeclaration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Define which obligation to declare */
  obligationId?: InputMaybe<Scalars['String']['input']>;
};

/** Empty response to confirm the successful declaration */
export type QontoAccountingObligationsFirstpartyV2_DeclareObligationResponse = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_DeclareObligationResponse';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Request for the catch-up flow summary of a given obligation. */
export type QontoAccountingObligationsFirstpartyV2_GetCatchUpFlowSummaryRequestInput = {
  /**
   * UUID of the obligation.
   * Route param: :obligation_id
   *
   * @gotags: validate:"required,uuid"
   */
  obligationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Amount to pay or recover from operations finalised in the catch-up flow of
 * an obligation.
 */
export type QontoAccountingObligationsFirstpartyV2_GetCatchUpFlowSummaryResponse = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_GetCatchUpFlowSummaryResponse';
  /**
   * VAT recoverable through the catch-up flow operations, computed from the
   * obligation's catch-up tasks.
   */
  catchUpRecoverableVat: QontoCommon_CurrencyAmount;
  /**
   * Net amount due to the tax administration.
   * Equal to total_collected_vat - total_deductible_vat.
   * A negative value (starting with "-") indicates a VAT credit owed to the
   * organization.
   */
  toPay: QontoCommon_CurrencyAmount;
  /** Sum of collected (output) VAT across all rates. */
  totalCollectedVat: QontoCommon_CurrencyAmount;
  /** Sum of deductible (input) VAT across all rates. */
  totalDeductibleVat: QontoCommon_CurrencyAmount;
};

/** Request to retrieve a single obligation by its UUID. */
export type QontoAccountingObligationsFirstpartyV2_GetObligationRequestInput = {
  /** UUID of the obligation to retrieve. */
  obligationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response containing the full obligation detail, including its VAT
 * declaration when one has been created.
 */
export type QontoAccountingObligationsFirstpartyV2_GetObligationResponse = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_GetObligationResponse';
  /**
   * Anomalies detected for this obligation period. Empty when none are detected.
   * Errors block submission to the tax authority; warnings are informational.
   */
  anomalies: Array<QontoAccountingObligationsFirstpartyV2_Anomaly>;
  /**
   * Label summarising whose turn it is, rendered next to the obligation title.
   * See ObligationBadge for the derivation rules. OBLIGATION_BADGE_UNSPECIFIED
   * means no badge is to be displayed.
   */
  badge: QontoAccountingObligationsFirstpartyV2_ObligationBadge;
  /** Inclusive end of the period covered (YYYY-MM-DD). */
  endDate: Scalars['String']['output'];
  /** Last day to file the declaration (YYYY-MM-DD). */
  filingDueDate: Scalars['String']['output'];
  /** Unique identifier of the obligation. */
  id: Scalars['String']['output'];
  /** Subtype of the obligation. */
  obligationSubtype: QontoAccountingObligationsFirstpartyV2_ObligationSubtype;
  /** Due date of the payment */
  paymentDueDate: Scalars['String']['output'];
  /**
   * Pre-signed S3 URL (TTL 5 minutes) to download the generated PDF document
   * associated with this obligation (e.g. CA3 for VAT). Null when no document
   * has been generated yet.
   */
  pdfFileUrl?: Maybe<Scalars['String']['output']>;
  /**
   * UUID of the obligation that immediately precedes this one in the same
   * accounting period sequence. Null for the first obligation of its type.
   * Used to render the "previous declaration" link at the top of the CA3 form.
   */
  previousObligationId?: Maybe<Scalars['String']['output']>;
  /** Inclusive start of the period covered (YYYY-MM-DD). */
  startDate: Scalars['String']['output'];
  /** Computed server-side. See ObligationStatus for the derivation rules. */
  status: QontoAccountingObligationsFirstpartyV2_ObligationStatus;
  /**
   * Lifecycle steps of the obligation, in chronological order, rendered as a
   * vertical stepper. Empty for non-VAT obligations.
   */
  timeline: Array<QontoAccountingObligationsFirstpartyV2_TimelineStep>;
  /** Type of obligation (VAT, etc.). */
  type: QontoAccountingObligationsFirstpartyV2_ObligationType;
  /**
   * VAT declaration detail. Null when no declaration has been created for
   * this obligation yet.
   */
  vatDetail?: Maybe<QontoAccountingObligationsFirstpartyV2_VatDetail>;
  /**
   * Filing frequency the period covered corresponds to. Set on VAT
   * obligations, absent on every other type.
   */
  vatPeriodicity?: Maybe<QontoAccountingObligationsFirstpartyV2_VatPeriodicity>;
};

/** Request to fetch one operation detail for a given obligation. */
export type QontoAccountingObligationsFirstpartyV2_GetOperationRequestInput = {
  /**
   * UUID of the operation.
   * Route param: :id
   *
   * @gotags: validate:"required,uuid"
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * UUID of the obligation.
   * Route param: :obligation_id
   *
   * @gotags: validate:"required,uuid"
   */
  obligationId?: InputMaybe<Scalars['String']['input']>;
};

/** Response containing one operation detail. */
export type QontoAccountingObligationsFirstpartyV2_GetOperationResponse = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_GetOperationResponse';
  /** Detailed operation. */
  operation: QontoAccountingObligationsFirstpartyV2_OperationDetail;
};

/**
 * Request to list obligations.
 *
 * The organization is always resolved from the PASETO of the authenticated
 * caller — there is no `organization_id` field in the request. Accountants
 * access a client organization's obligations through the standard PASETO
 * scoping flow that already powers the rest of this service.
 */
export type QontoAccountingObligationsFirstpartyV2_ListObligationsRequestInput = {
  /**
   * Filter by accounting period UUID. When omitted, the server falls back
   * to the organization's current accounting period.
   */
  accountingPeriodId?: InputMaybe<Scalars['String']['input']>;
  /** Page number to be fetched. Default: 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Number of records per page. Default: 25, Maximum: 100. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Comma separated statuses values */
  statuses?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter by obligation type. Accepts a comma-separated list of
   * ObligationType values (e.g. "OBLIGATION_TYPE_VAT"). When omitted or
   * empty, all types are returned. Multiple values use OR semantics.
   */
  types?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response containing a list of obligations and pagination metadata.
 *
 * Obligations are sorted by `due_date` ascending by default
 * (most urgent first).
 */
export type QontoAccountingObligationsFirstpartyV2_ListObligationsResponse = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_ListObligationsResponse';
  /** Pagination metadata. */
  meta: QontoCommon_PaginationMeta;
  /** List of obligations matching the request criteria. */
  obligations: Array<QontoAccountingObligationsFirstpartyV2_Obligation>;
};

/** Request to list operations for a given obligation. */
export type QontoAccountingObligationsFirstpartyV2_ListOperationsRequestInput = {
  /**
   * UUID of the obligation.
   * Route param: :obligation_id
   *
   * @gotags: validate:"required,uuid"
   */
  obligationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Page number to be fetched. Default: 1.
   *
   * @gotags: validate:"omitempty,gte=1"
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Number of records per page. Default: 25, Maximum: 100.
   *
   * @gotags: validate:"omitempty,gte=1,lte=100"
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Filter by operation status.
   * Query param: status
   */
  status?: InputMaybe<QontoAccountingObligationsFirstpartyV2_OperationStatus>;
};

/** Response containing operations for the requested obligation. */
export type QontoAccountingObligationsFirstpartyV2_ListOperationsResponse = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_ListOperationsResponse';
  /**
   * Global action counts over the obligation's scoped entry IDs.
   * Always filled when scoped IDs exist but independent of page size.
   */
  actionCounts: QontoAccountingObligationsFirstpartyV2_OperationActionCounts;
  /** Pagination metadata. */
  meta: QontoCommon_PaginationMeta;
  /** Operations that can be used to reconcile the obligation. */
  operations: Array<QontoAccountingObligationsFirstpartyV2_Operation>;
};

/**
 * Request to list the ledger entries that contribute to a specific line of the
 * CA3 VAT return for a given obligation.
 *
 * The organization is always resolved from the PASETO of the authenticated
 * caller. The period window and VAT exigibility (accrual vs cash-basis) are
 * derived server-side from the obligation.
 */
export type QontoAccountingObligationsFirstpartyV2_ListVatLedgerEntriesRequestInput = {
  /**
   * CA3 form line code whose contributing entries are requested
   * (e.g. "0979", "0207", "0703"). Must match a line defined in the
   * active VAT engine configuration.
   */
  lineCode?: InputMaybe<Scalars['String']['input']>;
  /** UUID of the VAT obligation whose period is used to scope the entries. */
  obligationId?: InputMaybe<Scalars['String']['input']>;
  /** Page number to be fetched. Default: 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Number of records per page. Default: 25, Maximum: 100. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Response containing the ledger entries contributing to a CA3 line and
 * pagination metadata.
 */
export type QontoAccountingObligationsFirstpartyV2_ListVatLedgerEntriesResponse = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_ListVatLedgerEntriesResponse';
  /**
   * Ledger entries that contribute to the requested CA3 line within the
   * obligation's period, in the same format as the reconciled entries endpoint.
   */
  entries: Array<QontoAccountingEntriesFirstpartyV2_LedgerEntryReconciled>;
  /** Pagination metadata. */
  meta: QontoCommon_PaginationMeta;
};

/**
 * Payload for the missing_justifications anomaly.
 * Carries the number of operations in the obligation's scope that still need a
 * justification — no proof attached, or attached proof that does not cover the
 * whole amount — split by the side of the CA3 they belong to.
 */
export type QontoAccountingObligationsFirstpartyV2_MissingJustificationsAnomaly = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_MissingJustificationsAnomaly';
  /**
   * Share of count on the collected (output VAT) side: inbound payments and
   * sales documents.
   */
  collectedCount: Scalars['Int']['output'];
  /** Total number of operations awaiting a justification. */
  count: Scalars['Int']['output'];
  /**
   * Share of count on the deductible (input VAT) side: outbound payments and
   * purchase documents.
   *
   * collected_count and deductible_count do not necessarily sum to count: an
   * operation whose side cannot be derived is counted in neither.
   */
  deductibleCount: Scalars['Int']['output'];
};

/**
 * Represents a fiscal obligation an organization must fulfill within a given
 * accounting period (e.g., a monthly or quarterly VAT declaration).
 */
export type QontoAccountingObligationsFirstpartyV2_Obligation = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_Obligation';
  /** UUID of the accounting period this obligation belongs to. */
  accountingPeriodId: Scalars['String']['output'];
  /**
   * UUID of the accounting setup driving the fiscal configuration that
   * generated this obligation (regimes, exigibility, etc.).
   */
  accountingSetupId: Scalars['String']['output'];
  /** Inclusive end of the period covered (YYYY-MM-DD). */
  endsAt: Scalars['String']['output'];
  /** Last day to fulfill the obligation (YYYY-MM-DD). */
  filingDueDate: Scalars['String']['output'];
  /** Unique identifier of the obligation. */
  id: Scalars['String']['output'];
  /** Subtype of the obligation. */
  obligationSubtype: QontoAccountingObligationsFirstpartyV2_ObligationSubtype;
  /**
   * Qonto account data for this obligation's organization (status, company, stakeholders).
   * Batched via GET /v5/accountancy_practices/organizations keyed on organizationId.
   */
  organization?: Maybe<QontoRegistrationApiOrganizationsFirstpartyV5_Organization>;
  /** UUID of the organization that owns the obligation. */
  organizationId: Scalars['String']['output'];
  /** Due date of the payment */
  paymentDueDate: Scalars['String']['output'];
  /** Inclusive start of the period covered (YYYY-MM-DD). */
  startsAt: Scalars['String']['output'];
  /** Computed server-side. See ObligationStatus for the derivation rules. */
  status: QontoAccountingObligationsFirstpartyV2_ObligationStatus;
  /** Type of obligation (VAT, etc.). */
  type: QontoAccountingObligationsFirstpartyV2_ObligationType;
  /**
   * Filing frequency the period covered corresponds to. Set on VAT
   * obligations, absent on every other type.
   */
  vatPeriodicity?: Maybe<QontoAccountingObligationsFirstpartyV2_VatPeriodicity>;
  /** VAT amount and filing timestamp. Present only for VAT obligations. */
  vatSummary?: Maybe<QontoAccountingObligationsFirstpartyV2_VatSummary>;
};

/**
 * Single label summarising, for the client, whose turn it is on an obligation.
 * Computed server-side from the obligation status, the VAT declaration status
 * and — while no declaration workflow exists yet — the number of operations
 * still needing action. Never persisted.
 *
 * Where the obligation status and the declaration status contradict each other,
 * or either is unknown, no badge is returned rather than a misleading one.
 */
export enum QontoAccountingObligationsFirstpartyV2_ObligationBadge {
  /**
   * Accountant's turn: the declaration is being prepared, or the period is
   * closed with nothing left for the client. Overdue obligations land here too.
   */
  ObligationBadgeAccountingReview = 'OBLIGATION_BADGE_ACCOUNTING_REVIEW',
  /** Declaration has been filed. */
  ObligationBadgeFiled = 'OBLIGATION_BADGE_FILED',
  /**
   * Client still has work: the declaration is waiting for their review, or no
   * declaration exists yet and operations still need action.
   */
  ObligationBadgeToComplete = 'OBLIGATION_BADGE_TO_COMPLETE',
  /**
   * No badge — the state is unknown or the two sources contradict each other.
   * Also covers an open period with nothing left to do, which has not been
   * handed to the accountant yet.
   */
  ObligationBadgeUnspecified = 'OBLIGATION_BADGE_UNSPECIFIED',
  /** Obligation period has not started yet. */
  ObligationBadgeUpcoming = 'OBLIGATION_BADGE_UPCOMING'
}

/**
 * Lifecycle status of an obligation. Computed server-side on-the-fly from
 * `starts_at`, `ends_at`, `due_date` and the presence of a related
 * declaration. Never persisted.
 */
export enum QontoAccountingObligationsFirstpartyV2_ObligationStatus {
  /** A related declaration has been submitted — obligation is fulfilled. */
  ObligationStatusDeclared = 'OBLIGATION_STATUS_DECLARED',
  /** starts_at <= now() <= ends_at — period is currently in progress. */
  ObligationStatusOpen = 'OBLIGATION_STATUS_OPEN',
  /** now() > due_date and not yet declared — overdue. */
  ObligationStatusOverdue = 'OBLIGATION_STATUS_OVERDUE',
  /** ends_at < now() <= due_date — period closed, must be filed before due_date. */
  ObligationStatusPending = 'OBLIGATION_STATUS_PENDING',
  /** Unspecified status — used as default and to filter "any status" in requests. */
  ObligationStatusUnspecified = 'OBLIGATION_STATUS_UNSPECIFIED',
  /** now() < starts_at — period has not begun yet. */
  ObligationStatusUpcoming = 'OBLIGATION_STATUS_UPCOMING'
}

/** Disambiguates multiple obligations that share the same type and period. */
export enum QontoAccountingObligationsFirstpartyV2_ObligationSubtype {
  /** Corporate income tax (IS) — annual balance payment. */
  ObligationSubtypeAnnualBalance = 'OBLIGATION_SUBTYPE_ANNUAL_BALANCE',
  /** Corporate income tax (IS) — annual return (liasse). */
  ObligationSubtypeAnnualReturn = 'OBLIGATION_SUBTYPE_ANNUAL_RETURN',
  /** Corporate property tax (CFE) — December balance. */
  ObligationSubtypeBalance = 'OBLIGATION_SUBTYPE_BALANCE',
  /** Corporate property tax (CFE) — first-year declaration (1447-C-SD). */
  ObligationSubtypeInitialDeclaration = 'OBLIGATION_SUBTYPE_INITIAL_DECLARATION',
  /** Corporate property tax (CFE) — June advance instalment. */
  ObligationSubtypeInstalment = 'OBLIGATION_SUBTYPE_INSTALMENT',
  /** Corporate income tax (IS) — quarterly instalment (Cerfa n°2571). */
  ObligationSubtypeQuarterlyInstalment = 'OBLIGATION_SUBTYPE_QUARTERLY_INSTALMENT',
  /** No subtype — used for VAT, third_party_fees, and as the default value. */
  ObligationSubtypeUnspecified = 'OBLIGATION_SUBTYPE_UNSPECIFIED'
}

/** Type of fiscal obligation. */
export enum QontoAccountingObligationsFirstpartyV2_ObligationType {
  /** Corporate property tax (CFE) — initial declaration, instalment, balance. */
  ObligationTypeCorporatePropertyTax = 'OBLIGATION_TYPE_CORPORATE_PROPERTY_TAX',
  /** Corporate income tax (IS) — instalments, annual return, balance. */
  ObligationTypeCorporateTax = 'OBLIGATION_TYPE_CORPORATE_TAX',
  /** Third-party fees (Cerfa DAS2) — annual declaration of 622x payees. */
  ObligationTypeThirdPartyFees = 'OBLIGATION_TYPE_THIRD_PARTY_FEES',
  /** Unspecified type — used as default and to filter "any type" in requests. */
  ObligationTypeUnspecified = 'OBLIGATION_TYPE_UNSPECIFIED',
  /** VAT (Value Added Tax) declaration obligation (CA3). */
  ObligationTypeVat = 'OBLIGATION_TYPE_VAT'
}

/** Operation that can be used to reconcile an obligation. */
export type QontoAccountingObligationsFirstpartyV2_Operation = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_Operation';
  /** Accounting amount of the document (including tax), in the accounting currency. */
  accountingAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Action available to the user for this operation. */
  action: QontoAccountingObligationsFirstpartyV2_OperationAction;
  /** Operation amount. */
  amount: QontoCommon_CurrencyAmount;
  /** Attachment UUID associated with the operation, if any. */
  attachmentId?: Maybe<Scalars['String']['output']>;
  /** Accounting categories associated with the operation. */
  categories: Array<Scalars['String']['output']>;
  /** Operation date in YYYY-MM-DD format. */
  date: Scalars['String']['output'];
  /** Direction of this operation in the accounting flow. */
  direction: QontoAccountingObligationsFirstpartyV2_OperationDirection;
  /** Populated when attachmentId is set on the operation. Null otherwise. */
  documentCategoryAllocations?: Maybe<QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_Document>;
  /** Unique operation identifier (UUID v7). */
  id: Scalars['String']['output'];
  /** Internal reference associated with the operation, if any. */
  internalReferenceId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation has already been verified. */
  isVerified: Scalars['Boolean']['output'];
  /** Matched resources counters. */
  matchedResources: QontoAccountingObligationsFirstpartyV2_OperationMatchedResources;
  /** Metadata associated with the operation. */
  metadata?: Maybe<QontoAccountingObligationsFirstpartyV2_OperationMetadata>;
  /** Human-readable operation title shown in the reconciliation UI. */
  title: Scalars['String']['output'];
  /** Populated when internalReferenceId is set and type == OPERATION_TYPE_TRANSACTION. Null otherwise. */
  transactionCategoryAllocations?: Maybe<QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_Transaction>;
  /** Operation type. */
  type: QontoAccountingObligationsFirstpartyV2_OperationType;
};

/** Action available to the user for this operation. */
export enum QontoAccountingObligationsFirstpartyV2_OperationAction {
  /** Operation can be categorized. */
  OperationActionCategorize = 'OPERATION_ACTION_CATEGORIZE',
  /** Operation requires additional clarification. */
  OperationActionClarify = 'OPERATION_ACTION_CLARIFY',
  /** Operation can be matched to a resource. */
  OperationActionMatch = 'OPERATION_ACTION_MATCH',
  /** Operation should be reviewed by the user. */
  OperationActionReview = 'OPERATION_ACTION_REVIEW',
  /** No explicit action. */
  OperationActionUnspecified = 'OPERATION_ACTION_UNSPECIFIED'
}

/**
 * Counts of operations by action, scoped to the obligation's full entry ID set
 * match + categorize + clarify count should equals to meta.total_count
 */
export type QontoAccountingObligationsFirstpartyV2_OperationActionCounts = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_OperationActionCounts';
  /** Number of operations with action categorize. */
  categorize: Scalars['Int']['output'];
  /** Number of operations with action clarify. */
  clarify: Scalars['Int']['output'];
  /** Number of operations with action match. */
  match: Scalars['Int']['output'];
};

/** Clarification required to complete operation reconciliation. */
export type QontoAccountingObligationsFirstpartyV2_OperationClarification = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_OperationClarification';
  /** Answers already selected for this clarification. */
  answers: Array<QontoAccountingObligationsFirstpartyV2_OperationClarificationOption>;
  /** Unique clarification identifier. */
  id: Scalars['String']['output'];
  /** Available options for this clarification. */
  options: Array<QontoAccountingObligationsFirstpartyV2_OperationClarificationOption>;
  /** Current clarification status. */
  status: QontoAccountingObligationsFirstpartyV2_OperationClarificationStatus;
  /** Clarification type. */
  type: QontoAccountingObligationsFirstpartyV2_OperationClarificationType;
};

/** Answer given by the user for one clarification question of an operation. */
export type QontoAccountingObligationsFirstpartyV2_OperationClarificationAnswerInput = {
  /**
   * Options selected by the user. Every value must belong to the options
   * offered for `type` in `operation.clarifications[].options`.
   *
   * @gotags: validate:"required,min=1,dive,required"
   */
  answers?: InputMaybe<Array<QontoAccountingObligationsFirstpartyV2_OperationClarificationOption>>;
  /**
   * UUID of the clarification question being answered, as returned by
   * GetOperation in `operation.clarifications[].id`.
   *
   * @gotags: validate:"required,uuid"
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * Clarification question type being answered. Must be one of the
   * clarification questions currently open on the operation.
   *
   * @gotags: validate:"required"
   */
  type?: InputMaybe<QontoAccountingObligationsFirstpartyV2_OperationClarificationType>;
};

/** Option that can be selected for a clarification. */
export enum QontoAccountingObligationsFirstpartyV2_OperationClarificationOption {
  /** Registration region is in Europe (excluding France). */
  OperationClarificationOptionEurope = 'OPERATION_CLARIFICATION_OPTION_EUROPE',
  /** Registration region is France. */
  OperationClarificationOptionFrance = 'OPERATION_CLARIFICATION_OPTION_FRANCE',
  /** Registration region is outside Europe. */
  OperationClarificationOptionOutsideEurope = 'OPERATION_CLARIFICATION_OPTION_OUTSIDE_EUROPE',
  /** The vehicle is a passenger vehicle. */
  OperationClarificationOptionPassengerVehicle = 'OPERATION_CLARIFICATION_OPTION_PASSENGER_VEHICLE',
  /** The expense is personal. */
  OperationClarificationOptionPersonal = 'OPERATION_CLARIFICATION_OPTION_PERSONAL',
  /** The expense is professional. */
  OperationClarificationOptionProfessional = 'OPERATION_CLARIFICATION_OPTION_PROFESSIONAL',
  /** Unspecified clarification option. */
  OperationClarificationOptionUnspecified = 'OPERATION_CLARIFICATION_OPTION_UNSPECIFIED',
  /** The vehicle is a utility vehicle. */
  OperationClarificationOptionUtilityVehicle = 'OPERATION_CLARIFICATION_OPTION_UTILITY_VEHICLE'
}

/** Current lifecycle state of a clarification. */
export enum QontoAccountingObligationsFirstpartyV2_OperationClarificationStatus {
  /** Clarification has been completed. */
  OperationClarificationStatusCompleted = 'OPERATION_CLARIFICATION_STATUS_COMPLETED',
  /** Clarification has been created but not completed yet. */
  OperationClarificationStatusCreated = 'OPERATION_CLARIFICATION_STATUS_CREATED',
  /** Unspecified clarification status. */
  OperationClarificationStatusUnspecified = 'OPERATION_CLARIFICATION_STATUS_UNSPECIFIED'
}

/** Type of clarification attached to an operation. */
export enum QontoAccountingObligationsFirstpartyV2_OperationClarificationType {
  /** Clarification related to fuel expenses for a vehicle. */
  OperationClarificationTypeCarFuel = 'OPERATION_CLARIFICATION_TYPE_CAR_FUEL',
  /** Clarification related to restaurant meal expenses. */
  OperationClarificationTypeRestaurantMeal = 'OPERATION_CLARIFICATION_TYPE_RESTAURANT_MEAL',
  /** Clarification related to third-party registration region. */
  OperationClarificationTypeThirdPartyRegistrationRegion = 'OPERATION_CLARIFICATION_TYPE_THIRD_PARTY_REGISTRATION_REGION',
  /** Unspecified clarification type. */
  OperationClarificationTypeUnspecified = 'OPERATION_CLARIFICATION_TYPE_UNSPECIFIED'
}

/** Detailed operation returned by GetOperation. */
export type QontoAccountingObligationsFirstpartyV2_OperationDetail = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_OperationDetail';
  /** Accounting amount of the document (including tax), in the accounting currency. */
  accountingAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Tax amount of the document, in the accounting currency. */
  accountingTaxesAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Action available to the user for this operation. */
  action: QontoAccountingObligationsFirstpartyV2_OperationAction;
  /** Operation amount. */
  amount: QontoCommon_CurrencyAmount;
  /** Attachment UUID associated with the operation, if any. */
  attachmentId?: Maybe<Scalars['String']['output']>;
  /** Clarifications that can be requested for this operation. */
  clarifications: Array<QontoAccountingObligationsFirstpartyV2_OperationClarification>;
  /** Operation date in YYYY-MM-DD format. */
  date: Scalars['String']['output'];
  /** Direction of this operation in the accounting flow. */
  direction: QontoAccountingObligationsFirstpartyV2_OperationDirection;
  /** Unique operation identifier (UUID v7). */
  id: Scalars['String']['output'];
  /** Internal reference associated with the operation, if any. */
  internalReferenceId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation has already been verified. */
  isVerified: Scalars['Boolean']['output'];
  /** Document lines linked to this operation. */
  lines: Array<QontoAccountingObligationsFirstpartyV2_OperationLine>;
  /** Metadata associated with the operation. */
  metadata?: Maybe<QontoAccountingObligationsFirstpartyV2_OperationMetadata>;
  /** Reconciliation candidates linked to this operation. */
  reconciliations: Array<QontoAccountingObligationsFirstpartyV2_OperationReconciliation>;
  /**
   * VAT recoverable for this operation, in the accounting currency.
   * Deprecated: use vat_impact_amount instead.
   * @deprecated No longer supported
   */
  recoverableTaxesAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Current status of the operation. */
  status: QontoAccountingObligationsFirstpartyV2_OperationStatus;
  /** Tax amount of the document, in the document's currency. */
  taxesAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Human-readable operation title shown in the reconciliation UI. */
  title: Scalars['String']['output'];
  /** Operation type. */
  type: QontoAccountingObligationsFirstpartyV2_OperationType;
  /**
   * How much of this operation is not covered by what it is matched with. For a
   * transaction, the part that the attached documents do not account for. For a
   * document, the part that the transactions do not pay for.
   *
   * Never negative. An operation covered by more than its own amount is fully
   * justified and reports zero.
   *
   * Set on both sides of a match. Absent when the operation is not matched with
   * anything.
   *
   * In the accounting currency, which can differ from the currency of `amount`
   * above. That one is the document's.
   */
  unjustifiedAmount?: Maybe<QontoCommon_CurrencyAmount>;
  /**
   * Net TAX-category amount across the operation's ledger lines (debit minus credit),
   * in the accounting currency. Positive = recoverable input VAT; negative = output
   * VAT payable to the tax authority.
   */
  vatImpactAmount?: Maybe<QontoCommon_CurrencyAmount>;
};

/** Direction of the operation in the accounting flow. */
export enum QontoAccountingObligationsFirstpartyV2_OperationDirection {
  /** Operation decreases the obligation balance (e.g. expense, liability). */
  OperationDirectionNegative = 'OPERATION_DIRECTION_NEGATIVE',
  /** Operation increases the obligation balance (e.g. income, asset). */
  OperationDirectionPositive = 'OPERATION_DIRECTION_POSITIVE',
  /** Unspecified direction. */
  OperationDirectionUnspecified = 'OPERATION_DIRECTION_UNSPECIFIED'
}

/** One operation line attached to the operation. */
export type QontoAccountingObligationsFirstpartyV2_OperationLine = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_OperationLine';
  /** Line amount. */
  amount: QontoCommon_CurrencyAmount;
  /** Category key for the line. */
  categoryKey: Scalars['String']['output'];
  /** Unique identifier of the line. */
  id: Scalars['String']['output'];
  /** Line label. */
  label: Scalars['String']['output'];
  /** Line position. */
  number: Scalars['Int']['output'];
};

/** Resource counters matched against an operation. */
export type QontoAccountingObligationsFirstpartyV2_OperationMatchedResources = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_OperationMatchedResources';
  /** Number of matched documents. */
  documents: Scalars['Int']['output'];
  /** Number of matched transactions. */
  transactions: Scalars['Int']['output'];
};

/** Metadata associated with the operation. */
export type QontoAccountingObligationsFirstpartyV2_OperationMetadata = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_OperationMetadata';
  /** Whether the transaction-operation is flagged as document lost. */
  attachmentLost?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the transaction-operation is flagged as document not required. */
  attachmentRequired?: Maybe<Scalars['Boolean']['output']>;
};

/** Reconciliation candidate linked to an operation. */
export type QontoAccountingObligationsFirstpartyV2_OperationReconciliation = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_OperationReconciliation';
  /** Amount associated with this reconciliation item. */
  amount?: Maybe<QontoCommon_CurrencyAmount>;
  /** Attachment UUID associated with the reconciliation item, if any. */
  attachmentId?: Maybe<Scalars['String']['output']>;
  /** Human-readable name of the linked resource. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Date of the linked resource in YYYY-MM-DD format. */
  documentDate: Scalars['String']['output'];
  /** UUID of the linked ledger entry. */
  ledgerEntryId: Scalars['String']['output'];
  /** Type of reconciliation item. */
  type: QontoAccountingEntriesFirstpartyV2_ReconciliationItemType;
};

/** Filter status for operations returned by ListOperations. */
export enum QontoAccountingObligationsFirstpartyV2_OperationStatus {
  /** Operation requires user action before reconciliation. */
  OperationStatusActionNeeded = 'OPERATION_STATUS_ACTION_NEEDED',
  /** Operation is ready to be reconciled. */
  OperationStatusReady = 'OPERATION_STATUS_READY',
  /** Default value. When omitted in request, server defaults to ACTION_NEEDED. */
  OperationStatusUnspecified = 'OPERATION_STATUS_UNSPECIFIED'
}

/**
 * Type of operation available for reconciliation.
 * Can be either a transaction or a specific document type.
 */
export enum QontoAccountingObligationsFirstpartyV2_OperationType {
  /** Customer credit note. */
  OperationTypeCustomerCreditNote = 'OPERATION_TYPE_CUSTOMER_CREDIT_NOTE',
  /** Expense document. */
  OperationTypeExpense = 'OPERATION_TYPE_EXPENSE',
  /** Receivable invoice. */
  OperationTypeReceivableInvoice = 'OPERATION_TYPE_RECEIVABLE_INVOICE',
  /** Supplier credit note. */
  OperationTypeSupplierCreditNote = 'OPERATION_TYPE_SUPPLIER_CREDIT_NOTE',
  /** Supplier invoice. */
  OperationTypeSupplierInvoice = 'OPERATION_TYPE_SUPPLIER_INVOICE',
  /** Operation backed by a bank transaction. */
  OperationTypeTransaction = 'OPERATION_TYPE_TRANSACTION',
  /** Unspecified operation type. */
  OperationTypeUnspecified = 'OPERATION_TYPE_UNSPECIFIED'
}

/**
 * Request for the obligations dashboard preview.
 *
 * The organization is resolved from the PASETO of the authenticated user.
 */
export type QontoAccountingObligationsFirstpartyV2_PreviewObligationsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Response containing a summary of the organization's current obligations,
 * structured by obligation type for easy consumption by the dashboard header.
 */
export type QontoAccountingObligationsFirstpartyV2_PreviewObligationsResponse = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_PreviewObligationsResponse';
  /**
   * Summary of the current VAT obligation, computed on-the-fly from the
   * current ledger state. Absent for organizations on a tax exemption regime.
   */
  vat?: Maybe<QontoAccountingObligationsFirstpartyV2_VatPreview>;
};

/**
 * One step of the obligation lifecycle, rendered as a vertical stepper on the
 * obligation detail page. Order is significant: steps are returned
 * chronologically.
 */
export type QontoAccountingObligationsFirstpartyV2_TimelineStep = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_TimelineStep';
  /**
   * Date the step is due or expected to happen (YYYY-MM-DD). Absent when no
   * date applies — today that is the accountant review, whose offset is not
   * defined yet.
   */
  date?: Maybe<Scalars['String']['output']>;
  /**
   * Stage of the lifecycle this step represents. The frontend composes the
   * wording from the kind and the state, which is why a step carries no label:
   * the same step reads "9 operations to complete" while outstanding and
   * "Operations completed" once cleared.
   */
  kind: QontoAccountingObligationsFirstpartyV2_TimelineStepKind;
  /** Progress of this step. */
  state: QontoAccountingObligationsFirstpartyV2_TimelineStepState;
};

/** Stage of the obligation lifecycle a timeline step represents. */
export enum QontoAccountingObligationsFirstpartyV2_TimelineStepKind {
  /** Review of the declaration by the accountant. */
  TimelineStepKindAccountantReview = 'TIMELINE_STEP_KIND_ACCOUNTANT_REVIEW',
  /** Filing of the declaration to the tax authority and payment. */
  TimelineStepKindFilingAndPayment = 'TIMELINE_STEP_KIND_FILING_AND_PAYMENT',
  /** Operations in the obligation period still needing action from the client. */
  TimelineStepKindOperationsToComplete = 'TIMELINE_STEP_KIND_OPERATIONS_TO_COMPLETE',
  /** Unspecified kind — used as default value. */
  TimelineStepKindUnspecified = 'TIMELINE_STEP_KIND_UNSPECIFIED'
}

/**
 * Progress of a timeline step. Exactly one step is CURRENT — the first one
 * that is not DONE — unless every step is DONE.
 */
export enum QontoAccountingObligationsFirstpartyV2_TimelineStepState {
  /** Step is the one currently to act on. */
  TimelineStepStateCurrent = 'TIMELINE_STEP_STATE_CURRENT',
  /** Step has been completed. */
  TimelineStepStateDone = 'TIMELINE_STEP_STATE_DONE',
  /** Unspecified state — used as default value. */
  TimelineStepStateUnspecified = 'TIMELINE_STEP_STATE_UNSPECIFIED',
  /** Step has not been reached yet. */
  TimelineStepStateUpcoming = 'TIMELINE_STEP_STATE_UPCOMING'
}

/**
 * Payload for the unverified_entries anomaly.
 * Carries the count of ledger entries with status = draft within the
 * obligation period, used by the frontend for i18n interpolation.
 */
export type QontoAccountingObligationsFirstpartyV2_UnverifiedEntriesAnomaly = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_UnverifiedEntriesAnomaly';
  /** Number of unverified (draft) ledger entries in the obligation period. */
  count: Scalars['Int']['output'];
};

/**
 * A single CA3 box row, aggregating ledger entry lines that share a
 * (line_code, account_code) combination. Stored as a snapshot at declaration
 * time — account_code is TEXT so later chart-of-accounts changes do not
 * mutate historical filings.
 */
export type QontoAccountingObligationsFirstpartyV2_VatDeclarationLine = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_VatDeclarationLine';
  /** Snapshot of the source account code, e.g. "445710". */
  accountCode: Scalars['String']['output'];
  /** CA3 box code, e.g. "0206" (20% VAT collected). Leading zeros preserved. */
  lineCode: Scalars['String']['output'];
  /**
   * VAT amount derived from base × rate. Stored explicitly to handle rounding
   * and manual overrides. Signed: see vat_base_amount.
   */
  vatAmount: QontoCommon_CurrencyAmount;
  /**
   * Base on which VAT is computed. Signed: negatives allowed for corrections
   * and credit notes (value starts with "-").
   */
  vatBaseAmount: QontoCommon_CurrencyAmount;
  /**
   * VAT rate for this box, e.g. "20.0000". Null for boxes aggregating
   * exempt or exonerated turnover.
   */
  vatRatePercent?: Maybe<Scalars['String']['output']>;
};

/**
 * Manually-set metadata for a VAT declaration, distinct from the
 * auto-computed VAT breakdown. Grows as new manually-set overrides are
 * added.
 */
export type QontoAccountingObligationsFirstpartyV2_VatDeclarationMetadata = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_VatDeclarationMetadata';
  /**
   * VAT amount to pay (MOA). Always set once the VAT declaration has been
   * filed, holding either the manually-set custom value or, absent an
   * override, the computed `to_pay` value.
   */
  customAmountToPay?: Maybe<QontoCommon_CurrencyAmount>;
};

/** Workflow status of a VAT declaration. */
export enum QontoAccountingObligationsFirstpartyV2_VatDeclarationStatus {
  /** Declaration is being prepared by the accountant. */
  VatDeclarationStatusAccountantSide = 'VAT_DECLARATION_STATUS_ACCOUNTANT_SIDE',
  /** Declaration has been sent to the client for review. */
  VatDeclarationStatusClientSide = 'VAT_DECLARATION_STATUS_CLIENT_SIDE',
  /** Declaration has been successfully filed. Terminal state. */
  VatDeclarationStatusCompleted = 'VAT_DECLARATION_STATUS_COMPLETED',
  /** Real-time VAT engine calculation — no declaration has been persisted yet. */
  VatDeclarationStatusComputed = 'VAT_DECLARATION_STATUS_COMPUTED',
  /** Unspecified status — used as default value. */
  VatDeclarationStatusUnspecified = 'VAT_DECLARATION_STATUS_UNSPECIFIED'
}

/**
 * VAT declaration associated with the obligation, including the full CA3
 * box breakdown. Only present when a declaration has been created for the
 * obligation.
 */
export type QontoAccountingObligationsFirstpartyV2_VatDetail = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_VatDetail';
  /**
   * Timestamp when the declaration reached the COMPLETED status (i.e. was
   * officially filed). Null while the declaration is still in progress.
   */
  declaredAt?: Maybe<Scalars['TimestampProto']['output']>;
  /**
   * VAT breakdown. For persisted declarations each row is a CA3 box
   * aggregating ledger lines sharing a (line_code, account_code) combination.
   * For status = VAT_DECLARATION_STATUS_COMPUTED each row represents one VAT
   * rate, with line_code and account_code set to empty string.
   */
  lines: Array<QontoAccountingObligationsFirstpartyV2_VatDeclarationLine>;
  /**
   * True when the declaration details have been manually edited and diverge
   * from the auto-computed VAT engine output. Used as a UI badge.
   */
  manuallyEdited: Scalars['Boolean']['output'];
  /**
   * Manually-set metadata overrides for the declaration. Null when none
   * have been set.
   */
  metadata?: Maybe<QontoAccountingObligationsFirstpartyV2_VatDeclarationMetadata>;
  /** Current workflow status of the declaration. */
  status: QontoAccountingObligationsFirstpartyV2_VatDeclarationStatus;
  /**
   * Net amount due to the tax administration.
   * Equal to total_collected_vat - total_deductible_vat.
   * A negative value (starting with "-") indicates a VAT credit owed to the
   * organization.
   */
  toPay: QontoCommon_CurrencyAmount;
  /** Sum of collected (output) VAT across all rates. */
  totalCollectedVat: QontoCommon_CurrencyAmount;
  /** Sum of deductible (input) VAT across all rates. */
  totalDeductibleVat: QontoCommon_CurrencyAmount;
};

/**
 * How often the organization files VAT, which is what makes an obligation
 * period readable as "August 2026" rather than "Q3 2026".
 *
 * Set on VAT obligations only. The other types have no equivalent: a corporate
 * tax quarterly instalment covers Jan 1 – Mar 15 and a CFE balance covers the
 * fiscal year start through Dec 15, so neither is a month, a quarter or a year.
 *
 * It describes the period the obligation already covers, not the organization's
 * current VAT regime. The two agree until the regime is changed, after which
 * obligations generated under the previous one keep reporting it.
 */
export enum QontoAccountingObligationsFirstpartyV2_VatPeriodicity {
  /** One calendar month, from the 1st to the last day of the month. */
  VatPeriodicityMonthly = 'VAT_PERIODICITY_MONTHLY',
  /**
   * One natural calendar quarter, starting in January, April, July or October.
   * Quarters follow the calendar rather than the organization's fiscal year.
   */
  VatPeriodicityQuarterly = 'VAT_PERIODICITY_QUARTERLY',
  /** Unspecified — the obligation is not a VAT obligation. */
  VatPeriodicityUnspecified = 'VAT_PERIODICITY_UNSPECIFIED'
}

/** VAT summary for the dashboard header card (current VAT period). */
export type QontoAccountingObligationsFirstpartyV2_VatPreview = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_VatPreview';
  /** Inclusive end of the current VAT period (YYYY-MM-DD). */
  endsAt: Scalars['String']['output'];
  /** Last day to file the VAT return for this period (YYYY-MM-DD). */
  filingDueDate: Scalars['String']['output'];
  /**
   * Number of bank transactions in the current VAT period that still have no
   * linked proof attachment (same semantics as the Transactions "missing
   * receipts" filter). Absent when the count could not be resolved.
   */
  missingAttachmentsCount?: Maybe<Scalars['Int']['output']>;
  /**
   * UUID of the persisted VAT obligation slot for the current period.
   * Absent when obligations have not been generated yet for the active setup.
   */
  obligationId?: Maybe<Scalars['String']['output']>;
  /** Inclusive start of the current VAT period (YYYY-MM-DD). */
  startsAt: Scalars['String']['output'];
  /**
   * Net VAT amount due to the tax administration for the current period.
   * Negative value indicates a VAT credit owed to the organization.
   */
  vatPayable: QontoCommon_CurrencyAmount;
};

/**
 * Lightweight VAT summary for obligation list views.
 *
 * Present only on VAT obligations. Non-VAT types (corporate tax, CFE, DAS2)
 * omit this field entirely.
 */
export type QontoAccountingObligationsFirstpartyV2_VatSummary = {
  __typename?: 'QontoAccountingObligationsFirstpartyV2_VatSummary';
  /**
   * Timestamp when the VAT return was officially filed (declaration status
   * COMPLETED). Absent while the return is still in progress or only computed
   * on-the-fly from the current ledger state.
   */
  declaredAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** When true, indicates this was submitted as a nil (zero-amount) declaration. */
  nilDeclaration?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Net VAT amount due to the tax administration for the obligation period.
   * Negative value indicates a VAT credit owed to the organization.
   */
  toPay: QontoCommon_CurrencyAmount;
};

/** An organization's onboarding checklist. */
export type QontoAccountingOnboardingFirstpartyV2_OnboardingChecklist = {
  __typename?: 'QontoAccountingOnboardingFirstpartyV2_OnboardingChecklist';
  /** When the whole checklist was completed (all required steps), if applicable. */
  completedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** ISO country of the checklist configuration (e.g. "FR"). */
  country: Scalars['String']['output'];
  /** Unique identifier for the checklist. */
  id: Scalars['String']['output'];
  /** The checklist steps in configured order. */
  items: Array<QontoAccountingOnboardingFirstpartyV2_OnboardingChecklistItem>;
  /** The checklist's phases, in configured order. */
  phases: Array<QontoAccountingOnboardingFirstpartyV2_OnboardingChecklistPhase>;
  /** Overall status. */
  status: QontoAccountingOnboardingFirstpartyV2_OnboardingChecklistStatus;
};

/** An organization's onboarding checklist. */
export type QontoAccountingOnboardingFirstpartyV2_OnboardingChecklistInput = {
  /** When the whole checklist was completed (all required steps), if applicable. */
  completedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** ISO country of the checklist configuration (e.g. "FR"). */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the checklist. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The checklist steps in configured order. */
  items?: InputMaybe<Array<QontoAccountingOnboardingFirstpartyV2_OnboardingChecklistItemInput>>;
  /** The checklist's phases, in configured order. */
  phases?: InputMaybe<Array<QontoAccountingOnboardingFirstpartyV2_OnboardingChecklistPhaseInput>>;
  /** Overall status. */
  status?: InputMaybe<QontoAccountingOnboardingFirstpartyV2_OnboardingChecklistStatus>;
};

/**
 * A single onboarding step, combining its static definition (from config) with
 * its derived display status and completion metadata.
 */
export type QontoAccountingOnboardingFirstpartyV2_OnboardingChecklistItem = {
  __typename?: 'QontoAccountingOnboardingFirstpartyV2_OnboardingChecklistItem';
  /**
   * Action key identifying the step's CTA, if any (e.g. "confirm_iban").
   * Unset when there's nothing to trigger (locked, already completed, or a
   * pure FE-navigation step). Whether an action is a one-click trigger or
   * needs a form first — and which form — is FE-owned knowledge keyed by
   * this value, the same way step titles/descriptions are FE-owned. Actual
   * triggering still goes through TriggerOnboardingStepAction(step_code).
   */
  action?: Maybe<Scalars['String']['output']>;
  /** Who can act on this step. */
  assignees: Array<QontoAccountingOnboardingFirstpartyV2_OnboardingStepAssignee>;
  /** When the step was completed, if it is completed. */
  completedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /**
   * Membership UUID of the person who completed the step, when completion was
   * a manual confirmation (OWNER or ACCOUNTANT source). Unset for SYSTEM
   * completions. Kept separate from source for audit/attribution purposes
   * (e.g. displaying "confirmed by <name>").
   */
  confirmedBy?: Maybe<Scalars['String']['output']>;
  /** Code of the phase the step belongs to. */
  phaseCode: Scalars['String']['output'];
  /**
   * Which category completed the step. Distinct from confirmed_by: source is
   * always populated once completed (including SYSTEM, which has no
   * confirmed_by), and tells FE the category directly instead of requiring a
   * membership lookup to know whether confirmed_by was the owner or the
   * accountant.
   */
  source: QontoAccountingOnboardingFirstpartyV2_OnboardingStepAssignee;
  /**
   * Derived display status. LOCKED already reflects unmet dependencies, so
   * FE doesn't need the raw dependency graph to know whether a step is
   * actionable.
   */
  status: QontoAccountingOnboardingFirstpartyV2_OnboardingStepStatus;
  /** Stable step code (e.g. "tax_settings_validated"). */
  stepCode: Scalars['String']['output'];
};

/**
 * A single onboarding step, combining its static definition (from config) with
 * its derived display status and completion metadata.
 */
export type QontoAccountingOnboardingFirstpartyV2_OnboardingChecklistItemInput = {
  /**
   * Action key identifying the step's CTA, if any (e.g. "confirm_iban").
   * Unset when there's nothing to trigger (locked, already completed, or a
   * pure FE-navigation step). Whether an action is a one-click trigger or
   * needs a form first — and which form — is FE-owned knowledge keyed by
   * this value, the same way step titles/descriptions are FE-owned. Actual
   * triggering still goes through TriggerOnboardingStepAction(step_code).
   */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Who can act on this step. */
  assignees?: InputMaybe<Array<QontoAccountingOnboardingFirstpartyV2_OnboardingStepAssignee>>;
  /** When the step was completed, if it is completed. */
  completedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /**
   * Membership UUID of the person who completed the step, when completion was
   * a manual confirmation (OWNER or ACCOUNTANT source). Unset for SYSTEM
   * completions. Kept separate from source for audit/attribution purposes
   * (e.g. displaying "confirmed by <name>").
   */
  confirmedBy?: InputMaybe<Scalars['String']['input']>;
  /** Code of the phase the step belongs to. */
  phaseCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * Which category completed the step. Distinct from confirmed_by: source is
   * always populated once completed (including SYSTEM, which has no
   * confirmed_by), and tells FE the category directly instead of requiring a
   * membership lookup to know whether confirmed_by was the owner or the
   * accountant.
   */
  source?: InputMaybe<QontoAccountingOnboardingFirstpartyV2_OnboardingStepAssignee>;
  /**
   * Derived display status. LOCKED already reflects unmet dependencies, so
   * FE doesn't need the raw dependency graph to know whether a step is
   * actionable.
   */
  status?: InputMaybe<QontoAccountingOnboardingFirstpartyV2_OnboardingStepStatus>;
  /** Stable step code (e.g. "tax_settings_validated"). */
  stepCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A phase groups related steps for display and unlocking purposes. Labels and
 * unlock-condition copy are FE-owned (keyed by phase_code), matching how step
 * titles/descriptions are handled.
 */
export type QontoAccountingOnboardingFirstpartyV2_OnboardingChecklistPhase = {
  __typename?: 'QontoAccountingOnboardingFirstpartyV2_OnboardingChecklistPhase';
  /** Display order of the phase. */
  order: Scalars['Int']['output'];
  /** Stable phase code (e.g. "tax_setup"). */
  phaseCode: Scalars['String']['output'];
};

/**
 * A phase groups related steps for display and unlocking purposes. Labels and
 * unlock-condition copy are FE-owned (keyed by phase_code), matching how step
 * titles/descriptions are handled.
 */
export type QontoAccountingOnboardingFirstpartyV2_OnboardingChecklistPhaseInput = {
  /** Display order of the phase. */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Stable phase code (e.g. "tax_setup"). */
  phaseCode?: InputMaybe<Scalars['String']['input']>;
};

/** Overall status of an onboarding checklist. */
export enum QontoAccountingOnboardingFirstpartyV2_OnboardingChecklistStatus {
  /** Every required step is completed. */
  OnboardingChecklistStatusCompleted = 'ONBOARDING_CHECKLIST_STATUS_COMPLETED',
  /** At least one required step is not yet completed. */
  OnboardingChecklistStatusInProgress = 'ONBOARDING_CHECKLIST_STATUS_IN_PROGRESS',
  /** Unspecified status. */
  OnboardingChecklistStatusUnspecified = 'ONBOARDING_CHECKLIST_STATUS_UNSPECIFIED'
}

/** Who can act on / is responsible for a step. */
export enum QontoAccountingOnboardingFirstpartyV2_OnboardingStepAssignee {
  /** The accountant managing the organization on behalf of the accounting firm. */
  OnboardingStepAssigneeAccountant = 'ONBOARDING_STEP_ASSIGNEE_ACCOUNTANT',
  /**
   * The organization's own user (the accounting firm's client), referred to
   * as "owner" throughout this domain.
   */
  OnboardingStepAssigneeOwner = 'ONBOARDING_STEP_ASSIGNEE_OWNER',
  /** Completed automatically, with no human action required. */
  OnboardingStepAssigneeSystem = 'ONBOARDING_STEP_ASSIGNEE_SYSTEM',
  /** Unspecified. */
  OnboardingStepAssigneeUnspecified = 'ONBOARDING_STEP_ASSIGNEE_UNSPECIFIED'
}

/**
 * Display status of a single onboarding step, derived from persisted completion
 * state and dependency gating.
 */
export enum QontoAccountingOnboardingFirstpartyV2_OnboardingStepStatus {
  /** The step has been completed. */
  OnboardingStepStatusCompleted = 'ONBOARDING_STEP_STATUS_COMPLETED',
  /** One or more of the step's dependencies are not yet completed. */
  OnboardingStepStatusLocked = 'ONBOARDING_STEP_STATUS_LOCKED',
  /** The step is actionable but not yet completed. */
  OnboardingStepStatusPending = 'ONBOARDING_STEP_STATUS_PENDING',
  /** Unspecified status. */
  OnboardingStepStatusUnspecified = 'ONBOARDING_STEP_STATUS_UNSPECIFIED',
  /** The step is blocked on the owner. */
  OnboardingStepStatusWaitingForOwner = 'ONBOARDING_STEP_STATUS_WAITING_FOR_OWNER'
}

/** Supplier fields that can be used to deduplicate list results. */
export enum QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_DistinctByField {
  /** Deduplicate by supplier IBAN. */
  DistinctByFieldIban = 'DISTINCT_BY_FIELD_IBAN',
  /** Deduplicate by supplier name. */
  DistinctByFieldName = 'DISTINCT_BY_FIELD_NAME',
  /** Unspecified field. */
  DistinctByFieldUnspecified = 'DISTINCT_BY_FIELD_UNSPECIFIED'
}

/** Request to get a supplier by ID. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_GetSupplierRequest = {
  __typename?: 'QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_GetSupplierRequest';
  /** Supplier ID (UUID). */
  id: Scalars['String']['output'];
};

/** Request to get a supplier by ID. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_GetSupplierRequestInput = {
  /** Supplier ID (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Response containing a single supplier. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_GetSupplierResponse = {
  __typename?: 'QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_GetSupplierResponse';
  /** The requested supplier. */
  supplier: QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier;
};

/** Response containing a single supplier. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_GetSupplierResponseInput = {
  /** The requested supplier. */
  supplier: QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SupplierInput;
};

/**
 * Request to search suppliers with filters, sorting, and pagination.
 * Organization ID is extracted from the PASETO of the authenticated user.
 */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SearchSuppliersRequest = {
  __typename?: 'QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SearchSuppliersRequest';
  /**
   * Filter criteria.
   * Note: when `filter` is omitted, or `filter.statuses` is empty,
   * only unarchived suppliers are returned. See SupplierFilter.statuses.
   */
  filter?: Maybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SupplierFilter>;
  /** Pagination parameters. */
  pagination: QontoCommon_PaginationInput;
  /** Sort order. Defaults to name ascending. */
  sort?: Maybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Sort>;
};

/**
 * Request to search suppliers with filters, sorting, and pagination.
 * Organization ID is extracted from the PASETO of the authenticated user.
 */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SearchSuppliersRequestInput = {
  /**
   * Filter criteria.
   * Note: when `filter` is omitted, or `filter.statuses` is empty,
   * only unarchived suppliers are returned. See SupplierFilter.statuses.
   */
  filter?: InputMaybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SupplierFilterInput>;
  /** Pagination parameters. */
  pagination: QontoCommon_PaginationInputInput;
  /** Sort order. Defaults to name ascending. */
  sort?: InputMaybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SortInput>;
};

/** Response containing a paginated list of suppliers matching the search. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SearchSuppliersResponse = {
  __typename?: 'QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SearchSuppliersResponse';
  /** Pagination metadata. */
  meta: QontoCommon_PaginationMeta;
  /** Matched suppliers. */
  suppliers: Array<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier>;
};

/** Response containing a paginated list of suppliers matching the search. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SearchSuppliersResponseInput = {
  /** Pagination metadata. */
  meta: QontoCommon_PaginationMetaInput;
  /** Matched suppliers. */
  suppliers?: InputMaybe<Array<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SupplierInput>>;
};

/** Sorting options for list requests. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Sort = {
  __typename?: 'QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Sort';
  /** Sort direction. */
  direction: QontoCommon_SortDirection;
  /** Field to sort by. */
  field: QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SortField;
};

/** Field to sort suppliers by. */
export enum QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SortField {
  /** Sort by supplier name. */
  SortFieldName = 'SORT_FIELD_NAME',
  /** Sort by outstanding balance. */
  SortFieldOutstandingBalance = 'SORT_FIELD_OUTSTANDING_BALANCE',
  /**
   * Sort by similarity score.
   * Only meaningful when filter.reference_invoice_id is set in SearchSuppliersRequest.
   * Silently falls back to default sorting (name ascending) when used without it.
   */
  SortFieldSimilarityScore = 'SORT_FIELD_SIMILARITY_SCORE',
  /** Unspecified field. */
  SortFieldUnspecified = 'SORT_FIELD_UNSPECIFIED'
}

/** Sorting options for list requests. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SortInput = {
  /** Sort direction. */
  direction?: InputMaybe<QontoCommon_SortDirection>;
  /** Field to sort by. */
  field?: InputMaybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SortField>;
};

/** Supplier entity. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier = {
  __typename?: 'QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier';
  /** Postal address of the supplier. */
  address?: Maybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_Address>;
  /** Contact information of the supplier. */
  contactInfo?: Maybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_ContactInfo>;
  /** Timestamp when the supplier was created. */
  createdAt: Scalars['TimestampProto']['output'];
  /** Supplier's default invoicing currency (ISO 4217). Defaults to EUR. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Default VAT rate applied to invoices from this supplier (e.g. 0.20 for 20%). */
  defaultVatRate?: Maybe<Scalars['Float']['output']>;
  /** Italian e-invoicing configuration of the supplier. */
  eInvoicing?: Maybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_EInvoicingInfo>;
  /** Unique identifier (UUID). */
  id: Scalars['String']['output'];
  /** Display name. */
  name: Scalars['String']['output'];
  /** ID of the organization that owns this supplier. */
  organizationId: Scalars['String']['output'];
  /**
   * Outstanding balance owed to this supplier, always reported in EUR.
   * The currency field in CurrencyAmount is part of the standard money representation
   * used across our APIs and will always be EUR, regardless of the supplier's invoicing currency.
   * Populated only when the caller has the supplier_invoices.access_insights permission.
   */
  outstandingBalance?: Maybe<QontoCommon_CurrencyAmount>;
  /** Payment information of the supplier. */
  paymentDetails?: Maybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_PaymentDetails>;
  /** Similarity score (when filtering by reference invoice). */
  similarityScore?: Maybe<Scalars['Int']['output']>;
  /** Current status of the supplier. */
  status: QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SupplierStatus;
  /** Tax identifiers of the supplier. */
  taxIdentifiers?: Maybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_TaxIdentifiers>;
  /** Timestamp when the supplier was last updated. */
  updatedAt: Scalars['TimestampProto']['output'];
};

/** Filter criteria for supplier list and search requests. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SupplierFilter = {
  __typename?: 'QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SupplierFilter';
  /** Deduplicate results by the specified supplier fields. */
  distinctBy: Array<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_DistinctByField>;
  /**
   * Filter by IBAN presence.
   * true = only suppliers with an IBAN; false = only suppliers without an IBAN.
   */
  hasIban?: Maybe<Scalars['Boolean']['output']>;
  /** Filter by supplier IDs. */
  ids: Array<Scalars['String']['output']>;
  /**
   * Filter by reference invoice ID to enable similarity scoring.
   * Required for SORT_FIELD_SIMILARITY_SCORE to take effect.
   */
  referenceInvoiceId?: Maybe<Scalars['String']['output']>;
  /** Partial text search against the supplier name. */
  search?: Maybe<Scalars['String']['output']>;
  /**
   * Filter by status. Multiple values are OR-combined.
   * If omitted or empty, only unarchived suppliers are returned
   * (the default excludes ARCHIVED). To include archived suppliers,
   * callers must explicitly pass the desired statuses (e.g. [UNARCHIVED, ARCHIVED, DRAFT]).
   */
  statuses: Array<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SupplierStatus>;
};

/** Filter criteria for supplier list and search requests. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SupplierFilterInput = {
  /** Deduplicate results by the specified supplier fields. */
  distinctBy?: InputMaybe<Array<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_DistinctByField>>;
  /**
   * Filter by IBAN presence.
   * true = only suppliers with an IBAN; false = only suppliers without an IBAN.
   */
  hasIban?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by supplier IDs. */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filter by reference invoice ID to enable similarity scoring.
   * Required for SORT_FIELD_SIMILARITY_SCORE to take effect.
   */
  referenceInvoiceId?: InputMaybe<Scalars['String']['input']>;
  /** Partial text search against the supplier name. */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter by status. Multiple values are OR-combined.
   * If omitted or empty, only unarchived suppliers are returned
   * (the default excludes ARCHIVED). To include archived suppliers,
   * callers must explicitly pass the desired statuses (e.g. [UNARCHIVED, ARCHIVED, DRAFT]).
   */
  statuses?: InputMaybe<Array<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SupplierStatus>>;
};

/** Supplier entity. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SupplierInput = {
  /** Postal address of the supplier. */
  address?: InputMaybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_AddressInput>;
  /** Contact information of the supplier. */
  contactInfo?: InputMaybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_ContactInfoInput>;
  /** Timestamp when the supplier was created. */
  createdAt: Scalars['TimestampProto']['input'];
  /** Supplier's default invoicing currency (ISO 4217). Defaults to EUR. */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Default VAT rate applied to invoices from this supplier (e.g. 0.20 for 20%). */
  defaultVatRate?: InputMaybe<Scalars['Float']['input']>;
  /** Italian e-invoicing configuration of the supplier. */
  eInvoicing?: InputMaybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_EInvoicingInfoInput>;
  /** Unique identifier (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Display name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the organization that owns this supplier. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Outstanding balance owed to this supplier, always reported in EUR.
   * The currency field in CurrencyAmount is part of the standard money representation
   * used across our APIs and will always be EUR, regardless of the supplier's invoicing currency.
   * Populated only when the caller has the supplier_invoices.access_insights permission.
   */
  outstandingBalance?: InputMaybe<QontoCommon_CurrencyAmountInput>;
  /** Payment information of the supplier. */
  paymentDetails?: InputMaybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_PaymentDetailsInput>;
  /** Similarity score (when filtering by reference invoice). */
  similarityScore?: InputMaybe<Scalars['Int']['input']>;
  /** Current status of the supplier. */
  status?: InputMaybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SupplierStatus>;
  /** Tax identifiers of the supplier. */
  taxIdentifiers?: InputMaybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_TaxIdentifiersInput>;
  /** Timestamp when the supplier was last updated. */
  updatedAt: Scalars['TimestampProto']['input'];
};

/** Supplier status. */
export enum QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SupplierStatus {
  /** Supplier is archived. */
  SupplierStatusArchived = 'SUPPLIER_STATUS_ARCHIVED',
  /** Supplier is a draft (not yet fully created). */
  SupplierStatusDraft = 'SUPPLIER_STATUS_DRAFT',
  /** Supplier is active (not archived). */
  SupplierStatusUnarchived = 'SUPPLIER_STATUS_UNARCHIVED',
  /** Unspecified status. */
  SupplierStatusUnspecified = 'SUPPLIER_STATUS_UNSPECIFIED'
}

/** Postal address. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_Address = {
  __typename?: 'QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_Address';
  /** City. */
  city?: Maybe<Scalars['String']['output']>;
  /** ISO 3166-1 alpha-2 country code. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Province or state code. */
  provinceCode?: Maybe<Scalars['String']['output']>;
  /** Street address. */
  streetAddress?: Maybe<Scalars['String']['output']>;
  /** Postal/zip code. */
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** Postal address. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_AddressInput = {
  /** City. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 alpha-2 country code. */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Province or state code. */
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  /** Street address. */
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  /** Postal/zip code. */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Contact information. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_ContactInfo = {
  __typename?: 'QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_ContactInfo';
  /** Email address. */
  email?: Maybe<Scalars['String']['output']>;
  /** Phone number. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Contact information. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_ContactInfoInput = {
  /** Email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Phone number. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** E-invoicing configuration. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_EInvoicingInfo = {
  __typename?: 'QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_EInvoicingInfo';
  /** Italian e-invoicing recipient code (Codice Destinatario). */
  recipientCode?: Maybe<Scalars['String']['output']>;
};

/** E-invoicing configuration. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_EInvoicingInfoInput = {
  /** Italian e-invoicing recipient code (Codice Destinatario). */
  recipientCode?: InputMaybe<Scalars['String']['input']>;
};

/** Payment data. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_PaymentDetails = {
  __typename?: 'QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_PaymentDetails';
  /**
   * IBAN of the supplier's bank account.
   * Obfuscated for non-draft suppliers unless the caller has the
   * suppliers.see_sensitive_fields permission.
   */
  iban?: Maybe<Scalars['String']['output']>;
};

/** Payment data. */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_PaymentDetailsInput = {
  /**
   * IBAN of the supplier's bank account.
   * Obfuscated for non-draft suppliers unless the caller has the
   * suppliers.see_sensitive_fields permission.
   */
  iban?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Tax identifiers. Redacted for non-draft suppliers unless the caller has
 * the suppliers.see_sensitive_fields permission.
 */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_TaxIdentifiers = {
  __typename?: 'QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_TaxIdentifiers';
  /** Tax Identification Number (TIN). */
  tinNumber?: Maybe<Scalars['String']['output']>;
  /** VAT identification number. */
  vatNumber?: Maybe<Scalars['String']['output']>;
};

/**
 * Tax identifiers. Redacted for non-draft suppliers unless the caller has
 * the suppliers.see_sensitive_fields permission.
 */
export type QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_Supplier_TaxIdentifiersInput = {
  /** Tax Identification Number (TIN). */
  tinNumber?: InputMaybe<Scalars['String']['input']>;
  /** VAT identification number. */
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

/** GetEnrichmentsRequest is the request for batch enrichment data */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_BatchGetEnrichmentsRequest = {
  __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_BatchGetEnrichmentsRequest';
  /** transaction_ids is the list of transaction IDs to fetch enrichment for */
  transactionParams: Array<QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionParams>;
};

/** GetEnrichmentsRequest is the request for batch enrichment data */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_BatchGetEnrichmentsRequestInput = {
  /** transaction_ids is the list of transaction IDs to fetch enrichment for */
  transactionParams?: InputMaybe<Array<QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionParamsInput>>;
};

/** GetEnrichmentsResponse is the response containing enrichment data */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_BatchGetEnrichmentsResponse = {
  __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_BatchGetEnrichmentsResponse';
  /** enrichments is the list of enrichment data per transaction */
  enrichments: Array<QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichment>;
};

/** GetEnrichmentsResponse is the response containing enrichment data */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_BatchGetEnrichmentsResponseInput = {
  /** enrichments is the list of enrichment data per transaction */
  enrichments?: InputMaybe<Array<QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichmentInput>>;
};

/** Logo contains logo image URLs */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_Logo = {
  __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_Logo';
  /** medium is the medium logo URL */
  medium: Scalars['String']['output'];
  /** small is the small logo URL */
  small: Scalars['String']['output'];
};

/** Logo contains logo image URLs */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_LogoInput = {
  /** medium is the medium logo URL */
  medium?: InputMaybe<Scalars['String']['input']>;
  /** small is the small logo URL */
  small?: InputMaybe<Scalars['String']['input']>;
};

/** TransactionEnrichment contains enrichment data for a single transaction */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichment = {
  __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichment';
  /** counterparty_name is the enriched and cleaned counterparty name, i.e. Google, Spotify */
  counterpartyName: Scalars['String']['output'];
  /** id is the enrichment identifier */
  id: Scalars['String']['output'];
  /**
   * is_enriched is a flag indicating whether the transaction has been enriched. For system transactions (biller, etc.) this will be false, yet a logo will still be returned
   * Without this flag there is no way to distinguish if a transaction is enriched or not, we have to base it on the fact if the record exists in the db
   */
  isEnriched: Scalars['Boolean']['output'];
  /** logo contains the logo URLs */
  logo?: Maybe<QontoAppSystemsApiEnrichmentsFirstpartyV1_Logo>;
  /** transaction_id is the transaction this enrichment belongs to */
  transactionId: Scalars['String']['output'];
};

/** TransactionEnrichment contains enrichment data for a single transaction */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichmentInput = {
  /** counterparty_name is the enriched and cleaned counterparty name, i.e. Google, Spotify */
  counterpartyName?: InputMaybe<Scalars['String']['input']>;
  /** id is the enrichment identifier */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * is_enriched is a flag indicating whether the transaction has been enriched. For system transactions (biller, etc.) this will be false, yet a logo will still be returned
   * Without this flag there is no way to distinguish if a transaction is enriched or not, we have to base it on the fact if the record exists in the db
   */
  isEnriched?: InputMaybe<Scalars['Boolean']['input']>;
  /** logo contains the logo URLs */
  logo?: InputMaybe<QontoAppSystemsApiEnrichmentsFirstpartyV1_LogoInput>;
  /** transaction_id is the transaction this enrichment belongs to */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/** TransactionParams represent the tuple of transaction_id, operation_type that is required to properly compute and serialize the response */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionParams = {
  __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionParams';
  /** operation_type is the operation type of the transaction, used to compute the logo for Qonto-originated transactions - biller, etc. */
  operationType: Scalars['String']['output'];
  /** transaction_id is the transaction ID to fetch enrichment for */
  transactionId: Scalars['String']['output'];
};

/** TransactionParams represent the tuple of transaction_id, operation_type that is required to properly compute and serialize the response */
export type QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionParamsInput = {
  /** operation_type is the operation type of the transaction, used to compute the logo for Qonto-originated transactions - biller, etc. */
  operationType?: InputMaybe<Scalars['String']['input']>;
  /** transaction_id is the transaction ID to fetch enrichment for */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/** ActivityTag defines the merchant activity classification of a transaction */
export enum QontoAppSystemsTransactionsFirstpartyV8_ActivityTag {
  /** ACTIVITY_TAG_ATM is for ATM withdrawals */
  ActivityTagAtm = 'ACTIVITY_TAG_ATM',
  /** ACTIVITY_TAG_DIRECT_DEBIT_HOLD is for direct debit hold transactions */
  ActivityTagDirectDebitHold = 'ACTIVITY_TAG_DIRECT_DEBIT_HOLD',
  /** ACTIVITY_TAG_FALLBACK is the fallback classification */
  ActivityTagFallback = 'ACTIVITY_TAG_FALLBACK',
  /** ACTIVITY_TAG_FEES is for fee transactions */
  ActivityTagFees = 'ACTIVITY_TAG_FEES',
  /** ACTIVITY_TAG_FINANCE is for finance-related transactions */
  ActivityTagFinance = 'ACTIVITY_TAG_FINANCE',
  /** ACTIVITY_TAG_FOOD_AND_GROCERY is for food and grocery expenses */
  ActivityTagFoodAndGrocery = 'ACTIVITY_TAG_FOOD_AND_GROCERY',
  /** ACTIVITY_TAG_GAS_STATION is for gas station expenses */
  ActivityTagGasStation = 'ACTIVITY_TAG_GAS_STATION',
  /** ACTIVITY_TAG_HARDWARE_AND_EQUIPMENT is for hardware and equipment expenses */
  ActivityTagHardwareAndEquipment = 'ACTIVITY_TAG_HARDWARE_AND_EQUIPMENT',
  /** ACTIVITY_TAG_HOTEL_AND_LODGING is for hotel and lodging expenses */
  ActivityTagHotelAndLodging = 'ACTIVITY_TAG_HOTEL_AND_LODGING',
  /** ACTIVITY_TAG_INSURANCE is for insurance expenses */
  ActivityTagInsurance = 'ACTIVITY_TAG_INSURANCE',
  /** ACTIVITY_TAG_IT_AND_ELECTRONICS is for IT and electronics expenses */
  ActivityTagItAndElectronics = 'ACTIVITY_TAG_IT_AND_ELECTRONICS',
  /** ACTIVITY_TAG_LEGAL_AND_ACCOUNTING is for legal and accounting expenses */
  ActivityTagLegalAndAccounting = 'ACTIVITY_TAG_LEGAL_AND_ACCOUNTING',
  /** ACTIVITY_TAG_LOGISTICS is for logistics expenses */
  ActivityTagLogistics = 'ACTIVITY_TAG_LOGISTICS',
  /** ACTIVITY_TAG_MANUFACTURING is for manufacturing expenses */
  ActivityTagManufacturing = 'ACTIVITY_TAG_MANUFACTURING',
  /** ACTIVITY_TAG_MARKETING is for marketing expenses */
  ActivityTagMarketing = 'ACTIVITY_TAG_MARKETING',
  /** ACTIVITY_TAG_OFFICE_RENTAL is for office rental expenses */
  ActivityTagOfficeRental = 'ACTIVITY_TAG_OFFICE_RENTAL',
  /** ACTIVITY_TAG_OFFICE_SUPPLY is for office supply expenses */
  ActivityTagOfficeSupply = 'ACTIVITY_TAG_OFFICE_SUPPLY',
  /** ACTIVITY_TAG_ONLINE_SERVICE is for online service expenses */
  ActivityTagOnlineService = 'ACTIVITY_TAG_ONLINE_SERVICE',
  /** ACTIVITY_TAG_OTHER_EXPENSE is for other miscellaneous expenses */
  ActivityTagOtherExpense = 'ACTIVITY_TAG_OTHER_EXPENSE',
  /** ACTIVITY_TAG_OTHER_INCOME is for other income */
  ActivityTagOtherIncome = 'ACTIVITY_TAG_OTHER_INCOME',
  /** ACTIVITY_TAG_OTHER_SERVICE is for other service expenses */
  ActivityTagOtherService = 'ACTIVITY_TAG_OTHER_SERVICE',
  /** ACTIVITY_TAG_PENDING is for transactions pending classification */
  ActivityTagPending = 'ACTIVITY_TAG_PENDING',
  /** ACTIVITY_TAG_REFUND is for refund transactions */
  ActivityTagRefund = 'ACTIVITY_TAG_REFUND',
  /** ACTIVITY_TAG_RESTAURANT_AND_BAR is for restaurant and bar expenses */
  ActivityTagRestaurantAndBar = 'ACTIVITY_TAG_RESTAURANT_AND_BAR',
  /** ACTIVITY_TAG_SALARY is for salary payments */
  ActivityTagSalary = 'ACTIVITY_TAG_SALARY',
  /** ACTIVITY_TAG_SALES is for sales income */
  ActivityTagSales = 'ACTIVITY_TAG_SALES',
  /** ACTIVITY_TAG_SUBSCRIPTION is for subscription payments */
  ActivityTagSubscription = 'ACTIVITY_TAG_SUBSCRIPTION',
  /** ACTIVITY_TAG_TAX is for tax payments */
  ActivityTagTax = 'ACTIVITY_TAG_TAX',
  /** ACTIVITY_TAG_TRANSPORT is for transport expenses */
  ActivityTagTransport = 'ACTIVITY_TAG_TRANSPORT',
  /** ACTIVITY_TAG_TREASURY_AND_INTERCO is for treasury and intercompany transactions */
  ActivityTagTreasuryAndInterco = 'ACTIVITY_TAG_TREASURY_AND_INTERCO',
  /** ACTIVITY_TAG_UNSPECIFIED is the default unspecified value */
  ActivityTagUnspecified = 'ACTIVITY_TAG_UNSPECIFIED',
  /** ACTIVITY_TAG_UTILITY is for utility expenses */
  ActivityTagUtility = 'ACTIVITY_TAG_UTILITY',
  /** ACTIVITY_TAG_VOUCHER is for voucher transactions */
  ActivityTagVoucher = 'ACTIVITY_TAG_VOUCHER'
}

/** AttachmentRequest groups the attachment request state for a transaction */
export type QontoAppSystemsTransactionsFirstpartyV8_AttachmentRequest = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_AttachmentRequest';
  /** requested indicates whether an attachment was requested */
  requested: Scalars['Boolean']['output'];
  /** requested_at is when an attachment was requested */
  requestedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** requested_by_id is the ID of the user who requested the attachment */
  requestedById?: Maybe<Scalars['String']['output']>;
};

/** AuthorizationType defines the type of card authorization for a pending transaction */
export enum QontoAppSystemsTransactionsFirstpartyV8_AuthorizationType {
  /** AUTHORIZATION_TYPE_FULL is a full authorization for the total transaction amount */
  AuthorizationTypeFull = 'AUTHORIZATION_TYPE_FULL',
  /** AUTHORIZATION_TYPE_REMAINING is an authorization for the remaining outstanding amount */
  AuthorizationTypeRemaining = 'AUTHORIZATION_TYPE_REMAINING',
  /** AUTHORIZATION_TYPE_UNSPECIFIED is the default unspecified value */
  AuthorizationTypeUnspecified = 'AUTHORIZATION_TYPE_UNSPECIFIED'
}

/** Conditional defines the logical operator for combining filter groups */
export enum QontoAppSystemsTransactionsFirstpartyV8_Conditional {
  /** CONDITIONAL_AND combines expressions with logical AND */
  ConditionalAnd = 'CONDITIONAL_AND',
  /** CONDITIONAL_AND_NOT combines expressions with logical AND NOT */
  ConditionalAndNot = 'CONDITIONAL_AND_NOT',
  /** CONDITIONAL_OR combines expressions with logical OR */
  ConditionalOr = 'CONDITIONAL_OR',
  /** CONDITIONAL_UNSPECIFIED is the default unspecified value */
  ConditionalUnspecified = 'CONDITIONAL_UNSPECIFIED'
}

/** Counterparty contains the counterparty (recipient/sender) details of a transaction */
export type QontoAppSystemsTransactionsFirstpartyV8_Counterparty = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_Counterparty';
  /** counterparty_account_number is the counterparty account number */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** counterparty_bic is the counterparty BIC */
  bic?: Maybe<Scalars['String']['output']>;
  /** counterparty_iban is the counterparty IBAN (only for external transactions: income, swift_income, direct_debit, transfer) */
  iban?: Maybe<Scalars['String']['output']>;
};

/** DeclinedReason defines the reason a transaction was declined */
export enum QontoAppSystemsTransactionsFirstpartyV8_DeclinedReason {
  /** DECLINED_REASON_ACCOUNT_INACTIVE is declined because the account is inactive */
  DeclinedReasonAccountInactive = 'DECLINED_REASON_ACCOUNT_INACTIVE',
  /** DECLINED_REASON_CANNOT_VERIFY_PIN is declined because the PIN cannot be verified */
  DeclinedReasonCannotVerifyPin = 'DECLINED_REASON_CANNOT_VERIFY_PIN',
  /** DECLINED_REASON_CARDHOLDER_TO_CONTACT_ISSUER is declined and the cardholder must contact the issuer */
  DeclinedReasonCardholderToContactIssuer = 'DECLINED_REASON_CARDHOLDER_TO_CONTACT_ISSUER',
  /** DECLINED_REASON_CUSTOMER_CANCELLATION is declined due to customer cancellation */
  DeclinedReasonCustomerCancellation = 'DECLINED_REASON_CUSTOMER_CANCELLATION',
  /** DECLINED_REASON_DIRECT_DEBIT_POSTPONED is declined because the direct debit was postponed */
  DeclinedReasonDirectDebitPostponed = 'DECLINED_REASON_DIRECT_DEBIT_POSTPONED',
  /** DECLINED_REASON_DO_NOT_HONOR is declined by the issuer without specific reason */
  DeclinedReasonDoNotHonor = 'DECLINED_REASON_DO_NOT_HONOR',
  /** DECLINED_REASON_EXCEEDS_WITHDRAWAL_AMOUNT_LIMIT is declined because the withdrawal amount limit was exceeded */
  DeclinedReasonExceedsWithdrawalAmountLimit = 'DECLINED_REASON_EXCEEDS_WITHDRAWAL_AMOUNT_LIMIT',
  /** DECLINED_REASON_EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT is declined because the withdrawal frequency limit was exceeded */
  DeclinedReasonExceedsWithdrawalFrequencyLimit = 'DECLINED_REASON_EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT',
  /** DECLINED_REASON_EXPIRED_CARD is declined because the card has expired */
  DeclinedReasonExpiredCard = 'DECLINED_REASON_EXPIRED_CARD',
  /** DECLINED_REASON_INCORRECT_PIN is declined due to an incorrect PIN */
  DeclinedReasonIncorrectPin = 'DECLINED_REASON_INCORRECT_PIN',
  /** DECLINED_REASON_INSUFFICIENT_FUNDS is declined due to insufficient funds */
  DeclinedReasonInsufficientFunds = 'DECLINED_REASON_INSUFFICIENT_FUNDS',
  /** DECLINED_REASON_INVALID_AMOUNT is declined due to an invalid amount */
  DeclinedReasonInvalidAmount = 'DECLINED_REASON_INVALID_AMOUNT',
  /** DECLINED_REASON_INVALID_CARD_NUMBER is declined due to an invalid card number */
  DeclinedReasonInvalidCardNumber = 'DECLINED_REASON_INVALID_CARD_NUMBER',
  /** DECLINED_REASON_INVALID_MERCHANT is declined due to an invalid merchant */
  DeclinedReasonInvalidMerchant = 'DECLINED_REASON_INVALID_MERCHANT',
  /** DECLINED_REASON_ISSUER_OR_SWITCH_IS_INOPERATIVE is declined because the issuer or switch is inoperative */
  DeclinedReasonIssuerOrSwitchIsInoperative = 'DECLINED_REASON_ISSUER_OR_SWITCH_IS_INOPERATIVE',
  /** DECLINED_REASON_LOST_CARD is declined because the card was reported lost */
  DeclinedReasonLostCard = 'DECLINED_REASON_LOST_CARD',
  /** DECLINED_REASON_MERCHANT_NAME_AND_COUNTRY_UNKNOWN is declined because merchant name and country are unknown */
  DeclinedReasonMerchantNameAndCountryUnknown = 'DECLINED_REASON_MERCHANT_NAME_AND_COUNTRY_UNKNOWN',
  /** DECLINED_REASON_NOT_PERMITTED_TO_CARDHOLDER is declined because the transaction is not permitted to the cardholder */
  DeclinedReasonNotPermittedToCardholder = 'DECLINED_REASON_NOT_PERMITTED_TO_CARDHOLDER',
  /** DECLINED_REASON_NOT_PERMITTED_TO_TERMINAL is declined because the transaction is not permitted to the terminal */
  DeclinedReasonNotPermittedToTerminal = 'DECLINED_REASON_NOT_PERMITTED_TO_TERMINAL',
  /** DECLINED_REASON_OPS_CANCELED is declined because operations canceled */
  DeclinedReasonOpsCanceled = 'DECLINED_REASON_OPS_CANCELED',
  /** DECLINED_REASON_OTHER_REASON is declined for another reason not listed */
  DeclinedReasonOtherReason = 'DECLINED_REASON_OTHER_REASON',
  /** DECLINED_REASON_PIN_TRIES_EXCEEDED is declined because the PIN attempt limit was exceeded */
  DeclinedReasonPinTriesExceeded = 'DECLINED_REASON_PIN_TRIES_EXCEEDED',
  /** DECLINED_REASON_RESPONSE_RECEIVED_TOO_LATE is declined because the response was received too late */
  DeclinedReasonResponseReceivedTooLate = 'DECLINED_REASON_RESPONSE_RECEIVED_TOO_LATE',
  /** DECLINED_REASON_RESTRICTED_CARD is declined because the card is restricted */
  DeclinedReasonRestrictedCard = 'DECLINED_REASON_RESTRICTED_CARD',
  /** DECLINED_REASON_SECURITY_VIOLATION is declined due to a security violation */
  DeclinedReasonSecurityViolation = 'DECLINED_REASON_SECURITY_VIOLATION',
  /** DECLINED_REASON_STOLEN_CARD is declined because the card was reported stolen */
  DeclinedReasonStolenCard = 'DECLINED_REASON_STOLEN_CARD',
  /** DECLINED_REASON_SYSTEM_MALFUNCTION is declined due to a system malfunction */
  DeclinedReasonSystemMalfunction = 'DECLINED_REASON_SYSTEM_MALFUNCTION',
  /** DECLINED_REASON_TIMEOUT is declined due to a timeout */
  DeclinedReasonTimeout = 'DECLINED_REASON_TIMEOUT',
  /** DECLINED_REASON_UNABLE_TO_ROUTE_TRANSACTION is declined because the transaction could not be routed */
  DeclinedReasonUnableToRouteTransaction = 'DECLINED_REASON_UNABLE_TO_ROUTE_TRANSACTION',
  /** DECLINED_REASON_UNSPECIFIED is the default unspecified value */
  DeclinedReasonUnspecified = 'DECLINED_REASON_UNSPECIFIED',
  /** DECLINED_REASON_USER_CANCELED is declined because the user canceled */
  DeclinedReasonUserCanceled = 'DECLINED_REASON_USER_CANCELED'
}

/** FilterExpression defines a single filter condition */
export type QontoAppSystemsTransactionsFirstpartyV8_FilterExpressionInput = {
  /** operator is the comparison operator */
  operator?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_Operator>;
  /** property is the field to filter on */
  property?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_FilterProperty>;
  /** values are the values to compare against */
  values?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_ValueInput>>;
};

/** FilterGroup defines a logical group of filter expressions */
export type QontoAppSystemsTransactionsFirstpartyV8_FilterGroupInput = {
  /** conditional is the logical operator for combining expressions */
  conditional?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_Conditional>;
  /** expressions are the filter conditions in this group */
  expressions?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_FilterGroupOrExpressionInput>>;
};

/** FilterGroupOrExpression is a union of a filter expression or a nested filter group */
export type QontoAppSystemsTransactionsFirstpartyV8_FilterGroupOrExpressionInput = {
  /** filter_expression is a single filter condition */
  filterExpression?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_FilterExpressionInput>;
  /** filter_group is a nested filter group */
  filterGroup?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_FilterGroupInput>;
};

/** FilterProperty defines the available transaction fields for filtering */
export enum QontoAppSystemsTransactionsFirstpartyV8_FilterProperty {
  /** FILTER_PROPERTY_ACCOUNT_TYPE filters by account type */
  FilterPropertyAccountType = 'FILTER_PROPERTY_ACCOUNT_TYPE',
  /** FILTER_PROPERTY_ACTIVITY_TAG filters by activity tag */
  FilterPropertyActivityTag = 'FILTER_PROPERTY_ACTIVITY_TAG',
  /** FILTER_PROPERTY_AMOUNT filters by amount (remapped to amount.raw by API adapter) */
  FilterPropertyAmount = 'FILTER_PROPERTY_AMOUNT',
  /** FILTER_PROPERTY_AMOUNT_CURRENCY filters by transaction amount currency (ISO 4217 code) */
  FilterPropertyAmountCurrency = 'FILTER_PROPERTY_AMOUNT_CURRENCY',
  /** FILTER_PROPERTY_AMOUNT_WITH_FX_FEES filters by amount with FX fees (remapped to amount_with_fx_fees.raw by API adapter) */
  FilterPropertyAmountWithFxFees = 'FILTER_PROPERTY_AMOUNT_WITH_FX_FEES',
  /** FILTER_PROPERTY_ATTACHMENT_IDS filters by attachment IDs */
  FilterPropertyAttachmentIds = 'FILTER_PROPERTY_ATTACHMENT_IDS',
  /** FILTER_PROPERTY_ATTACHMENT_STATUS filters by attachment status (remapped to has_attachment + attachment_lost_or_not_required) */
  FilterPropertyAttachmentStatus = 'FILTER_PROPERTY_ATTACHMENT_STATUS',
  /** FILTER_PROPERTY_BANK_ACCOUNT_ID filters by bank account ID */
  FilterPropertyBankAccountId = 'FILTER_PROPERTY_BANK_ACCOUNT_ID',
  /** FILTER_PROPERTY_BRAND_ID filters by brand ID */
  FilterPropertyBrandId = 'FILTER_PROPERTY_BRAND_ID',
  /** FILTER_PROPERTY_CARD_ID filters by card ID */
  FilterPropertyCardId = 'FILTER_PROPERTY_CARD_ID',
  /** FILTER_PROPERTY_CATEGORY_ASSIGNMENT_CATEGORY_ID filters by category assignment category ID */
  FilterPropertyCategoryAssignmentCategoryId = 'FILTER_PROPERTY_CATEGORY_ASSIGNMENT_CATEGORY_ID',
  /** FILTER_PROPERTY_CATEGORY_ASSIGNMENT_SOURCE filters by category assignment source */
  FilterPropertyCategoryAssignmentSource = 'FILTER_PROPERTY_CATEGORY_ASSIGNMENT_SOURCE',
  /** FILTER_PROPERTY_CATEGORY_IDS filters by the cash-flow category IDs allocated to the transaction */
  FilterPropertyCategoryIds = 'FILTER_PROPERTY_CATEGORY_IDS',
  /** FILTER_PROPERTY_COUNTERPARTY_BANK_ACCOUNT_ID filters by counterparty bank account ID (complex nested query) */
  FilterPropertyCounterpartyBankAccountId = 'FILTER_PROPERTY_COUNTERPARTY_BANK_ACCOUNT_ID',
  /** FILTER_PROPERTY_CREATED_AT filters by creation date */
  FilterPropertyCreatedAt = 'FILTER_PROPERTY_CREATED_AT',
  /** FILTER_PROPERTY_DISPLAY_AT filters by display date (remapped with timezone formatting) */
  FilterPropertyDisplayAt = 'FILTER_PROPERTY_DISPLAY_AT',
  /** FILTER_PROPERTY_DISPLAY_NAME filters by display name (remapped to counterparty_name + clean_counterparty_name) */
  FilterPropertyDisplayName = 'FILTER_PROPERTY_DISPLAY_NAME',
  /** FILTER_PROPERTY_EMITTED_AT filters by emission date */
  FilterPropertyEmittedAt = 'FILTER_PROPERTY_EMITTED_AT',
  /** FILTER_PROPERTY_EXCLUDED_FROM_ANALYTICS filters by analytics exclusion status */
  FilterPropertyExcludedFromAnalytics = 'FILTER_PROPERTY_EXCLUDED_FROM_ANALYTICS',
  /** FILTER_PROPERTY_EXCLUDE_MERGED_FEES controls whether merged fees are excluded (controller-only, not forwarded to search engine) */
  FilterPropertyExcludeMergedFees = 'FILTER_PROPERTY_EXCLUDE_MERGED_FEES',
  /** FILTER_PROPERTY_ID filters by transaction ID */
  FilterPropertyId = 'FILTER_PROPERTY_ID',
  /** FILTER_PROPERTY_INITIATOR_ID filters by initiator user ID */
  FilterPropertyInitiatorId = 'FILTER_PROPERTY_INITIATOR_ID',
  /** FILTER_PROPERTY_IS_MERGED_FEE filters by merged fee status */
  FilterPropertyIsMergedFee = 'FILTER_PROPERTY_IS_MERGED_FEE',
  /** FILTER_PROPERTY_LABEL_IDS filters by label IDs */
  FilterPropertyLabelIds = 'FILTER_PROPERTY_LABEL_IDS',
  /** FILTER_PROPERTY_LABEL_LIST_IDS filters by label list IDs */
  FilterPropertyLabelListIds = 'FILTER_PROPERTY_LABEL_LIST_IDS',
  /** FILTER_PROPERTY_MANDATE_ID filters by mandate ID */
  FilterPropertyMandateId = 'FILTER_PROPERTY_MANDATE_ID',
  /** FILTER_PROPERTY_NOTE filters by note content */
  FilterPropertyNote = 'FILTER_PROPERTY_NOTE',
  /** FILTER_PROPERTY_OPERATION_METHOD filters by payment method */
  FilterPropertyOperationMethod = 'FILTER_PROPERTY_OPERATION_METHOD',
  /** FILTER_PROPERTY_OPERATION_TYPE filters by operation type */
  FilterPropertyOperationType = 'FILTER_PROPERTY_OPERATION_TYPE',
  /** FILTER_PROPERTY_QUALIFIED_FOR_ACCOUNTING filters by qualified for accounting status */
  FilterPropertyQualifiedForAccounting = 'FILTER_PROPERTY_QUALIFIED_FOR_ACCOUNTING',
  /** FILTER_PROPERTY_REFERENCE filters by reference */
  FilterPropertyReference = 'FILTER_PROPERTY_REFERENCE',
  /** FILTER_PROPERTY_SETTLED_AT filters by settlement date */
  FilterPropertySettledAt = 'FILTER_PROPERTY_SETTLED_AT',
  /** FILTER_PROPERTY_SIDE filters by transaction side (debit/credit) */
  FilterPropertySide = 'FILTER_PROPERTY_SIDE',
  /** FILTER_PROPERTY_SLUG filters by transaction slug */
  FilterPropertySlug = 'FILTER_PROPERTY_SLUG',
  /** FILTER_PROPERTY_STATUS filters by transaction status */
  FilterPropertyStatus = 'FILTER_PROPERTY_STATUS',
  /** FILTER_PROPERTY_TEAM_ID filters by team ID (remapped to initiator_id via membership lookup) */
  FilterPropertyTeamId = 'FILTER_PROPERTY_TEAM_ID',
  /** FILTER_PROPERTY_TRANSACTION_FEES filters by transaction fee status (remapped to is_related_fee) */
  FilterPropertyTransactionFees = 'FILTER_PROPERTY_TRANSACTION_FEES',
  /** FILTER_PROPERTY_UNSPECIFIED is the default unspecified value */
  FilterPropertyUnspecified = 'FILTER_PROPERTY_UNSPECIFIED',
  /** FILTER_PROPERTY_UPDATED_AT filters by last update date */
  FilterPropertyUpdatedAt = 'FILTER_PROPERTY_UPDATED_AT',
  /** FILTER_PROPERTY_VAT_COMPLETENESS filters by VAT completeness status */
  FilterPropertyVatCompleteness = 'FILTER_PROPERTY_VAT_COMPLETENESS'
}

/** Request for fetching child transaction links of a parent transaction. */
export type QontoAppSystemsTransactionsFirstpartyV8_GetChildTransactionLinksRequestInput = {
  /** The link types to retrieve. If empty, all link types will be retrieved. */
  linkTypes?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_LinkType>>;
  /** Pagination parameters */
  pagination?: InputMaybe<QontoCommon_PaginationInputInput>;
  /** The ID of the parent transaction. */
  parentTransactionId?: InputMaybe<Scalars['String']['input']>;
  /** sort defines the sort criteria */
  sort?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_SortInput>>;
};

/** GetChildTransactionsResponse is the response message containing child transaction links */
export type QontoAppSystemsTransactionsFirstpartyV8_GetChildTransactionLinksResponse = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_GetChildTransactionLinksResponse';
  /** links is the list of child transaction links */
  links: Array<QontoAppSystemsTransactionsFirstpartyV8_TransactionLink>;
  /** meta contains pagination metadata */
  meta: QontoCommon_PaginationMeta;
};

/** GetChildTransactionsRequest is the request message for fetching child transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_GetChildTransactionsRequestInput = {
  /** parent_ids is the list of parent transaction IDs whose children to fetch */
  parentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** GetChildTransactionsResponse is the response message containing child transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_GetChildTransactionsResponse = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_GetChildTransactionsResponse';
  /** transactions is the list of child transactions */
  transactions: Array<QontoAppSystemsTransactionsFirstpartyV8_Transaction>;
};

/** Request for fetching parent transaction links of a child transaction. */
export type QontoAppSystemsTransactionsFirstpartyV8_GetParentTransactionLinksRequestInput = {
  /** The ID of the child transaction. */
  childTransactionId?: InputMaybe<Scalars['String']['input']>;
  /** The link types to retrieve. If empty, all link types will be retrieved. */
  linkTypes?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_LinkType>>;
  /** Pagination parameters */
  pagination?: InputMaybe<QontoCommon_PaginationInputInput>;
  /** sort defines the sort criteria */
  sort?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_SortInput>>;
};

/** GetParentTransactionsResponse is the response message containing parent transaction links */
export type QontoAppSystemsTransactionsFirstpartyV8_GetParentTransactionLinksResponse = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_GetParentTransactionLinksResponse';
  /** links is the list of parent transaction links */
  links: Array<QontoAppSystemsTransactionsFirstpartyV8_TransactionLink>;
  /** meta contains pagination metadata */
  meta: QontoCommon_PaginationMeta;
};

/** GetParentTransactionsRequest is the request message for fetching parent transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_GetParentTransactionsRequestInput = {
  /** child_ids is the list of child transaction IDs whose parents to fetch */
  childIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** GetParentTransactionsResponse is the response message containing parent transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_GetParentTransactionsResponse = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_GetParentTransactionsResponse';
  /** transactions is the list of parent transactions */
  transactions: Array<QontoAppSystemsTransactionsFirstpartyV8_Transaction>;
};

/** GetTransactionAttachmentStatusesRequest is the request for batch attachment status */
export type QontoAppSystemsTransactionsFirstpartyV8_GetTransactionAttachmentStatusesRequestInput = {
  /** transaction_ids is the list of transaction IDs to fetch attachment status for */
  transactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** GetTransactionAttachmentStatusesResponse is the response containing attachment status data */
export type QontoAppSystemsTransactionsFirstpartyV8_GetTransactionAttachmentStatusesResponse = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_GetTransactionAttachmentStatusesResponse';
  /** attachment_statuses is the list of attachment status data per transaction */
  attachmentStatuses: Array<QontoAppSystemsTransactionsFirstpartyV8_TransactionAttachmentStatus>;
};

/** LinkType defines the type of the link between transactions in a parent-child relationship. */
export enum QontoAppSystemsTransactionsFirstpartyV8_LinkType {
  /** DDC Repayment link type: used to link a DDC repayment transaction to its underlying card transactions */
  LinkTypeDdcRepayment = 'LINK_TYPE_DDC_REPAYMENT',
  /** Merged fee link type: for fees charged in relation to parent transaction; fee+parent amounts get summed, fee transaction hidden from customer */
  LinkTypeMergedFee = 'LINK_TYPE_MERGED_FEE',
  /** Related fee link type: for fees charged in relation to parent transaction; fee transaction visible to customer */
  LinkTypeRelatedFee = 'LINK_TYPE_RELATED_FEE',
  /** Unspecified link type */
  LinkTypeUnspecified = 'LINK_TYPE_UNSPECIFIED'
}

/** OperationMethod defines the payment method used for a transaction */
export enum QontoAppSystemsTransactionsFirstpartyV8_OperationMethod {
  /** OPERATION_METHOD_BILLER is a billing fee transaction */
  OperationMethodBiller = 'OPERATION_METHOD_BILLER',
  /** OPERATION_METHOD_CARD is a card payment */
  OperationMethodCard = 'OPERATION_METHOD_CARD',
  /** OPERATION_METHOD_CARD_ACQUIRER_ONLINE_PAYOUT is a card acquirer online payout */
  OperationMethodCardAcquirerOnlinePayout = 'OPERATION_METHOD_CARD_ACQUIRER_ONLINE_PAYOUT',
  /** OPERATION_METHOD_CARD_ACQUIRER_PAYOUT is a card acquirer payout */
  OperationMethodCardAcquirerPayout = 'OPERATION_METHOD_CARD_ACQUIRER_PAYOUT',
  /** OPERATION_METHOD_CASHBACK is a card cashback payout or adjustment */
  OperationMethodCashback = 'OPERATION_METHOD_CASHBACK',
  /** OPERATION_METHOD_CHEQUE is a cheque payment */
  OperationMethodCheque = 'OPERATION_METHOD_CHEQUE',
  /** OPERATION_METHOD_DDC is a deferred debit card payment */
  OperationMethodDdc = 'OPERATION_METHOD_DDC',
  /** OPERATION_METHOD_DIRECT_DEBIT is a direct debit (also covers direct debit collections) */
  OperationMethodDirectDebit = 'OPERATION_METHOD_DIRECT_DEBIT',
  /** OPERATION_METHOD_DIRECT_DEBIT_HOLD is a hold for a future direct debit */
  OperationMethodDirectDebitHold = 'OPERATION_METHOD_DIRECT_DEBIT_HOLD',
  /** OPERATION_METHOD_ESIM_DATA_PURCHASE is a transaction representing the purchase of an eSIM data plan */
  OperationMethodEsimDataPurchase = 'OPERATION_METHOD_ESIM_DATA_PURCHASE',
  /** OPERATION_METHOD_INVESTMENT is an investment transaction */
  OperationMethodInvestment = 'OPERATION_METHOD_INVESTMENT',
  /** OPERATION_METHOD_OTHER is an uncategorized transaction type */
  OperationMethodOther = 'OPERATION_METHOD_OTHER',
  /** OPERATION_METHOD_OVERDRAFT is a transaction that got a short-term credit when the amount was bigger than the available balance */
  OperationMethodOverdraft = 'OPERATION_METHOD_OVERDRAFT',
  /** OPERATION_METHOD_PAGOPA_PAYMENT is a PagoPA payment */
  OperationMethodPagopaPayment = 'OPERATION_METHOD_PAGOPA_PAYMENT',
  /** OPERATION_METHOD_PAY_LATER is a deferred pay later payment */
  OperationMethodPayLater = 'OPERATION_METHOD_PAY_LATER',
  /** OPERATION_METHOD_REMUNERATION is an account remuneration */
  OperationMethodRemuneration = 'OPERATION_METHOD_REMUNERATION',
  /** OPERATION_METHOD_RIBA_PAYMENT is an Italian RIBA payment */
  OperationMethodRibaPayment = 'OPERATION_METHOD_RIBA_PAYMENT',
  /** OPERATION_METHOD_TAX is a tax payment (covers f24 and nrc payment types) */
  OperationMethodTax = 'OPERATION_METHOD_TAX',
  /** OPERATION_METHOD_TRANSFER is a bank transfer (also covers income, recall, swift income, and international outgoing transfers) */
  OperationMethodTransfer = 'OPERATION_METHOD_TRANSFER',
  /** OPERATION_METHOD_UNSPECIFIED is the default unspecified value */
  OperationMethodUnspecified = 'OPERATION_METHOD_UNSPECIFIED'
}

/** OperationType defines the fine-grained type of a transaction operation */
export enum QontoAppSystemsTransactionsFirstpartyV8_OperationType {
  /** OPERATION_TYPE_ACCOUNT_REMUNERATION is an account remuneration */
  OperationTypeAccountRemuneration = 'OPERATION_TYPE_ACCOUNT_REMUNERATION',
  /** OPERATION_TYPE_BILLER is a billing fee transaction */
  OperationTypeBiller = 'OPERATION_TYPE_BILLER',
  /** OPERATION_TYPE_CARD is a card payment */
  OperationTypeCard = 'OPERATION_TYPE_CARD',
  /** OPERATION_TYPE_CARD_ACQUIRER_ONLINE_PAYOUT is a card acquirer online payout */
  OperationTypeCardAcquirerOnlinePayout = 'OPERATION_TYPE_CARD_ACQUIRER_ONLINE_PAYOUT',
  /** OPERATION_TYPE_CARD_ACQUIRER_PAYOUT is a card acquirer payout */
  OperationTypeCardAcquirerPayout = 'OPERATION_TYPE_CARD_ACQUIRER_PAYOUT',
  /** OPERATION_TYPE_CASHBACK_ADJUSTMENT is a cashback adjustment */
  OperationTypeCashbackAdjustment = 'OPERATION_TYPE_CASHBACK_ADJUSTMENT',
  /** OPERATION_TYPE_CASHBACK_PAYOUT is a cashback payout */
  OperationTypeCashbackPayout = 'OPERATION_TYPE_CASHBACK_PAYOUT',
  /** OPERATION_TYPE_CHEQUE is a cheque payment */
  OperationTypeCheque = 'OPERATION_TYPE_CHEQUE',
  /** OPERATION_TYPE_DIRECT_DEBIT is a direct debit payment */
  OperationTypeDirectDebit = 'OPERATION_TYPE_DIRECT_DEBIT',
  /** OPERATION_TYPE_DIRECT_DEBIT_COLLECTION is a direct debit collection */
  OperationTypeDirectDebitCollection = 'OPERATION_TYPE_DIRECT_DEBIT_COLLECTION',
  /** OPERATION_TYPE_DIRECT_DEBIT_HOLD is a hold for a future direct debit */
  OperationTypeDirectDebitHold = 'OPERATION_TYPE_DIRECT_DEBIT_HOLD',
  /** OPERATION_TYPE_ESIM_DATA_PURCHASE is a transaction representing the purchase of an eSIM data plan */
  OperationTypeEsimDataPurchase = 'OPERATION_TYPE_ESIM_DATA_PURCHASE',
  /** OPERATION_TYPE_EXTERNAL_FEES is fees transactions from external banks */
  OperationTypeExternalFees = 'OPERATION_TYPE_EXTERNAL_FEES',
  /** OPERATION_TYPE_F24 is an Italian F24 tax payment */
  OperationTypeF24 = 'OPERATION_TYPE_F24',
  /** OPERATION_TYPE_FINANCING_INSTALLMENT is a financing installment payment */
  OperationTypeFinancingInstallment = 'OPERATION_TYPE_FINANCING_INSTALLMENT',
  /** OPERATION_TYPE_INCOME is an incoming transfer */
  OperationTypeIncome = 'OPERATION_TYPE_INCOME',
  /** OPERATION_TYPE_INVESTMENT is an investment transaction */
  OperationTypeInvestment = 'OPERATION_TYPE_INVESTMENT',
  /** OPERATION_TYPE_INVESTMENT_PROMO is an investment promo bonus payout */
  OperationTypeInvestmentPromo = 'OPERATION_TYPE_INVESTMENT_PROMO',
  /** OPERATION_TYPE_NRC_PAYMENT is an Italian NRC tax payment */
  OperationTypeNrcPayment = 'OPERATION_TYPE_NRC_PAYMENT',
  /** OPERATION_TYPE_OTHER is an uncategorized operation type */
  OperationTypeOther = 'OPERATION_TYPE_OTHER',
  /** OPERATION_TYPE_PAGOPA_PAYMENT is an Italian PagoPA payment */
  OperationTypePagopaPayment = 'OPERATION_TYPE_PAGOPA_PAYMENT',
  /** OPERATION_TYPE_PAY_LATER is a deferred pay later payment */
  OperationTypePayLater = 'OPERATION_TYPE_PAY_LATER',
  /** OPERATION_TYPE_RECALL is a recalled transfer */
  OperationTypeRecall = 'OPERATION_TYPE_RECALL',
  /** OPERATION_TYPE_RIBA_PAYMENT is an Italian RIBA payment */
  OperationTypeRibaPayment = 'OPERATION_TYPE_RIBA_PAYMENT',
  /** OPERATION_TYPE_SWIFT_INCOME is an incoming SWIFT transfer */
  OperationTypeSwiftIncome = 'OPERATION_TYPE_SWIFT_INCOME',
  /** OPERATION_TYPE_TRANSFER is a bank transfer */
  OperationTypeTransfer = 'OPERATION_TYPE_TRANSFER',
  /** OPERATION_TYPE_UNSPECIFIED is the default unspecified value */
  OperationTypeUnspecified = 'OPERATION_TYPE_UNSPECIFIED'
}

/** Operator defines the comparison operators for filter expressions */
export enum QontoAppSystemsTransactionsFirstpartyV8_Operator {
  /** OPERATOR_CALENDAR_INTERVAL matches values within a calendar interval */
  OperatorCalendarInterval = 'OPERATOR_CALENDAR_INTERVAL',
  /** OPERATOR_EQ matches exact equality */
  OperatorEq = 'OPERATOR_EQ',
  /** OPERATOR_EXISTS matches fields that exist */
  OperatorExists = 'OPERATOR_EXISTS',
  /** OPERATOR_GT matches greater than */
  OperatorGt = 'OPERATOR_GT',
  /** OPERATOR_GTE matches greater than or equal */
  OperatorGte = 'OPERATOR_GTE',
  /** OPERATOR_IN matches any value in a list */
  OperatorIn = 'OPERATOR_IN',
  /** OPERATOR_INTERVAL matches values within an interval */
  OperatorInterval = 'OPERATOR_INTERVAL',
  /** OPERATOR_LT matches less than */
  OperatorLt = 'OPERATOR_LT',
  /** OPERATOR_LTE matches less than or equal */
  OperatorLte = 'OPERATOR_LTE',
  /** OPERATOR_MATCH matches text using full-text search */
  OperatorMatch = 'OPERATOR_MATCH',
  /** OPERATOR_NOT_EQ matches inequality */
  OperatorNotEq = 'OPERATOR_NOT_EQ',
  /** OPERATOR_NOT_EXISTS matches fields that do not exist */
  OperatorNotExists = 'OPERATOR_NOT_EXISTS',
  /** OPERATOR_NOT_IN matches values not in a list */
  OperatorNotIn = 'OPERATOR_NOT_IN',
  /** OPERATOR_NOT_MATCH excludes text using full-text search */
  OperatorNotMatch = 'OPERATOR_NOT_MATCH',
  /** OPERATOR_UNSPECIFIED is the default unspecified value */
  OperatorUnspecified = 'OPERATOR_UNSPECIFIED',
  /** OPERATOR_WITHIN matches values within a range */
  OperatorWithin = 'OPERATOR_WITHIN'
}

/** PaymentMetadata contains card details snapshotted at transaction time (both fields are last-4 only) */
export type QontoAppSystemsTransactionsFirstpartyV8_PaymentMetadata = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_PaymentMetadata';
  /** card_last4 is the last 4 digits of a Qonto-issued card (internal card transactions) */
  cardLast4?: Maybe<Scalars['String']['output']>;
  /** card_number is the last 4 digits of a third-party card (external card transactions from aggregated accounts) */
  cardNumber?: Maybe<Scalars['String']['output']>;
};

/** SearchTransactionsRequest is the request message for searching transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsRequestInput = {
  /** filter_group defines the filter criteria */
  filterGroup?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_FilterGroupInput>;
  /** pagination defines the pagination parameters */
  pagination?: InputMaybe<QontoCommon_PaginationInputInput>;
  /** search is a free-text search query */
  search?: InputMaybe<Scalars['String']['input']>;
  /** sort defines the sort criteria */
  sort?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_SortInput>>;
};

/** SearchTransactionsResponse is the response message for searching transactions */
export type QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsResponse = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsResponse';
  /** meta contains pagination metadata */
  meta: QontoCommon_PaginationMeta;
  /** transactions is the list of matching transactions */
  transactions: Array<QontoAppSystemsTransactionsFirstpartyV8_Transaction>;
};

/** Side defines the direction of a transaction relative to the account */
export enum QontoAppSystemsTransactionsFirstpartyV8_Side {
  /** SIDE_CREDIT is a credit (incoming) transaction */
  SideCredit = 'SIDE_CREDIT',
  /** SIDE_DEBIT is a debit (outgoing) transaction */
  SideDebit = 'SIDE_DEBIT',
  /** SIDE_UNSPECIFIED is the default unspecified value */
  SideUnspecified = 'SIDE_UNSPECIFIED'
}

/** SortDirection defines the sort order direction */
export enum QontoAppSystemsTransactionsFirstpartyV8_SortDirection {
  /** SORT_DIRECTION_ASC sorts in ascending order */
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  /** SORT_DIRECTION_DESC sorts in descending order */
  SortDirectionDesc = 'SORT_DIRECTION_DESC',
  /** SORT_DIRECTION_UNSPECIFIED is the default unspecified value */
  SortDirectionUnspecified = 'SORT_DIRECTION_UNSPECIFIED'
}

/** Sort defines the sort criteria for a transaction query */
export type QontoAppSystemsTransactionsFirstpartyV8_SortInput = {
  /** direction is the sort order */
  direction?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_SortDirection>;
  /** property is the field to sort by */
  property?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_SortProperty>;
};

/** SortProperty defines the available transaction fields for sorting */
export enum QontoAppSystemsTransactionsFirstpartyV8_SortProperty {
  /** SORT_PROPERTY_AMOUNT sorts by transaction amount */
  SortPropertyAmount = 'SORT_PROPERTY_AMOUNT',
  /** SORT_PROPERTY_COUNTERPARTY_NAME sorts by counterparty name */
  SortPropertyCounterpartyName = 'SORT_PROPERTY_COUNTERPARTY_NAME',
  /** SORT_PROPERTY_CREATED_AT sorts by creation date (default) */
  SortPropertyCreatedAt = 'SORT_PROPERTY_CREATED_AT',
  /** SORT_PROPERTY_DISPLAY_AT sorts by display date */
  SortPropertyDisplayAt = 'SORT_PROPERTY_DISPLAY_AT',
  /** SORT_PROPERTY_EMITTED_AT sorts by emission date */
  SortPropertyEmittedAt = 'SORT_PROPERTY_EMITTED_AT',
  /** SORT_PROPERTY_OPERATION_METHOD sorts by payment method */
  SortPropertyOperationMethod = 'SORT_PROPERTY_OPERATION_METHOD',
  /** SORT_PROPERTY_SETTLED_AT sorts by settlement date */
  SortPropertySettledAt = 'SORT_PROPERTY_SETTLED_AT',
  /** SORT_PROPERTY_STATUS sorts by transaction status */
  SortPropertyStatus = 'SORT_PROPERTY_STATUS',
  /** SORT_PROPERTY_UNSPECIFIED is the default unspecified value */
  SortPropertyUnspecified = 'SORT_PROPERTY_UNSPECIFIED',
  /** SORT_PROPERTY_UPDATED_AT sorts by last update date */
  SortPropertyUpdatedAt = 'SORT_PROPERTY_UPDATED_AT'
}

/** StatusHistory represents a status transition event */
export type QontoAppSystemsTransactionsFirstpartyV8_StatusHistory = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_StatusHistory';
  /** created_at is when this status was recorded */
  createdAt: Scalars['TimestampProto']['output'];
  /** status is the status value (e.g. "authorized", "settled") */
  status: QontoAppSystemsTransactionsFirstpartyV8_StatusHistoryStatus;
};

/** StatusHistoryStatus defines the status values recorded in a transaction's status history */
export enum QontoAppSystemsTransactionsFirstpartyV8_StatusHistoryStatus {
  /** STATUS_HISTORY_STATUS_AUTHORIZED is the authorized status in the transaction lifecycle */
  StatusHistoryStatusAuthorized = 'STATUS_HISTORY_STATUS_AUTHORIZED',
  /** STATUS_HISTORY_STATUS_SETTLED is the settled status in the transaction lifecycle */
  StatusHistoryStatusSettled = 'STATUS_HISTORY_STATUS_SETTLED',
  /** STATUS_HISTORY_STATUS_UNSPECIFIED is the default unspecified value */
  StatusHistoryStatusUnspecified = 'STATUS_HISTORY_STATUS_UNSPECIFIED'
}

/**
 * SubjectReference groups the depolymorphized subject ids — they are serialized depending on the subject_type
 * Some types can have multiple fields, like Card
 */
export type QontoAppSystemsTransactionsFirstpartyV8_SubjectReference = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_SubjectReference';
  /** account_remuneration_id is the AccountRemuneration subject ID (when subject_type == AccountRemuneration) */
  accountRemunerationId?: Maybe<Scalars['String']['output']>;
  /** billing_transfer_id is the provider_object_id (when subject_type == BillingTransfer, subject_type remapped to WalletToWallet) */
  billingTransferId?: Maybe<Scalars['String']['output']>;
  /** card_acquirer_payout_id is the CardAcquirerPayout subject ID (when subject_type == CardAcquirerPayout) */
  cardAcquirerPayoutId?: Maybe<Scalars['String']['output']>;
  /** card_id is the Card subject ID (when subject_type == Card) */
  cardId?: Maybe<Scalars['String']['output']>;
  /** card_transaction_movement_id is the provider_object_id (when subject_type == Card) */
  cardTransactionMovementId?: Maybe<Scalars['String']['output']>;
  /** cashback_id is the Cashback subject ID (when subject_type == Cashback) */
  cashbackId?: Maybe<Scalars['String']['output']>;
  /** check_id is the provider_object_id (when subject_type == Check) */
  checkId?: Maybe<Scalars['String']['output']>;
  /** direct_debit_collection_id is the DirectDebitCollection subject ID (when subject_type == DirectDebitCollection) */
  directDebitCollectionId?: Maybe<Scalars['String']['output']>;
  /** direct_debit_hold_id is the DirectDebitHold subject ID (when subject_type == DirectDebitHold) */
  directDebitHoldId?: Maybe<Scalars['String']['output']>;
  /** direct_debit_id is the DirectDebit subject ID (when subject_type == DirectDebit) */
  directDebitId?: Maybe<Scalars['String']['output']>;
  /** dispute_id is the transaction ID for which we need to fetch the dispyte (when subject_type == Card) */
  disputeId?: Maybe<Scalars['String']['output']>;
  /** esim_subscription_addon_purchase_id is the EsimSubscriptionAddonPurchase subject ID (when subject_type == EsimSubscriptionAddonPurchase) */
  esimSubscriptionAddonPurchaseId?: Maybe<Scalars['String']['output']>;
  /** f24_payment_id is the F24Payment subject ID (when subject_type == F24Payment) */
  f24PaymentId?: Maybe<Scalars['String']['output']>;
  /** financing_installment_id is the provider_object_id (when subject_type == FinancingInstallment) */
  financingInstallmentId?: Maybe<Scalars['String']['output']>;
  /** income_id is the Income subject ID (when subject_type == Income) */
  incomeId?: Maybe<Scalars['String']['output']>;
  /** nrc_payment_id is the provider_object_id (when subject_type == NrcPayment) */
  nrcPaymentId?: Maybe<Scalars['String']['output']>;
  /** pagopa_payment_id is the provider_object_id (when subject_type == PagopaPayment) */
  pagopaPaymentId?: Maybe<Scalars['String']['output']>;
  /** riba_payment_id is the provider_object_id (when subject_type == RibaPayment) */
  ribaPaymentId?: Maybe<Scalars['String']['output']>;
  /** swift_income_id is the provider_object_id (when subject_type == SwiftIncome) */
  swiftIncomeId?: Maybe<Scalars['String']['output']>;
  /** transfer_id is the Transfer subject ID (when subject_type == Transfer) */
  transferId?: Maybe<Scalars['String']['output']>;
  /** wallet_to_wallet_id is the WalletToWallet subject ID (when subject_type == WalletToWallet) */
  walletToWalletId?: Maybe<Scalars['String']['output']>;
};

/** SubjectType defines the type of a transaction subject. */
export enum QontoAppSystemsTransactionsFirstpartyV8_SubjectType {
  /** Account remuneration (interest on deposits). */
  SubjectTypeAccountRemuneration = 'SUBJECT_TYPE_ACCOUNT_REMUNERATION',
  /** Billing transfer (Qonto fees, subscription charges). */
  SubjectTypeBillingTransfer = 'SUBJECT_TYPE_BILLING_TRANSFER',
  /** Capital deposit transfer. */
  SubjectTypeCapitalDepositTransfer = 'SUBJECT_TYPE_CAPITAL_DEPOSIT_TRANSFER',
  /** Card payment transaction. */
  SubjectTypeCard = 'SUBJECT_TYPE_CARD',
  /** Card acquirer online payout (online merchant settlement). */
  SubjectTypeCardAcquirerOnlinePayout = 'SUBJECT_TYPE_CARD_ACQUIRER_ONLINE_PAYOUT',
  /** Card acquirer payout (merchant settlement). */
  SubjectTypeCardAcquirerPayout = 'SUBJECT_TYPE_CARD_ACQUIRER_PAYOUT',
  /** Card cashback payout or adjustment. */
  SubjectTypeCashback = 'SUBJECT_TYPE_CASHBACK',
  /** Cheque deposit. */
  SubjectTypeCheck = 'SUBJECT_TYPE_CHECK',
  /** SEPA direct debit. */
  SubjectTypeDirectDebit = 'SUBJECT_TYPE_DIRECT_DEBIT',
  /** SEPA direct debit collection (creditor-initiated). */
  SubjectTypeDirectDebitCollection = 'SUBJECT_TYPE_DIRECT_DEBIT_COLLECTION',
  /** SEPA direct debit hold (pending collection). */
  SubjectTypeDirectDebitHold = 'SUBJECT_TYPE_DIRECT_DEBIT_HOLD',
  /** eSIM subscription add-on purchase. */
  SubjectTypeEsimSubscriptionAddonPurchase = 'SUBJECT_TYPE_ESIM_SUBSCRIPTION_ADDON_PURCHASE',
  /** Italian F24 tax payment. */
  SubjectTypeF24Payment = 'SUBJECT_TYPE_F24_PAYMENT',
  /** Financing income (pay later disbursement). */
  SubjectTypeFinancingIncome = 'SUBJECT_TYPE_FINANCING_INCOME',
  /** Financing installment repayment. */
  SubjectTypeFinancingInstallment = 'SUBJECT_TYPE_FINANCING_INSTALLMENT',
  /** Incoming SEPA credit transfer. */
  SubjectTypeIncome = 'SUBJECT_TYPE_INCOME',
  /** Spanish NRC tax payment. */
  SubjectTypeNrcPayment = 'SUBJECT_TYPE_NRC_PAYMENT',
  /** Italian PagoPA payment. */
  SubjectTypePagopaPayment = 'SUBJECT_TYPE_PAGOPA_PAYMENT',
  /** Italian RiBa (Ricevuta Bancaria) payment. */
  SubjectTypeRibaPayment = 'SUBJECT_TYPE_RIBA_PAYMENT',
  /** Incoming SWIFT international transfer. */
  SubjectTypeSwiftIncome = 'SUBJECT_TYPE_SWIFT_INCOME',
  /** Outgoing transfer (SEPA, international, internal). */
  SubjectTypeTransfer = 'SUBJECT_TYPE_TRANSFER',
  /** Unspecified subject type, default zero value. */
  SubjectTypeUnspecified = 'SUBJECT_TYPE_UNSPECIFIED',
  /** Internal wallet-to-wallet transfer between Qonto accounts. */
  SubjectTypeWalletToWallet = 'SUBJECT_TYPE_WALLET_TO_WALLET'
}

/** Transaction represents a slim transaction record with core fields only */
export type QontoAppSystemsTransactionsFirstpartyV8_Transaction = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_Transaction';
  accountRemuneration?: Maybe<AccountRemuneration>;
  /** activity_tag is the activity classification */
  activityTag: QontoAppSystemsTransactionsFirstpartyV8_ActivityTag;
  /** amount is the transaction amount */
  amount: QontoCommon_CurrencyAmount;
  /** attachment_ids is the list of attachment IDs (from ES) */
  attachmentIds: Array<Scalars['String']['output']>;
  /** attachment_request groups the attachment request state (requested, requested_at, requested_by_id) */
  attachmentRequest?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_AttachmentRequest>;
  attachmentStatus?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_TransactionAttachmentStatus>;
  attachments: Array<Attachment>;
  /** authorization_type is the authorization type (only present for pending transactions) */
  authorizationType?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_AuthorizationType>;
  bankAccount?: Maybe<BankAccount>;
  /** bank_account_id is the associated bank account ID */
  bankAccountId: Scalars['String']['output'];
  billingTransfer?: Maybe<BillingTransfer>;
  card?: Maybe<Card>;
  cardAcquirerPayout?: Maybe<CardAcquirerPayout>;
  cardTransaction?: Maybe<CardTransaction>;
  cardTransactionStatus?: Maybe<CardTransactionStatus>;
  cashback?: Maybe<Cashback>;
  categories?: Maybe<QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_Transaction>;
  category?: Maybe<CashFlowCategory>;
  check?: Maybe<Check>;
  childTransactions: Array<QontoAppSystemsTransactionsFirstpartyV8_Transaction>;
  /** clean_counterparty_name returns the enriched counterparty name, if the transaction is enriched, otherwise it will be null */
  cleanCounterpartyName?: Maybe<Scalars['String']['output']>;
  /** counterparty contains the counterparty (recipient/sender) details */
  counterparty?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_Counterparty>;
  /** counterparty_name returns the clean counterparty name or a translated counterparty name for system transactions, like biller fees */
  counterpartyName: Scalars['String']['output'];
  /** created_at is the timestamp of when the transaction record was created in the DB */
  createdAt: Scalars['TimestampProto']['output'];
  /** declined_reason is the reason for decline (if applicable) */
  declinedReason: QontoAppSystemsTransactionsFirstpartyV8_DeclinedReason;
  deferredDebitCardRepayment?: Maybe<DeferredDebitCardRepayment>;
  deferredDebitCardRepaymentDetails?: Maybe<DeferredDebitCardRepaymentDetails>;
  /** description is the transaction description */
  description?: Maybe<Scalars['String']['output']>;
  directDebit?: Maybe<DirectDebit>;
  directDebitCollection?: Maybe<DirectDebitCollection>;
  directDebitHold?: Maybe<DirectDebitHold>;
  /** display_at is the display timestamp = settled_at || emitted_at */
  displayAt: Scalars['TimestampProto']['output'];
  disputes: Array<Dispute>;
  /** emitted_at is when the movement that the transaction represents was emitted in the CBS */
  emittedAt: Scalars['TimestampProto']['output'];
  enrichment?: Maybe<QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichment>;
  /** excluded_from_analytics indicates exclusion from analytics (from ES) */
  excludedFromAnalytics: Scalars['Boolean']['output'];
  f24Payment?: Maybe<F24Payment>;
  financingInstallment?: Maybe<FinancingInstallment>;
  /** fx indicates whether the transaction involves foreign exchange */
  fx: Scalars['Boolean']['output'];
  /** fx_rate is the foreign exchange rate (if applicable) */
  fxRate?: Maybe<Scalars['Float']['output']>;
  /** has_attachment indicates whether the transaction has an attachment (from ES) */
  hasAttachment: Scalars['Boolean']['output'];
  /** id is the unique identifier */
  id: Scalars['String']['output'];
  income?: Maybe<Income>;
  initiator?: Maybe<QontoSpendManagementMembershipsMembershipsFirstpartyV1_Membership>;
  /** initiator_id is the ID of the initiating user */
  initiatorId?: Maybe<Scalars['String']['output']>;
  /** is_atm indicates whether this is an ATM transaction */
  isAtm: Scalars['Boolean']['output'];
  /** is_external_transaction indicates whether this is an external transaction */
  isExternalTransaction: Scalars['Boolean']['output'];
  /** is_merged_fee indicates whether this is a merged fee transaction (from ES) */
  isMergedFee: Scalars['Boolean']['output'];
  /** is_pos indicates whether this is a point-of-sale transaction */
  isPos: Scalars['Boolean']['output'];
  /** is_proxied indicates whether this is a proxied F24 payment */
  isProxied: Scalars['Boolean']['output'];
  /** label_ids is the list of label IDs (from ES) */
  labelIds: Array<Scalars['String']['output']>;
  labels: Array<Label>;
  /** local_amount is the amount in local currency */
  localAmount: QontoCommon_CurrencyAmount;
  matchedExpectedTransactions: Array<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_MatchedExpectedTransaction>;
  mergedFees?: Maybe<RelatedFees>;
  /** merged_fees_id is the ID of merged fees (if applicable) */
  mergedFeesId?: Maybe<Scalars['String']['output']>;
  /** note is a user-provided note */
  note?: Maybe<Scalars['String']['output']>;
  nrcPayment?: Maybe<NrcPayment>;
  /** operation_method is the payment method */
  operationMethod: QontoAppSystemsTransactionsFirstpartyV8_OperationMethod;
  /** operation_type is the operation classification */
  operationType: QontoAppSystemsTransactionsFirstpartyV8_OperationType;
  /** organization_id is sourced from Elasticsearch response */
  organizationId: Scalars['String']['output'];
  overdraftInterestPayment?: Maybe<OverdraftInterestPayment>;
  pagopaPayment?: Maybe<PagopaPayment>;
  parentTransactions: Array<QontoAppSystemsTransactionsFirstpartyV8_Transaction>;
  /** payment_metadata contains card details snapshotted at transaction time */
  paymentMetadata?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_PaymentMetadata>;
  /** provider_object_id is the provider's object identifier */
  providerObjectId: Scalars['String']['output'];
  /** qualified_for_accounting indicates accounting eligibility (from ES) */
  qualifiedForAccounting: Scalars['Boolean']['output'];
  /** raw_counterparty_name is the unprocessed counterparty name */
  rawCounterpartyName: Scalars['String']['output'];
  /** related_transaction_id is the ID of a related transaction */
  relatedTransactionId?: Maybe<Scalars['String']['output']>;
  ribaPayment?: Maybe<RibaPayment>;
  /** settled_at is when the transaction was settled in the CBS */
  settledAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** settled_balance is the account balance after settlement of the transaction */
  settledBalance?: Maybe<QontoCommon_CurrencyAmount>;
  /** side is the transaction direction (debit/credit) */
  side: QontoAppSystemsTransactionsFirstpartyV8_Side;
  /** slug is the human-readable identifier */
  slug: Scalars['String']['output'];
  /** status is the transaction status */
  status: QontoAppSystemsTransactionsFirstpartyV8_TransactionStatus;
  /** status_history is the list of status transitions (computed from emitted_at/settled_at) */
  statusHistory: Array<QontoAppSystemsTransactionsFirstpartyV8_StatusHistory>;
  /** subject_id is the uuid of the polymorphic relation attached to the transaction in the DB */
  subjectId?: Maybe<Scalars['String']['output']>;
  /** Depolymorphized subject fields — each maps to subject_id or provider_object_id based on subject_type */
  subjectReference: QontoAppSystemsTransactionsFirstpartyV8_SubjectReference;
  /** subject_type is the subject entity type (note: BillingTransfer is remapped to WalletToWallet) */
  subjectType: QontoAppSystemsTransactionsFirstpartyV8_SubjectType;
  suggestedCategory?: Maybe<SuggestedCategory>;
  supplierInvoices: Array<SupplierInvoice>;
  supplierSubscription?: Maybe<SupplierSubscription>;
  supplierSubscriptionMeta?: Maybe<SupplierSubscriptionMeta>;
  supportedInvoiceCollector?: Maybe<SupportedInvoiceCollector>;
  swiftIncome?: Maybe<SwiftIncome>;
  thread?: Maybe<Thread>;
  transfer?: Maybe<Transfer>;
  /** updated_at is the last update timestamp */
  updatedAt: Scalars['TimestampProto']['output'];
  /** vat_status is the VAT completeness status (from ES) */
  vatDetails: QontoAppSystemsTransactionsFirstpartyV8_VatDetails;
  walletToWallet?: Maybe<WalletToWallet>;
};

/** TransactionAttachmentStatus contains attachment status for a single transaction */
export type QontoAppSystemsTransactionsFirstpartyV8_TransactionAttachmentStatus = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_TransactionAttachmentStatus';
  /** attachment_lost indicates whether attachment was lost or not required (from ES) */
  attachmentLost: Scalars['Boolean']['output'];
  /** attachment_required indicates whether an attachment is required */
  attachmentRequired: Scalars['Boolean']['output'];
  /** attachment_suggestion_ids is the list of suggested attachment IDs (top 5 matches) */
  attachmentSuggestionIds: Array<Scalars['String']['output']>;
  /** automatically_added_attachment_ids is the list of automatically added attachment IDs */
  automaticallyAddedAttachmentIds: Array<Scalars['String']['output']>;
  /** transaction_id is the transaction this status belongs to */
  transactionId: Scalars['String']['output'];
};

/** TransactionLink represents one side of a parent-child relationship between two transactions. */
export type QontoAppSystemsTransactionsFirstpartyV8_TransactionLink = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_TransactionLink';
  /** The type of the link between the transactions */
  linkType: QontoAppSystemsTransactionsFirstpartyV8_LinkType;
  /**
   * The ID of the related transaction:
   * - for a parent transaction link, this is the ID of the child transaction;
   * - for a child transaction link, this is the ID of the parent transaction
   */
  relatedTransactionId: Scalars['String']['output'];
  /** The linked transaction */
  transaction: QontoAppSystemsTransactionsFirstpartyV8_Transaction;
};

/** TransactionStatus defines the lifecycle status of a transaction */
export enum QontoAppSystemsTransactionsFirstpartyV8_TransactionStatus {
  /** TRANSACTION_STATUS_COMPLETED is a successfully completed transaction */
  TransactionStatusCompleted = 'TRANSACTION_STATUS_COMPLETED',
  /** TRANSACTION_STATUS_DECLINED is a declined transaction */
  TransactionStatusDeclined = 'TRANSACTION_STATUS_DECLINED',
  /** TRANSACTION_STATUS_PENDING is a transaction awaiting settlement */
  TransactionStatusPending = 'TRANSACTION_STATUS_PENDING',
  /** TRANSACTION_STATUS_REVERSED is a reversed transaction */
  TransactionStatusReversed = 'TRANSACTION_STATUS_REVERSED',
  /** TRANSACTION_STATUS_UNSPECIFIED is the default unspecified value */
  TransactionStatusUnspecified = 'TRANSACTION_STATUS_UNSPECIFIED'
}

/** Value represents a filter value of any supported primitive type */
export type QontoAppSystemsTransactionsFirstpartyV8_ValueInput = {
  /** boolean_value is a boolean value */
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  /** float_value is a float value */
  floatValue?: InputMaybe<Scalars['Float']['input']>;
  /** integer_value is an integer value */
  integerValue?: InputMaybe<Scalars['Int64']['input']>;
  /** string_value is a string value */
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

/** VatDetails contains VAT details of a transaction */
export type QontoAppSystemsTransactionsFirstpartyV8_VatDetails = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_VatDetails';
  /** items is the list of VAT line items */
  items: Array<QontoAppSystemsTransactionsFirstpartyV8_VatItem>;
  /** status is the VAT status of the transaction */
  status: QontoAppSystemsTransactionsFirstpartyV8_VatStatus;
  /** total_amount is the total VAT amount */
  totalAmount: QontoCommon_CurrencyAmount;
};

/** VatItem represents a single VAT line item */
export type QontoAppSystemsTransactionsFirstpartyV8_VatItem = {
  __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_VatItem';
  /** amount is the VAT amount */
  amount?: Maybe<QontoCommon_CurrencyAmount>;
  /** amount_excluding_vat is the amount excluding VAT */
  amountExcludingVat?: Maybe<QontoCommon_CurrencyAmount>;
  /** id is the VAT item ID */
  id: Scalars['String']['output'];
  /** rate is the VAT rate */
  rate?: Maybe<Scalars['Float']['output']>;
  /** source is the source of the VAT item */
  source?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_VatItemSource>;
};

/** VatItemSource defines how a vat item was created */
export enum QontoAppSystemsTransactionsFirstpartyV8_VatItemSource {
  /** VAT_ITEM_SOURCE_FROM_RECEIVABLE_INVOICING is a source from receivable invoicing */
  VatItemSourceFromReceivableInvoicing = 'VAT_ITEM_SOURCE_FROM_RECEIVABLE_INVOICING',
  /** VAT_ITEM_SOURCE_OCR is an OCR source */
  VatItemSourceOcr = 'VAT_ITEM_SOURCE_OCR',
  /** VAT_ITEM_SOURCE_QONTO is a Qonto source */
  VatItemSourceQonto = 'VAT_ITEM_SOURCE_QONTO',
  /** VAT_ITEM_SOURCE_TAX_AUTHORITY is a tax authority source */
  VatItemSourceTaxAuthority = 'VAT_ITEM_SOURCE_TAX_AUTHORITY',
  /** VAT_ITEM_SOURCE_UNKNOWN is an unknown source */
  VatItemSourceUnknown = 'VAT_ITEM_SOURCE_UNKNOWN',
  /** VAT_ITEM_SOURCE_UNSPECIFIED is the default unspecified value */
  VatItemSourceUnspecified = 'VAT_ITEM_SOURCE_UNSPECIFIED',
  /** VAT_ITEM_SOURCE_USER is a user-provided source */
  VatItemSourceUser = 'VAT_ITEM_SOURCE_USER'
}

/** VatStatus defines the VAT detection completeness status of a transaction */
export enum QontoAppSystemsTransactionsFirstpartyV8_VatStatus {
  /** VAT_STATUS_AUTO is an automatically detected VAT value */
  VatStatusAuto = 'VAT_STATUS_AUTO',
  /** VAT_STATUS_CONFIRMED is a confirmed VAT value */
  VatStatusConfirmed = 'VAT_STATUS_CONFIRMED',
  /** VAT_STATUS_DETECTING is VAT detection in progress */
  VatStatusDetecting = 'VAT_STATUS_DETECTING',
  /** VAT_STATUS_DETECTION_ERROR is the status when VAT detection failed */
  VatStatusDetectionError = 'VAT_STATUS_DETECTION_ERROR',
  /** VAT_STATUS_INHERITED_FROM_BENEFICIARY is a VAT value inherited from the beneficiary */
  VatStatusInheritedFromBeneficiary = 'VAT_STATUS_INHERITED_FROM_BENEFICIARY',
  /** VAT_STATUS_MANUAL is a manually set VAT status */
  VatStatusManual = 'VAT_STATUS_MANUAL',
  /** VAT_STATUS_NOT_FOUND is the status when no VAT rate was found */
  VatStatusNotFound = 'VAT_STATUS_NOT_FOUND',
  /** VAT_STATUS_OVERRIDDEN is a VAT value that was overridden by the user */
  VatStatusOverridden = 'VAT_STATUS_OVERRIDDEN',
  /** VAT_STATUS_SUGGESTED is a VAT value suggested by the system */
  VatStatusSuggested = 'VAT_STATUS_SUGGESTED',
  /** VAT_STATUS_UNSPECIFIED is the default unspecified value */
  VatStatusUnspecified = 'VAT_STATUS_UNSPECIFIED'
}

/** Represents an Avatar. */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_Avatar = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_Avatar';
  /** URL for the avatar file. */
  fileUrl: Scalars['String']['output'];
};

/** Request to cancel a subscription by ID */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CancelSubscriptionRequestInput = {
  /** The payment link ID (from path parameter) */
  paymentLinkId?: InputMaybe<Scalars['String']['input']>;
  /** The subscription ID to terminate (from path parameter) */
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

/** Response when a subscription is successfully canceled */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CancelSubscriptionResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_CancelSubscriptionResponse';
  /** Subscription data */
  subscription: QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscription;
};

/** Request to create a checkout link for a payment link */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CreateCheckoutRequestInput = {
  /** Token if the selected payment method is a credit card. Required if the payment method is credit_card. */
  creditCardToken?: InputMaybe<Scalars['String']['input']>;
  /** Locale for the checkout link (BCP 47 language tag format) */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Payment method for the checkout link (Bank transfer is not allowed here) */
  paymentMethod?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod>;
  /** ID of the resource associated with the payment link */
  resourceId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Shopper Info
   * Email of the shopper (required if payment link is of type basket)
   */
  shopperEmail?: InputMaybe<Scalars['String']['input']>;
  /** First name of the shopper (required if payment link is of type basket and recurrence_type is recurring) max length: 100 */
  shopperFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the shopper (required if payment link is of type basket and recurrence_type is recurring) max length: 100 */
  shopperLastName?: InputMaybe<Scalars['String']['input']>;
};

/** Response when a checkout link is successfully created */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CreateCheckoutResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_CreateCheckoutResponse';
  /** URL of the checkout link */
  paymentLink: Scalars['String']['output'];
};

/** Request to create a payment link */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CreatePaymentLinkRequestInput = {
  /** Payment amount */
  amount: QontoCommon_CurrencyAmountInput;
  /** Debitor name (can be null, required if resource_type is Invoice) */
  debitorName?: InputMaybe<Scalars['String']['input']>;
  /** Items in the basket (can be null, required if resource_type is Basket) */
  items?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItemCreateInput>>;
  /** Organization name (can be null) */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  /** Payment initiator information */
  paymentInitiator: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiatorCreateInput;
  /** List of potential payment methods (at least one required) */
  potentialPaymentMethods?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod>>;
  /** Recurrency settings (can be nullable if not a recurrent payment link) */
  recurrenceSettings?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_RecurrenceSettingsInput>;
  /** Payment link settings (can be null) */
  settings?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkSettingsInput>;
};

/** Response when a payment link is successfully created */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_CreatePaymentLinkResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_CreatePaymentLinkResponse';
  /** The created payment link */
  paymentLink: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink;
};

/** Request message for DeactivatePaymentLink */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_DeactivatePaymentLinkRequestInput = {
  /** The unique identifier for the payment link (from path parameter) */
  paymentLinkId?: InputMaybe<Scalars['String']['input']>;
};

/** Response message for DeactivatePaymentLink */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_DeactivatePaymentLinkResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_DeactivatePaymentLinkResponse';
  /** The deactivated payment link */
  paymentLink: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink;
};

/** Enum for subscription recurrency */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_FrequencyRecurrence {
  /** monthly frequency */
  FrequencyRecurrenceMonthly = 'FREQUENCY_RECURRENCE_MONTHLY',
  /** quarterly frequency */
  FrequencyRecurrenceQuarterly = 'FREQUENCY_RECURRENCE_QUARTERLY',
  /** semesterly frequency */
  FrequencyRecurrenceSemesterly = 'FREQUENCY_RECURRENCE_SEMESTERLY',
  /** Default unspecified value for unknown or unrecognized frequency */
  FrequencyRecurrenceUnspecified = 'FREQUENCY_RECURRENCE_UNSPECIFIED',
  /** weekly frequency */
  FrequencyRecurrenceWeekly = 'FREQUENCY_RECURRENCE_WEEKLY',
  /** yearly frequency */
  FrequencyRecurrenceYearly = 'FREQUENCY_RECURRENCE_YEARLY'
}

/** Request message for GetPaymentLink */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByIdRequestInput = {
  /** Payment link ID (UUID format) */
  paymentLinkId?: InputMaybe<Scalars['String']['input']>;
};

/** Response message for retrieving a single payment link */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByIdResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByIDResponse';
  /** Payment link data */
  paymentLink: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink;
};

/** Request message for retrieving a payment link by resource scope and resource ID */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByResourceScopeAndResourceIdRequestInput = {
  /** The ID of the resource */
  resourceId?: InputMaybe<Scalars['String']['input']>;
  /** Scope of the resource */
  resourceScope?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByResourceScopeAndResourceIdRequest_ResourceScope>;
};

/** Represents the type of a resource in path. */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByResourceScopeAndResourceIdRequest_ResourceScope {
  /** Default unspecified value for unknown or unrecognized resource type */
  ResourceScopeUnspecified = 'RESOURCE_SCOPE_UNSPECIFIED',
  /**
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   * Basket resource.
   */
  Baskets = 'baskets',
  /**
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   * Invoice resource.
   */
  Invoices = 'invoices'
}

/** Message for payment link attributes */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByResourceScopeAndResourceIdResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkByResourceScopeAndResourceIdResponse';
  /** Payment link details */
  paymentLink: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink;
};

/** Message for payment link checkout */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkForCheckoutRequestInput = {
  /** The unique identifier for the checkout */
  resourceId?: InputMaybe<Scalars['String']['input']>;
};

/** Message for payment link checkout response */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkForCheckoutResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_GetPaymentLinkForCheckoutResponse';
  /** Avatar of the organization. */
  organizationAvatar?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_Avatar>;
  /** The payment link */
  paymentLink: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink;
  /** ID of the profile associated with the payment link */
  profileId: Scalars['String']['output'];
};

/** Request message for GetSubscriptionByID */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetSubscriptionByIdRequestInput = {
  /** Payment link ID (UUID format) */
  paymentLinkId?: InputMaybe<Scalars['String']['input']>;
  /** Subscription ID (UUID format) */
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

/** Response message for retrieving a single subscription of a payment link */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_GetSubscriptionByIdResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_GetSubscriptionByIDResponse';
  /** Subscription data */
  subscription: QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscription;
};

/** Enum for item type */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_ItemType {
  /** Good item type */
  ItemTypeGood = 'ITEM_TYPE_GOOD',
  /** Service item type */
  ItemTypeService = 'ITEM_TYPE_SERVICE',
  /** Default unspecified value for unknown or unrecognized item type */
  ItemTypeUnspecified = 'ITEM_TYPE_UNSPECIFIED'
}

/** Message for payment method */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_Method = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_Method';
  /** Whether the payment method is eligible based on the input resource type + is_recurrent. */
  eligible: Scalars['Boolean']['output'];
  /** Whether the payment method is enabled for the provided filters. */
  enabled: Scalars['Boolean']['output'];
  /** Unique identifier for the payment method. */
  id: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod;
  /** The activation status of the payment method. */
  status: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethodStatus;
};

/** Message for a payment */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_Payment = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_Payment';
  /** Payment amount */
  amount: QontoCommon_CurrencyAmount;
  /** Creation timestamp */
  createdAt: Scalars['TimestampProto']['output'];
  /** Payment ID */
  id: Scalars['String']['output'];
  /** Payment completion timestamp */
  paidAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Payment method used */
  paymentMethod: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod;
  /** Payment status */
  status: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentStatus;
};

/** Message for payment initiator information */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiator = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiator';
  /** Resource ID */
  resourceId: Scalars['String']['output'];
  /** Resource number (can be null) */
  resourceNumber?: Maybe<Scalars['String']['output']>;
  /** Resource type */
  resourceType: QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType;
};

/** Payment initiator data for creation */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiatorCreateInput = {
  /** Resource ID (can be null, required if resource_type is Invoice) */
  resourceId?: InputMaybe<Scalars['String']['input']>;
  /** Resource number (can be null) */
  resourceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Resource type */
  resourceType?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType>;
};

/** Message for payment link */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink';
  /** Payment amount */
  amount: QontoCommon_CurrencyAmount;
  /** Creation timestamp */
  createdAt: Scalars['String']['output'];
  /** Debitor name (can be null) */
  debitorName?: Maybe<Scalars['String']['output']>;
  /** Expiration date */
  expirationDate?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the payment link */
  id: Scalars['String']['output'];
  /** Payment link items */
  items: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItem>;
  /** Latest payment method used (can be null) */
  latestPaymentMethod?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod>;
  /** Payment link name */
  name: Scalars['String']['output'];
  /** Organization name (can be null) */
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Payment initiator information */
  paymentInitiator: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiator;
  /** List of potential payment methods */
  potentialPaymentMethods: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod>;
  /** Recurrence settings (required when it is a recurrent payment link) */
  recurrenceSettings?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_RecurrenceSettings>;
  /** Payment link recurrence type */
  recurrenceType: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkRecurrenceType;
  /** Payment link settings (can be null) */
  settings?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkSettings>;
  /** Payment link status */
  status: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkStatus;
};

/** Message for payment link item */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItem = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItem';
  /** Item description */
  description?: Maybe<Scalars['String']['output']>;
  /** Item ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Measurement unit */
  measureUnit?: Maybe<Scalars['String']['output']>;
  /** Item quantity */
  quantity: Scalars['Float']['output'];
  /** Item title */
  title: Scalars['String']['output'];
  /** Item type */
  type?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_ItemType>;
  /** Unit price */
  unitPrice: QontoCommon_CurrencyAmount;
  /** VAT rate */
  vatRate: Scalars['String']['output'];
};

/** Payment link item data for creation */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItemCreateInput = {
  /** Item description (can be null) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Measurement unit (can be null) */
  measureUnit?: InputMaybe<Scalars['String']['input']>;
  /** Item quantity */
  quantity?: InputMaybe<Scalars['Float']['input']>;
  /** Item title */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Item type (can be null) */
  type?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_ItemType>;
  /** Unit price */
  unitPrice: QontoCommon_CurrencyAmountInput;
  /** VAT rate */
  vatRate?: InputMaybe<Scalars['String']['input']>;
};

/** Enum for Payment Link recurrence type */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkRecurrenceType {
  /** One-off payment link recurrence type */
  PaymentLinkRecurrenceTypeOneOff = 'PAYMENT_LINK_RECURRENCE_TYPE_ONE_OFF',
  /** Recurring payment link recurrence type */
  PaymentLinkRecurrenceTypeRecurring = 'PAYMENT_LINK_RECURRENCE_TYPE_RECURRING',
  /** Default unspecified value for unknown or unrecognized payment link recurrence type */
  PaymentLinkRecurrenceTypeUnspecified = 'PAYMENT_LINK_RECURRENCE_TYPE_UNSPECIFIED'
}

/** Message for payment link settings */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkSettings = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkSettings';
  /** How many number of payments/subscriptions can be done out of a payment link. If not provided: reusable payment link */
  limit?: Maybe<Scalars['Int']['output']>;
  /** URL to redirect to after payment */
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

/** Message for payment link settings */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkSettingsInput = {
  /** How many number of payments/subscriptions can be done out of a payment link. If not provided: reusable payment link */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** URL to redirect to after payment */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Enum for payment link status */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkStatus {
  /** Payment link has been canceled */
  PaymentLinkStatusCanceled = 'PAYMENT_LINK_STATUS_CANCELED',
  /** Payment link has expired */
  PaymentLinkStatusExpired = 'PAYMENT_LINK_STATUS_EXPIRED',
  /** Payment link is open for payments */
  PaymentLinkStatusOpen = 'PAYMENT_LINK_STATUS_OPEN',
  /** Payment link has been paid */
  PaymentLinkStatusPaid = 'PAYMENT_LINK_STATUS_PAID',
  /** Payment link is processing */
  PaymentLinkStatusProcessing = 'PAYMENT_LINK_STATUS_PROCESSING',
  /** Default unspecified value for unknown or unrecognized status */
  PaymentLinkStatusUnspecified = 'PAYMENT_LINK_STATUS_UNSPECIFIED'
}

/** Enum for payment methods */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod {
  /** Apple Pay payment method */
  PaymentMethodApplePay = 'PAYMENT_METHOD_APPLE_PAY',
  /** Bank transfer payment method */
  PaymentMethodBankTransfer = 'PAYMENT_METHOD_BANK_TRANSFER',
  /** Credit card payment method */
  PaymentMethodCreditCard = 'PAYMENT_METHOD_CREDIT_CARD',
  /** iDEAL payment method */
  PaymentMethodIdeal = 'PAYMENT_METHOD_IDEAL',
  /** PayPal payment method */
  PaymentMethodPaypal = 'PAYMENT_METHOD_PAYPAL',
  /** Default unspecified value for unknown or unrecognized payment method */
  PaymentMethodUnspecified = 'PAYMENT_METHOD_UNSPECIFIED'
}

/** The status of the payment method. */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethodStatus {
  /** Method is active. */
  PaymentMethodStatusActive = 'PAYMENT_METHOD_STATUS_ACTIVE',
  /** Method is inactive. */
  PaymentMethodStatusInactive = 'PAYMENT_METHOD_STATUS_INACTIVE',
  /** Method is pending external processing. */
  PaymentMethodStatusPendingExternal = 'PAYMENT_METHOD_STATUS_PENDING_EXTERNAL',
  /** Method is pending onboarding. */
  PaymentMethodStatusPendingOnboarding = 'PAYMENT_METHOD_STATUS_PENDING_ONBOARDING',
  /** Method is pending review. */
  PaymentMethodStatusPendingReview = 'PAYMENT_METHOD_STATUS_PENDING_REVIEW',
  /** Method was rejected. */
  PaymentMethodStatusRejected = 'PAYMENT_METHOD_STATUS_REJECTED',
  /** Unspecified method status. */
  PaymentMethodStatusUnspecified = 'PAYMENT_METHOD_STATUS_UNSPECIFIED'
}

/** Enum for payment status */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentStatus {
  /** Payment canceled */
  PaymentStatusCanceled = 'PAYMENT_STATUS_CANCELED',
  /** Payment expired */
  PaymentStatusExpired = 'PAYMENT_STATUS_EXPIRED',
  /** Payment failed */
  PaymentStatusFailed = 'PAYMENT_STATUS_FAILED',
  /** Payment is open */
  PaymentStatusOpen = 'PAYMENT_STATUS_OPEN',
  /** Payment is paid */
  PaymentStatusPaid = 'PAYMENT_STATUS_PAID',
  /** Payment status Default unspecified value */
  PaymentStatusUnspecified = 'PAYMENT_STATUS_UNSPECIFIED'
}

/** Message for recurrence settings */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_RecurrenceSettings = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_RecurrenceSettings';
  /** Frequency recurrence - required when payment link type is recurring */
  frequencyRecurrence: QontoCardsAcceptancePaymentLinksFirstpartyV4_FrequencyRecurrence;
  /** Frequency value - required when payment link type is recurring, min=1 */
  frequencyValue: Scalars['Int']['output'];
  /** Total number of payments for the subscription - optional, min=1, max=9999 */
  times?: Maybe<Scalars['Int']['output']>;
};

/** Message for recurrence settings */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_RecurrenceSettingsInput = {
  /** Frequency recurrence - required when payment link type is recurring */
  frequencyRecurrence?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_FrequencyRecurrence>;
  /** Frequency value - required when payment link type is recurring, min=1 */
  frequencyValue?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of payments for the subscription - optional, min=1, max=9999 */
  times?: InputMaybe<Scalars['Int']['input']>;
};

/** Enum for resource type */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType {
  /** Basket resource type */
  ResourceTypeBasket = 'RESOURCE_TYPE_BASKET',
  /** Invoice resource type */
  ResourceTypeInvoice = 'RESOURCE_TYPE_INVOICE',
  /** Default unspecified value for unknown or unrecognized resource type */
  ResourceTypeUnspecified = 'RESOURCE_TYPE_UNSPECIFIED'
}

/** Message for filter parameters */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequestFiltersInput = {
  /** Filter by payment link type. */
  paymentLinkRecurrenceType?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkRecurrenceType>>;
  /** Filter by resource IDs (from payment initiator) */
  resourceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by resource type (from payment initiator) */
  resourceType?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType>;
  /** Filters by payment link status - array of statuses */
  status?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkStatus>>;
};

/** Request message for GetPaymentLinks */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequestInput = {
  /** Filters parameters for payment links (can be null) */
  filters?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequestFiltersInput>;
  /** Pagination parameters (can be null) */
  paginationInput?: InputMaybe<QontoCommon_PaginationInputInput>;
  /**
   * Sort fields (can be null)
   * Attributes to sort by. By default, it sorts by created_at descending.
   * Suffix with asc to have ascending order, desc for descending.
   */
  sortField?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequest_SortField>>;
};

/** Enum for sort fields */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksRequest_SortField {
  /** Sort by amount ASC */
  SortFieldAmountAsc = 'SORT_FIELD_AMOUNT_ASC',
  /** Sort by amount DESC */
  SortFieldAmountDesc = 'SORT_FIELD_AMOUNT_DESC',
  /** Sort by created at ASC */
  SortFieldCreatedAtAsc = 'SORT_FIELD_CREATED_AT_ASC',
  /** Sort by created at DESC */
  SortFieldCreatedAtDesc = 'SORT_FIELD_CREATED_AT_DESC',
  /** Sort by name ASC */
  SortFieldNameAsc = 'SORT_FIELD_NAME_ASC',
  /** Sort by name DESC */
  SortFieldNameDesc = 'SORT_FIELD_NAME_DESC',
  /** Default unspecified value for unknown or unrecognized sort field */
  SortFieldUnspecified = 'SORT_FIELD_UNSPECIFIED'
}

/** Response message for retrieving payment links */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentLinksResponse';
  /** Pagination metadata */
  pagination: QontoCommon_PaginationMeta;
  /** Array of payment links */
  paymentLinks: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink>;
};

/** Message for filter parameters */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsRequestFiltersInput = {
  /** Filter by amount. */
  amount?: InputMaybe<Scalars['String']['input']>;
  /** Filter by currency. */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Filter by locale. */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Filter by payment link recurrence type. */
  paymentLinkRecurrenceType?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkRecurrenceType>;
  /** Filter by resource type. */
  resourceType?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType>;
};

/** Request message to retrieve available payment methods. */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsRequestInput = {
  /** Filter for payment methods. */
  filters?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsRequestFiltersInput>;
};

/** Response message for ListPaymentMethods. */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchPaymentMethodsResponse';
  /** List of payment methods. */
  paymentMethods: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_Method>;
};

/** Message for search subscription payments filter parameters */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequestFiltersInput = {
  /** Filter by payment status - array of statuses. The absence of value, will return everything. */
  status?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentStatus>>;
};

/** Request message for SearchSubscriptionPayments */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequestInput = {
  /** Filters parameters (optional) */
  filters?: InputMaybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequestFiltersInput>;
  /** Pagination parameters (optional) */
  paginationInput?: InputMaybe<QontoCommon_PaginationInputInput>;
  /** Payment link ID (UUID format) */
  paymentLinkId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Sort fields (can be null)
   * Attributes to sort by. By default, it sorts by created_at descending.
   * Suffix with asc to have ascending order, desc for descending.
   */
  sortField?: InputMaybe<Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequest_SortField>>;
  /** Subscription ID (UUID format) */
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
};

/** Enum for sort fields for search subscription payments request */
export enum QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsRequest_SortField {
  /** Sort by created at ASC */
  SortFieldCreatedAtAsc = 'SORT_FIELD_CREATED_AT_ASC',
  /** Sort by created at DESC */
  SortFieldCreatedAtDesc = 'SORT_FIELD_CREATED_AT_DESC',
  /** Default unspecified value for unknown or unrecognized sort field */
  SortFieldUnspecified = 'SORT_FIELD_UNSPECIFIED'
}

/** Response message for searching subscription payments */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionPaymentsResponse';
  /** Pagination metadata */
  pagination: QontoCommon_PaginationMeta;
  /** Array of payments related to the subscription */
  payments: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_Payment>;
};

/** Request message for SearchSubscriptions */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionsRequestInput = {
  /** Pagination parameters (optional) */
  paginationInput?: InputMaybe<QontoCommon_PaginationInputInput>;
  /** Payment link ID (UUID format) */
  paymentLinkId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response message for retrieving subscriptions
 * By default it is sorted by: active DESC, first_name ASC, last_name ASC
 */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionsResponse = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_SearchSubscriptionsResponse';
  /** Pagination metadata */
  pagination: QontoCommon_PaginationMeta;
  /** Array of subscriptions */
  subscriptions: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscription>;
};

/** Message for subscription subscriber information */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscriber = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscriber';
  /** Subscriber's email address */
  email: Scalars['String']['output'];
  /** Subscriber's first name */
  firstName: Scalars['String']['output'];
  /** Subscriber's last name */
  lastName: Scalars['String']['output'];
};

/** Message for subscription */
export type QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscription = {
  __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscription';
  /** Whether the subscription is active */
  active: Scalars['Boolean']['output'];
  /** Subscription ID */
  id: Scalars['String']['output'];
  /** Subscriber information */
  subscriber: QontoCardsAcceptancePaymentLinksFirstpartyV4_Subscriber;
};

/** A coverage zone for eSIM data plans, which defines the geographical area where the data plan can be used */
export type QontoCardsIssuingEsimFirstpartyV1_CoverageZone = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_CoverageZone';
  /**
   * The ISO 3166 alpha2 code of the countries for which the coverage zone applies.
   * Single element for country coverage zones, multiple elements for region and global coverage zones.
   */
  countryCode: Array<Scalars['String']['output']>;
  /** The ID of the coverage zone. UUID format */
  id: Scalars['String']['output'];
  /** The name of the coverage zone. */
  name: Scalars['String']['output'];
  /** The type of coverage zone, which defines the scope of the coverage zone (e.g. global, region, country) */
  type: QontoCardsIssuingEsimFirstpartyV1_CoverageZoneType;
};

/** A coverage zone for eSIM data plans, which defines the geographical area where the data plan can be used */
export type QontoCardsIssuingEsimFirstpartyV1_CoverageZoneInput = {
  /**
   * The ISO 3166 alpha2 code of the countries for which the coverage zone applies.
   * Single element for country coverage zones, multiple elements for region and global coverage zones.
   */
  countryCode?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The ID of the coverage zone. UUID format */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The name of the coverage zone. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The type of coverage zone, which defines the scope of the coverage zone (e.g. global, region, country) */
  type?: InputMaybe<QontoCardsIssuingEsimFirstpartyV1_CoverageZoneType>;
};

/** The type of coverage zone for a given data plan */
export enum QontoCardsIssuingEsimFirstpartyV1_CoverageZoneType {
  /** The coverage zone applies to a specific country */
  CoverageZoneTypeCountry = 'COVERAGE_ZONE_TYPE_COUNTRY',
  /** The coverage zone applies to the whole world */
  CoverageZoneTypeGlobal = 'COVERAGE_ZONE_TYPE_GLOBAL',
  /** The coverage zone applies to a specific region (i.e. a list of countries) */
  CoverageZoneTypeRegion = 'COVERAGE_ZONE_TYPE_REGION',
  /** No or unknown coverage zone type was provided */
  CoverageZoneTypeUnspecified = 'COVERAGE_ZONE_TYPE_UNSPECIFIED'
}

/** A data package represents a data plan purchased on an eSIM, enriched with the specific usage data */
export type QontoCardsIssuingEsimFirstpartyV1_DataPackage = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_DataPackage';
  /** The way this data package was obtained */
  acquisitionMethod?: Maybe<QontoCardsIssuingEsimFirstpartyV1_DataPackageAcquisitionMethod>;
  /** The activation timestamp for this data package */
  activatedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** The expiration timestamp for this data package */
  expiresAt?: Maybe<Scalars['TimestampProto']['output']>;
  holder?: Maybe<QontoSpendManagementMembershipsMembershipsFirstpartyV1_Membership>;
  /** The ID of the membership that owns the eSIM on which the data package was purchased */
  holderId: Scalars['String']['output'];
  /** The ID of the data package. UUID format */
  id: Scalars['String']['output'];
  initiator?: Maybe<QontoSpendManagementMembershipsMembershipsFirstpartyV1_Membership>;
  /** The ID of the membership that purchased this data package */
  initiatorId: Scalars['String']['output'];
  /** Additional info for when the package was obtained as a perk */
  perkInfo?: Maybe<QontoCardsIssuingEsimFirstpartyV1_DataPackagePerkInfo>;
  /** The plan associated with the data package */
  plan: QontoCardsIssuingEsimFirstpartyV1_DataPlan;
  /** The renewal date for this data package, only filled for recurring add-ons */
  renewsAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** The status of the data package */
  status: QontoCardsIssuingEsimFirstpartyV1_DataPackageStatus;
  /** The amount of data that was already used for the package */
  usage: QontoCardsIssuingEsimFirstpartyV1_DataValue;
};

/** The way this data package was obtained by the user */
export enum QontoCardsIssuingEsimFirstpartyV1_DataPackageAcquisitionMethod {
  /** The data package was obtained as a perk from some other product (e.g. an Ultra card) */
  DataPackageAcquisitionMethodPerk = 'DATA_PACKAGE_ACQUISITION_METHOD_PERK',
  /** The data package was obtained via a direct purchase */
  DataPackageAcquisitionMethodPurchase = 'DATA_PACKAGE_ACQUISITION_METHOD_PURCHASE',
  /** No or unknown method was provided */
  DataPackageAcquisitionMethodUnspecified = 'DATA_PACKAGE_ACQUISITION_METHOD_UNSPECIFIED'
}

/** A data package represents a data plan purchased on an eSIM, enriched with the specific usage data */
export type QontoCardsIssuingEsimFirstpartyV1_DataPackageInput = {
  /** The way this data package was obtained */
  acquisitionMethod?: InputMaybe<QontoCardsIssuingEsimFirstpartyV1_DataPackageAcquisitionMethod>;
  /** The activation timestamp for this data package */
  activatedAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** The expiration timestamp for this data package */
  expiresAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** The ID of the membership that owns the eSIM on which the data package was purchased */
  holderId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the data package. UUID format */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the membership that purchased this data package */
  initiatorId?: InputMaybe<Scalars['String']['input']>;
  /** Additional info for when the package was obtained as a perk */
  perkInfo?: InputMaybe<QontoCardsIssuingEsimFirstpartyV1_DataPackagePerkInfoInput>;
  /** The plan associated with the data package */
  plan: QontoCardsIssuingEsimFirstpartyV1_DataPlanInput;
  /** The renewal date for this data package, only filled for recurring add-ons */
  renewsAt?: InputMaybe<Scalars['TimestampProto']['input']>;
  /** The status of the data package */
  status?: InputMaybe<QontoCardsIssuingEsimFirstpartyV1_DataPackageStatus>;
  /** The amount of data that was already used for the package */
  usage: QontoCardsIssuingEsimFirstpartyV1_DataValueInput;
};

/** Information about the reason that provided this package as a perk */
export type QontoCardsIssuingEsimFirstpartyV1_DataPackagePerkInfo = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_DataPackagePerkInfo';
  /** The reason for providing this data package as a perk */
  reason: QontoCardsIssuingEsimFirstpartyV1_DataPackagePerkReason;
  /** The reference to the object providing the perk in the other system (e.g. the specific card) */
  reference?: Maybe<QontoCardsIssuingEsimFirstpartyV1_DataPackagePerkReasonReference>;
};

/** Information about the reason that provided this package as a perk */
export type QontoCardsIssuingEsimFirstpartyV1_DataPackagePerkInfoInput = {
  /** The reason for providing this data package as a perk */
  reason?: InputMaybe<QontoCardsIssuingEsimFirstpartyV1_DataPackagePerkReason>;
  /** The reference to the object providing the perk in the other system (e.g. the specific card) */
  reference?: InputMaybe<QontoCardsIssuingEsimFirstpartyV1_DataPackagePerkReasonReferenceInput>;
};

/** The reason this data package was provided as a perk */
export enum QontoCardsIssuingEsimFirstpartyV1_DataPackagePerkReason {
  /** The data package was assigned due to possession of a card */
  DataPackagePerkReasonCard = 'DATA_PACKAGE_PERK_REASON_CARD',
  /** No or unknown reason was provided */
  DataPackagePerkReasonUnspecified = 'DATA_PACKAGE_PERK_REASON_UNSPECIFIED'
}

/**
 * De-normalised reference of the perk reason
 * Used for aggregating data in GraphQL by querying each perk reason from its underlying domain
 */
export type QontoCardsIssuingEsimFirstpartyV1_DataPackagePerkReasonReference = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_DataPackagePerkReasonReference';
  card?: Maybe<Card>;
  /** The identifier of the card */
  cardId?: Maybe<Scalars['String']['output']>;
};

/**
 * De-normalised reference of the perk reason
 * Used for aggregating data in GraphQL by querying each perk reason from its underlying domain
 */
export type QontoCardsIssuingEsimFirstpartyV1_DataPackagePerkReasonReferenceInput = {
  /** The identifier of the card */
  cardId?: InputMaybe<Scalars['String']['input']>;
};

/** The sorting parameters for the results */
export type QontoCardsIssuingEsimFirstpartyV1_DataPackageSort = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_DataPackageSort';
  /** The direction of the sorting. Allowed values are: "asc" for ascending order, "desc" for descending order */
  direction: QontoCardsIssuingEsimFirstpartyV1_SortDirection;
  /** The field by which to sort the results */
  field: QontoCardsIssuingEsimFirstpartyV1_DataPackageSortField;
};

/** The field by which to sort the results */
export enum QontoCardsIssuingEsimFirstpartyV1_DataPackageSortField {
  /**
   * Sort by acquisition method
   * Note: the priority between methods is defined on BE level to be BENEFITS > PURCHASE for ASC order.
   */
  DataPackageSortFieldAcquisitionMethod = 'DATA_PACKAGE_SORT_FIELD_ACQUISITION_METHOD',
  /** Sort by activation timestamp */
  DataPackageSortFieldActivatedAt = 'DATA_PACKAGE_SORT_FIELD_ACTIVATED_AT',
  /** Sort by creation timestamp */
  DataPackageSortFieldCreatedAt = 'DATA_PACKAGE_SORT_FIELD_CREATED_AT',
  /** No or unknown sort field was provided */
  DataPackageSortFieldUnspecified = 'DATA_PACKAGE_SORT_FIELD_UNSPECIFIED'
}

/** The sorting parameters for the results */
export type QontoCardsIssuingEsimFirstpartyV1_DataPackageSortInput = {
  /** The direction of the sorting. Allowed values are: "asc" for ascending order, "desc" for descending order */
  direction?: InputMaybe<QontoCardsIssuingEsimFirstpartyV1_SortDirection>;
  /** The field by which to sort the results */
  field?: InputMaybe<QontoCardsIssuingEsimFirstpartyV1_DataPackageSortField>;
};

/** The status of a data package */
export enum QontoCardsIssuingEsimFirstpartyV1_DataPackageStatus {
  /** The data package is active and can be used */
  DataPackageStatusActive = 'DATA_PACKAGE_STATUS_ACTIVE',
  /** The data package has reached its end validity date */
  DataPackageStatusEnded = 'DATA_PACKAGE_STATUS_ENDED',
  /** The data included in the package was fully used */
  DataPackageStatusFullyUsed = 'DATA_PACKAGE_STATUS_FULLY_USED',
  /** The data package has not been ordered yet */
  DataPackageStatusNotCreated = 'DATA_PACKAGE_STATUS_NOT_CREATED',
  /** The data package purchase was not successful due to failed payment, and the data package won't be usable */
  DataPackageStatusNotPaid = 'DATA_PACKAGE_STATUS_NOT_PAID',
  /** The data package was created on the provider and is waiting for activation */
  DataPackageStatusPending = 'DATA_PACKAGE_STATUS_PENDING',
  /** No or unknown data package status was provided */
  DataPackageStatusUnspecified = 'DATA_PACKAGE_STATUS_UNSPECIFIED',
  /** The data package is waiting for the payment confirmation before being marked usable */
  DataPackageStatusWaitingFunds = 'DATA_PACKAGE_STATUS_WAITING_FUNDS',
  /** The data package has been ordered on Gigs, and is waiting for the invoice to be generated to proceed with payment */
  DataPackageStatusWaitingInvoice = 'DATA_PACKAGE_STATUS_WAITING_INVOICE'
}

/** A data plan that can be purchased for an eSIM, with its details and coverage zone */
export type QontoCardsIssuingEsimFirstpartyV1_DataPlan = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_DataPlan';
  /** The allowance of the data plan, which defines the data amount included in the data plan */
  allowance: QontoCardsIssuingEsimFirstpartyV1_DataValue;
  /** The coverage zone for the data plan, which defines the geographical area where the data plan can be used */
  coverageZone: QontoCardsIssuingEsimFirstpartyV1_CoverageZone;
  /** The ID of the data plan. UUID format */
  id: Scalars['String']['output'];
  /** The price of the data plan */
  price: QontoCardsIssuingEsimFirstpartyV1_DataPlanPrice;
  /** The validity of the data plan, which defines the duration for which the data plan is valid after activation */
  validity: QontoCardsIssuingEsimFirstpartyV1_DataPlanValidity;
};

/** A data plan that can be purchased for an eSIM, with its details and coverage zone */
export type QontoCardsIssuingEsimFirstpartyV1_DataPlanInput = {
  /** The allowance of the data plan, which defines the data amount included in the data plan */
  allowance: QontoCardsIssuingEsimFirstpartyV1_DataValueInput;
  /** The coverage zone for the data plan, which defines the geographical area where the data plan can be used */
  coverageZone: QontoCardsIssuingEsimFirstpartyV1_CoverageZoneInput;
  /** The ID of the data plan. UUID format */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The price of the data plan */
  price: QontoCardsIssuingEsimFirstpartyV1_DataPlanPriceInput;
  /** The validity of the data plan, which defines the duration for which the data plan is valid after activation */
  validity: QontoCardsIssuingEsimFirstpartyV1_DataPlanValidityInput;
};

/** The price of a data plan */
export type QontoCardsIssuingEsimFirstpartyV1_DataPlanPrice = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_DataPlanPrice';
  /** Whether the price includes VAT or not */
  includesVat: Scalars['Boolean']['output'];
  /** The price of the data plan */
  total: QontoCommon_CurrencyAmount;
};

/** The price of a data plan */
export type QontoCardsIssuingEsimFirstpartyV1_DataPlanPriceInput = {
  /** Whether the price includes VAT or not */
  includesVat?: InputMaybe<Scalars['Boolean']['input']>;
  /** The price of the data plan */
  total: QontoCommon_CurrencyAmountInput;
};

/** The validity of a data plan, which defines the duration for which the data plan is valid after activation */
export type QontoCardsIssuingEsimFirstpartyV1_DataPlanValidity = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_DataPlanValidity';
  /** The unit for the data plan validity, which defines the time unit for which the data plan is valid after activation (e.g. day) */
  unit: QontoCardsIssuingEsimFirstpartyV1_DataPlanValidityUnit;
  /** The value for the data plan validity, which defines the duration for which the data plan is valid after activation (e.g. "30" for a validity of 30 days) */
  value: Scalars['String']['output'];
};

/** The validity of a data plan, which defines the duration for which the data plan is valid after activation */
export type QontoCardsIssuingEsimFirstpartyV1_DataPlanValidityInput = {
  /** The unit for the data plan validity, which defines the time unit for which the data plan is valid after activation (e.g. day) */
  unit?: InputMaybe<QontoCardsIssuingEsimFirstpartyV1_DataPlanValidityUnit>;
  /** The value for the data plan validity, which defines the duration for which the data plan is valid after activation (e.g. "30" for a validity of 30 days) */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** The validity unit of a data plan, which defines the time unit for which the data plan is valid after activation */
export enum QontoCardsIssuingEsimFirstpartyV1_DataPlanValidityUnit {
  /** The data plan validity is expressed in days */
  DataPlanValidityUnitDay = 'DATA_PLAN_VALIDITY_UNIT_DAY',
  /** The data plan validity is expressed in months */
  DataPlanValidityUnitMonth = 'DATA_PLAN_VALIDITY_UNIT_MONTH',
  /** No or unknown data plan validity unit was provided */
  DataPlanValidityUnitUnspecified = 'DATA_PLAN_VALIDITY_UNIT_UNSPECIFIED'
}

/** The data unit of a data plan, which defines the unit for the data amount included in the data plan */
export enum QontoCardsIssuingEsimFirstpartyV1_DataUnit {
  /** The data unit is expressed in gigabytes */
  DataUnitGb = 'DATA_UNIT_GB',
  /** No or unknown data unit was provided */
  DataUnitUnspecified = 'DATA_UNIT_UNSPECIFIED'
}

/** Expresses a data amount */
export type QontoCardsIssuingEsimFirstpartyV1_DataValue = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_DataValue';
  /** The unit for the data amount included in the data plan, which defines the unit for the data amount included in the data plan (e.g. GB) */
  unit: QontoCardsIssuingEsimFirstpartyV1_DataUnit;
  /** The value for the data amount included in the data plan, which defines the data amount included in the data plan (e.g. "5" for a data plan including 5 GB of data) */
  value: Scalars['String']['output'];
};

/** Expresses a data amount */
export type QontoCardsIssuingEsimFirstpartyV1_DataValueInput = {
  /** The unit for the data amount included in the data plan, which defines the unit for the data amount included in the data plan (e.g. GB) */
  unit?: InputMaybe<QontoCardsIssuingEsimFirstpartyV1_DataUnit>;
  /** The value for the data amount included in the data plan, which defines the data amount included in the data plan (e.g. "5" for a data plan including 5 GB of data) */
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request for getting the list of available coverage zones for eSIM data plans
 * The membership info is retrieved from the authentication context of the request
 */
export type QontoCardsIssuingEsimFirstpartyV1_GetAvailableCoverageZonesRequest = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_GetAvailableCoverageZonesRequest';
  /** The locale used to localise the coverage zone name in the returned details */
  locale: Scalars['String']['output'];
};

/**
 * Request for getting the list of available coverage zones for eSIM data plans
 * The membership info is retrieved from the authentication context of the request
 */
export type QontoCardsIssuingEsimFirstpartyV1_GetAvailableCoverageZonesRequestInput = {
  /** The locale used to localise the coverage zone name in the returned details */
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** Response for getting the list of available coverage zones for eSIM data plans */
export type QontoCardsIssuingEsimFirstpartyV1_GetAvailableCoverageZonesResponse = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_GetAvailableCoverageZonesResponse';
  /** The individual countries coverage zones */
  countries: Array<QontoCardsIssuingEsimFirstpartyV1_CoverageZone>;
  /** The global coverage zone */
  global: QontoCardsIssuingEsimFirstpartyV1_CoverageZone;
  /** The regional coverage zones */
  regions: Array<QontoCardsIssuingEsimFirstpartyV1_CoverageZone>;
};

/** Response for getting the list of available coverage zones for eSIM data plans */
export type QontoCardsIssuingEsimFirstpartyV1_GetAvailableCoverageZonesResponseInput = {
  /** The individual countries coverage zones */
  countries?: InputMaybe<Array<QontoCardsIssuingEsimFirstpartyV1_CoverageZoneInput>>;
  /** The global coverage zone */
  global: QontoCardsIssuingEsimFirstpartyV1_CoverageZoneInput;
  /** The regional coverage zones */
  regions?: InputMaybe<Array<QontoCardsIssuingEsimFirstpartyV1_CoverageZoneInput>>;
};

/** Request for getting the list of data plans available for purchase for the current membership */
export type QontoCardsIssuingEsimFirstpartyV1_GetAvailableDataPlansRequest = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_GetAvailableDataPlansRequest';
  /** The ID of the coverage zone for which to retrieve the available data plans, from the request path parameter. UUID format */
  coverageZoneId: Scalars['String']['output'];
  /** The locale used to localise the coverage zone name in the returned details */
  locale: Scalars['String']['output'];
};

/** Request for getting the list of data plans available for purchase for the current membership */
export type QontoCardsIssuingEsimFirstpartyV1_GetAvailableDataPlansRequestInput = {
  /** The ID of the coverage zone for which to retrieve the available data plans, from the request path parameter. UUID format */
  coverageZoneId?: InputMaybe<Scalars['String']['input']>;
  /** The locale used to localise the coverage zone name in the returned details */
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** Response for getting the list of data plans available for purchase for the current membership */
export type QontoCardsIssuingEsimFirstpartyV1_GetAvailableDataPlansResponse = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_GetAvailableDataPlansResponse';
  /** The list of data plans available for purchase for the current membership */
  dataPlans: Array<QontoCardsIssuingEsimFirstpartyV1_DataPlan>;
};

/** Response for getting the list of data plans available for purchase for the current membership */
export type QontoCardsIssuingEsimFirstpartyV1_GetAvailableDataPlansResponseInput = {
  /** The list of data plans available for purchase for the current membership */
  dataPlans?: InputMaybe<Array<QontoCardsIssuingEsimFirstpartyV1_DataPlanInput>>;
};

/**
 * The filters to apply to the results.
 * Any filter left empty will not be applied.
 */
export type QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesFilters = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesFilters';
  /**
   * List of acquisition methods to include in the result.
   * Note: for client backwards compatibility, an empty list is interpreted as the constant
   * [DATA_PACKAGE_ACQUISITION_METHOD_PURCHASE]
   */
  acquisitionMethod: Array<QontoCardsIssuingEsimFirstpartyV1_DataPackageAcquisitionMethod>;
  /** List of holder IDs to exclude from the results. */
  excludedHolderIds: Array<Scalars['String']['output']>;
  /** List of holder IDs to include in the results. */
  holderIds: Array<Scalars['String']['output']>;
  /** List of IDs to include in the results. */
  ids: Array<Scalars['String']['output']>;
  /** List of statuses to include in the results. */
  statuses: Array<QontoCardsIssuingEsimFirstpartyV1_DataPackageStatus>;
};

/**
 * The filters to apply to the results.
 * Any filter left empty will not be applied.
 */
export type QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesFiltersInput = {
  /**
   * List of acquisition methods to include in the result.
   * Note: for client backwards compatibility, an empty list is interpreted as the constant
   * [DATA_PACKAGE_ACQUISITION_METHOD_PURCHASE]
   */
  acquisitionMethod?: InputMaybe<Array<QontoCardsIssuingEsimFirstpartyV1_DataPackageAcquisitionMethod>>;
  /** List of holder IDs to exclude from the results. */
  excludedHolderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of holder IDs to include in the results. */
  holderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of IDs to include in the results. */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of statuses to include in the results. */
  statuses?: InputMaybe<Array<QontoCardsIssuingEsimFirstpartyV1_DataPackageStatus>>;
};

/** Request for getting the list of data packages for the current membership */
export type QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesRequest = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesRequest';
  /** The filters to apply to the returned results */
  filters: QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesFilters;
  /** The locale used to localise the coverage zone name in the returned details */
  locale: Scalars['String']['output'];
  /** The pagination parameters for the request */
  pagination: QontoCommon_PaginationInput;
  /**
   * The sorting parameters for the request
   * Multiple sort parameters are applied hierarchically
   */
  sort: Array<QontoCardsIssuingEsimFirstpartyV1_DataPackageSort>;
  /**
   * The sorting parameters for the request
   * Deprecated: use "sort" instead, which supports sorting by multiple fields at once
   */
  sorting: QontoCardsIssuingEsimFirstpartyV1_DataPackageSort;
};

/** Request for getting the list of data packages for the current membership */
export type QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesRequestInput = {
  /** The filters to apply to the returned results */
  filters: QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesFiltersInput;
  /** The locale used to localise the coverage zone name in the returned details */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** The pagination parameters for the request */
  pagination: QontoCommon_PaginationInputInput;
  /**
   * The sorting parameters for the request
   * Multiple sort parameters are applied hierarchically
   */
  sort?: InputMaybe<Array<QontoCardsIssuingEsimFirstpartyV1_DataPackageSortInput>>;
  /**
   * The sorting parameters for the request
   * Deprecated: use "sort" instead, which supports sorting by multiple fields at once
   */
  sorting: QontoCardsIssuingEsimFirstpartyV1_DataPackageSortInput;
};

/** Response for getting the list of data packages for the current membership */
export type QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesResponse = {
  __typename?: 'QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesResponse';
  /** The list of data packages for the current membership */
  dataPackages: Array<QontoCardsIssuingEsimFirstpartyV1_DataPackage>;
  /** Pagination metadata for the response */
  meta: QontoCommon_PaginationMeta;
};

/** Response for getting the list of data packages for the current membership */
export type QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesResponseInput = {
  /** The list of data packages for the current membership */
  dataPackages?: InputMaybe<Array<QontoCardsIssuingEsimFirstpartyV1_DataPackageInput>>;
  /** Pagination metadata for the response */
  meta: QontoCommon_PaginationMetaInput;
};

/** The direction of the sort */
export enum QontoCardsIssuingEsimFirstpartyV1_SortDirection {
  /** Sort in ascending order */
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  /** Sort in descending order */
  SortDirectionDesc = 'SORT_DIRECTION_DESC',
  /** No or unknown sort direction was provided */
  SortDirectionUnspecified = 'SORT_DIRECTION_UNSPECIFIED'
}

/** Attachment resource */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment = {
  __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment';
  /** Type of attachment */
  attachmentType: QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_AttachmentType;
  /** Creation timestamp */
  createdAt: Scalars['String']['output'];
  /** Source through which the attachment was created */
  creationSource?: Maybe<QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_CreationSource>;
  /** Download URL */
  downloadUrl: Scalars['String']['output'];
  /** File information */
  file: QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_File;
  /** Unique attachment ID */
  id: Scalars['String']['output'];
  initiator?: Maybe<Membership>;
  /** ID of the membership who initiated the attachment upload */
  initiatorId?: Maybe<Scalars['String']['output']>;
  /** Optional human readable name */
  name?: Maybe<Scalars['String']['output']>;
  /** Organization ID */
  organizationId: Scalars['String']['output'];
  /** Probative attachment information */
  probativeAttachment: QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProbativeAttachment;
  /** Slug */
  slug: Scalars['String']['output'];
  /** Processing status of the attachment in the Attachments Hub pipeline */
  status?: Maybe<QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProcessingStatus>;
  /** Thumbnail information */
  thumbnail: QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_Thumbnail;
};

/** Attachment resource */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_AttachmentInput = {
  /** Type of attachment */
  attachmentType?: InputMaybe<QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_AttachmentType>;
  /** Creation timestamp */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  /** Source through which the attachment was created */
  creationSource?: InputMaybe<QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_CreationSource>;
  /** Download URL */
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** File information */
  file: QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_FileInput;
  /** Unique attachment ID */
  id?: InputMaybe<Scalars['String']['input']>;
  /** ID of the membership who initiated the attachment upload */
  initiatorId?: InputMaybe<Scalars['String']['input']>;
  /** Optional human readable name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Probative attachment information */
  probativeAttachment: QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProbativeAttachmentInput;
  /** Slug */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Processing status of the attachment in the Attachments Hub pipeline */
  status?: InputMaybe<QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProcessingStatus>;
  /** Thumbnail information */
  thumbnail: QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ThumbnailInput;
};

/** Attachment types */
export enum QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_AttachmentType {
  /** Unspecified type. */
  AttachmentTypeUnspecified = 'ATTACHMENT_TYPE_UNSPECIFIED',
  /**
   * Attachment is an accounts-payable credit note.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  ApCreditNote = 'ap_credit_note',
  /**
   * Attachment is an accounts-receivable credit note.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  ArCreditNote = 'ar_credit_note',
  /**
   * Attachment is a general attachment.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Attachment = 'attachment',
  /**
   * Attachment is a bank statement.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  BankStatement = 'bank_statement',
  /**
   * Attachment is a CA3 document attachment.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Ca3Document = 'ca3_document',
  /**
   * Attachment is a card acceptance settlement statement.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  CardAcquirerPayout = 'card_acquirer_payout',
  /**
   * Attachment is a commercial contract.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  CommercialContract = 'commercial_contract',
  /**
   * Attachment is an end of fiscal period bundle.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  EndOfFiscalPeriodBundle = 'end_of_fiscal_period_bundle',
  /**
   * Attachment is a financial statement.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  FinancialStatement = 'financial_statement',
  /**
   * Attachment is an impots.gouv mandate.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  ImpotsGouvMandate = 'impots_gouv_mandate',
  /**
   * Attachment is an invoice attachment.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Invoice = 'invoice',
  /**
   * Attachment is a lease agreement attachment.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  LeaseAgreement = 'lease_agreement',
  /**
   * Attachment is a lease loan contract attachment.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  LeaseLoanContract = 'lease_loan_contract',
  /**
   * Attachment is a mileage reimbursement receipt.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  MileageReceipt = 'mileage_receipt',
  /**
   * Attachment is a nrc attachment.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Nrc = 'nrc',
  /**
   * Attachment is of another type not covered by the above.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Other = 'other',
  /**
   * Attachment is a pagopa attachment.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Pagopa = 'pagopa',
  /**
   * Attachment is a payment schedule.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  PaymentSchedule = 'payment_schedule',
  /**
   * Attachment is a payslip.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Payslip = 'payslip',
  /**
   * Attachment is a receipt.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Receipt = 'receipt',
  /**
   * Attachment is a receivable invoice attachment.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  ReceivableInvoice = 'receivable_invoice',
  /**
   * Attachment is a RIB (Relevé d'Identité Bancaire).
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Rib = 'rib',
  /**
   * Attachment is a riba attachment.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Riba = 'riba',
  /**
   * Attachment is a social notice (e.g. Urssaf).
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  SocialNotice = 'social_notice',
  /**
   * Attachment is a state receipt attachment.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  StateReceipt = 'state_receipt',
  /**
   * Attachment is a supplier invoice.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  SupplierInvoice = 'supplier_invoice',
  /**
   * Attachment is a tax memo.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  TaxMemo = 'tax_memo',
  /**
   * Attachment is a tax notice.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  TaxNotice = 'tax_notice',
  /**
   * Attachment is of unknown type.
   * Not yet present in the Rails enum — planned addition for this feature.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  UnknownAttachmentType = 'unknown_attachment_type'
}

/** Source through which the attachment was created */
export enum QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_CreationSource {
  /** Unspecified creation source. */
  CreationSourceUnspecified = 'CREATION_SOURCE_UNSPECIFIED',
  /**
   * Attachment created via AI Lab.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  AiLab = 'ai_lab',
  /**
   * Attachment created via Attachments Hub.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  AttachmentsHub = 'attachments_hub',
  /**
   * Attachment created via e-invoicing.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  EInvoicing = 'e_invoicing',
  /**
   * Attachment created via email.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Email = 'email',
  /**
   * Attachment created via third-party API.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  ThirdPartyApi = 'third_party_api'
}

/** File information */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_File = {
  __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_File';
  /** File content type (nullable) */
  fileContentType?: Maybe<Scalars['String']['output']>;
  /** File name (nullable) */
  fileName?: Maybe<Scalars['String']['output']>;
  /** File size (nullable) */
  fileSize?: Maybe<Scalars['String']['output']>;
  /** File URL (nullable) */
  fileUrl?: Maybe<Scalars['String']['output']>;
};

/** File information */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_FileInput = {
  /** File content type (nullable) */
  fileContentType?: InputMaybe<Scalars['String']['input']>;
  /** File name (nullable) */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** File size (nullable) */
  fileSize?: InputMaybe<Scalars['String']['input']>;
  /** File URL (nullable) */
  fileUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Probative attachment information */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProbativeAttachment = {
  __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProbativeAttachment';
  /** Download URL (nullable) */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** File content type (nullable) */
  fileContentType?: Maybe<Scalars['String']['output']>;
  /** File name (nullable) */
  fileName?: Maybe<Scalars['String']['output']>;
  /** File size (nullable) */
  fileSize?: Maybe<Scalars['String']['output']>;
  /** File URL (nullable) */
  fileUrl?: Maybe<Scalars['String']['output']>;
  /** Status of probative attachment */
  status: QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProbativeAttachment_ProbativeAttachmentStatus;
};

/** Probative attachment information */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProbativeAttachmentInput = {
  /** Download URL (nullable) */
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  /** File content type (nullable) */
  fileContentType?: InputMaybe<Scalars['String']['input']>;
  /** File name (nullable) */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** File size (nullable) */
  fileSize?: InputMaybe<Scalars['String']['input']>;
  /** File URL (nullable) */
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  /** Status of probative attachment */
  status?: InputMaybe<QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProbativeAttachment_ProbativeAttachmentStatus>;
};

/** individual probative attachment statuses */
export enum QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProbativeAttachment_ProbativeAttachmentStatus {
  /** Unspecified status. */
  ProbativeAttachmentStatusUnspecified = 'PROBATIVE_ATTACHMENT_STATUS_UNSPECIFIED',
  /**
   * Probative attachment is available.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Available = 'available',
  /**
   * Probative attachment is corrupted.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Corrupted = 'corrupted',
  /**
   * Probative attachment is pending.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Pending = 'pending',
  /**
   * Probative attachment is unavailable.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Unavailable = 'unavailable'
}

/**
 * Processing status of the attachment in the Document Hub pipeline.
 * NULL (legacy records pre-Document Hub) is represented by the field being absent.
 */
export enum QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProcessingStatus {
  /** Unspecified status. */
  ProcessingStatusUnspecified = 'PROCESSING_STATUS_UNSPECIFIED',
  /**
   * Classifier determined type automatically, OR user manually set it.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Classified = 'classified',
  /**
   * Document routed to its final destination.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Completed = 'completed',
  /**
   * ATMA returned no match and attachment is eligible for matching — human action required.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  ManualActionRequired = 'manual_action_required',
  /**
   * Classifier could not determine document type with enough confidence.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  ManualClassificationRequired = 'manual_classification_required',
  /**
   * File stored in S3, attachment record created.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Uploaded = 'uploaded'
}

/** Thumbnail information */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_Thumbnail = {
  __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_Thumbnail';
  /** Thumbnail file URL */
  fileUrl: Scalars['String']['output'];
};

/** Thumbnail information */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ThumbnailInput = {
  /** Thumbnail file URL */
  fileUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Error codes for the ListAttachments method. */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsErrors = {
  __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsErrors';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Error codes for the ListAttachments method. */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsErrorsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Unprocessable entity error codes. */
export enum QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsErrors_UnprocessableEntityError {
  /**
   * per_page was given but is not a number (existing InvalidPerPageError
   * behavior). Note: exceeding the max is clamped, not rejected.
   */
  UnprocessableEntityErrorInvalidPagination = 'UNPROCESSABLE_ENTITY_ERROR_INVALID_PAGINATION',
  /** A value in filter[types][] is not in the allowed list. */
  UnprocessableEntityErrorInvalidTypeFilter = 'UNPROCESSABLE_ENTITY_ERROR_INVALID_TYPE_FILTER',
  /** Unspecified error. */
  UnprocessableEntityErrorUnspecified = 'UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED'
}

/**
 * Request message for listing attachments accessible to the current
 * membership. The set of returned attachments is scoped server-side based on
 * the viewer's access_scope, derived from the PASETO token.
 */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsRequest = {
  __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsRequest';
  /** Optional filter criteria. */
  filters?: Maybe<QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsRequest_Filters>;
  /** Page number to retrieve. Defaults to 1. */
  page?: Maybe<Scalars['Int']['output']>;
  /**
   * Page size to retrieve. Defaults to 100, and silently clamped to 100 if
   * a larger value is given (matches the default_per_page/max_per_page
   * clamp already implemented in PasetoBaseController).
   */
  perPage?: Maybe<Scalars['Int']['output']>;
};

/**
 * Request message for listing attachments accessible to the current
 * membership. The set of returned attachments is scoped server-side based on
 * the viewer's access_scope, derived from the PASETO token.
 */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsRequestInput = {
  /** Optional filter criteria. */
  filters?: InputMaybe<QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsRequest_FiltersInput>;
  /** Page number to retrieve. Defaults to 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Page size to retrieve. Defaults to 100, and silently clamped to 100 if
   * a larger value is given (matches the default_per_page/max_per_page
   * clamp already implemented in PasetoBaseController).
   */
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters for the attachments list. */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsRequest_Filters = {
  __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsRequest_Filters';
  /**
   * Inclusive lower bound on attachment creation time (ISO 8601 datetime).
   * When set, only attachments created at or after this value are returned
   * (e.g. pass "now minus 30 days" to limit results to the last 30 days).
   */
  createdAtFrom?: Maybe<Scalars['String']['output']>;
  /** Case-insensitive substring match on file_name. */
  fileName?: Maybe<Scalars['String']['output']>;
  /** Array of attachment IDs to filter by */
  ids: Array<Scalars['String']['output']>;
  /**
   * Filter by processing status. When provided, only attachments with a
   * non-null processing_status (i.e. Document Hub attachments) are returned.
   * Pass all known statuses for the "Recent" tab; pass
   * [manual_classification_required, manual_action_required] for "To review".
   */
  processingStatuses: Array<QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProcessingStatus>;
  /**
   * Attachment type values to filter by (e.g. "accounting_documents",
   * "unknown_attachment_type"). Omit to return all accessible types. Is not enum on purpose.
   */
  types: Array<Scalars['String']['output']>;
};

/** Filters for the attachments list. */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsRequest_FiltersInput = {
  /**
   * Inclusive lower bound on attachment creation time (ISO 8601 datetime).
   * When set, only attachments created at or after this value are returned
   * (e.g. pass "now minus 30 days" to limit results to the last 30 days).
   */
  createdAtFrom?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive substring match on file_name. */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Array of attachment IDs to filter by */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filter by processing status. When provided, only attachments with a
   * non-null processing_status (i.e. Document Hub attachments) are returned.
   * Pass all known statuses for the "Recent" tab; pass
   * [manual_classification_required, manual_action_required] for "To review".
   */
  processingStatuses?: InputMaybe<Array<QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProcessingStatus>>;
  /**
   * Attachment type values to filter by (e.g. "accounting_documents",
   * "unknown_attachment_type"). Omit to return all accessible types. Is not enum on purpose.
   */
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Response message for listing attachments. */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsResponse = {
  __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsResponse';
  /** Attachments matching the request. */
  attachments: Array<QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment>;
  /** Pagination metadata. */
  meta: QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsResponse_Meta;
};

/** Response message for listing attachments. */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsResponseInput = {
  /** Attachments matching the request. */
  attachments?: InputMaybe<Array<QontoCashFlowManagementAttachmentsFirstpartyV4_AttachmentInput>>;
  /** Pagination metadata. */
  meta: QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsResponse_MetaInput;
};

/** Pagination metadata. */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsResponse_Meta = {
  __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsResponse_Meta';
  /** Current page number. */
  currentPage: Scalars['Int']['output'];
  /** Next page number (absent if there is no next page). */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** Page size. */
  perPage: Scalars['Int']['output'];
  /** Previous page number (absent if there is no previous page). */
  prevPage?: Maybe<Scalars['Int']['output']>;
  /** Total number of attachments. */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** Pagination metadata. */
export type QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsResponse_MetaInput = {
  /** Current page number. */
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  /** Next page number (absent if there is no next page). */
  nextPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page size. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Previous page number (absent if there is no previous page). */
  prevPage?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of attachments. */
  totalCount?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of pages. */
  totalPages?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * AllocationSource identifies what produced a category allocation. Only MANUAL is set
 * through these first-party write endpoints; the others are produced elsewhere (rules,
 * classifier, accounting, pro-rata computation, migration) and appear on reads only.
 */
export enum QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_AllocationSource {
  /** Allocation changed by an accountant. */
  AllocationSourceAccountant = 'ALLOCATION_SOURCE_ACCOUNTANT',
  /** Deprecated: use ALLOCATION_SOURCE_ACCOUNTING_ENGINE. */
  AllocationSourceAccounting = 'ALLOCATION_SOURCE_ACCOUNTING',
  /** Set from the accounting integration. */
  AllocationSourceAccountingEngine = 'ALLOCATION_SOURCE_ACCOUNTING_ENGINE',
  /** Computed pro-rata on a transaction from its linked, categorized documents. */
  AllocationSourceComputed = 'ALLOCATION_SOURCE_COMPUTED',
  /** Set manually by a user. */
  AllocationSourceManual = 'ALLOCATION_SOURCE_MANUAL',
  /** Produced by a data migration. */
  AllocationSourceMigration = 'ALLOCATION_SOURCE_MIGRATION',
  /** Produced by the Qonto auto-categorization classifier. */
  AllocationSourceQontoClassifier = 'ALLOCATION_SOURCE_QONTO_CLASSIFIER',
  /** Produced by a categorization rule (carries a rule_id). */
  AllocationSourceRule = 'ALLOCATION_SOURCE_RULE',
  /** Default unspecified value. */
  AllocationSourceUnspecified = 'ALLOCATION_SOURCE_UNSPECIFIED'
}

/**
 * CategoryAllocation is one (category, amount) split of an entity's amount, on the read path.
 * The active allocations of an entity always sum to the entity amount.
 */
export type QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_CategoryAllocation = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_CategoryAllocation';
  /** When the split was made (UTC). */
  allocatedAt: Scalars['TimestampProto']['output'];
  /** Portion of the entity amount allocated to this category, in the entity currency. */
  amount: QontoCommon_CurrencyAmount;
  /** Percentage of the amount used to compute this allocation; set only when source = ALLOCATION_SOURCE_COMPUTED. */
  amountProRataPercentage?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_CategoryDetails>;
  /** Organization-scoped id of the leaf category assigned to this portion of the amount. */
  categoryId: Scalars['String']['output'];
  /** Categorization rule that produced the allocation; set only when source = ALLOCATION_SOURCE_RULE. */
  ruleId?: Maybe<Scalars['String']['output']>;
  /** What produced this allocation. */
  source: QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_AllocationSource;
};

/**
 * Document is the read view of a document's categorization. A document is backed by exactly one
 * attachment and is identified by that attachment's id.
 */
export type QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_Document = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_Document';
  /** Total amount of the document, in the document currency. */
  amount: QontoCommon_CurrencyAmount;
  /** Attachment id identifying the document. */
  attachmentId: Scalars['String']['output'];
  /** Active category allocations, sorted by update date. Empty when the document is uncategorized. */
  categoryAllocations: Array<QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_CategoryAllocation>;
  /** When the document's allocations were locked (accountant-verified); unset when not locked. */
  lockedAt?: Maybe<Scalars['TimestampProto']['output']>;
};

/** ExclusionSource identifies what excluded a transaction from cash-flow categorization. */
export enum QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_ExclusionSource {
  /** Excluded manually by a user. */
  ExclusionSourceManual = 'EXCLUSION_SOURCE_MANUAL',
  /** Excluded by a categorization rule. */
  ExclusionSourceRule = 'EXCLUSION_SOURCE_RULE',
  /** Default unspecified value. */
  ExclusionSourceUnspecified = 'EXCLUSION_SOURCE_UNSPECIFIED'
}

/** GetAllocationsByAttachmentIdsRequest fetches the allocations of several documents in one call. */
export type QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_GetAllocationsByAttachmentIdsRequestInput = {
  /** Ids of the attachments identifying the documents to fetch. */
  attachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** GetAllocationsByAttachmentIdsResponse returns the requested documents with their allocations. */
export type QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_GetAllocationsByAttachmentIdsResponse = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_GetAllocationsByAttachmentIdsResponse';
  /**
   * The requested documents, each carrying its active allocations. A document without
   * allocations is returned with an empty allocations list.
   */
  documents: Array<QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_Document>;
};

/** GetAllocationsByTransactionIdsRequest fetches the allocations of several transactions in one call. */
export type QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_GetAllocationsByTransactionIdsRequestInput = {
  /** Ids of the transactions to fetch allocations for. */
  transactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** GetAllocationsByTransactionIdsResponse returns the requested transactions with their allocations. */
export type QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_GetAllocationsByTransactionIdsResponse = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_GetAllocationsByTransactionIdsResponse';
  /**
   * The requested transactions, each carrying its active allocations. A transaction without
   * allocations is returned with an empty allocations list.
   */
  transactions: Array<QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_Transaction>;
};

/** Transaction is the read view of a transaction's categorization. */
export type QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_Transaction = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_Transaction';
  /** Total amount of the transaction, in the bank account currency. */
  amount: QontoCommon_CurrencyAmount;
  /**
   * Aggregated active category allocations, sorted by category_id. Empty when the transaction is
   * uncategorized. For document provenance, use document_allocations.
   */
  categoryAllocations: Array<QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_CategoryAllocation>;
  /** Active allocations grouped by matched document, including pro-rata contributions. */
  documentAllocations: Array<QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_TransactionDocumentAllocation>;
  /** When the transaction was excluded from cash flow; unset when not excluded. */
  excludedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** What excluded the transaction; other than EXCLUSION_SOURCE_UNSPECIFIED only when excluded_at is set. */
  exclusionSource: QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_ExclusionSource;
  /** Original-currency amount of an FX transaction. Equal to amount for non-FX transactions. */
  localAmount: QontoCommon_CurrencyAmount;
  /** When the transaction's allocations were locked (accountant-verified); unset when not locked. */
  lockedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Id of the transaction. */
  transactionId: Scalars['String']['output'];
};

/**
 * TransactionDocumentAllocation groups a matched document's category allocations attributed to
 * a transaction. Nested CategoryAllocation.amount is the amount attributed to the transaction,
 * not the original category amount on the document.
 */
export type QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_TransactionDocumentAllocation = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_TransactionDocumentAllocation';
  /** Attachment id identifying the matched document. */
  attachmentId: Scalars['String']['output'];
  /**
   * Category allocations attributed to the transaction. Groups are sorted by attachment_id;
   * allocations are sorted by category_id.
   */
  categoryAllocations: Array<QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_CategoryAllocation>;
};

/** Categories grouped by flow direction */
export type QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_Categories = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_Categories';
  /** Inflow categories (money coming in) */
  inflow: Array<QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_Category>;
  /** Outflow categories (money going out) */
  outflow: Array<QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_Category>;
};

/** Categories grouped by flow direction */
export type QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_CategoriesInput = {
  /** Inflow categories (money coming in) */
  inflow?: InputMaybe<Array<QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_CategoryInput>>;
  /** Outflow categories (money going out) */
  outflow?: InputMaybe<Array<QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_CategoryInput>>;
};

/** Represents a cash flow category */
export type QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_Category = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_Category';
  /** Color key for UI display */
  colorKey: Scalars['String']['output'];
  /** Icon key for UI display */
  iconKey: Scalars['String']['output'];
  /** Unique identifier for the category */
  id: Scalars['String']['output'];
  /** Display name of the category */
  name: Scalars['String']['output'];
  /** Localization key for the category name */
  nameKey?: Maybe<Scalars['String']['output']>;
  /** List of subcategories */
  subcategories: Array<QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_SubCategory>;
  /** VAT rate associated with this category */
  vatRate?: Maybe<Scalars['String']['output']>;
};

/**
 * CategoryDetails is the flat read view of one category or subcategory, carrying everything needed
 * to render it without walking the category tree. GetCategories returns the nested tree instead;
 * this message exists because an id on its own carries no parent context, and a subcategory
 * inherits part of its presentation from its parent.
 */
export type QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_CategoryDetails = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_CategoryDetails';
  /** Colour token used to render the category. */
  colorKey: Scalars['String']['output'];
  /**
   * Icon token used to render the category. Subcategories carry no icon of their own, so this is
   * the parent's icon when parent_id is set.
   */
  iconKey: Scalars['String']['output'];
  /** Id of the category or subcategory. */
  id: Scalars['String']['output'];
  /** Whether this category is assigned to any entities */
  isAssignedToAnyEntities: Scalars['Boolean']['output'];
  /** Whether this category is a Qonto-provided default category rather than one created by the organization */
  isDefault: Scalars['Boolean']['output'];
  /** Display name, in the organization's language when the category is a Qonto default. */
  name: Scalars['String']['output'];
  /** Translation key for Qonto default categories; unset for organization-created ones. */
  nameKey?: Maybe<Scalars['String']['output']>;
  /** Id of the parent category; set only when this message describes a subcategory. */
  parentId?: Maybe<Scalars['String']['output']>;
  /**
   * Which side of the cash flow the category belongs to. Implicit in the tree GetCategories
   * returns, explicit here because a flat result has no branch to infer it from.
   */
  type: QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_CategoryType;
  /** Default VAT rate of the category; unset when it has none. */
  vatRate?: Maybe<Scalars['String']['output']>;
};

/**
 * CategoryDetails is the flat read view of one category or subcategory, carrying everything needed
 * to render it without walking the category tree. GetCategories returns the nested tree instead;
 * this message exists because an id on its own carries no parent context, and a subcategory
 * inherits part of its presentation from its parent.
 */
export type QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_CategoryDetailsInput = {
  /** Colour token used to render the category. */
  colorKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * Icon token used to render the category. Subcategories carry no icon of their own, so this is
   * the parent's icon when parent_id is set.
   */
  iconKey?: InputMaybe<Scalars['String']['input']>;
  /** Id of the category or subcategory. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Whether this category is assigned to any entities */
  isAssignedToAnyEntities?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this category is a Qonto-provided default category rather than one created by the organization */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display name, in the organization's language when the category is a Qonto default. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Translation key for Qonto default categories; unset for organization-created ones. */
  nameKey?: InputMaybe<Scalars['String']['input']>;
  /** Id of the parent category; set only when this message describes a subcategory. */
  parentId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Which side of the cash flow the category belongs to. Implicit in the tree GetCategories
   * returns, explicit here because a flat result has no branch to infer it from.
   */
  type?: InputMaybe<QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_CategoryType>;
  /** Default VAT rate of the category; unset when it has none. */
  vatRate?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a cash flow category */
export type QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_CategoryInput = {
  /** Color key for UI display */
  colorKey?: InputMaybe<Scalars['String']['input']>;
  /** Icon key for UI display */
  iconKey?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the category */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Display name of the category */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Localization key for the category name */
  nameKey?: InputMaybe<Scalars['String']['input']>;
  /** List of subcategories */
  subcategories?: InputMaybe<Array<QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_SubCategoryInput>>;
  /** VAT rate associated with this category */
  vatRate?: InputMaybe<Scalars['String']['input']>;
};

/** Type of cash flow category */
export enum QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_CategoryType {
  /** Inflow category (money coming in) */
  CategoryTypeInflow = 'CATEGORY_TYPE_INFLOW',
  /** Outflow category (money going out) */
  CategoryTypeOutflow = 'CATEGORY_TYPE_OUTFLOW',
  /** Default unspecified value */
  CategoryTypeUnspecified = 'CATEGORY_TYPE_UNSPECIFIED'
}

/**
 * GetCategoriesByIdsRequest resolves several categories by id in one call. Ids may name either a
 * top-level category or a subcategory; both are returned as CategoryDetails.
 */
export type QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_GetCategoriesByIdsRequest = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_GetCategoriesByIdsRequest';
  /** Ids of the categories to resolve. Ids belonging to another organization are treated as unknown. */
  categoryIds: Array<Scalars['String']['output']>;
};

/**
 * GetCategoriesByIdsRequest resolves several categories by id in one call. Ids may name either a
 * top-level category or a subcategory; both are returned as CategoryDetails.
 */
export type QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_GetCategoriesByIdsRequestInput = {
  /** Ids of the categories to resolve. Ids belonging to another organization are treated as unknown. */
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** GetCategoriesByIdsResponse returns the requested categories. */
export type QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_GetCategoriesByIdsResponse = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_GetCategoriesByIdsResponse';
  /**
   * The resolved categories, in the requested order. Unknown ids are omitted rather than erroring,
   * so callers map results back by id and treat a gap as "no such category".
   */
  categories: Array<QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_CategoryDetails>;
};

/** GetCategoriesByIdsResponse returns the requested categories. */
export type QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_GetCategoriesByIdsResponseInput = {
  /**
   * The resolved categories, in the requested order. Unknown ids are omitted rather than erroring,
   * so callers map results back by id and treat a gap as "no such category".
   */
  categories?: InputMaybe<Array<QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_CategoryDetailsInput>>;
};

/** Represents a subcategory under a category */
export type QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_SubCategory = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_SubCategory';
  /** Color key for UI display */
  colorKey: Scalars['String']['output'];
  /** Unique identifier for the subcategory */
  id: Scalars['String']['output'];
  /** Display name of the subcategory */
  name: Scalars['String']['output'];
  /** Localization key for the subcategory name */
  nameKey?: Maybe<Scalars['String']['output']>;
  /** VAT rate associated with this subcategory */
  vatRate?: Maybe<Scalars['String']['output']>;
};

/** Represents a subcategory under a category */
export type QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_SubCategoryInput = {
  /** Color key for UI display */
  colorKey?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier for the subcategory */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Display name of the subcategory */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Localization key for the subcategory name */
  nameKey?: InputMaybe<Scalars['String']['input']>;
  /** VAT rate associated with this subcategory */
  vatRate?: InputMaybe<Scalars['String']['input']>;
};

/** CreateTransactionMatchFeedbackErrors defines custom application errors for the FeedbackTransactionMatch endpoint. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_CreateTransactionMatchFeedbackErrors = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_CreateTransactionMatchFeedbackErrors';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** CreateTransactionMatchFeedbackErrors defines custom application errors for the FeedbackTransactionMatch endpoint. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_CreateTransactionMatchFeedbackErrorsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** BadRequestError represents bad request errors */
export enum QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_CreateTransactionMatchFeedbackErrors_BadRequestError {
  /** Invalid expected transaction ID format */
  BadRequestErrorInvalidExpectedTransactionId = 'BAD_REQUEST_ERROR_INVALID_EXPECTED_TRANSACTION_ID',
  /** Invalid transaction ID format */
  BadRequestErrorInvalidTransactionId = 'BAD_REQUEST_ERROR_INVALID_TRANSACTION_ID',
  /** Unspecified bad request error */
  BadRequestErrorUnspecified = 'BAD_REQUEST_ERROR_UNSPECIFIED'
}

/** NotFoundError represents not found errors */
export enum QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_CreateTransactionMatchFeedbackErrors_NotFoundError {
  /** Expected transaction not found */
  NotFoundErrorExpectedTransactionNotFound = 'NOT_FOUND_ERROR_EXPECTED_TRANSACTION_NOT_FOUND',
  /** Match not found between transaction and expected transaction */
  NotFoundErrorMatchNotFound = 'NOT_FOUND_ERROR_MATCH_NOT_FOUND',
  /** Transaction not found */
  NotFoundErrorTransactionNotFound = 'NOT_FOUND_ERROR_TRANSACTION_NOT_FOUND',
  /** Unspecified not found error */
  NotFoundErrorUnspecified = 'NOT_FOUND_ERROR_UNSPECIFIED'
}

/** CreateTransactionMatchFeedbackRequest provides feedback on a matched transaction. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_CreateTransactionMatchFeedbackRequest = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_CreateTransactionMatchFeedbackRequest';
  /** The expected transaction ID */
  expectedTransactionId: Scalars['String']['output'];
  /** The type of feedback (positive to confirm, negative to reject) */
  feedbackType: QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_FeedbackType;
  /** The transaction ID to provide feedback for */
  transactionId: Scalars['String']['output'];
};

/** CreateTransactionMatchFeedbackRequest provides feedback on a matched transaction. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_CreateTransactionMatchFeedbackRequestInput = {
  /** The expected transaction ID */
  expectedTransactionId?: InputMaybe<Scalars['String']['input']>;
  /** The type of feedback (positive to confirm, negative to reject) */
  feedbackType?: InputMaybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_FeedbackType>;
  /** The transaction ID to provide feedback for */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/** CreateTransactionMatchFeedbackResponse is empty as the feedback operation returns no data. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_CreateTransactionMatchFeedbackResponse = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_CreateTransactionMatchFeedbackResponse';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** CreateTransactionMatchFeedbackResponse is empty as the feedback operation returns no data. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_CreateTransactionMatchFeedbackResponseInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The source used to determine the expected date of a transaction. */
export enum QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ExpectedDateSource {
  /** Automatically determined. */
  ExpectedDateSourceAuto = 'EXPECTED_DATE_SOURCE_AUTO',
  /** Based on the client's average payment delay. */
  ExpectedDateSourceClientAverage = 'EXPECTED_DATE_SOURCE_CLIENT_AVERAGE',
  /** Manually set by the user. */
  ExpectedDateSourceManual = 'EXPECTED_DATE_SOURCE_MANUAL',
  /** Based on the organization's average payment delay. */
  ExpectedDateSourceOrganizationAverage = 'EXPECTED_DATE_SOURCE_ORGANIZATION_AVERAGE',
  /** Based on Qonto's average payment delay. */
  ExpectedDateSourceQontoAverage = 'EXPECTED_DATE_SOURCE_QONTO_AVERAGE',
  /** Unspecified source. */
  ExpectedDateSourceUnspecified = 'EXPECTED_DATE_SOURCE_UNSPECIFIED'
}

/** FeedbackType represents the type of feedback on a match. */
export enum QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_FeedbackType {
  /** Negative feedback (reject the match) */
  FeedbackTypeNegative = 'FEEDBACK_TYPE_NEGATIVE',
  /** Positive feedback (confirm the match) */
  FeedbackTypePositive = 'FEEDBACK_TYPE_POSITIVE',
  /** Unspecified feedback type */
  FeedbackTypeUnspecified = 'FEEDBACK_TYPE_UNSPECIFIED'
}

/** ListTransactionMatchesErrors defines custom application errors for the ListTransactionMatches endpoint. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ListTransactionMatchesErrors = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ListTransactionMatchesErrors';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** ListTransactionMatchesErrors defines custom application errors for the ListTransactionMatches endpoint. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ListTransactionMatchesErrorsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** BadRequestError represents bad request errors */
export enum QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ListTransactionMatchesErrors_BadRequestError {
  /** Invalid transaction ID format */
  BadRequestErrorInvalidTransactionId = 'BAD_REQUEST_ERROR_INVALID_TRANSACTION_ID',
  /** Too many transaction IDs requested */
  BadRequestErrorTooManyTransactionIds = 'BAD_REQUEST_ERROR_TOO_MANY_TRANSACTION_IDS',
  /** Unspecified bad request error */
  BadRequestErrorUnspecified = 'BAD_REQUEST_ERROR_UNSPECIFIED'
}

/** NotFoundError represents not found errors */
export enum QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ListTransactionMatchesErrors_NotFoundError {
  /** One or more transactions not found */
  NotFoundErrorTransactionNotFound = 'NOT_FOUND_ERROR_TRANSACTION_NOT_FOUND',
  /** Unspecified not found error */
  NotFoundErrorUnspecified = 'NOT_FOUND_ERROR_UNSPECIFIED'
}

/** ListTransactionMatchesRequest retrieves expected transactions that match the given transaction IDs. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ListTransactionMatchesRequest = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ListTransactionMatchesRequest';
  /** List of transaction IDs to find matching expected transactions for */
  transactionIds: Array<Scalars['String']['output']>;
};

/** ListTransactionMatchesRequest retrieves expected transactions that match the given transaction IDs. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ListTransactionMatchesRequestInput = {
  /** List of transaction IDs to find matching expected transactions for */
  transactionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** ListTransactionMatchesResponse contains the matches for each requested transaction ID. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ListTransactionMatchesResponse = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ListTransactionMatchesResponse';
  /**
   * One entry per matched expected transaction, each tagged with the real
   * transaction it was matched to. Transactions with no match contribute
   * no entries.
   */
  matchedExpectedTransactions: Array<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_MatchedExpectedTransaction>;
};

/** ListTransactionMatchesResponse contains the matches for each requested transaction ID. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ListTransactionMatchesResponseInput = {
  /**
   * One entry per matched expected transaction, each tagged with the real
   * transaction it was matched to. Transactions with no match contribute
   * no entries.
   */
  matchedExpectedTransactions?: InputMaybe<Array<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_MatchedExpectedTransactionInput>>;
};

/**
 * MatchedExpectedTransaction contains a subset of fields from the
 * ExpectedTransaction entity, plus the transaction it was matched to.
 */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_MatchedExpectedTransaction = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_MatchedExpectedTransaction';
  /** The transaction amount. */
  amount: QontoCommon_CurrencyAmount;
  /** The counterparty name. */
  counterpartyName: Scalars['String']['output'];
  /** User feedback if any */
  feedback?: Maybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_FeedbackType>;
  /** The unique identifier of the upcoming transaction. */
  id: Scalars['String']['output'];
  /** The ID of the provider object. */
  providerObjectId: Scalars['String']['output'];
  /** The type of provider object. */
  providerObjectType: QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ProviderObjectType;
  /** The side of the transaction (credit or debit). */
  side: QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_TransactionSide;
  /** The real transaction this expected transaction was matched to. */
  transactionId: Scalars['String']['output'];
};

/**
 * MatchedExpectedTransaction contains a subset of fields from the
 * ExpectedTransaction entity, plus the transaction it was matched to.
 */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_MatchedExpectedTransactionInput = {
  /** The transaction amount. */
  amount: QontoCommon_CurrencyAmountInput;
  /** The counterparty name. */
  counterpartyName?: InputMaybe<Scalars['String']['input']>;
  /** User feedback if any */
  feedback?: InputMaybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_FeedbackType>;
  /** The unique identifier of the upcoming transaction. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the provider object. */
  providerObjectId?: InputMaybe<Scalars['String']['input']>;
  /** The type of provider object. */
  providerObjectType?: InputMaybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ProviderObjectType>;
  /** The side of the transaction (credit or debit). */
  side?: InputMaybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_TransactionSide>;
  /** The real transaction this expected transaction was matched to. */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

/** Metadata for upcoming transactions with additional context. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_Metadata = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_Metadata';
  /** Average number of days a customer takes to pay for a quote. */
  averagePaymentDelayDays?: Maybe<Scalars['Int']['output']>;
  /** The invoice number. */
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  /** The logo URL. */
  logoUrl: Scalars['String']['output'];
  /** The mandate ID. */
  mandateId?: Maybe<Scalars['String']['output']>;
  /** The original expected date (YYYY-MM-DD format). */
  originalExpectedDate?: Maybe<Scalars['String']['output']>;
  /** The parent object ID (e.g., financing_id). */
  parentObjectId?: Maybe<Scalars['String']['output']>;
  /** The current installment number for pay later (for installment payments). */
  payLaterCurrentInstallmentNumber?: Maybe<Scalars['Int']['output']>;
  /** The total number of installments for pay later (for installment payments). */
  payLaterTotalInstallmentsNumber?: Maybe<Scalars['Int']['output']>;
  /** The quote number. */
  quoteNumber?: Maybe<Scalars['String']['output']>;
  /** The state of the quote. */
  quoteState?: Maybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_QuoteState>;
  /** The recurrence information. */
  recurrence?: Maybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_Recurrence>;
  /** The supplier invoice ID. */
  supplierInvoiceId?: Maybe<Scalars['String']['output']>;
};

/** Metadata for upcoming transactions with additional context. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_MetadataInput = {
  /** Average number of days a customer takes to pay for a quote. */
  averagePaymentDelayDays?: InputMaybe<Scalars['Int']['input']>;
  /** The invoice number. */
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  /** The logo URL. */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** The mandate ID. */
  mandateId?: InputMaybe<Scalars['String']['input']>;
  /** The original expected date (YYYY-MM-DD format). */
  originalExpectedDate?: InputMaybe<Scalars['String']['input']>;
  /** The parent object ID (e.g., financing_id). */
  parentObjectId?: InputMaybe<Scalars['String']['input']>;
  /** The current installment number for pay later (for installment payments). */
  payLaterCurrentInstallmentNumber?: InputMaybe<Scalars['Int']['input']>;
  /** The total number of installments for pay later (for installment payments). */
  payLaterTotalInstallmentsNumber?: InputMaybe<Scalars['Int']['input']>;
  /** The quote number. */
  quoteNumber?: InputMaybe<Scalars['String']['input']>;
  /** The state of the quote. */
  quoteState?: InputMaybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_QuoteState>;
  /** The recurrence information. */
  recurrence?: InputMaybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_RecurrenceInput>;
  /** The supplier invoice ID. */
  supplierInvoiceId?: InputMaybe<Scalars['String']['input']>;
};

/** The type of provider object. */
export enum QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ProviderObjectType {
  /** Direct debit. */
  ProviderObjectTypeDirectDebit = 'PROVIDER_OBJECT_TYPE_DIRECT_DEBIT',
  /** Financing installment. */
  ProviderObjectTypeFinancingInstallment = 'PROVIDER_OBJECT_TYPE_FINANCING_INSTALLMENT',
  /** Manual entry. */
  ProviderObjectTypeManualEntry = 'PROVIDER_OBJECT_TYPE_MANUAL_ENTRY',
  /** Quote. */
  ProviderObjectTypeQuote = 'PROVIDER_OBJECT_TYPE_QUOTE',
  /** Receivable invoice. */
  ProviderObjectTypeReceivableInvoice = 'PROVIDER_OBJECT_TYPE_RECEIVABLE_INVOICE',
  /** Subscription. */
  ProviderObjectTypeSubscription = 'PROVIDER_OBJECT_TYPE_SUBSCRIPTION',
  /** Supplier invoice. */
  ProviderObjectTypeSupplierInvoice = 'PROVIDER_OBJECT_TYPE_SUPPLIER_INVOICE',
  /** Transfer. */
  ProviderObjectTypeTransfer = 'PROVIDER_OBJECT_TYPE_TRANSFER',
  /** Unspecified provider object type. */
  ProviderObjectTypeUnspecified = 'PROVIDER_OBJECT_TYPE_UNSPECIFIED'
}

/** The state of a quote. */
export enum QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_QuoteState {
  /** Quote has been approved. */
  QuoteStateApproved = 'QUOTE_STATE_APPROVED',
  /** Quote has been canceled. */
  QuoteStateCanceled = 'QUOTE_STATE_CANCELED',
  /** Quote is pending approval. */
  QuoteStatePendingApproval = 'QUOTE_STATE_PENDING_APPROVAL',
  /** Unspecified state. */
  QuoteStateUnspecified = 'QUOTE_STATE_UNSPECIFIED'
}

/** Recurrence information for metadata. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_Recurrence = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_Recurrence';
  /** The recurrence frequency. */
  frequency: QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_RecurrenceFrequencyEnum;
};

/** Recurrence frequency enum. */
export enum QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_RecurrenceFrequencyEnum {
  /** Biyearly recurrence. */
  RecurrenceFrequencyEnumBiyearly = 'RECURRENCE_FREQUENCY_ENUM_BIYEARLY',
  /** Daily recurrence. */
  RecurrenceFrequencyEnumDaily = 'RECURRENCE_FREQUENCY_ENUM_DAILY',
  /** Monthly recurrence. */
  RecurrenceFrequencyEnumMonthly = 'RECURRENCE_FREQUENCY_ENUM_MONTHLY',
  /** Quarterly recurrence. */
  RecurrenceFrequencyEnumQuarterly = 'RECURRENCE_FREQUENCY_ENUM_QUARTERLY',
  /** Unspecified frequency. */
  RecurrenceFrequencyEnumUnspecified = 'RECURRENCE_FREQUENCY_ENUM_UNSPECIFIED',
  /** Weekly recurrence. */
  RecurrenceFrequencyEnumWeekly = 'RECURRENCE_FREQUENCY_ENUM_WEEKLY',
  /** Yearly recurrence. */
  RecurrenceFrequencyEnumYearly = 'RECURRENCE_FREQUENCY_ENUM_YEARLY'
}

/** Recurrence information for metadata. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_RecurrenceInput = {
  /** The recurrence frequency. */
  frequency?: InputMaybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_RecurrenceFrequencyEnum>;
};

/** The side of a transaction. */
export enum QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_TransactionSide {
  /** Credit (incoming money). */
  TransactionSideCredit = 'TRANSACTION_SIDE_CREDIT',
  /** Debit (outgoing money). */
  TransactionSideDebit = 'TRANSACTION_SIDE_DEBIT',
  /** Unspecified side. */
  TransactionSideUnspecified = 'TRANSACTION_SIDE_UNSPECIFIED'
}

/** The status of an upcoming transaction. */
export enum QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_TransactionStatus {
  /** Transaction has been canceled. */
  TransactionStatusCanceled = 'TRANSACTION_STATUS_CANCELED',
  /** Transaction has been completed. */
  TransactionStatusCompleted = 'TRANSACTION_STATUS_COMPLETED',
  /** Transaction has been discarded. */
  TransactionStatusDiscarded = 'TRANSACTION_STATUS_DISCARDED',
  /** Transaction is pending. */
  TransactionStatusPending = 'TRANSACTION_STATUS_PENDING',
  /** Transaction has been removed. */
  TransactionStatusRemoved = 'TRANSACTION_STATUS_REMOVED',
  /** Unspecified status. */
  TransactionStatusUnspecified = 'TRANSACTION_STATUS_UNSPECIFIED'
}

/** Represents an upcoming transaction in the cash flow forecast. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_UpcomingTransaction = {
  __typename?: 'QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_UpcomingTransaction';
  /** The transaction amount. */
  amount: QontoCommon_CurrencyAmount;
  /** The bank account ID (if applicable). */
  bankAccountId?: Maybe<Scalars['String']['output']>;
  /** The counterparty name. */
  counterpartyName: Scalars['String']['output'];
  /** The expected date (YYYY-MM-DD format). */
  expectedDate: Scalars['String']['output'];
  /** The source used to determine the expected date. */
  expectedDateSource: QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ExpectedDateSource;
  /** The unique identifier of the upcoming transaction. */
  id: Scalars['String']['output'];
  /** The local amount (in original currency if different). */
  localAmount: QontoCommon_CurrencyAmount;
  /** The ID of the matching actual transaction (if matched). */
  matchedTransactionId?: Maybe<Scalars['String']['output']>;
  /** Additional metadata for the transaction. */
  metadata?: Maybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_Metadata>;
  /** The name/label for display. */
  name: Scalars['String']['output'];
  /** The ID of the provider object. */
  providerObjectId: Scalars['String']['output'];
  /** The type of provider object. */
  providerObjectType: QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ProviderObjectType;
  /** The side of the transaction (credit or debit). */
  side: QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_TransactionSide;
  /** The status of the transaction. */
  status: QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_TransactionStatus;
};

/** Represents an upcoming transaction in the cash flow forecast. */
export type QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_UpcomingTransactionInput = {
  /** The transaction amount. */
  amount: QontoCommon_CurrencyAmountInput;
  /** The bank account ID (if applicable). */
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  /** The counterparty name. */
  counterpartyName?: InputMaybe<Scalars['String']['input']>;
  /** The expected date (YYYY-MM-DD format). */
  expectedDate?: InputMaybe<Scalars['String']['input']>;
  /** The source used to determine the expected date. */
  expectedDateSource?: InputMaybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ExpectedDateSource>;
  /** The unique identifier of the upcoming transaction. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The local amount (in original currency if different). */
  localAmount: QontoCommon_CurrencyAmountInput;
  /** The ID of the matching actual transaction (if matched). */
  matchedTransactionId?: InputMaybe<Scalars['String']['input']>;
  /** Additional metadata for the transaction. */
  metadata?: InputMaybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_MetadataInput>;
  /** The name/label for display. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the provider object. */
  providerObjectId?: InputMaybe<Scalars['String']['input']>;
  /** The type of provider object. */
  providerObjectType?: InputMaybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ProviderObjectType>;
  /** The side of the transaction (credit or debit). */
  side?: InputMaybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_TransactionSide>;
  /** The status of the transaction. */
  status?: InputMaybe<QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_TransactionStatus>;
};

/** Repayment schedule shape a financing is amortized with. */
export enum QontoCommon_AmortizationSystem {
  /**
   * Constant annuity: every installment is the same amount.
   *
   * On the financing.orders Kafka contract the same concept is a string, carrying
   * "french_amortization_system" rather than the name of this value.
   */
  AmortizationSystemFrenchAmortizationSystem = 'AMORTIZATION_SYSTEM_FRENCH_AMORTIZATION_SYSTEM',
  /** No or unknown amortization system was given. */
  AmortizationSystemUnspecified = 'AMORTIZATION_SYSTEM_UNSPECIFIED'
}

/**
 * Represents a currency amount according to
 * https://www.w3.org/TR/payment-request/#paymentcurrencyamount-dictionary.
 */
export type QontoCommon_CurrencyAmount = {
  __typename?: 'QontoCommon_CurrencyAmount';
  /** The ISO 4217 currency code of the currency in which `value` is denoted. */
  currency: Scalars['String']['output'];
  /** The value in major units of `currency`, as a decimal string. */
  value: Scalars['String']['output'];
};

/**
 * Represents a currency amount according to
 * https://www.w3.org/TR/payment-request/#paymentcurrencyamount-dictionary.
 */
export type QontoCommon_CurrencyAmountInput = {
  /** The ISO 4217 currency code of the currency in which `value` is denoted. */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** The value in major units of `currency`, as a decimal string. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Repayment health signal for a DDC installment. Values match the REST API wire format.
 * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
 * buf:lint:ignore ENUM_VALUE_PREFIX
 */
export enum QontoCommon_DdcRepaymentStatus {
  /** Default / unspecified value. Not returned by the API in practice. */
  DdcRepaymentStatusUnspecified = 'DDC_REPAYMENT_STATUS_UNSPECIFIED',
  /** Repayment is at risk (e.g., bank account issue detected). */
  AtRisk = 'at_risk',
  /** A scheduled installment is past its due date without payment. */
  Late = 'late',
  /** Installment is scheduled for a future debit and on track. */
  Scheduled = 'scheduled'
}

/** Represents pagination metadata for cursor-based pagination */
export type QontoCommon_PaginationCursorMeta = {
  __typename?: 'QontoCommon_PaginationCursorMeta';
  /** The cursor to retrieve the next set of items. If null, it means there are no more items to retrieve. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The number of items per page. */
  perPage: Scalars['Int']['output'];
};

/** Represents pagination metadata for cursor-based pagination */
export type QontoCommon_PaginationCursorMetaInput = {
  /** The cursor to retrieve the next set of items. If null, it means there are no more items to retrieve. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** The number of items per page. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Pagination option for controlling result set size and position */
export type QontoCommon_PaginationInput = {
  __typename?: 'QontoCommon_PaginationInput';
  /** Cursor token for cursor-based pagination */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Page number for page-based pagination (starts at 1) */
  page?: Maybe<Scalars['Int64']['output']>;
  /** Number of results to return per page */
  perPage: Scalars['Int']['output'];
};

/** Pagination option for controlling result set size and position */
export type QontoCommon_PaginationInputInput = {
  /** Cursor token for cursor-based pagination */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Page number for page-based pagination (starts at 1) */
  page?: InputMaybe<Scalars['Int64']['input']>;
  /** Number of results to return per page */
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Represents pagination metadata
 * It uses camel case so it may not be suitable for endpoints defined before proto standard
 */
export type QontoCommon_PaginationMeta = {
  __typename?: 'QontoCommon_PaginationMeta';
  /** Current page number */
  currentPage: Scalars['Int']['output'];
  /** Cursor token for fetching the next set of results */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Next page number (null if no next page) */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** Number of results per page */
  perPage: Scalars['Int']['output'];
  /** Previous page number (null if no previous page) */
  prevPage?: Maybe<Scalars['Int']['output']>;
  /** Total number of orders */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages */
  totalPages: Scalars['Int']['output'];
};

/**
 * Represents pagination metadata
 * It uses camel case so it may not be suitable for endpoints defined before proto standard
 */
export type QontoCommon_PaginationMetaInput = {
  /** Current page number */
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  /** Cursor token for fetching the next set of results */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Next page number (null if no next page) */
  nextPage?: InputMaybe<Scalars['Int']['input']>;
  /** Number of results per page */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Previous page number (null if no previous page) */
  prevPage?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of orders */
  totalCount?: InputMaybe<Scalars['Int']['input']>;
  /** Total number of pages */
  totalPages?: InputMaybe<Scalars['Int']['input']>;
};

/** Direction for sorting results. */
export enum QontoCommon_SortDirection {
  /** Ascending order */
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  /** Descending order */
  SortDirectionDesc = 'SORT_DIRECTION_DESC',
  /** Unspecified order */
  SortDirectionUnspecified = 'SORT_DIRECTION_UNSPECIFIED'
}

/** Segmentation of the organization, describing how it uses invoicing at Qonto. */
export enum QontoEinvoicingEinvoicingCompaniesFirstpartyV3_CompanySegmentation {
  /** Unspecified segmentation. */
  CompanySegmentationUnspecified = 'COMPANY_SEGMENTATION_UNSPECIFIED',
  /**
   * Organization uses AP or AR, e.g. it has sent or received invoices at Qonto.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  ApAr = 'ap_ar',
  /**
   * Organization which does not use invoices at Qonto and for which we do not
   * know whether it uses an invoicing tool or not.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Standard = 'standard',
  /**
   * Organization uses other invoicing tools.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  ThirdParty = 'third_party'
}

/**
 * Status of the company in e-invoicing. Maps directly to the value stored in
 * the companies.status column.
 */
export enum QontoEinvoicingEinvoicingCompaniesFirstpartyV3_CompanyStatus {
  /**
   * The status is unknown to e-invoicing (companies.status is NULL, e.g. the
   * company has not been synced yet).
   */
  CompanyStatusUnspecified = 'COMPANY_STATUS_UNSPECIFIED',
  /**
   * Activated.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Activated = 'activated',
  /**
   * Deactivated.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Deactivated = 'deactivated',
  /**
   * Awaiting KYB validation.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  KybWaiting = 'kyb_waiting',
  /**
   * Awaiting light validation.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  LightValidationPending = 'light_validation_pending',
  /**
   * Suspended.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Suspended = 'suspended'
}

/** Request to retrieve an einvoicing company by its organization. */
export type QontoEinvoicingEinvoicingCompaniesFirstpartyV3_GetCompanyRequestInput = {
  /** The organization ID (path parameter). */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response carrying the einvoicing company, wrapped in the JSON:API data
 * envelope.
 */
export type QontoEinvoicingEinvoicingCompaniesFirstpartyV3_GetCompanyResponse = {
  __typename?: 'QontoEinvoicingEinvoicingCompaniesFirstpartyV3_GetCompanyResponse';
  /** The JSON:API data envelope wrapping the company resource. */
  data: QontoEinvoicingEinvoicingCompaniesFirstpartyV3_GetCompanyResponse_Data;
};

/** Attributes of the einvoicing company resource. */
export type QontoEinvoicingEinvoicingCompaniesFirstpartyV3_GetCompanyResponse_Attributes = {
  __typename?: 'QontoEinvoicingEinvoicingCompaniesFirstpartyV3_GetCompanyResponse_Attributes';
  /**
   * Segmentation of the organization. Always present; defaults to `standard`
   * when the organization's invoicing usage is unknown.
   */
  segmentation: QontoEinvoicingEinvoicingCompaniesFirstpartyV3_CompanySegmentation;
  /**
   * Status of the organization, mirroring the companies.status column.
   * COMPANY_STATUS_UNSPECIFIED when e-invoicing has no status for the
   * organization yet.
   */
  status: QontoEinvoicingEinvoicingCompaniesFirstpartyV3_CompanyStatus;
};

/** JSON:API resource object for the einvoicing company. */
export type QontoEinvoicingEinvoicingCompaniesFirstpartyV3_GetCompanyResponse_Data = {
  __typename?: 'QontoEinvoicingEinvoicingCompaniesFirstpartyV3_GetCompanyResponse_Data';
  /** The einvoicing company attributes. */
  attributes: QontoEinvoicingEinvoicingCompaniesFirstpartyV3_GetCompanyResponse_Attributes;
  frAddresses?: Maybe<QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_ListAddressesProxyResponse>;
  frSettings?: Maybe<QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsProxyResponse>;
  /** The organization ID identifying the company. */
  id: Scalars['String']['output'];
  /** The resource type. Always "companies". */
  type: Scalars['String']['output'];
};

/**
 * A French e-invoicing address as a JSON:API resource object. Shared by the
 * list (GET) and create (POST) endpoints.
 */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_Address = {
  __typename?: 'QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_Address';
  /** The address attributes. */
  attributes: QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_Address_Attributes;
  /** The unique identifier of the address resource. */
  id: Scalars['String']['output'];
  /** Relationships to other resources. */
  relationships: QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_AddressRelationships;
  /** The resource type. Always "addresses". */
  type: Scalars['String']['output'];
};

/** JSON:API to-one relationship pointing to the company resource. */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_AddressCompanyRelationship = {
  __typename?: 'QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_AddressCompanyRelationship';
  /** Resource identifier of the related company. */
  data: QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_AddressResourceIdentifier;
};

/** JSON:API relationships block for an address resource. */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_AddressRelationships = {
  __typename?: 'QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_AddressRelationships';
  /** The company the address belongs to. */
  company: QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_AddressCompanyRelationship;
};

/** JSON:API resource identifier (type + id) used within the address envelope. */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_AddressResourceIdentifier = {
  __typename?: 'QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_AddressResourceIdentifier';
  /** The resource id. */
  id: Scalars['String']['output'];
  /** The resource type, e.g. "companies". */
  type: Scalars['String']['output'];
};

/**
 * Status of a French e-invoicing address, aggregating the underlying lifecycle
 * states into the set the frontend renders.
 */
export enum QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_AddressStatus {
  /** Unspecified status. */
  AddressStatusUnspecified = 'ADDRESS_STATUS_UNSPECIFIED',
  /**
   * The address is active in the Annuaire.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Active = 'active',
  /**
   * The address is no longer active in the Annuaire.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Disabled = 'disabled',
  /**
   * The address is on the waiting list before it is created, either because the
   * Annuaire is under maintenance or because the company is not yet eligible for
   * e-invoicing.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  InWaitingList = 'in_waiting_list',
  /**
   * The address is not served by Qonto; it was found in the Annuaire directory
   * and belongs to another PDP.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  NoQonto = 'no_qonto',
  /**
   * The address is derived from a pending consent and is created automatically
   * once the company is activated.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  PendingCompanyActivation = 'pending_company_activation',
  /**
   * The address is still being created in the Annuaire/Peppol.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  PendingCreation = 'pending_creation',
  /**
   * The address is being removed from the Annuaire.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  PendingDeletion = 'pending_deletion',
  /**
   * The address is being migrated to Qonto from another e-invoicing platform
   * (inbound migration).
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  PendingInboundMigration = 'pending_inbound_migration',
  /**
   * The address is being migrated away from Qonto to another e-invoicing
   * platform (outbound migration), at that platform's request.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  PendingOutboundMigration = 'pending_outbound_migration',
  /**
   * The address is already registered in the Annuaire but will only become
   * active at a later date.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Scheduled = 'scheduled'
}

/**
 * Attributes of a French e-invoicing address. The full e-invoicing address
 * string is obtained by joining the non-empty siren, siret, routing_code and
 * suffix parts with "_".
 */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_Address_Attributes = {
  __typename?: 'QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_Address_Attributes';
  /**
   * Date on which the company opted in to e-invoicing for this address,
   * formatted as YYYY-MM-DD. Populated only for addresses derived from a
   * pending consent (pending_company_activation), which may not have a
   * start_date yet; the frontend can fall back to this date. Absent otherwise.
   */
  consentedAt?: Maybe<Scalars['String']['output']>;
  /**
   * Date until which the address is active, formatted as YYYY-MM-DD. Absent
   * when the address has no end date.
   */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Name of the PDP serving this address, e.g. "Qonto (Olinda SAS)". */
  pdpName: Scalars['String']['output'];
  /** Routing code. Empty when the address has none. */
  routingCode: Scalars['String']['output'];
  /** SIREN of the company (9 digits). Always present. */
  siren: Scalars['String']['output'];
  /**
   * SIRET of the establishment (14 digits). Empty when the address is not
   * scoped to a specific establishment.
   */
  siret: Scalars['String']['output'];
  /**
   * Date from which the address is active, formatted as YYYY-MM-DD. Absent
   * when no start date has been set yet.
   */
  startDate?: Maybe<Scalars['String']['output']>;
  /** Current status of the address. */
  status: QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_AddressStatus;
  /** Suffix. Empty when the address has none. */
  suffix: Scalars['String']['output'];
};

/** Custom application error codes for CreateAddress. */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_CreateAddressErrors = {
  __typename?: 'QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_CreateAddressErrors';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Custom application error codes for CreateAddress. */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_CreateAddressErrorsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Custom error codes for HTTP 422 Unprocessable Entity. */
export enum QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_CreateAddressErrors_UnprocessableEntityError {
  /** Fallback for unknown or unspecified application error code. */
  UnprocessableEntityErrorUnspecified = 'UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED',
  /**
   * Returned when end_date is before start_date.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  EndDateBeforeStartDate = 'end_date_before_start_date',
  /**
   * Returned when end_date is set but is not a valid YYYY-MM-DD date.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  InvalidEndDate = 'invalid_end_date',
  /**
   * Returned when siren is missing, blank, or not a valid 9-digit SIREN.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  InvalidSiren = 'invalid_siren',
  /**
   * Returned when siret is set but is not a valid 14-digit SIRET.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  InvalidSiret = 'invalid_siret',
  /**
   * Returned when start_date is set but is not a valid YYYY-MM-DD date.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  InvalidStartDate = 'invalid_start_date',
  /**
   * Returned when start_date is a valid date but is not in the future.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  StartDateInPast = 'start_date_in_past'
}

/**
 * Request to create a French e-invoicing address for a company, wrapped in the
 * JSON:API data envelope.
 */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_CreateAddressRequestInput = {
  /** The JSON:API data envelope carrying the address to create. */
  data: QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_CreateAddressRequest_DataInput;
  /** The organization ID (path parameter). */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Attributes accepted on creation. Only siren is required; the other parts
 * describe a more specific address. When start_date is omitted the server
 * sets it, the same way it does when it schedules the address itself; when
 * end_date is omitted the address is left without an end date.
 */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_CreateAddressRequest_AttributesInput = {
  /**
   * Date until which the address should be active, formatted as YYYY-MM-DD.
   * Optional; when omitted the address is left without an end date.
   */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Routing code. Optional. */
  routingCode?: InputMaybe<Scalars['String']['input']>;
  /** SIREN of the company (9 digits). Required. */
  siren?: InputMaybe<Scalars['String']['input']>;
  /** SIRET of the establishment (14 digits). Optional. */
  siret?: InputMaybe<Scalars['String']['input']>;
  /**
   * Date from which the address should be active, formatted as YYYY-MM-DD.
   * Optional; when omitted the server sets it.
   */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Suffix. Optional. */
  suffix?: InputMaybe<Scalars['String']['input']>;
};

/** JSON:API resource object with the address fields to create. */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_CreateAddressRequest_DataInput = {
  /** The address attributes to create. */
  attributes: QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_CreateAddressRequest_AttributesInput;
  /** The resource type. Always "addresses". */
  type?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response carrying the created French e-invoicing address, wrapped in the
 * JSON:API data envelope.
 */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_CreateAddressResponse = {
  __typename?: 'QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_CreateAddressResponse';
  /** The JSON:API data envelope wrapping the created address resource. */
  data: QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_Address;
};

/** Custom application error codes for DeleteAddress. */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_DeleteAddressErrors = {
  __typename?: 'QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_DeleteAddressErrors';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Custom application error codes for DeleteAddress. */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_DeleteAddressErrorsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Custom error codes for HTTP 404 Not Found. */
export enum QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_DeleteAddressErrors_NotFoundError {
  /** Fallback for unknown or unspecified application error code. */
  NotFoundErrorUnspecified = 'NOT_FOUND_ERROR_UNSPECIFIED',
  /**
   * Returned when no address exists for the given id.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  AddressNotFound = 'address_not_found'
}

/** Custom error codes for HTTP 422 Unprocessable Entity. */
export enum QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_DeleteAddressErrors_UnprocessableEntityError {
  /** Fallback for unknown or unspecified application error code. */
  UnprocessableEntityErrorUnspecified = 'UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED',
  /**
   * Returned when the address is not in a state that allows deletion.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  AddressNotEligibleForDeletion = 'address_not_eligible_for_deletion'
}

/**
 * Request to delete a French e-invoicing address by its id. Deletion is
 * asynchronous: the address transitions to pending_deletion before it is
 * removed from the Annuaire.
 */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_DeleteAddressRequestInput = {
  /** The address ID (path parameter). */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The organization ID (path parameter). */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Free-text reason for the deletion, forwarded to the PDP. Optional. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response for a successful address deletion. Empty: the address is being
 * removed asynchronously.
 */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_DeleteAddressResponse = {
  __typename?: 'QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_DeleteAddressResponse';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Request to list the French e-invoicing addresses of a company over POST.
 * Behaves exactly like ListAddresses; it exists for internal callers that
 * cannot issue GET reads (the GraphQL gateway). The body is currently unused
 * and reserved for future filter parameters.
 */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_ListAddressesProxyRequestInput = {
  /** The organization ID (path parameter). */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response carrying the company's French e-invoicing addresses, identical to
 * ListAddressesResponse.
 */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_ListAddressesProxyResponse = {
  __typename?: 'QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_ListAddressesProxyResponse';
  /** The JSON:API data envelope wrapping the address resources. */
  data: Array<QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_Address>;
};

/** Request to list the French e-invoicing addresses of a company. */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_ListAddressesRequestInput = {
  /** The organization ID (path parameter). */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response carrying the company's French e-invoicing addresses, wrapped in the
 * JSON:API data envelope.
 */
export type QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_ListAddressesResponse = {
  __typename?: 'QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_ListAddressesResponse';
  /** The JSON:API data envelope wrapping the address resources. */
  data: Array<QontoEinvoicingEinvoicingFranceAddressesFirstpartyV3_Address>;
};

/** Custom errors for the GetSettings endpoint, grouped by HTTP status. */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsErrors = {
  __typename?: 'QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsErrors';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Custom errors for the GetSettings endpoint, grouped by HTTP status. */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsErrorsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Custom error codes for HTTP 404 Not Found. */
export enum QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsErrors_NotFoundError {
  /** No or unknown application specific error code was given. */
  NotFoundErrorUnspecified = 'NOT_FOUND_ERROR_UNSPECIFIED',
  /**
   * The company is not known to e-invoicing.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  CompanyNotFound = 'company_not_found'
}

/**
 * Request to retrieve the French e-invoicing settings of a company over POST.
 * Behaves exactly like GetSettings; it exists for internal callers that cannot
 * issue GET reads (the GraphQL gateway). The body is currently unused and
 * reserved for future filter parameters.
 */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsProxyRequestInput = {
  /** The organization ID (path parameter). */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response carrying the French e-invoicing settings of a company, identical to
 * GetSettingsResponse.
 */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsProxyResponse = {
  __typename?: 'QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsProxyResponse';
  /** The JSON:API data envelope wrapping the settings resource. */
  data: QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsResponse_Data;
};

/** Request to retrieve the French e-invoicing settings of a company. */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsRequestInput = {
  /** The organization ID (path parameter). */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response carrying the French e-invoicing settings of a company, wrapped
 * in the JSON:API data envelope. Returns 404 when the company is unknown
 * to e-invoicing, or 200 with an empty company_size when the company is
 * known but has no company size set.
 */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsResponse = {
  __typename?: 'QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsResponse';
  /** The JSON:API data envelope wrapping the settings resource. */
  data: QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsResponse_Data;
};

/** Attributes of the French e-invoicing settings resource. */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsResponse_Attributes = {
  __typename?: 'QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsResponse_Attributes';
  /**
   * Company size. Always present; empty string when the company has none set.
   * Valid values: "small", "large".
   */
  companySize: Scalars['String']['output'];
};

/** JSON:API resource object for the French e-invoicing settings. */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsResponse_Data = {
  __typename?: 'QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsResponse_Data';
  /** The French e-invoicing settings of the company. */
  attributes: QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_GetSettingsResponse_Attributes;
  /** The unique identifier of the settings resource. */
  id: Scalars['String']['output'];
  /** Relationships to other resources. */
  relationships: QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_SettingsRelationships;
  /** The resource type. Always "settings". */
  type: Scalars['String']['output'];
};

/** JSON:API to-one relationship pointing to the company resource. */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_SettingsCompanyRelationship = {
  __typename?: 'QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_SettingsCompanyRelationship';
  /** Resource identifier of the related company. */
  data: QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_SettingsResourceIdentifier;
};

/**
 * JSON:API relationships block for a settings resource, shared by the GET and
 * PUT endpoints.
 */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_SettingsRelationships = {
  __typename?: 'QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_SettingsRelationships';
  /** The company the settings belong to. */
  company: QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_SettingsCompanyRelationship;
};

/** JSON:API resource identifier (type + id) used within the settings envelope. */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_SettingsResourceIdentifier = {
  __typename?: 'QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_SettingsResourceIdentifier';
  /** The resource id. */
  id: Scalars['String']['output'];
  /** The resource type, e.g. "companies". */
  type: Scalars['String']['output'];
};

/** Custom errors for the UpdateSettings endpoint, grouped by HTTP status. */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsErrors = {
  __typename?: 'QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsErrors';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Custom errors for the UpdateSettings endpoint, grouped by HTTP status. */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsErrorsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Custom error codes for HTTP 422 Unprocessable Entity. */
export enum QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsErrors_UnprocessableEntityError {
  /** No or unknown application specific error code was given. */
  UnprocessableEntityErrorUnspecified = 'UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED',
  /**
   * The company is not known to e-invoicing.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  CompanyNotFound = 'company_not_found',
  /**
   * company_size is a non-empty value other than "small" or "large".
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  InvalidCompanySize = 'invalid_company_size'
}

/**
 * Request to update the French e-invoicing settings of a company, wrapped
 * in the JSON:API data envelope.
 */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsRequestInput = {
  /** The JSON:API data envelope carrying the fields to update. */
  data: QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsRequest_DataInput;
  /** The organization ID (path parameter). */
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes accepted on an update. */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsRequest_AttributesInput = {
  /**
   * Company size to set on the company. Valid values: "small", "large",
   * or "" to leave it unset. The empty string lets the frontend effectively
   * skip the field without it being optional. A non-empty value that is not
   * "small" or "large" is rejected with 422.
   */
  companySize?: InputMaybe<Scalars['String']['input']>;
};

/** JSON:API resource object with the settings fields to update. */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsRequest_DataInput = {
  /** The settings attributes to update. */
  attributes: QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsRequest_AttributesInput;
  /** The resource type. Always "settings". */
  type?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response carrying the company size after the update, wrapped in the JSON:API
 * data envelope.
 */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsResponse = {
  __typename?: 'QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsResponse';
  /** The JSON:API data envelope wrapping the updated settings resource. */
  data: QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsResponse_Data;
};

/** Attributes of the updated French e-invoicing settings resource. */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsResponse_Attributes = {
  __typename?: 'QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsResponse_Attributes';
  /**
   * Company size after the update. Always present; empty string when the
   * company has none set. Valid values: "small", "large".
   */
  companySize: Scalars['String']['output'];
};

/** JSON:API resource object for the updated French e-invoicing settings. */
export type QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsResponse_Data = {
  __typename?: 'QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsResponse_Data';
  /** The updated settings attributes. */
  attributes: QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_UpdateSettingsResponse_Attributes;
  /** The unique identifier of the settings resource. */
  id: Scalars['String']['output'];
  /** Relationships to other resources. */
  relationships: QontoEinvoicingEinvoicingFranceSettingsFirstpartyV3_SettingsRelationships;
  /** The resource type. Always "settings". */
  type: Scalars['String']['output'];
};

/** Individual error object following the JSON API specification (https://jsonapi.org/format/#errors). */
export type QontoHttpJson_Error = {
  __typename?: 'QontoHttpJson_Error';
  /** An application-specific error code, expressed as a string value. */
  code?: Maybe<Scalars['String']['output']>;
  /** A human-readable explanation specific to this occurrence of the problem. Like title, this field’s value can be localized. */
  detail?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for this particular occurrence of the problem. */
  id?: Maybe<Scalars['String']['output']>;
  /** An object containing non-standard meta-information about the error. */
  meta?: Maybe<Scalars['GoogleProtobuf_Struct']['output']>;
  /** A Source message containing references to the primary source of the error. */
  source?: Maybe<QontoHttpJson_Error_Source>;
  /** The HTTP status code applicable to this problem, expressed as a string value. This SHOULD be provided. */
  status?: Maybe<Scalars['String']['output']>;
  /** A short, human-readable summary of the problem that SHOULD NOT change from occurrence to occurrence of the problem, except for purposes of localization. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Individual error object following the JSON API specification (https://jsonapi.org/format/#errors). */
export type QontoHttpJson_ErrorInput = {
  /** An application-specific error code, expressed as a string value. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** A human-readable explanation specific to this occurrence of the problem. Like title, this field’s value can be localized. */
  detail?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for this particular occurrence of the problem. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** An object containing non-standard meta-information about the error. */
  meta?: InputMaybe<Scalars['GoogleProtobuf_StructInput']['input']>;
  /** A Source message containing references to the primary source of the error. */
  source?: InputMaybe<QontoHttpJson_Error_SourceInput>;
  /** The HTTP status code applicable to this problem, expressed as a string value. This SHOULD be provided. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** A short, human-readable summary of the problem that SHOULD NOT change from occurrence to occurrence of the problem, except for purposes of localization. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Source objects provide references to the source of an error in the request document. */
export type QontoHttpJson_Error_Source = {
  __typename?: 'QontoHttpJson_Error_Source';
  /** A string indicating the name of a single request header which caused the error. */
  header?: Maybe<Scalars['String']['output']>;
  /** A string indicating which URI query parameter caused the error. */
  parameter?: Maybe<Scalars['String']['output']>;
  /** A JSON Pointer [RFC6901] to the value in the request document that caused the error [e.g. "/data" for a primary data object, or "/data/attributes/title" for a specific attribute]. This MUST point to a value in the request document that exists; if it doesn’t, the client SHOULD simply ignore the pointer. */
  pointer?: Maybe<Scalars['String']['output']>;
};

/** Source objects provide references to the source of an error in the request document. */
export type QontoHttpJson_Error_SourceInput = {
  /** A string indicating the name of a single request header which caused the error. */
  header?: InputMaybe<Scalars['String']['input']>;
  /** A string indicating which URI query parameter caused the error. */
  parameter?: InputMaybe<Scalars['String']['input']>;
  /** A JSON Pointer [RFC6901] to the value in the request document that caused the error [e.g. "/data" for a primary data object, or "/data/attributes/title" for a specific attribute]. This MUST point to a value in the request document that exists; if it doesn’t, the client SHOULD simply ignore the pointer. */
  pointer?: InputMaybe<Scalars['String']['input']>;
};

/** Error object following the JSON API specification (https://jsonapi.org/format/#errors). */
export type QontoHttpJson_JsonApiError = {
  __typename?: 'QontoHttpJson_JSONApiError';
  /** Array of error objects that occurred during the request */
  errors: Array<QontoHttpJson_Error>;
};

/** Error object following the JSON API specification (https://jsonapi.org/format/#errors). */
export type QontoHttpJson_JsonApiErrorInput = {
  /** Array of error objects that occurred during the request */
  errors?: InputMaybe<Array<QontoHttpJson_ErrorInput>>;
};

/** Metadata for describing the HTTP routes. */
export type QontoHttp_Route = {
  __typename?: 'QontoHttp_Route';
  /** To be used with DELETE requests */
  delete?: Maybe<Scalars['String']['output']>;
  /** To be used with GET requests */
  get?: Maybe<Scalars['String']['output']>;
  /** To be used with PATCH requests */
  patch?: Maybe<Scalars['String']['output']>;
  /** To be used with POST requests */
  post?: Maybe<Scalars['String']['output']>;
  /** To be used with PUT requests */
  put?: Maybe<Scalars['String']['output']>;
};

/** Metadata for describing the HTTP routes. */
export type QontoHttp_RouteInput = {
  /** To be used with DELETE requests */
  delete?: InputMaybe<Scalars['String']['input']>;
  /** To be used with GET requests */
  get?: InputMaybe<Scalars['String']['input']>;
  /** To be used with PATCH requests */
  patch?: InputMaybe<Scalars['String']['input']>;
  /** To be used with POST requests */
  post?: InputMaybe<Scalars['String']['input']>;
  /** To be used with PUT requests */
  put?: InputMaybe<Scalars['String']['input']>;
};

/** Fee represents an individual fee */
export type QontoPricingBillerFeesFirstpartyV1_Fee = {
  __typename?: 'QontoPricingBillerFeesFirstpartyV1_Fee';
  /** Base amount of the fees (all fee items summed up) */
  amount: QontoCommon_CurrencyAmount;
  /** Comment set on the fee, most likely by a human */
  comment?: Maybe<Scalars['String']['output']>;
  /** Datetime in ISO 8601 */
  createdAt: Scalars['String']['output'];
  /** A superset of fee_type; includes more specific domain fee types */
  eventType: Scalars['String']['output'];
  /** Translated, human readable variant of what this fee is */
  feeLabel: Scalars['String']['output'];
  /** Sums provided for a single fee's fee payments */
  feePaymentSums: QontoPricingBillerFeesFirstpartyV1_FeePaymentSums;
  /** Status of the Fee */
  feeStatus: QontoPricingBillerFeesFirstpartyV1_FeeStatus;
  /** Type if the Fee, */
  feeType: QontoPricingBillerFeesFirstpartyV1_FeeType;
  /** Id of the fee */
  id: Scalars['String']['output'];
  /** Organization ID the fee is associated with */
  organizationId: Scalars['String']['output'];
  /** Subscription ID the fee is associated with */
  subscriptionId: Scalars['String']['output'];
  /** Base amount of the fee with discounts applied */
  totalAmount: QontoCommon_CurrencyAmount;
  /** Total amount of fee with discounts applied, including VAT */
  totalAmountVatIncluded: QontoCommon_CurrencyAmount;
  /** Datetime in ISO 8601 */
  updatedAt: Scalars['String']['output'];
  /** VAT amount of the fee, based on the totalAmount */
  vatAmount: QontoCommon_CurrencyAmount;
  /** The fees VAT, where e.g. 20% VAT is represented as 20.0 in this field. 0.0 is a valid value. */
  vatRate: Scalars['Float']['output'];
};

/** FeePaymentSums are sums of the individual FeePayments by their status. */
export type QontoPricingBillerFeesFirstpartyV1_FeePaymentSums = {
  __typename?: 'QontoPricingBillerFeesFirstpartyV1_FeePaymentSums';
  /** Amount that was forgiven (without VAT) */
  cancelledAmount: QontoCommon_CurrencyAmount;
  /** Convenience to detect zero amounts without comparing money objects */
  cancelledAmountIsZero: Scalars['Boolean']['output'];
  /** Amount that was forgiven (with VAT) */
  cancelledAmountVatIncluded: QontoCommon_CurrencyAmount;
  /** Amount that was forgiven (VAT only) */
  cancelledVatAmount: QontoCommon_CurrencyAmount;
  /** Amount that was already paid (without VAT) */
  completedAmount: QontoCommon_CurrencyAmount;
  /** Convenience to detect zero amounts without comparing money objects */
  completedAmountIsZero: Scalars['Boolean']['output'];
  /** Amount that was already paid (with VAT) */
  completedAmountVatIncluded: QontoCommon_CurrencyAmount;
  /** Amount that was already paid (VAT only) */
  completedVatAmount: QontoCommon_CurrencyAmount;
  /** Total amount the customer has paid or will pay (without VAT) */
  expectedAmount: QontoCommon_CurrencyAmount;
  /** Convenience to detect zero amounts without comparing money objects */
  expectedAmountIsZero: Scalars['Boolean']['output'];
  /** Total amount the customer has paid or will pay (with VAT) */
  expectedAmountVatIncluded: QontoCommon_CurrencyAmount;
  /** Total amount the customer has paid or will pay (VAT only) */
  expectedVatAmount: QontoCommon_CurrencyAmount;
  /** Amount we are currently collecting (without VAT) */
  orderedAmount: QontoCommon_CurrencyAmount;
  /** Convenience to detect zero amounts without comparing money objects */
  orderedAmountIsZero: Scalars['Boolean']['output'];
  /** Amount we are currently collecting (with VAT) */
  orderedAmountVatIncluded: QontoCommon_CurrencyAmount;
  /** Amount we are currently collecting (VAT only) */
  orderedVatAmount: QontoCommon_CurrencyAmount;
  /** Amount we will attempt to collect soon (without VAT) */
  pendingAmount: QontoCommon_CurrencyAmount;
  /** Convenience to detect zero amounts without comparing money objects */
  pendingAmountIsZero: Scalars['Boolean']['output'];
  /** Amount we will attempt to collect soon (with VAT) */
  pendingAmountVatIncluded: QontoCommon_CurrencyAmount;
  /** Amount we will attempt to collect soon (VAT only) */
  pendingVatAmount: QontoCommon_CurrencyAmount;
  /** Total amount that we still expect to collect (without VAT) */
  unsettledAmount: QontoCommon_CurrencyAmount;
  /** Convenience to detect zero amounts without comparing money objects */
  unsettledAmountIsZero: Scalars['Boolean']['output'];
  /** Total amount that we still expect to collect (with VAT) */
  unsettledAmountVatIncluded: QontoCommon_CurrencyAmount;
  /** Total amount that we still expect to collect (VAT only) */
  unsettledVatAmount: QontoCommon_CurrencyAmount;
  /** Amount that we are waiting to collect (without VAT) */
  waitingFundsAmount: QontoCommon_CurrencyAmount;
  /** Convenience to detect zero amounts without comparing money objects */
  waitingFundsAmountIsZero: Scalars['Boolean']['output'];
  /** Amount that we are waiting to collect (with VAT) */
  waitingFundsAmountVatIncluded: QontoCommon_CurrencyAmount;
  /** Amount that we are waiting to collect (VAT only) */
  waitingFundsVatAmount: QontoCommon_CurrencyAmount;
};

/**
 * FeeStatus represents the status of a fee
 * buf:lint:ignore ENUM_VALUE_PREFIX
 * buf:lint:ignore COMMENT_ENUM_VALUE
 */
export enum QontoPricingBillerFeesFirstpartyV1_FeeStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  CompletedOffered = 'COMPLETED_OFFERED',
  FeeStatusUnspecified = 'FEE_STATUS_UNSPECIFIED',
  Pending = 'PENDING',
  WaitingFunds = 'WAITING_FUNDS'
}

/**
 * FeeType represents the type of fee
 * buf:lint:ignore ENUM_VALUE_PREFIX
 * buf:lint:ignore COMMENT_ENUM_VALUE
 */
export enum QontoPricingBillerFeesFirstpartyV1_FeeType {
  Accounting = 'ACCOUNTING',
  AccountsPayable = 'ACCOUNTS_PAYABLE',
  AccountsReceivable = 'ACCOUNTS_RECEIVABLE',
  AccountClosed = 'ACCOUNT_CLOSED',
  AdditionalUser = 'ADDITIONAL_USER',
  AdvertisingCard = 'ADVERTISING_CARD',
  Atm = 'ATM',
  AtmPlus = 'ATM_PLUS',
  CapitalIncrease = 'CAPITAL_INCREASE',
  CardAcquirerPayout = 'CARD_ACQUIRER_PAYOUT',
  CashFlowManagement = 'CASH_FLOW_MANAGEMENT',
  Cheque = 'CHEQUE',
  ConfirmationLetter = 'CONFIRMATION_LETTER',
  DebtCollection = 'DEBT_COLLECTION',
  DepositInterest = 'DEPOSIT_INTEREST',
  DirectDebitCollectionActivation = 'DIRECT_DEBIT_COLLECTION_ACTIVATION',
  DirectDebitCollectionRefund = 'DIRECT_DEBIT_COLLECTION_REFUND',
  DirectDebitCollectionRefundLate = 'DIRECT_DEBIT_COLLECTION_REFUND_LATE',
  DirectDebitCollectionReturn = 'DIRECT_DEBIT_COLLECTION_RETURN',
  DirectDebitCollectionSend = 'DIRECT_DEBIT_COLLECTION_SEND',
  EckertLaw = 'ECKERT_LAW',
  ExpenseSpendManagement = 'EXPENSE_SPEND_MANAGEMENT',
  FeeTypeUnspecified = 'FEE_TYPE_UNSPECIFIED',
  FlashCard = 'FLASH_CARD',
  Fraud = 'FRAUD',
  FxCard = 'FX_CARD',
  FxCardPlus = 'FX_CARD_PLUS',
  FxInboundTransfer = 'FX_INBOUND_TRANSFER',
  FxOutboundTransfer = 'FX_OUTBOUND_TRANSFER',
  FxOutboundTransferEurSwiftOur = 'FX_OUTBOUND_TRANSFER_EUR_SWIFT_OUR',
  FxOutboundTransferEurSwiftSha = 'FX_OUTBOUND_TRANSFER_EUR_SWIFT_SHA',
  FxOutboundTransferLocalNonStandardCurrency = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY',
  FxOutboundTransferLocalNonStandardCurrencyReduced_10 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_10',
  FxOutboundTransferLocalNonStandardCurrencyReduced_20 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_20',
  FxOutboundTransferLocalNonStandardCurrencyReduced_40 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_40',
  FxOutboundTransferLocalNonStandardCurrencyReduced_50 = 'FX_OUTBOUND_TRANSFER_LOCAL_NON_STANDARD_CURRENCY_REDUCED_50',
  FxOutboundTransferLocalStandardCurrency = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY',
  FxOutboundTransferLocalStandardCurrencyReduced_10 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_10',
  FxOutboundTransferLocalStandardCurrencyReduced_20 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_20',
  FxOutboundTransferLocalStandardCurrencyReduced_40 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_40',
  FxOutboundTransferLocalStandardCurrencyReduced_50 = 'FX_OUTBOUND_TRANSFER_LOCAL_STANDARD_CURRENCY_REDUCED_50',
  FxOutboundTransferOnlyVariableSwiftOur = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR',
  FxOutboundTransferOnlyVariableSwiftOurReduced_10 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_10',
  FxOutboundTransferOnlyVariableSwiftOurReduced_20 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_20',
  FxOutboundTransferOnlyVariableSwiftOurReduced_40 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_40',
  FxOutboundTransferOnlyVariableSwiftOurReduced_50 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_OUR_REDUCED_50',
  FxOutboundTransferOnlyVariableSwiftSha = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA',
  FxOutboundTransferOnlyVariableSwiftShaReduced_10 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_10',
  FxOutboundTransferOnlyVariableSwiftShaReduced_20 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_20',
  FxOutboundTransferOnlyVariableSwiftShaReduced_40 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_40',
  FxOutboundTransferOnlyVariableSwiftShaReduced_50 = 'FX_OUTBOUND_TRANSFER_ONLY_VARIABLE_SWIFT_SHA_REDUCED_50',
  FxOutboundTransferSwiftOur = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR',
  FxOutboundTransferSwiftOurReduced_10 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_10',
  FxOutboundTransferSwiftOurReduced_20 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_20',
  FxOutboundTransferSwiftOurReduced_40 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_40',
  FxOutboundTransferSwiftOurReduced_50 = 'FX_OUTBOUND_TRANSFER_SWIFT_OUR_REDUCED_50',
  FxOutboundTransferSwiftSha = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA',
  FxOutboundTransferSwiftShaReduced_10 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_10',
  FxOutboundTransferSwiftShaReduced_20 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_20',
  FxOutboundTransferSwiftShaReduced_40 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_40',
  FxOutboundTransferSwiftShaReduced_50 = 'FX_OUTBOUND_TRANSFER_SWIFT_SHA_REDUCED_50',
  FxRefund = 'FX_REFUND',
  GenericFee = 'GENERIC_FEE',
  InvoiceAutomation = 'INVOICE_AUTOMATION',
  JudicialRequisition = 'JUDICIAL_REQUISITION',
  Other = 'OTHER',
  Pagopa = 'PAGOPA',
  PhysicalCard = 'PHYSICAL_CARD',
  PhysicalCardDelivery = 'PHYSICAL_CARD_DELIVERY',
  PhysicalCardMetal = 'PHYSICAL_CARD_METAL',
  PhysicalCardMirror = 'PHYSICAL_CARD_MIRROR',
  PhysicalCardPlus = 'PHYSICAL_CARD_PLUS',
  ProjectTracking = 'PROJECT_TRACKING',
  RejectedDebit = 'REJECTED_DEBIT',
  RejectedFxTransfer = 'REJECTED_FX_TRANSFER',
  RejectedTransfer = 'REJECTED_TRANSFER',
  ReturnedCheque = 'RETURNED_CHEQUE',
  Satd = 'SATD',
  SciNumberObtention = 'SCI_NUMBER_OBTENTION',
  SeizureForeclosure = 'SEIZURE_FORECLOSURE',
  SepaInboundTransfer = 'SEPA_INBOUND_TRANSFER',
  SepaOutboundTransfer = 'SEPA_OUTBOUND_TRANSFER',
  Shortfall = 'SHORTFALL',
  Subscription = 'SUBSCRIPTION',
  SwiftIncome = 'SWIFT_INCOME',
  SwiftIncomeFree = 'SWIFT_INCOME_FREE',
  TeamSpendControls = 'TEAM_SPEND_CONTROLS',
  ThirdPartyNotice = 'THIRD_PARTY_NOTICE',
  UnpaidCheque = 'UNPAID_CHEQUE',
  UpvestMmfFeeCancellation = 'UPVEST_MMF_FEE_CANCELLATION',
  VirtualCard = 'VIRTUAL_CARD'
}

/** GroupedFees contains the list of fees found for the parentMovementId */
export type QontoPricingBillerFeesFirstpartyV1_GroupedFees = {
  __typename?: 'QontoPricingBillerFeesFirstpartyV1_GroupedFees';
  /** Sums provided for all fees and their fee payments */
  feePaymentSums: QontoPricingBillerFeesFirstpartyV1_FeePaymentSums;
  /** Individual fee details. */
  fees: Array<QontoPricingBillerFeesFirstpartyV1_Fee>;
  /** The movement ID given by the domain event that triggered creation of the fees */
  parentMovementId: Scalars['String']['output'];
  /** Provider object ID (deprecated - use parent_movement_id instead) */
  providerObjectId: Scalars['String']['output'];
};

/** Custom application error codes when searching */
export type QontoPricingBillerFeesFirstpartyV1_SearchErrors = {
  __typename?: 'QontoPricingBillerFeesFirstpartyV1_SearchErrors';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Custom application error codes when searching */
export type QontoPricingBillerFeesFirstpartyV1_SearchErrorsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Custom application error codes for 422 HTTP errors. */
export enum QontoPricingBillerFeesFirstpartyV1_SearchErrors_UnprocessableEntity {
  /** Returned when any of the fee payments isn't using the allowed currency */
  UnprocessableEntityDisallowedCurrency = 'UNPROCESSABLE_ENTITY_DISALLOWED_CURRENCY',
  /** No or unknown application specific error code was given, fallback using the error's status field as guidance. */
  UnprocessableEntityUnspecified = 'UNPROCESSABLE_ENTITY_UNSPECIFIED'
}

/** Request message for listing cost center categories. */
export type QontoPricingBillerFeesFirstpartyV1_SearchRequestInput = {
  /** List of parent movement IDs to search by */
  parentMovementIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Response message for fee search operations */
export type QontoPricingBillerFeesFirstpartyV1_SearchResponse = {
  __typename?: 'QontoPricingBillerFeesFirstpartyV1_SearchResponse';
  /** List of fee search results */
  groupedFees: Array<QontoPricingBillerFeesFirstpartyV1_GroupedFees>;
};

/** Request message for GetPlanChangeMarketingContent */
export type QontoPricingCatalogFirstpartyV1_GetPlanChangeMarketingContentRequest = {
  __typename?: 'QontoPricingCatalogFirstpartyV1_GetPlanChangeMarketingContentRequest';
  /** Product UUIDs — batched as repeated query params: ?product_id=id1&product_id=id2 */
  productIds: Array<Scalars['String']['output']>;
  /** Optional feature code that highlights matching features (is_upsell: true) */
  requestedFeature?: Maybe<Scalars['String']['output']>;
};

/** Request message for GetPlanChangeMarketingContent */
export type QontoPricingCatalogFirstpartyV1_GetPlanChangeMarketingContentRequestInput = {
  /** Product UUIDs — batched as repeated query params: ?product_id=id1&product_id=id2 */
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional feature code that highlights matching features (is_upsell: true) */
  requestedFeature?: InputMaybe<Scalars['String']['input']>;
};

/** Response containing marketing content for each requested product */
export type QontoPricingCatalogFirstpartyV1_GetPlanChangeMarketingContentResponse = {
  __typename?: 'QontoPricingCatalogFirstpartyV1_GetPlanChangeMarketingContentResponse';
  /** Marketing content entries, one per requested product */
  content: Array<QontoPricingCatalogFirstpartyV1_PlanChangeProductContent>;
};

/** Response containing marketing content for each requested product */
export type QontoPricingCatalogFirstpartyV1_GetPlanChangeMarketingContentResponseInput = {
  /** Marketing content entries, one per requested product */
  content?: InputMaybe<Array<QontoPricingCatalogFirstpartyV1_PlanChangeProductContentInput>>;
};

/** Marketing content for a single product */
export type QontoPricingCatalogFirstpartyV1_PlanChangeProductContent = {
  __typename?: 'QontoPricingCatalogFirstpartyV1_PlanChangeProductContent';
  /** Display name, e.g. "Essential" or "Accounts Receivable Plus" */
  brandName: Scalars['String']['output'];
  /** Translated feature list for plan-selection display */
  features: Array<QontoPricingCatalogFirstpartyV1_ProductFeature>;
  /** Product UUID */
  productId: Scalars['String']['output'];
};

/** Marketing content for a single product */
export type QontoPricingCatalogFirstpartyV1_PlanChangeProductContentInput = {
  /** Display name, e.g. "Essential" or "Accounts Receivable Plus" */
  brandName?: InputMaybe<Scalars['String']['input']>;
  /** Translated feature list for plan-selection display */
  features?: InputMaybe<Array<QontoPricingCatalogFirstpartyV1_ProductFeatureInput>>;
  /** Product UUID */
  productId?: InputMaybe<Scalars['String']['input']>;
};

/** A single marketing feature entry for a product */
export type QontoPricingCatalogFirstpartyV1_ProductFeature = {
  __typename?: 'QontoPricingCatalogFirstpartyV1_ProductFeature';
  /** True when this feature matches the requested_feature in the request */
  isUpsell: Scalars['Boolean']['output'];
  /** Translated marketing copy for this feature */
  name: Scalars['String']['output'];
};

/** A single marketing feature entry for a product */
export type QontoPricingCatalogFirstpartyV1_ProductFeatureInput = {
  /** True when this feature matches the requested_feature in the request */
  isUpsell?: InputMaybe<Scalars['Boolean']['input']>;
  /** Translated marketing copy for this feature */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Product lineup enumeration */
export enum QontoPricingCommonV1_ProductLineup {
  /** Default unspecified value for unknown or unrecognized lineup */
  ProductLineupUnspecified = 'PRODUCT_LINEUP_UNSPECIFIED',
  /**
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   * Legacy lineup
   */
  Legacy = 'legacy',
  /**
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   * Light lineup
   */
  Light = 'light',
  /**
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   * Solo lineup
   */
  Solo = 'solo',
  /**
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   * Teams lineup
   */
  Teams = 'teams'
}

/** Product type enumeration */
export enum QontoPricingCommonV1_ProductType {
  /** Default unspecified value for unknown or unrecognized product type */
  ProductTypeUnspecified = 'PRODUCT_TYPE_UNSPECIFIED',
  /**
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   * Addon product type
   */
  Addon = 'addon',
  /**
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   * Core product type
   */
  Core = 'core'
}

/** Subscription recurrence enumeration */
export enum QontoPricingCommonV1_SubscriptionRecurrence {
  /** Default unspecified value */
  SubscriptionRecurrenceUnspecified = 'SUBSCRIPTION_RECURRENCE_UNSPECIFIED',
  /**
   * Annual subscription recurrence
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Annual = 'annual',
  /**
   * Monthly subscription recurrence
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Monthly = 'monthly'
}

/** A single upcoming billing event in the billing timeline. */
export type QontoPricingSubscriptionsFirstpartyV6_BillingMilestone = {
  __typename?: 'QontoPricingSubscriptionsFirstpartyV6_BillingMilestone';
  /** Amount due on this date. */
  amount: QontoCommon_CurrencyAmount;
  /** Active discount tags at this milestone: "trial" | "promo". */
  billingTags: Array<Scalars['String']['output']>;
  /** Date in YYYY-MM-DD format (date-only, not a timestamp). */
  date: Scalars['String']['output'];
  /** true when this cycle's net charge is a refund. */
  isNegative: Scalars['Boolean']['output'];
  /** Human-readable label set by qonto-biller (locale-aware, e.g. "Enjoy features for free!", "Pro-rated amount"). */
  subtitle?: Maybe<Scalars['String']['output']>;
};

/**
 * Machine-readable blocker preventing confirmation.
 * v6 exposes a curated subset of v5 error codes — deprecated codes are still
 * evaluated internally for v5 compatibility but filtered from this response.
 */
export type QontoPricingSubscriptionsFirstpartyV6_Blocker = {
  __typename?: 'QontoPricingSubscriptionsFirstpartyV6_Blocker';
  /** Additional structured context (e.g. conflicting product IDs). */
  additionalData: Scalars['GoogleProtobuf_Struct']['output'];
  /** Machine-readable error code. */
  code: Scalars['String']['output'];
  /** Human-readable detail (for debugging, not displayed to end users). */
  detail: Scalars['String']['output'];
};

/** Current core subscription context, used by the gateway to enrich with brand name. */
export type QontoPricingSubscriptionsFirstpartyV6_CurrentCoreSubscription = {
  __typename?: 'QontoPricingSubscriptionsFirstpartyV6_CurrentCoreSubscription';
  marketingContent: QontoPricingCatalogFirstpartyV1_PlanChangeProductContent;
  /**
   * Product ID of the org's current core plan.
   * Used by the gateway to fetch marketing_content via the pricing-catalog DataLoader.
   */
  productId: Scalars['String']['output'];
};

/**
 * Request message for EstimateSubscriptionChange.
 * organization_id and locale are NOT in the proto body — read from forwarded headers by qonto-biller.
 */
export type QontoPricingSubscriptionsFirstpartyV6_EstimateSubscriptionChangeRequestInput = {
  /**
   * Optional sales-gated flow marker (e.g. "accounting"). Forwarded to go-biller's
   * contract offers as a fact so the flow's gated product can be estimated.
   */
  registrationFlow?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional feature identifier that triggered this estimate (e.g. "upsell_modal", "checkout_cta").
   * Forwarded to qonto-biller for analytics and feature-specific pricing logic.
   */
  requestedFeature?: InputMaybe<Scalars['String']['input']>;
  /** List of products to include in the subscription change estimate. */
  selectedProducts?: InputMaybe<Array<QontoPricingSubscriptionsFirstpartyV6_SubscriptionChangeEstimateProductInput>>;
  /** Optional voucher code. Invalid/inapplicable vouchers surface as a warning, not a blocker. */
  voucherCode?: InputMaybe<Scalars['String']['input']>;
};

/** Response message for EstimateSubscriptionChange. */
export type QontoPricingSubscriptionsFirstpartyV6_EstimateSubscriptionChangeResponse = {
  __typename?: 'QontoPricingSubscriptionsFirstpartyV6_EstimateSubscriptionChangeResponse';
  /** UUID; client passes back in the confirmation request. */
  basketId: Scalars['String']['output'];
  /** Upcoming billing events (e.g. now, end of trial, voucher expiry). */
  billingMilestones: Array<QontoPricingSubscriptionsFirstpartyV6_BillingMilestone>;
  /** Current subscription context — used by the frontend to display "You're currently on X plan". */
  currentCoreSubscription: QontoPricingSubscriptionsFirstpartyV6_CurrentCoreSubscription;
  /** Business-level blockers preventing confirmation. */
  errors: Array<QontoPricingSubscriptionsFirstpartyV6_Blocker>;
  /** Controls whether the "Add promo code" button is visible to the user. */
  isEligibleForVoucherCode: Scalars['Boolean']['output'];
  /** Itemised charge breakdown for the immediate payment. */
  priceBreakdown: QontoPricingSubscriptionsFirstpartyV6_PriceBreakdown;
  /** Addon recommendation(s) for the selected plan. */
  suggestedSubscriptions: Array<QontoPricingSubscriptionsFirstpartyV6_SubscriptionTargetItem>;
  /** Per-product data for the selected products. */
  targetSubscriptions: Array<QontoPricingSubscriptionsFirstpartyV6_SubscriptionTargetItem>;
  /** Non-blocking informational conditions (e.g. inapplicable voucher). */
  warnings: Array<QontoPricingSubscriptionsFirstpartyV6_Warning>;
};

/** Full itemised price breakdown for the immediate charge. */
export type QontoPricingSubscriptionsFirstpartyV6_PriceBreakdown = {
  __typename?: 'QontoPricingSubscriptionsFirstpartyV6_PriceBreakdown';
  /** Grouped line item blocks (plan, addons, cards, users, discounts, VAT). */
  blocks: Array<QontoPricingSubscriptionsFirstpartyV6_PriceBreakdownBlock>;
  /** Net total row. */
  total: QontoPricingSubscriptionsFirstpartyV6_PriceBreakdownTotal;
};

/** A grouped section within the price breakdown. */
export type QontoPricingSubscriptionsFirstpartyV6_PriceBreakdownBlock = {
  __typename?: 'QontoPricingSubscriptionsFirstpartyV6_PriceBreakdownBlock';
  /** Line items within this block. */
  items: Array<QontoPricingSubscriptionsFirstpartyV6_PriceBreakdownItem>;
  /** Section label: "Plan" | "Add-on" | "Cards" | "Users" | null (for discount/VAT/total rows). */
  section?: Maybe<Scalars['String']['output']>;
};

/** A single line item within a price breakdown block. */
export type QontoPricingSubscriptionsFirstpartyV6_PriceBreakdownItem = {
  __typename?: 'QontoPricingSubscriptionsFirstpartyV6_PriceBreakdownItem';
  /** Monetary amount for this line item. */
  amount: QontoCommon_CurrencyAmount;
  /** true for credits and discounts (negative lines). */
  isNegative: Scalars['Boolean']['output'];
  /** Optional subtitle (e.g. "(x2)" for multiple users). */
  subTitle?: Maybe<Scalars['String']['output']>;
  /** Display title, always set by qonto-biller. */
  title: Scalars['String']['output'];
};

/** Total row of the price breakdown. */
export type QontoPricingSubscriptionsFirstpartyV6_PriceBreakdownTotal = {
  __typename?: 'QontoPricingSubscriptionsFirstpartyV6_PriceBreakdownTotal';
  /** Net total amount. */
  amount: QontoCommon_CurrencyAmount;
  /** true when the net total is a refund (negative total). */
  isNegative: Scalars['Boolean']['output'];
  /** Display title (e.g. "Total due today"). */
  title: Scalars['String']['output'];
};

/**
 * A NEW trial or promotional offer that would START upon plan change confirmation.
 * price = base_price minus ONLY this offer's discount (independent of other concurrent offers).
 */
export type QontoPricingSubscriptionsFirstpartyV6_SpecialOffer = {
  __typename?: 'QontoPricingSubscriptionsFirstpartyV6_SpecialOffer';
  /** Inclusive end date of the offer in YYYY-MM-DD format. */
  endDate: Scalars['String']['output'];
  /** Discounted price during this offer period. */
  price: QontoCommon_CurrencyAmount;
  /** Additional offer properties. Empty for trials; contains { promo_id: "..." } for promos. */
  properties: Scalars['Map']['output'];
  /** Offer type. */
  type: QontoPricingSubscriptionsFirstpartyV6_SpecialOffer_Type;
};

/** Special offer type. */
export enum QontoPricingSubscriptionsFirstpartyV6_SpecialOffer_Type {
  /** Default unspecified value. */
  TypeUnspecified = 'TYPE_UNSPECIFIED',
  /**
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   * Promotional offer.
   */
  Promo = 'promo',
  /**
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   * Trial offer.
   */
  Trial = 'trial'
}

/**
 * One entry per product being estimated or removed.
 * Mirrors the shape of the v5 public endpoint's selected_products convention.
 */
export type QontoPricingSubscriptionsFirstpartyV6_SubscriptionChangeEstimateProductInput = {
  /** true when the user explicitly selected this product. */
  mainSelection?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the product (price plan) being estimated. */
  productId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Billing recurrence for this product.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   * SubscriptionRecurrence proto enum uses lowercase values (monthly/annual) via buf:lint:ignore —
   * proto-graphql-gen generates lowercase GraphQL enum values directly, matching REST conventions.
   */
  recurrence?: InputMaybe<QontoPricingCommonV1_SubscriptionRecurrence>;
  /** true when estimating the effect of removing this product. */
  removal?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Per-product data returned by qonto-biller for a selected or suggested subscription.
 * brand_name and features are NOT in this proto — fetched by the gateway via the marketingContent DataLoader.
 * discounted_price and special_offers only reflect NEW offers starting upon confirmation.
 * Ongoing discounts appear only in priceBreakdown.
 */
export type QontoPricingSubscriptionsFirstpartyV6_SubscriptionTargetItem = {
  __typename?: 'QontoPricingSubscriptionsFirstpartyV6_SubscriptionTargetItem';
  /** Full price before any discounts. */
  basePrice: QontoCommon_CurrencyAmount;
  /**
   * true when this product is discontinued (no longer part of the catalog).
   * Used by the frontend to render the "Discontinued add-on" section in checkout.
   */
  discontinuedProduct: Scalars['Boolean']['output'];
  /**
   * Lowest effective price from new offers starting upon confirmation (e.g. €0 during trial).
   * Absent when no new offer applies.
   */
  discountedPrice?: Maybe<QontoCommon_CurrencyAmount>;
  /**
   * Change type(s) relative to the org's current subscriptions.
   * Possible values: "upgrade" | "downgrade" | "upsize" | "downsize" | "removal" | "addition".
   * May contain multiple values (e.g. ["upgrade", "downsize"] for a higher-tier plan at shorter recurrence).
   */
  flow: Array<Scalars['String']['output']>;
  /** Whether this product can be compared against the current plan. */
  isComparable: Scalars['Boolean']['output'];
  /** Whether this product is required (cannot be removed from the basket). */
  isRequired: Scalars['Boolean']['output'];
  marketingContent: QontoPricingCatalogFirstpartyV1_PlanChangeProductContent;
  /** Product code (e.g. "solo_basic_2024"). */
  productCode: Scalars['String']['output'];
  /** Product group code (e.g. "solo_basic"). */
  productGroupCode: Scalars['String']['output'];
  /** Product ID (price plan ID). */
  productId: Scalars['String']['output'];
  /** Product type. */
  productType: QontoPricingCommonV1_ProductType;
  /**
   * Billing recurrence for this product.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   * SubscriptionRecurrence proto enum uses lowercase values (monthly/annual) via buf:lint:ignore —
   * proto-graphql-gen generates lowercase GraphQL enum values directly, matching REST conventions.
   */
  recurrence: QontoPricingCommonV1_SubscriptionRecurrence;
  /** New offers only — see SpecialOffer comment above. */
  specialOffers: Array<QontoPricingSubscriptionsFirstpartyV6_SpecialOffer>;
};

/**
 * Non-blocking informational condition.
 * additional_data carries sub-type context (e.g. voucher_code_invalid: type "invalid"|"not_applicable").
 */
export type QontoPricingSubscriptionsFirstpartyV6_Warning = {
  __typename?: 'QontoPricingSubscriptionsFirstpartyV6_Warning';
  /** Additional structured context (e.g. voucher invalidity reason). */
  additionalData: Scalars['GoogleProtobuf_Struct']['output'];
  /** Machine-readable warning code. */
  code: Scalars['String']['output'];
  /** Human-readable detail (for debugging, not displayed to end users). */
  detail: Scalars['String']['output'];
};

/** Message for address information. */
export type QontoRegistrationApiCompanyFirstpartyV1_Address = {
  __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_Address';
  /** City of the address. */
  city?: Maybe<Scalars['String']['output']>;
  /** Country of the address. */
  country?: Maybe<Scalars['String']['output']>;
  /** First line of the address. */
  firstLine?: Maybe<Scalars['String']['output']>;
  /** Second line of the address. */
  secondLine?: Maybe<Scalars['String']['output']>;
  /** Third line of the address. */
  thirdLine?: Maybe<Scalars['String']['output']>;
  /** Type of the address. */
  type: QontoRegistrationApiCompanyFirstpartyV1_AddressType;
  /** Zip code of the address. */
  zipcode?: Maybe<Scalars['String']['output']>;
};

/** Enum for address type. */
export enum QontoRegistrationApiCompanyFirstpartyV1_AddressType {
  /** Default or undefined journal entry type. */
  AddressTypeUnspecified = 'ADDRESS_TYPE_UNSPECIFIED',
  /**
   * Supplier invoices journal entry.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Headquarter = 'headquarter',
  /**
   * Client invoices journal entry.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  OperatingOffice = 'operating_office',
  /**
   * Expense report journal entry.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Standard = 'standard'
}

/** Message for company information. */
export type QontoRegistrationApiCompanyFirstpartyV1_Company = {
  __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_Company';
  /** Activity description of the company. */
  activityDescription?: Maybe<Scalars['String']['output']>;
  /** List of addresses of the company. */
  addresses: Array<QontoRegistrationApiCompanyFirstpartyV1_Address>;
  /** Contact email of the company. */
  contactEmail: Scalars['String']['output'];
  /** Financial detail of the company. */
  financialDetail?: Maybe<QontoRegistrationApiCompanyFirstpartyV1_FinancialDetail>;
  /** Legal code of the company. */
  legalCode?: Maybe<Scalars['String']['output']>;
  /** Legal country of the company. */
  legalCountry: Scalars['String']['output'];
  /** Legal form of the company. */
  legalForm?: Maybe<Scalars['String']['output']>;
  /** Legal name of the company. */
  legalName: Scalars['String']['output'];
  /** Legal number of the company. */
  legalNumber?: Maybe<Scalars['String']['output']>;
  /** Legal registration date of the company. */
  legalRegistrationDate?: Maybe<Scalars['String']['output']>;
  /** Legal sector of the company. */
  legalSector?: Maybe<Scalars['String']['output']>;
  /** Legal TVA/VAT number of the company. */
  legalTvaNumber?: Maybe<Scalars['String']['output']>;
  /** Organization ID associated with this company. */
  organizationId?: Maybe<Scalars['String']['output']>;
  /** Tax residence of the company. */
  taxResidence?: Maybe<QontoRegistrationApiCompanyFirstpartyV1_TaxResidence>;
  /** Trade name of the company. */
  tradeName?: Maybe<Scalars['String']['output']>;
  /** Website URL of the company. */
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** Company attributes to update. */
export type QontoRegistrationApiCompanyFirstpartyV1_CompanyAttributesForUpdate = {
  __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_CompanyAttributesForUpdate';
  /** Contact email of the company. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Legal form of the company. */
  legalForm?: Maybe<Scalars['String']['output']>;
  /** Legal name of the company. */
  legalName?: Maybe<Scalars['String']['output']>;
};

/** Company attributes to update. */
export type QontoRegistrationApiCompanyFirstpartyV1_CompanyAttributesForUpdateInput = {
  /** Contact email of the company. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Legal form of the company. */
  legalForm?: InputMaybe<Scalars['String']['input']>;
  /** Legal name of the company. */
  legalName?: InputMaybe<Scalars['String']['input']>;
};

/** Message for financial detail information. */
export type QontoRegistrationApiCompanyFirstpartyV1_FinancialDetail = {
  __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_FinancialDetail';
  /** Annual turnover. */
  annualTurnover?: Maybe<Scalars['String']['output']>;
  /** Estimated annual turnover. */
  estimatedAnnualTurnover?: Maybe<Scalars['Int64']['output']>;
  /** Estimated yearly income. */
  estimatedYearlyIncome?: Maybe<Scalars['String']['output']>;
  /** Max single payment amount. */
  maxSinglePaymentAmount?: Maybe<Scalars['Int64']['output']>;
  /** Yearly transaction volume. */
  yearlyTransactionVolume?: Maybe<Scalars['String']['output']>;
};

/** Request for retrieving company information. */
export type QontoRegistrationApiCompanyFirstpartyV1_GetCompanyRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response for retrieving company information. */
export type QontoRegistrationApiCompanyFirstpartyV1_GetCompanyResponse = {
  __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_GetCompanyResponse';
  /** Company attributes. */
  company: QontoRegistrationApiCompanyFirstpartyV1_Company;
};

/** Request for listing companies by organization IDs. */
export type QontoRegistrationApiCompanyFirstpartyV1_ListAccountancyPracticeCompaniesRequestInput = {
  /** Comma-separated list of organization IDs. */
  ids?: InputMaybe<Scalars['String']['input']>;
};

/** Response containing a list of companies. */
export type QontoRegistrationApiCompanyFirstpartyV1_ListAccountancyPracticeCompaniesResponse = {
  __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_ListAccountancyPracticeCompaniesResponse';
  /** The list of companies. */
  companies: Array<QontoRegistrationApiCompanyFirstpartyV1_Company>;
};

/** Request for listing stakeholders by organization IDs. */
export type QontoRegistrationApiCompanyFirstpartyV1_ListAccountancyPracticeStakeholdersRequestInput = {
  /** Comma-separated list of organization IDs. */
  ids?: InputMaybe<Scalars['String']['input']>;
};

/** Response containing stakeholders grouped by organization. */
export type QontoRegistrationApiCompanyFirstpartyV1_ListAccountancyPracticeStakeholdersResponse = {
  __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_ListAccountancyPracticeStakeholdersResponse';
  /** Stakeholders grouped by organization. */
  organizations: Array<QontoRegistrationApiCompanyFirstpartyV1_OrganizationStakeholders>;
};

/** Stakeholders belonging to a single organization. */
export type QontoRegistrationApiCompanyFirstpartyV1_OrganizationStakeholders = {
  __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_OrganizationStakeholders';
  /** The organization ID. */
  organizationId: Scalars['String']['output'];
  /** Stakeholders belonging to the organization. */
  stakeholders: Array<QontoRegistrationApiCompanyFirstpartyV1_Stakeholder>;
};

/** Stakeholder details. */
export type QontoRegistrationApiCompanyFirstpartyV1_Stakeholder = {
  __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_Stakeholder';
  /** First name of the stakeholder. */
  firstName: Scalars['String']['output'];
  /** Last name of the stakeholder. */
  lastName: Scalars['String']['output'];
};

/** Message for tax residence information. */
export type QontoRegistrationApiCompanyFirstpartyV1_TaxResidence = {
  __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_TaxResidence';
  /** Country of the tax residence. */
  country?: Maybe<Scalars['String']['output']>;
  /** Tax identification number. */
  taxIdentificationNumber?: Maybe<Scalars['String']['output']>;
};

/** Request for updating company information. */
export type QontoRegistrationApiCompanyFirstpartyV1_UpdateCompanyRequestInput = {
  /** Company attributes to update. */
  company: QontoRegistrationApiCompanyFirstpartyV1_CompanyAttributesForUpdateInput;
};

/** Response for updating company information. */
export type QontoRegistrationApiCompanyFirstpartyV1_UpdateCompanyResponse = {
  __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_UpdateCompanyResponse';
  /** Company attributes to update. */
  company: QontoRegistrationApiCompanyFirstpartyV1_CompanyAttributesForUpdate;
};

/** Message for customer information. */
export type QontoRegistrationApiCustomerFirstpartyV1_Customer = {
  __typename?: 'QontoRegistrationApiCustomerFirstpartyV1_Customer';
  /** Timestamp when the contract was signed. */
  contractSignedAt?: Maybe<Scalars['TimestampProto']['output']>;
  /** Nature of operations. */
  natureOfOperations: Array<Scalars['String']['output']>;
};

/** Request for retrieving customer information. */
export type QontoRegistrationApiCustomerFirstpartyV1_GetCustomerRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response for retrieving customer information. */
export type QontoRegistrationApiCustomerFirstpartyV1_GetCustomerResponse = {
  __typename?: 'QontoRegistrationApiCustomerFirstpartyV1_GetCustomerResponse';
  /** Customer attributes. */
  customer: QontoRegistrationApiCustomerFirstpartyV1_Customer;
};

/** Request for listing organizations belonging to the authenticated user. */
export type QontoRegistrationApiOrganizationsFirstpartyV1_ListOrganizationsRequestInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response containing the list of organizations. */
export type QontoRegistrationApiOrganizationsFirstpartyV1_ListOrganizationsResponse = {
  __typename?: 'QontoRegistrationApiOrganizationsFirstpartyV1_ListOrganizationsResponse';
  /** List of organizations the authenticated user belongs to, ordered by name. */
  organizations: Array<QontoRegistrationApiOrganizationsFirstpartyV1_Organization>;
};

/**
 * Enum for the membership role within an organization.
 * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
 * buf:lint:ignore ENUM_VALUE_PREFIX
 */
export enum QontoRegistrationApiOrganizationsFirstpartyV1_MembershipRole {
  /** Unspecified membership role. */
  MembershipRoleUnspecified = 'MEMBERSHIP_ROLE_UNSPECIFIED',
  /** Admin role. */
  Admin = 'admin',
  /** Employee role. */
  Employee = 'employee',
  /** Manager role. */
  Manager = 'manager',
  /** Owner role. */
  Owner = 'owner',
  /** Reporting role. */
  Reporting = 'reporting'
}

/** Organization summary returned in the list response. */
export type QontoRegistrationApiOrganizationsFirstpartyV1_Organization = {
  __typename?: 'QontoRegistrationApiOrganizationsFirstpartyV1_Organization';
  /** Unique identifier for the organization (UUID format). */
  id: Scalars['String']['output'];
  /** ISO country code of the organization's legal country (e.g. "FR", "DE"). */
  legalCountry?: Maybe<Scalars['String']['output']>;
  /** Organization legal name. */
  legalName?: Maybe<Scalars['String']['output']>;
  /** Organization legal registration number (e.g. SIRET for French companies). */
  legalNumber?: Maybe<Scalars['String']['output']>;
  /** Role of the authenticated user's membership in this organization. */
  membershipRole?: Maybe<QontoRegistrationApiOrganizationsFirstpartyV1_MembershipRole>;
  /** Organization display name. */
  name: Scalars['String']['output'];
};

/** Request for getting organization information. */
export type QontoRegistrationApiOrganizationsFirstpartyV5_GetOrganizationRequest = {
  __typename?: 'QontoRegistrationApiOrganizationsFirstpartyV5_GetOrganizationRequest';
  /** The organization ID. */
  id: Scalars['String']['output'];
};

/** Request for getting organization information. */
export type QontoRegistrationApiOrganizationsFirstpartyV5_GetOrganizationRequestInput = {
  /** The organization ID. */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Response containing organization information. */
export type QontoRegistrationApiOrganizationsFirstpartyV5_GetOrganizationResponse = {
  __typename?: 'QontoRegistrationApiOrganizationsFirstpartyV5_GetOrganizationResponse';
  /** The organization details. */
  organization: QontoRegistrationApiOrganizationsFirstpartyV5_Organization;
};

/** Response containing organization information. */
export type QontoRegistrationApiOrganizationsFirstpartyV5_GetOrganizationResponseInput = {
  /** The organization details. */
  organization: QontoRegistrationApiOrganizationsFirstpartyV5_OrganizationInput;
};

/** Request for listing organizations by IDs for an accountancy practice. */
export type QontoRegistrationApiOrganizationsFirstpartyV5_ListAccountancyPracticeOrganizationsRequest = {
  __typename?: 'QontoRegistrationApiOrganizationsFirstpartyV5_ListAccountancyPracticeOrganizationsRequest';
  /** Comma-separated list of organization IDs. */
  ids: Scalars['String']['output'];
};

/** Request for listing organizations by IDs for an accountancy practice. */
export type QontoRegistrationApiOrganizationsFirstpartyV5_ListAccountancyPracticeOrganizationsRequestInput = {
  /** Comma-separated list of organization IDs. */
  ids?: InputMaybe<Scalars['String']['input']>;
};

/** Response containing a list of organizations for an accountancy practice. */
export type QontoRegistrationApiOrganizationsFirstpartyV5_ListAccountancyPracticeOrganizationsResponse = {
  __typename?: 'QontoRegistrationApiOrganizationsFirstpartyV5_ListAccountancyPracticeOrganizationsResponse';
  /** The list of organizations. */
  organizations: Array<QontoRegistrationApiOrganizationsFirstpartyV5_Organization>;
};

/** Response containing a list of organizations for an accountancy practice. */
export type QontoRegistrationApiOrganizationsFirstpartyV5_ListAccountancyPracticeOrganizationsResponseInput = {
  /** The list of organizations. */
  organizations?: InputMaybe<Array<QontoRegistrationApiOrganizationsFirstpartyV5_OrganizationInput>>;
};

/** Organization details. */
export type QontoRegistrationApiOrganizationsFirstpartyV5_Organization = {
  __typename?: 'QontoRegistrationApiOrganizationsFirstpartyV5_Organization';
  /**
   * Legal and registration data for this organization.
   * Batched via GET /v1/accountancy_practices/companies keyed on id.
   */
  company?: Maybe<QontoRegistrationApiCompanyFirstpartyV1_Company>;
  /** Timestamp when the organization was created. */
  createdAt: Scalars['TimestampProto']['output'];
  /** Organization ID. */
  id: Scalars['String']['output'];
  /** Organization name. */
  name: Scalars['String']['output'];
  /** Organization slug. */
  slug: Scalars['String']['output'];
  /**
   * Stakeholders (owners, directors, shareholders) for this organization.
   * Batched via GET /v1/accountancy_practices/stakeholders keyed on id.
   */
  stakeholders?: Maybe<QontoRegistrationApiCompanyFirstpartyV1_OrganizationStakeholders>;
  /** Organization status. */
  status: QontoRegistrationApiOrganizationsFirstpartyV5_OrganizationStatus;
  /** Timestamp when the contract was signed. */
  suspensionReason?: Maybe<QontoRegistrationApiOrganizationsFirstpartyV5_SuspensionReason>;
};

/** Organization details. */
export type QontoRegistrationApiOrganizationsFirstpartyV5_OrganizationInput = {
  /** Timestamp when the organization was created. */
  createdAt: Scalars['TimestampProto']['input'];
  /** Organization ID. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Organization name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Organization slug. */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Organization status. */
  status?: InputMaybe<QontoRegistrationApiOrganizationsFirstpartyV5_OrganizationStatus>;
  /** Timestamp when the contract was signed. */
  suspensionReason?: InputMaybe<QontoRegistrationApiOrganizationsFirstpartyV5_SuspensionReason>;
};

/** Enum for organization status. */
export enum QontoRegistrationApiOrganizationsFirstpartyV5_OrganizationStatus {
  /** Unspecified status. */
  OrganizationStatusUnspecified = 'ORGANIZATION_STATUS_UNSPECIFIED',
  /**
   * Organization is activated.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Activated = 'activated',
  /**
   * Organization is deactivated.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Deactivated = 'deactivated',
  /**
   * Organization is waiting for KYB.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  KybWaiting = 'kyb_waiting',
  /**
   * Organization is suspended.
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Suspended = 'suspended'
}

/** Enum for suspension reason. */
export enum QontoRegistrationApiOrganizationsFirstpartyV5_SuspensionReason {
  /** Unspecified suspension reason */
  SuspensionReasonUnspecified = 'SUSPENSION_REASON_UNSPECIFIED',
  /**
   * AFC asset freeze
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  AfcAssetFreeze = 'afc_asset_freeze',
  /**
   * AFC investigation
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  AfcInvestigation = 'afc_investigation',
  /**
   * AML investigation
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  AmlInvestigation = 'aml_investigation',
  /**
   * BaFin regulatory suspension
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Bafin = 'bafin',
  /**
   * Collective procedure
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  CollectiveProcedure = 'collective_procedure',
  /**
   * Criminal seizure
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  CriminalSeizure = 'criminal_seizure',
  /**
   * Deactivation postponement
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  DeactivationPostponement = 'deactivation_postponement',
  /**
   * Dormant account
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  DormantAccount = 'dormant_account',
  /**
   * Due diligence
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  DueDiligence = 'due_diligence',
  /**
   * Expired due diligence
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  ExpiredDueDiligence = 'expired_due_diligence',
  /**
   * Expired POI
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  ExpiredPoi = 'expired_poi',
  /**
   * Flex KYB grace period expired
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  FlexKybGracePeriodExpired = 'flex_kyb_grace_period_expired',
  /**
   * Fraud account protection
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  FraudAccountProtection = 'fraud_account_protection',
  /**
   * Fraud investigation
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  FraudInvestigation = 'fraud_investigation',
  /**
   * Inheritance
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Inheritance = 'inheritance',
  /**
   * Manual suspension
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  ManualSuspension = 'manual_suspension',
  /**
   * Re-KYC required
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  ReKyc = 're_kyc',
  /**
   * Seizure
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Seizure = 'seizure'
}

/** Represents a membership. */
export type QontoSpendManagementMembershipsMembershipsFirstpartyV1_Membership = {
  __typename?: 'QontoSpendManagementMembershipsMembershipsFirstpartyV1_Membership';
  avatar?: Maybe<UserAvatar>;
  /** Unique identifier of the membership. */
  id: Scalars['String']['output'];
  invitation?: Maybe<Invite>;
  kyc: MembershipKycStatus;
  /** Organization ID this membership belongs to */
  organizationId: Scalars['String']['output'];
  person?: Maybe<Person>;
  /** Role assigned to the membership */
  role: QontoSpendManagementMembershipsMembershipsFirstpartyV1_MembershipRole;
  /** Status of the membership */
  status: QontoSpendManagementMembershipsMembershipsFirstpartyV1_MembershipStatus;
  /** Team ID this membership belongs to (optional) */
  teamId?: Maybe<Scalars['String']['output']>;
  /** Name of the team (optional) */
  teamName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  /** Unique identifier of the user. */
  userId?: Maybe<Scalars['String']['output']>;
};

/** Represents a membership. */
export type QontoSpendManagementMembershipsMembershipsFirstpartyV1_MembershipInput = {
  /** Unique identifier of the membership. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID this membership belongs to */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Role assigned to the membership */
  role?: InputMaybe<QontoSpendManagementMembershipsMembershipsFirstpartyV1_MembershipRole>;
  /** Status of the membership */
  status?: InputMaybe<QontoSpendManagementMembershipsMembershipsFirstpartyV1_MembershipStatus>;
  /** Team ID this membership belongs to (optional) */
  teamId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the team (optional) */
  teamName?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the user. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Represents all possible membership roles */
export enum QontoSpendManagementMembershipsMembershipsFirstpartyV1_MembershipRole {
  /** The role has not been specified */
  MembershipRoleUnspecified = 'MEMBERSHIP_ROLE_UNSPECIFIED',
  /**
   * Accountant role
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Accountant = 'accountant',
  /**
   * Administrator
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Admin = 'admin',
  /**
   * Employee role
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Employee = 'employee',
  /**
   * Manager role
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Manager = 'manager',
  /**
   * Organization owner
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Owner = 'owner'
}

/** Represents all possible membership statuses */
export enum QontoSpendManagementMembershipsMembershipsFirstpartyV1_MembershipStatus {
  /** The status has not been specified */
  MembershipStatusUnspecified = 'MEMBERSHIP_STATUS_UNSPECIFIED',
  /**
   * Membership is active
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Active = 'active',
  /**
   * Membership is in invited state
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Invited = 'invited',
  /**
   * Membership is revoked
   * buf:lint:ignore ENUM_VALUE_UPPER_SNAKE_CASE
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Revoked = 'revoked'
}

/** Type of client for the mandate. */
export enum QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_ClientKind {
  /** Company client. */
  ClientKindCompany = 'CLIENT_KIND_COMPANY',
  /** Freelancer client. */
  ClientKindFreelancer = 'CLIENT_KIND_FREELANCER',
  /** Individual client. */
  ClientKindIndividual = 'CLIENT_KIND_INDIVIDUAL',
  /** Unspecified client kind. */
  ClientKindUnspecified = 'CLIENT_KIND_UNSPECIFIED'
}

/** Client information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_ClientSnapshot = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_ClientSnapshot';
  /** Client street address. */
  address: Scalars['String']['output'];
  /** Client city. */
  city: Scalars['String']['output'];
  /** Client country code (ISO 3166-1 alpha-2). */
  countryCode: Scalars['String']['output'];
  /** Client email address. */
  email: Scalars['String']['output'];
  /** Client first name (for individuals). */
  firstName: Scalars['String']['output'];
  /** Client unique identifier. */
  id: Scalars['String']['output'];
  /** Client type (individual, company, freelancer). */
  kind: QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_ClientKind;
  /** Client last name (for individuals). */
  lastName: Scalars['String']['output'];
  /** Client preferred locale (e.g., "en", "fr"). */
  locale: Scalars['String']['output'];
  /** Client display name (company name or full name). */
  name: Scalars['String']['output'];
  /** Client province/state code (required for Italy). */
  provinceCode: Scalars['String']['output'];
  /** Client postal/zip code. */
  zipCode: Scalars['String']['output'];
};

/** Client information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_ClientSnapshotInput = {
  /** Client street address. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Client city. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Client country code (ISO 3166-1 alpha-2). */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Client email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Client first name (for individuals). */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Client unique identifier. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Client type (individual, company, freelancer). */
  kind?: InputMaybe<QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_ClientKind>;
  /** Client last name (for individuals). */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Client preferred locale (e.g., "en", "fr"). */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Client display name (company name or full name). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Client province/state code (required for Italy). */
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  /** Client postal/zip code. */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Status of an SDD mandate. */
export enum QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_MandateStatus {
  /**
   * Mandate is active and can be used for collections.
   * Either approved, imported or pending amendment mandates.
   */
  MandateStatusApproved = 'MANDATE_STATUS_APPROVED',
  /** Mandate has been canceled. */
  MandateStatusCanceled = 'MANDATE_STATUS_CANCELED',
  /** Deprecated: Kept for backwards compatibility while clients migrate. */
  MandateStatusDeclined = 'MANDATE_STATUS_DECLINED',
  /** Mandate has been suspended. */
  MandateStatusExpired = 'MANDATE_STATUS_EXPIRED',
  /** Mandate is pending signature. */
  MandateStatusPendingSignature = 'MANDATE_STATUS_PENDING_SIGNATURE',
  /** Unspecified mandate status. */
  MandateStatusUnspecified = 'MANDATE_STATUS_UNSPECIFIED'
}

/** Organization information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_OrganizationSnapshot = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_OrganizationSnapshot';
  /** Address line 1. */
  addressLine_1: Scalars['String']['output'];
  /** Address line 2. */
  addressLine_2: Scalars['String']['output'];
  /** Address line 3. */
  addressLine_3: Scalars['String']['output'];
  /** Organization city. */
  city: Scalars['String']['output'];
  /** Organization country. */
  country: Scalars['String']['output'];
  /** Organization identifier (UUID). */
  id: Scalars['String']['output'];
  /** Organization logo URL. */
  logoUrl: Scalars['String']['output'];
  /** Organization name. */
  name: Scalars['String']['output'];
  /** Organization ZIP code. */
  zipCode: Scalars['String']['output'];
};

/** Organization information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_OrganizationSnapshotInput = {
  /** Address line 1. */
  addressLine_1?: InputMaybe<Scalars['String']['input']>;
  /** Address line 2. */
  addressLine_2?: InputMaybe<Scalars['String']['input']>;
  /** Address line 3. */
  addressLine_3?: InputMaybe<Scalars['String']['input']>;
  /** Organization city. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Organization country. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Organization identifier (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Organization logo URL. */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Organization name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Organization ZIP code. */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Request for batch fetching mandates by their IDs.
 * Used by GraphQL gateway dataloaders for efficient mandate resolution.
 */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesRequest = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesRequest';
  /** Mandate IDs to fetch. Maximum 100 IDs per request. */
  ids: Array<Scalars['String']['output']>;
};

/**
 * Request for batch fetching mandates by their IDs.
 * Used by GraphQL gateway dataloaders for efficient mandate resolution.
 */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesRequestInput = {
  /** Mandate IDs to fetch. Maximum 100 IDs per request. */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Response containing the requested mandates.
 * Only mandates that exist and are accessible are returned.
 * The GraphQL gateway dataloader handles missing results.
 */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse';
  /** List of found mandates. */
  mandates: Array<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_Mandate>;
};

/**
 * Response containing the requested mandates.
 * Only mandates that exist and are accessible are returned.
 * The GraphQL gateway dataloader handles missing results.
 */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponseInput = {
  /** List of found mandates. */
  mandates?: InputMaybe<Array<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_MandateInput>>;
};

/** Client information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_ClientSnapshot = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_ClientSnapshot';
  /** Client street address. */
  address: Scalars['String']['output'];
  /** Client city. */
  city: Scalars['String']['output'];
  /** Client country code (ISO 3166-1 alpha-2). */
  countryCode: Scalars['String']['output'];
  /** Client email address. */
  email: Scalars['String']['output'];
  /** Client first name (for individuals). */
  firstName: Scalars['String']['output'];
  /** Client unique identifier. */
  id: Scalars['String']['output'];
  /** Client type (individual, company, freelancer). */
  kind: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ClientKind;
  /** Client last name (for individuals). */
  lastName: Scalars['String']['output'];
  /** Client preferred locale (e.g., "en", "fr"). */
  locale: Scalars['String']['output'];
  /** Client display name (company name or full name). */
  name: Scalars['String']['output'];
  /** Client province/state code (required for Italy). */
  provinceCode: Scalars['String']['output'];
  /** Client postal/zip code. */
  zipCode: Scalars['String']['output'];
};

/** Client information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_ClientSnapshotInput = {
  /** Client street address. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Client city. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Client country code (ISO 3166-1 alpha-2). */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Client email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Client first name (for individuals). */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Client unique identifier. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Client type (individual, company, freelancer). */
  kind?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ClientKind>;
  /** Client last name (for individuals). */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Client preferred locale (e.g., "en", "fr"). */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Client display name (company name or full name). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Client province/state code (required for Italy). */
  provinceCode?: InputMaybe<Scalars['String']['input']>;
  /** Client postal/zip code. */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** First payment details. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_FirstPayment = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_FirstPayment';
  /** Payment amount. */
  amount: QontoCommon_CurrencyAmount;
  /** Collection date. Format: YYYY-MM-DD. */
  collectionDate: Scalars['String']['output'];
  /** Whether the first payment date has passed. */
  isOverdue?: Maybe<Scalars['Boolean']['output']>;
  /** Payment reference/description. */
  reference: Scalars['String']['output'];
};

/** First payment details. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_FirstPaymentInput = {
  /** Payment amount. */
  amount: QontoCommon_CurrencyAmountInput;
  /** Collection date. Format: YYYY-MM-DD. */
  collectionDate?: InputMaybe<Scalars['String']['input']>;
  /** Whether the first payment date has passed. */
  isOverdue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Payment reference/description. */
  reference?: InputMaybe<Scalars['String']['input']>;
};

/** Full mandate snapshot optimized for GraphQL gateway consumption. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_Mandate = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_Mandate';
  /** Client's Bank Identifier Code. */
  clientBic: Scalars['String']['output'];
  /** Full client IBAN. */
  clientIban: Scalars['String']['output'];
  /** Last 4 digits of client IBAN (masked). */
  clientIbanLastDigits: Scalars['String']['output'];
  /** Client ID associated with this mandate. */
  clientId: Scalars['String']['output'];
  /** Snapshot of client data at mandate creation. */
  clientSnapshot: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_ClientSnapshot;
  /** Creditor Scheme Identifier (CSI). */
  creditorIdentifier: Scalars['String']['output'];
  /** Unique mandate identifier (UUID). */
  id: Scalars['String']['output'];
  /** Payment link URL for mandate signing. */
  link: Scalars['String']['output'];
  /** Date when mandate was signed. Format: YYYY-MM-DD. */
  mandateSignatureDate: Scalars['String']['output'];
  /** Organization ID that owns this mandate. */
  organizationId: Scalars['String']['output'];
  /** Snapshot of organization data at mandate creation. */
  organizationSnapshot: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_OrganizationSnapshot;
  /** Payment configuration if mandate has scheduled payments. */
  paymentInfo?: Maybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_PaymentInfo>;
  /** Recurrence type (recurring or one-off). */
  recurrenceType: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateRecurrenceType;
  /** Current mandate status. */
  status: QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_MandateStatus;
  /** SEPA scheme type (CORE or B2B). */
  type: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateType;
  /** Unique Mandate Reference (UMR) for SEPA. */
  uniqueMandateReference: Scalars['String']['output'];
};

/** Full mandate snapshot optimized for GraphQL gateway consumption. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_MandateInput = {
  /** Client's Bank Identifier Code. */
  clientBic?: InputMaybe<Scalars['String']['input']>;
  /** Full client IBAN. */
  clientIban?: InputMaybe<Scalars['String']['input']>;
  /** Last 4 digits of client IBAN (masked). */
  clientIbanLastDigits?: InputMaybe<Scalars['String']['input']>;
  /** Client ID associated with this mandate. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Snapshot of client data at mandate creation. */
  clientSnapshot: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_ClientSnapshotInput;
  /** Creditor Scheme Identifier (CSI). */
  creditorIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Unique mandate identifier (UUID). */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Payment link URL for mandate signing. */
  link?: InputMaybe<Scalars['String']['input']>;
  /** Date when mandate was signed. Format: YYYY-MM-DD. */
  mandateSignatureDate?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID that owns this mandate. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Snapshot of organization data at mandate creation. */
  organizationSnapshot: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_OrganizationSnapshotInput;
  /** Payment configuration if mandate has scheduled payments. */
  paymentInfo?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_PaymentInfoInput>;
  /** Recurrence type (recurring or one-off). */
  recurrenceType?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateRecurrenceType>;
  /** Current mandate status. */
  status?: InputMaybe<QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_MandateStatus>;
  /** SEPA scheme type (CORE or B2B). */
  type?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateType>;
  /** Unique Mandate Reference (UMR) for SEPA. */
  uniqueMandateReference?: InputMaybe<Scalars['String']['input']>;
};

/** Organization information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_OrganizationSnapshot = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_OrganizationSnapshot';
  /** Address line 1. */
  addressLine_1: Scalars['String']['output'];
  /** Address line 2. */
  addressLine_2: Scalars['String']['output'];
  /** Address line 3. */
  addressLine_3: Scalars['String']['output'];
  /** City. */
  city: Scalars['String']['output'];
  /** Country name. */
  country: Scalars['String']['output'];
  /** Organization unique identifier. */
  id: Scalars['String']['output'];
  /** Organization logo URL (empty if using default). */
  logoUrl: Scalars['String']['output'];
  /** Organization legal name. */
  name: Scalars['String']['output'];
  /** Postal/zip code. */
  zipCode: Scalars['String']['output'];
};

/** Organization information snapshot. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_OrganizationSnapshotInput = {
  /** Address line 1. */
  addressLine_1?: InputMaybe<Scalars['String']['input']>;
  /** Address line 2. */
  addressLine_2?: InputMaybe<Scalars['String']['input']>;
  /** Address line 3. */
  addressLine_3?: InputMaybe<Scalars['String']['input']>;
  /** City. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Country name. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Organization unique identifier. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Organization logo URL (empty if using default). */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Organization legal name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Postal/zip code. */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Payment schedule configuration. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_PaymentInfo = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_PaymentInfo';
  /** First payment details. */
  firstPayment: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_FirstPayment;
  /** Custom schedule interval (for custom schedules). */
  interval: Scalars['Int']['output'];
  /** Whether to notify client before collections. */
  notifyClient: Scalars['Boolean']['output'];
  /** Custom schedule unit (for custom schedules). */
  scheduleCustomUnit: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleUnit;
  /** Total number of collections (0 = unlimited). */
  scheduleTotalCollectionCount: Scalars['Int']['output'];
  /** Schedule type (one_off, weekly, monthly, etc.). */
  scheduleType: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleType;
};

/** Payment schedule configuration. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_PaymentInfoInput = {
  /** First payment details. */
  firstPayment: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_FirstPaymentInput;
  /** Custom schedule interval (for custom schedules). */
  interval?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to notify client before collections. */
  notifyClient?: InputMaybe<Scalars['Boolean']['input']>;
  /** Custom schedule unit (for custom schedules). */
  scheduleCustomUnit?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleUnit>;
  /** Total number of collections (0 = unlimited). */
  scheduleTotalCollectionCount?: InputMaybe<Scalars['Int']['input']>;
  /** Schedule type (one_off, weekly, monthly, etc.). */
  scheduleType?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleType>;
};

/** Type of client for the mandate. */
export enum QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ClientKind {
  /** Company client. */
  ClientKindCompany = 'CLIENT_KIND_COMPANY',
  /** Freelancer client. */
  ClientKindFreelancer = 'CLIENT_KIND_FREELANCER',
  /** Individual client. */
  ClientKindIndividual = 'CLIENT_KIND_INDIVIDUAL',
  /** Unspecified client kind. */
  ClientKindUnspecified = 'CLIENT_KIND_UNSPECIFIED'
}

/** Custom application error codes for the CreatePublicMandate endpoint. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateErrors = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateErrors';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/** Custom application error codes for the CreatePublicMandate endpoint. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateErrorsInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Custom error codes for HTTP 422 Unprocessable Entity. */
export enum QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateErrors_BadRequestError {
  /** The request has an invalid format, source and detail fields contain more information. */
  BadRequestErrorCodeFormatError = 'BAD_REQUEST_ERROR_CODE_FORMAT_ERROR',
  /** Missing required field. */
  BadRequestErrorCodeMissingRequiredField = 'BAD_REQUEST_ERROR_CODE_MISSING_REQUIRED_FIELD',
  /** Unspecified validation error. */
  BadRequestErrorCodeUnspecified = 'BAD_REQUEST_ERROR_CODE_UNSPECIFIED'
}

/** Request for creating a mandate via public invitation link. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateRequest = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateRequest';
  /** Client's street address. */
  address: Scalars['String']['output'];
  /** Client's city. */
  city: Scalars['String']['output'];
  /** Client's first name. */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Client's country code (ISO 3166-1 alpha-2 e.g., "fr", "en"). */
  countryCode: Scalars['String']['output'];
  /** Client's email address. */
  email: Scalars['String']['output'];
  /** Client's first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Client's IBAN for the mandate. */
  iban: Scalars['String']['output'];
  /**
   * Unique identifier for the invitation link from URL path.
   *
   * @gotags: validate:"uuid"
   */
  invitationLinkId: Scalars['String']['output'];
  /** Type of client. */
  kind: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ClientKind;
  /** Client's last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Client's city. */
  province?: Maybe<Scalars['String']['output']>;
  /** Client's postal/zip code. */
  zipCode: Scalars['String']['output'];
};

/** Request for creating a mandate via public invitation link. */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateRequestInput = {
  /** Client's street address. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Client's city. */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Client's first name. */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Client's country code (ISO 3166-1 alpha-2 e.g., "fr", "en"). */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Client's email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Client's first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Client's IBAN for the mandate. */
  iban?: InputMaybe<Scalars['String']['input']>;
  /**
   * Unique identifier for the invitation link from URL path.
   *
   * @gotags: validate:"uuid"
   */
  invitationLinkId?: InputMaybe<Scalars['String']['input']>;
  /** Type of client. */
  kind?: InputMaybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ClientKind>;
  /** Client's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Client's city. */
  province?: InputMaybe<Scalars['String']['input']>;
  /** Client's postal/zip code. */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Response for successful mandate creation.
 * Empty response for successful creation (200 OK).
 */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateResponse = {
  __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateResponse';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Response for successful mandate creation.
 * Empty response for successful creation (200 OK).
 */
export type QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_CreatePublicMandateResponseInput = {
  _empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Mandate recurrence type. */
export enum QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateRecurrenceType {
  /** One-off mandate (non-recurring collection) */
  MandateRecurrenceTypeOneOff = 'MANDATE_RECURRENCE_TYPE_ONE_OFF',
  /** Recurring mandate (multiple collections allowed). */
  MandateRecurrenceTypeRecurring = 'MANDATE_RECURRENCE_TYPE_RECURRING',
  /** Unspecified recurrence type. */
  MandateRecurrenceTypeUnspecified = 'MANDATE_RECURRENCE_TYPE_UNSPECIFIED'
}

/** Mandate type (SEPA scheme). */
export enum QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateType {
  /** SEPA B2B Direct Debit scheme. */
  MandateTypeB2B = 'MANDATE_TYPE_B2B',
  /** SEPA Core Direct Debit scheme. */
  MandateTypeCore = 'MANDATE_TYPE_CORE',
  /** Unspecified mandate type. */
  MandateTypeUnspecified = 'MANDATE_TYPE_UNSPECIFIED'
}

/** Schedule type. */
export enum QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleType {
  /** Custom interval collections. */
  ScheduleTypeCustom = 'SCHEDULE_TYPE_CUSTOM',
  /** Monthly collections. */
  ScheduleTypeMonthly = 'SCHEDULE_TYPE_MONTHLY',
  /** Single collection only. */
  ScheduleTypeOneOff = 'SCHEDULE_TYPE_ONE_OFF',
  /** Quarterly collections. */
  ScheduleTypeQuarterly = 'SCHEDULE_TYPE_QUARTERLY',
  /** Unspecified schedule type. */
  ScheduleTypeUnspecified = 'SCHEDULE_TYPE_UNSPECIFIED',
  /** Weekly collections. */
  ScheduleTypeWeekly = 'SCHEDULE_TYPE_WEEKLY',
  /** Yearly collections. */
  ScheduleTypeYearly = 'SCHEDULE_TYPE_YEARLY'
}

/** Schedule unit for custom schedules. */
export enum QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleUnit {
  /** Monthly interval. */
  ScheduleUnitMonths = 'SCHEDULE_UNIT_MONTHS',
  /** Unspecified schedule unit. */
  ScheduleUnitUnspecified = 'SCHEDULE_UNIT_UNSPECIFIED',
  /** Weekly interval. */
  ScheduleUnitWeeks = 'SCHEDULE_UNIT_WEEKS',
  /** Yearly interval. */
  ScheduleUnitYears = 'SCHEDULE_UNIT_YEARS'
}

/** Request for creating a B2B mandate. */
export type QontoTransfersSddMandatesFirstpartyV2_CreateMandateRequestInput = {
  /** Attributes of the mandate to create. */
  mandate: QontoTransfersSddMandatesFirstpartyV2_CreateMandateRequest_MandateInput;
};

/** Attributes accepted when creating a mandate. */
export type QontoTransfersSddMandatesFirstpartyV2_CreateMandateRequest_MandateInput = {
  /** Identifiers of the attachments associated with the mandate. */
  attachmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Identifier of the bank account the mandate is attached to. */
  bankAccountId?: InputMaybe<Scalars['String']['input']>;
  /** Identifier of the creditor (ICS) the mandate is created for. */
  creditorIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Name of the creditor the mandate is created for. */
  creditorName?: InputMaybe<Scalars['String']['input']>;
  /** Counterparty information for the mandate. */
  mandatesCounterparty: QontoTransfersSddMandatesFirstpartyV2_CreateMandateRequest_Mandate_MandatesCounterpartyInput;
  /** Identifier of the organization the mandate belongs to. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the mandate authorises recurrent direct debits. */
  recurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique Mandate Reference (UMR). */
  umr?: InputMaybe<Scalars['String']['input']>;
};

/** Counterparty information attached to a mandate. */
export type QontoTransfersSddMandatesFirstpartyV2_CreateMandateRequest_Mandate_MandatesCounterpartyInput = {
  /** Activity tag (cash-flow category) of the counterparty. */
  activityTag?: InputMaybe<Scalars['String']['input']>;
};

/** Request for fetching a single mandate by its identifier. */
export type QontoTransfersSddMandatesFirstpartyV2_GetMandateRequestInput = {
  /** Identifier of the mandate to fetch. */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Response containing a single mandate. */
export type QontoTransfersSddMandatesFirstpartyV2_GetMandateResponse = {
  __typename?: 'QontoTransfersSddMandatesFirstpartyV2_GetMandateResponse';
  /** The requested mandate. */
  mandate: QontoTransfersSddMandatesFirstpartyV2_MandateDetails;
};

/** Request for listing SDD mandates with pagination. */
export type QontoTransfersSddMandatesFirstpartyV2_ListMandatesByIDsRequestInput = {
  /** IDs of mandates to fetch */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Response containing the list of mandates and metadata. */
export type QontoTransfersSddMandatesFirstpartyV2_ListMandatesByIDsResponse = {
  __typename?: 'QontoTransfersSddMandatesFirstpartyV2_ListMandatesByIDsResponse';
  /** List of mandates. */
  mandates: Array<QontoTransfersSddMandatesFirstpartyV2_Mandate>;
};

/** Request for listing the mandates of an organization. */
export type QontoTransfersSddMandatesFirstpartyV2_ListMandatesRequestInput = {
  /** Filters narrowing down the returned mandates. */
  filters?: InputMaybe<QontoTransfersSddMandatesFirstpartyV2_ListMandatesRequest_FiltersInput>;
  /** Identifier of the organization whose mandates are listed. */
  organizationId?: InputMaybe<Scalars['String']['input']>;
  /** Page number to retrieve (starts at 1). */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Number of results per page. */
  perPage?: InputMaybe<Scalars['Int']['input']>;
  /** Free-text search over creditor_name, umr, id and creditor_identifier. */
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Filters that can be applied when listing mandates. */
export type QontoTransfersSddMandatesFirstpartyV2_ListMandatesRequest_FiltersInput = {
  /** Restrict the results to these bank account identifiers. */
  bankAccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether to include draft mandates in the results. */
  showDrafts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response containing a page of mandates. */
export type QontoTransfersSddMandatesFirstpartyV2_ListMandatesResponse = {
  __typename?: 'QontoTransfersSddMandatesFirstpartyV2_ListMandatesResponse';
  /** The mandates for the requested page. */
  mandates: Array<QontoTransfersSddMandatesFirstpartyV2_MandateDetails>;
  /** Pagination metadata for the result set. */
  meta: QontoTransfersSddMandatesFirstpartyV2_PaginationMeta;
};

/** A single SDD mandate */
export type QontoTransfersSddMandatesFirstpartyV2_Mandate = {
  __typename?: 'QontoTransfersSddMandatesFirstpartyV2_Mandate';
  /** Attachment IDs linked to the mandate */
  attachmentIds: Array<Scalars['String']['output']>;
  /** Creditor identifier */
  creditorIdentifier: Scalars['String']['output'];
  /** Debtor IBAN */
  iban: Scalars['String']['output'];
  /** Unique identifier of the mandate */
  id: Scalars['String']['output'];
  /** Mandate type (string representation) */
  mandateType: Scalars['String']['output'];
  /** Whether the mandate is recurrent */
  recurrent: Scalars['Boolean']['output'];
  /** Current status of the mandate (string representation) */
  status: Scalars['String']['output'];
  /** Unique Mandate Reference (UMR) */
  umr?: Maybe<Scalars['String']['output']>;
};

/**
 * MandateDetails is the rich representation of a SEPA Direct Debit mandate
 * returned by the v2 REST endpoints (list, get, create, update, suspend,
 * unsuspend, update activity). It is distinct from the leaner `Mandate`
 * message used by the protobuf-native ListMandatesByIDs endpoint.
 */
export type QontoTransfersSddMandatesFirstpartyV2_MandateDetails = {
  __typename?: 'QontoTransfersSddMandatesFirstpartyV2_MandateDetails';
  /** Identifiers of the attachments associated with the mandate. */
  attachmentIds: Array<Scalars['String']['output']>;
  /** Identifier of the bank account the mandate is attached to. */
  bankAccountId: Scalars['String']['output'];
  /** Identifier of the creditor (ICS). */
  creditorIdentifier: Scalars['String']['output'];
  /** Name of the creditor. */
  creditorName: Scalars['String']['output'];
  /** Average amount of the direct debits collected under this mandate. */
  directDebitsAverageAmount: QontoCommon_CurrencyAmount;
  /** Total amount of the direct debits collected under this mandate. */
  directDebitsTotalAmount: QontoCommon_CurrencyAmount;
  /** Merchant enrichment metadata (branding, logos). */
  enrichmentData?: Maybe<QontoTransfersSddMandatesFirstpartyV2_MandateDetails_EnrichmentData>;
  /** Unique identifier of the mandate. */
  id: Scalars['String']['output'];
  /** Date of the most recent direct debit (ISO 8601 date). */
  lastDirectDebitDate: Scalars['String']['output'];
  /** Type of the mandate. Possible values: core, b2b. */
  mandateType: Scalars['String']['output'];
  /** Counterparty information for the mandate. */
  mandatesCounterparty: QontoTransfersSddMandatesFirstpartyV2_MandateDetails_MandatesCounterparty;
  /** Whether the mandate authorises recurrent direct debits. */
  recurrent: Scalars['Boolean']['output'];
  /**
   * Actions the user must take on the mandate. Only populated by ListMandates.
   * Possible values: authorize_mandate.
   */
  requiredActions: Array<Scalars['String']['output']>;
  /** Status of the mandate. Possible values: active, suspended. */
  status: Scalars['String']['output'];
  /** Number of successful direct debits collected under this mandate. */
  successfulDirectDebitsCount: Scalars['Int']['output'];
  /** Unique Mandate Reference (UMR). */
  umr: Scalars['String']['output'];
  /** Upcoming direct debit scheduled under this mandate, if any. */
  upcomingDirectDebit: QontoTransfersSddMandatesFirstpartyV2_MandateDetails_UpcomingDirectDebit;
};

/** Merchant enrichment metadata attached to a mandate. */
export type QontoTransfersSddMandatesFirstpartyV2_MandateDetails_EnrichmentData = {
  __typename?: 'QontoTransfersSddMandatesFirstpartyV2_MandateDetails_EnrichmentData';
  /** Merchant logo, when available. */
  logo?: Maybe<QontoTransfersSddMandatesFirstpartyV2_MandateDetails_EnrichmentData_EnrichmentLogo>;
};

/** Logo images for the merchant. */
export type QontoTransfersSddMandatesFirstpartyV2_MandateDetails_EnrichmentData_EnrichmentLogo = {
  __typename?: 'QontoTransfersSddMandatesFirstpartyV2_MandateDetails_EnrichmentData_EnrichmentLogo';
  /** URL of the medium-resolution logo. */
  medium: Scalars['String']['output'];
  /** URL of the small-resolution logo. */
  small: Scalars['String']['output'];
};

/** Counterparty information attached to a mandate. */
export type QontoTransfersSddMandatesFirstpartyV2_MandateDetails_MandatesCounterparty = {
  __typename?: 'QontoTransfersSddMandatesFirstpartyV2_MandateDetails_MandatesCounterparty';
  /** Activity tag (cash-flow category) of the counterparty. */
  activityTag: Scalars['String']['output'];
};

/** Details of an upcoming direct debit scheduled under a mandate. */
export type QontoTransfersSddMandatesFirstpartyV2_MandateDetails_UpcomingDirectDebit = {
  __typename?: 'QontoTransfersSddMandatesFirstpartyV2_MandateDetails_UpcomingDirectDebit';
  /** Amount of the upcoming direct debit. */
  amount: QontoCommon_CurrencyAmount;
  /** Scheduled debit date of the upcoming direct debit (ISO 8601 date). */
  debitDate: Scalars['String']['output'];
};

/**
 * PaginationMeta carries the pagination metadata returned by list endpoints.
 * Defined locally (rather than reusing qonto.common.PaginationMeta) so the
 * JSON keys stay snake_case to match the REST API.
 */
export type QontoTransfersSddMandatesFirstpartyV2_PaginationMeta = {
  __typename?: 'QontoTransfersSddMandatesFirstpartyV2_PaginationMeta';
  /** Current page number. */
  currentPage: Scalars['Int']['output'];
  /** Next page number, if any. */
  nextPage?: Maybe<Scalars['Int']['output']>;
  /** Number of records returned per page. */
  perPage: Scalars['Int']['output'];
  /** Previous page number, if any. */
  prevPage?: Maybe<Scalars['Int']['output']>;
  /** Total number of records. */
  totalCount: Scalars['Int']['output'];
  /** Total number of pages. */
  totalPages: Scalars['Int']['output'];
};

/** Request for suspending the future direct debits of a mandate (core & b2b). */
export type QontoTransfersSddMandatesFirstpartyV2_SuspendMandateRequestInput = {
  /** Identifier of the mandate to suspend. */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Request for unsuspending a previously suspended mandate. */
export type QontoTransfersSddMandatesFirstpartyV2_UnsuspendMandateRequestInput = {
  /** Identifier of the mandate to unsuspend. */
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Request for updating the activity tag of a mandate. */
export type QontoTransfersSddMandatesFirstpartyV2_UpdateMandateActivityRequestInput = {
  /** Identifier of the mandate whose activity tag is updated. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Activity tag attributes to apply to the mandate. */
  mandate: QontoTransfersSddMandatesFirstpartyV2_UpdateMandateActivityRequest_MandateInput;
};

/** Attributes accepted when updating the activity tag of a mandate. */
export type QontoTransfersSddMandatesFirstpartyV2_UpdateMandateActivityRequest_MandateInput = {
  /** Activity tag (cash-flow category) to set on the mandate. */
  activityTag?: InputMaybe<Scalars['String']['input']>;
};

/** Request for updating a B2B mandate. */
export type QontoTransfersSddMandatesFirstpartyV2_UpdateMandateRequestInput = {
  /** Identifier of the mandate to update. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Attributes of the mandate to update. */
  mandate: QontoTransfersSddMandatesFirstpartyV2_UpdateMandateRequest_MandateInput;
};

/** Attributes accepted when updating a mandate. */
export type QontoTransfersSddMandatesFirstpartyV2_UpdateMandateRequest_MandateInput = {
  /** Identifier of the creditor (ICS). */
  creditorIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Name of the creditor. */
  creditorName?: InputMaybe<Scalars['String']['input']>;
  /** Whether the mandate authorises recurrent direct debits. */
  recurrent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique Mandate Reference (UMR). */
  umr?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  einvoicingCompany?: Maybe<QontoEinvoicingEinvoicingCompaniesFirstpartyV3_GetCompanyResponse>;
  getAccountingSetups?: Maybe<QontoAccountingAccountingSetupsFirstpartyV2_ListAccountingSetupsResponse>;
  getAccounts?: Maybe<QontoAccountingAccountsFirstpartyV2_ListAccountsResponse>;
  getEsimDataPackages: QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesResponse;
  getJournals: QontoAccountingJournalsFirstpartyV2_ListJournalsResponse;
  getLedgerEntries?: Maybe<QontoAccountingEntriesFirstpartyV2_GetEntriesResponse>;
  getMyBankDetails: MyBankDetailsResult;
  getSingleMembership?: Maybe<Membership>;
  getSingleReceivableInvoice?: Maybe<ReceivableInvoice>;
  getSupplier: QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_GetSupplierResponse;
  listAccountancyPracticeAccountingSetups?: Maybe<QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeAccountingSetupsResponse>;
  listAccountancyPracticeConversations?: Maybe<QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeConversationsResponse>;
  listAccountancyPracticeObligations?: Maybe<QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeObligationsResponse>;
  listAccountancyPracticeTasks?: Maybe<QontoAccountingHubTaskEngineFirstpartyV3_ListAccountancyPracticeTasksResponse>;
  listAttachments: QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsResponse;
  listObligationOperations?: Maybe<QontoAccountingObligationsFirstpartyV2_ListOperationsResponse>;
  searchCards: SearchCardsResult;
  searchChildTransactionLinksV2: QontoAppSystemsTransactionsFirstpartyV8_GetChildTransactionLinksResponse;
  searchMemberships: SearchMembershipsResult;
  searchOrganization: SearchOrganizationResult;
  searchSingleExpenseReport: SearchSingleExpenseReportResult;
  searchSingleRequestExpenseReport: SearchSingleRequestExpenseReportResult;
  searchSingleSupplierInvoice: SearchSingleSupplierInvoiceResult;
  searchSingleSupplierSubscription: SearchSingleSupplierSubscriptionResult;
  searchSupplierInvoices: SearchSupplierInvoicesResult;
  searchSupplierSubscriptions: SearchSupplierSubscriptionsResult;
  searchSuppliers: QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SearchSuppliersResponse;
  searchThreads: Array<Thread>;
  searchTransactions: SearchTransactionsResult;
  searchTransactionsV2: QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsResponse;
  subscriptionChangeEstimate: QontoPricingSubscriptionsFirstpartyV6_EstimateSubscriptionChangeResponse;
};


export type QueryEinvoicingCompanyArgs = {
  input?: InputMaybe<EinvoicingCompanySearch>;
};


export type QueryGetAccountingSetupsArgs = {
  input?: InputMaybe<QontoAccountingAccountingSetupsFirstpartyV2_ListAccountingSetupsRequestInput>;
};


export type QueryGetAccountsArgs = {
  input?: InputMaybe<QontoAccountingAccountsFirstpartyV2_ListAccountsRequestInput>;
};


export type QueryGetEsimDataPackagesArgs = {
  input?: InputMaybe<QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesRequestInput>;
};


export type QueryGetJournalsArgs = {
  input?: InputMaybe<QontoAccountingJournalsFirstpartyV2_ListJournalsRequestInput>;
};


export type QueryGetLedgerEntriesArgs = {
  input?: InputMaybe<QontoAccountingEntriesFirstpartyV2_GetEntriesRequestInput>;
};


export type QueryGetMyBankDetailsArgs = {
  input?: InputMaybe<MyBankDetailsSearch>;
};


export type QueryGetSingleMembershipArgs = {
  input?: InputMaybe<SingleMembershipsSearch>;
};


export type QueryGetSingleReceivableInvoiceArgs = {
  input?: InputMaybe<SingleReceivableInvoicesSearch>;
};


export type QueryGetSupplierArgs = {
  input?: InputMaybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_GetSupplierRequestInput>;
};


export type QueryListAccountancyPracticeAccountingSetupsArgs = {
  input?: InputMaybe<QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeAccountingSetupsRequestInput>;
};


export type QueryListAccountancyPracticeConversationsArgs = {
  input?: InputMaybe<QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeConversationsRequestInput>;
};


export type QueryListAccountancyPracticeObligationsArgs = {
  input?: InputMaybe<QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeObligationsRequestInput>;
};


export type QueryListAccountancyPracticeTasksArgs = {
  input?: InputMaybe<QontoAccountingHubTaskEngineFirstpartyV3_ListAccountancyPracticeTasksRequestInput>;
};


export type QueryListAttachmentsArgs = {
  input?: InputMaybe<QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsRequestInput>;
};


export type QueryListObligationOperationsArgs = {
  input?: InputMaybe<QontoAccountingObligationsFirstpartyV2_ListOperationsRequestInput>;
};


export type QuerySearchCardsArgs = {
  input?: InputMaybe<CardsSearch>;
};


export type QuerySearchChildTransactionLinksV2Args = {
  input?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_GetChildTransactionLinksRequestInput>;
};


export type QuerySearchMembershipsArgs = {
  input?: InputMaybe<MembershipsSearch>;
};


export type QuerySearchOrganizationArgs = {
  input?: InputMaybe<OrganizationsSearch>;
};


export type QuerySearchSingleExpenseReportArgs = {
  input?: InputMaybe<SingleExpenseReportsSearch>;
};


export type QuerySearchSingleRequestExpenseReportArgs = {
  input?: InputMaybe<SingleRequestExpenseReportsSearch>;
};


export type QuerySearchSingleSupplierInvoiceArgs = {
  input?: InputMaybe<SingleSupplierInvoicesSearch>;
};


export type QuerySearchSingleSupplierSubscriptionArgs = {
  input?: InputMaybe<SingleSupplierSubscriptionsSearch>;
};


export type QuerySearchSupplierInvoicesArgs = {
  input?: InputMaybe<SupplierInvoicesSearch>;
};


export type QuerySearchSupplierSubscriptionsArgs = {
  input?: InputMaybe<SupplierSubscriptionsSearch>;
};


export type QuerySearchSuppliersArgs = {
  input?: InputMaybe<QontoAccountsPayableSupplierInvoicesSuppliersFirstpartyV2_SearchSuppliersRequestInput>;
};


export type QuerySearchThreadsArgs = {
  input?: InputMaybe<ThreadsSearch>;
};


export type QuerySearchTransactionsArgs = {
  input?: InputMaybe<TransactionsSearch>;
};


export type QuerySearchTransactionsV2Args = {
  input?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsRequestInput>;
};


export type QuerySubscriptionChangeEstimateArgs = {
  input?: InputMaybe<QontoPricingSubscriptionsFirstpartyV6_EstimateSubscriptionChangeRequestInput>;
};

export type ReceivableInvoice = {
  __typename?: 'ReceivableInvoice';
  accountingRecordedAt?: Maybe<Scalars['String']['output']>;
  amountDue?: Maybe<Amount>;
  amountPaid?: Maybe<Amount>;
  attachmentId: Scalars['String']['output'];
  balanceInvoiceIds?: Maybe<Array<Scalars['String']['output']>>;
  bankAccountId?: Maybe<Scalars['String']['output']>;
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerSnapshot?: Maybe<ReceivableInvoiceCustomerSnapshot>;
  debtCollection?: Maybe<ReceivableInvoiceDebtCollection>;
  depositAmount?: Maybe<Amount>;
  depositInvoiceId?: Maybe<Scalars['String']['output']>;
  directDebitCollectionMandate?: Maybe<QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_Mandate>;
  directDebitCollectionMandateId?: Maybe<Scalars['String']['output']>;
  directDebitEnabled: Scalars['Boolean']['output'];
  directDebitSubscriptionId?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<ReceivableInvoiceDiscount>;
  dueDate?: Maybe<Scalars['String']['output']>;
  einvoicingLifecycleEvents?: Maybe<Array<ReceivableInvoiceEinvoicingLifecycleEvent>>;
  einvoicingStatus?: Maybe<ReceivableInvoiceEinvoicingStatus>;
  fileName?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  hasDuplicates: Scalars['Boolean']['output'];
  header?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importAnalyzedAt?: Maybe<Scalars['String']['output']>;
  imported: Scalars['Boolean']['output'];
  intermediaryBankBic?: Maybe<Scalars['String']['output']>;
  invoiceNumber: Scalars['String']['output'];
  invoiceSubscription?: Maybe<ReceivableInvoiceSubscription>;
  invoiceSubscriptionId?: Maybe<Scalars['String']['output']>;
  invoiceType?: Maybe<ReceivableInvoiceType>;
  isDeposit: Scalars['Boolean']['output'];
  isEinvoice: Scalars['Boolean']['output'];
  isHiddenFromClientPortal: Scalars['Boolean']['output'];
  isPdfGenerated: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['String']['output']>;
  lastPartialInvoiceId?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  nextReminderDate?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationSnapshot?: Maybe<ReceivableInvoiceOrganizationSnapshot>;
  overdue: Scalars['Boolean']['output'];
  paidAt?: Maybe<Scalars['String']['output']>;
  partialInvoiceIds?: Maybe<Array<Scalars['String']['output']>>;
  payment?: Maybe<ReceivableInvoicePayment>;
  paymentLink?: Maybe<ReceivableInvoicePaymentLink>;
  paymentLinkDetails?: Maybe<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink>;
  performanceDate?: Maybe<Scalars['String']['output']>;
  performanceEndDate?: Maybe<Scalars['String']['output']>;
  performanceStartDate?: Maybe<Scalars['String']['output']>;
  previousPartialInvoiceId?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<ReceivableInvoiceProgress>;
  purchaseOrder?: Maybe<Scalars['String']['output']>;
  quoteId?: Maybe<Scalars['String']['output']>;
  receivableCreditNoteIds?: Maybe<Array<Scalars['String']['output']>>;
  receivableInvoicingUploadId?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  referralLink?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<ReceivableInvoiceSection>>;
  stampDutyAmount?: Maybe<Amount>;
  status: ReceivableInvoiceStatus;
  subtotal?: Maybe<Amount>;
  subtotalBeforeDiscount?: Maybe<Amount>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  termsConditionsUploadId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  vatAmount?: Maybe<Amount>;
  welfareFund?: Maybe<ReceivableInvoiceWelfareFund>;
  withholdingTax?: Maybe<ReceivableInvoiceWithholdingTax>;
};

export type ReceivableInvoiceBillingAddress = {
  __typename?: 'ReceivableInvoiceBillingAddress';
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export enum ReceivableInvoiceCustomerKind {
  Company = 'COMPANY',
  Freelancer = 'FREELANCER',
  Individual = 'INDIVIDUAL'
}

export type ReceivableInvoiceCustomerSnapshot = {
  __typename?: 'ReceivableInvoiceCustomerSnapshot';
  address?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<ReceivableInvoiceBillingAddress>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<ReceivableInvoiceCustomerKind>;
  lastName?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tinNumber?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceDebtCollection = {
  __typename?: 'ReceivableInvoiceDebtCollection';
  actionNeeded: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type ReceivableInvoiceDiscount = {
  __typename?: 'ReceivableInvoiceDiscount';
  amount?: Maybe<Amount>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceEinvoicingLifecycleEvent = {
  __typename?: 'ReceivableInvoiceEinvoicingLifecycleEvent';
  /** @deprecated Use timestamp instead */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use reasonMessage instead */
  message?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  reasonCode?: Maybe<Scalars['String']['output']>;
  reasonMessage?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use statusCode instead */
  status?: Maybe<Scalars['String']['output']>;
  statusCode: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
  /** @deprecated Use reason instead */
  type?: Maybe<Scalars['String']['output']>;
};

export enum ReceivableInvoiceEinvoicingStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  NotDelivered = 'NOT_DELIVERED',
  Pending = 'PENDING',
  SubmissionFailed = 'SUBMISSION_FAILED',
  Submitted = 'SUBMITTED'
}

export type ReceivableInvoiceOrganizationSnapshot = {
  __typename?: 'ReceivableInvoiceOrganizationSnapshot';
  addressCity?: Maybe<Scalars['String']['output']>;
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressZipcode?: Maybe<Scalars['String']['output']>;
  commercialRegisterNumber?: Maybe<Scalars['String']['output']>;
  companyLeadership?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  districtCourt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legalCapitalShare?: Maybe<Amount>;
  legalCountry?: Maybe<Scalars['String']['output']>;
  legalForm?: Maybe<Scalars['String']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  legalNumber?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vatPaymentCondition?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoicePayment = {
  __typename?: 'ReceivableInvoicePayment';
  conditions?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoicePaymentLink = {
  __typename?: 'ReceivableInvoicePaymentLink';
  methods?: Maybe<Array<Scalars['String']['output']>>;
};

export type ReceivableInvoiceProgress = {
  __typename?: 'ReceivableInvoiceProgress';
  cumulativeAmount?: Maybe<Amount>;
  cumulativePercentage?: Maybe<Scalars['String']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  remainingSubtotalBeforeDiscount?: Maybe<Amount>;
  remainingSubtotalBeforeDiscountPercentage?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSection = {
  __typename?: 'ReceivableInvoiceSection';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<ReceivableInvoiceSectionItem>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSectionItem = {
  __typename?: 'ReceivableInvoiceSectionItem';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<ReceivableInvoiceDiscount>;
  id: Scalars['ID']['output'];
  links?: Maybe<Array<ReceivableInvoiceSectionItemLink>>;
  productId?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<ReceivableInvoiceSectionItemProgress>;
  quantity?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Amount>;
  title?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Amount>;
  totalVat?: Maybe<Amount>;
  unit?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Amount>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  vatExemptionCode?: Maybe<Scalars['String']['output']>;
  vatRate?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSectionItemLink = {
  __typename?: 'ReceivableInvoiceSectionItemLink';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSectionItemProgress = {
  __typename?: 'ReceivableInvoiceSectionItemProgress';
  amount?: Maybe<Amount>;
  cumulativeAmount?: Maybe<Amount>;
  cumulativePercentage?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['String']['output']>;
  remainingAmount?: Maybe<Amount>;
  remainingPercentage?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum ReceivableInvoiceStatus {
  Canceled = 'CANCELED',
  Draft = 'DRAFT',
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export type ReceivableInvoiceSubscription = {
  __typename?: 'ReceivableInvoiceSubscription';
  amountDue?: Maybe<Amount>;
  bankAccountId?: Maybe<Scalars['String']['output']>;
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  directDebitCollectionMandateId?: Maybe<Scalars['String']['output']>;
  directDebitEnabled?: Maybe<Scalars['Boolean']['output']>;
  discount?: Maybe<ReceivableInvoiceSubscriptionDiscount>;
  emailTemplate?: Maybe<ReceivableInvoiceSubscriptionEmailTemplate>;
  endDate?: Maybe<Scalars['String']['output']>;
  footer?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<ReceivableInvoiceSubscriptionFrequency>;
  header?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceStatus?: Maybe<ReceivableInvoiceSubscriptionInvoiceStatus>;
  isEinvoice?: Maybe<Scalars['Boolean']['output']>;
  nextInvoiceDate?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<ReceivableInvoiceSubscriptionPayment>;
  paymentLink?: Maybe<ReceivableInvoiceSubscriptionPaymentLink>;
  paymentTermsDays?: Maybe<Scalars['Int']['output']>;
  purchaseOrder?: Maybe<Scalars['String']['output']>;
  receivableInvoiceId?: Maybe<Scalars['String']['output']>;
  receivableInvoicingUploadId?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<ReceivableInvoiceSubscriptionSection>>;
  stampDutyAmount?: Maybe<Amount>;
  startDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ReceivableInvoiceSubscriptionStatus>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  welfareFund?: Maybe<ReceivableInvoiceSubscriptionWelfareFund>;
  withholdingTax?: Maybe<ReceivableInvoiceSubscriptionWithholdingTax>;
};

export type ReceivableInvoiceSubscriptionDiscount = {
  __typename?: 'ReceivableInvoiceSubscriptionDiscount';
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSubscriptionEmailTemplate = {
  __typename?: 'ReceivableInvoiceSubscriptionEmailTemplate';
  copyToSelf?: Maybe<Scalars['Boolean']['output']>;
  emailBody?: Maybe<Scalars['String']['output']>;
  emailTitle?: Maybe<Scalars['String']['output']>;
  sendTo?: Maybe<Array<Scalars['String']['output']>>;
};

export type ReceivableInvoiceSubscriptionFrequency = {
  __typename?: 'ReceivableInvoiceSubscriptionFrequency';
  recurrence?: Maybe<ReceivableInvoiceSubscriptionRecurrence>;
  value?: Maybe<Scalars['Int']['output']>;
};

export enum ReceivableInvoiceSubscriptionInvoiceStatus {
  Draft = 'DRAFT',
  Unpaid = 'UNPAID'
}

export type ReceivableInvoiceSubscriptionPayment = {
  __typename?: 'ReceivableInvoiceSubscriptionPayment';
  conditions?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSubscriptionPaymentLink = {
  __typename?: 'ReceivableInvoiceSubscriptionPaymentLink';
  methods?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ReceivableInvoiceSubscriptionRecurrence {
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type ReceivableInvoiceSubscriptionSection = {
  __typename?: 'ReceivableInvoiceSubscriptionSection';
  id: Scalars['ID']['output'];
  items?: Maybe<Array<ReceivableInvoiceSubscriptionSectionItem>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSubscriptionSectionItem = {
  __typename?: 'ReceivableInvoiceSubscriptionSectionItem';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<ReceivableInvoiceSubscriptionDiscount>;
  id: Scalars['ID']['output'];
  links?: Maybe<Array<ReceivableInvoiceSubscriptionSectionItemLink>>;
  productId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<Amount>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  vatExemptionCode?: Maybe<Scalars['String']['output']>;
  vatRate?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSubscriptionSectionItemLink = {
  __typename?: 'ReceivableInvoiceSubscriptionSectionItemLink';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum ReceivableInvoiceSubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Finished = 'FINISHED',
  Scheduled = 'SCHEDULED',
  Suspended = 'SUSPENDED'
}

export type ReceivableInvoiceSubscriptionWelfareFund = {
  __typename?: 'ReceivableInvoiceSubscriptionWelfareFund';
  rate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceSubscriptionWithholdingTax = {
  __typename?: 'ReceivableInvoiceSubscriptionWithholdingTax';
  rate?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum ReceivableInvoiceType {
  Balance = 'BALANCE',
  Deposit = 'DEPOSIT',
  Partial = 'PARTIAL',
  Standard = 'STANDARD'
}

export type ReceivableInvoiceWelfareFund = {
  __typename?: 'ReceivableInvoiceWelfareFund';
  rate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ReceivableInvoiceWithholdingTax = {
  __typename?: 'ReceivableInvoiceWithholdingTax';
  rate?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RelatedFees = {
  __typename?: 'RelatedFees';
  /** Sums provided for all fees and their fee payments */
  feePaymentSums: FeePaymentSums;
  /** Individual fee details. Fees with expectedAmountIsZero=true are excluded. */
  fees: Array<Fee>;
  /** The movement ID given by the domain event that triggered creation of the fee. */
  parentMovementID: Scalars['String']['output'];
};

export type RelatedInvoice = {
  __typename?: 'RelatedInvoice';
  attachmentId: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Amount>;
};

export type RequestExpenseReport = {
  __typename?: 'RequestExpenseReport';
  amount: Amount;
  approvalWorkflowStateId?: Maybe<Scalars['String']['output']>;
  approverId?: Maybe<Scalars['String']['output']>;
  attachmentIds: Array<Scalars['String']['output']>;
  attachments: Array<Attachment>;
  bankless?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['String']['output'];
  declinedNote?: Maybe<Scalars['String']['output']>;
  expenseReport: ExpenseReport;
  expenseReportId: Scalars['String']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initiatorId: Scalars['String']['output'];
  lastStep: Scalars['Boolean']['output'];
  membership: Membership;
  note: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  processedAt?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
  requestType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  vatAmount?: Maybe<Amount>;
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export type RibaPayment = {
  __typename?: 'RibaPayment';
  id: Scalars['ID']['output'];
  movementId: Scalars['ID']['output'];
  reference: Scalars['String']['output'];
  ribaNumber: Scalars['String']['output'];
};

export type SearchCardsMeta = {
  __typename?: 'SearchCardsMeta';
  currentPage: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchCardsResult = {
  __typename?: 'SearchCardsResult';
  cards: Array<Card>;
  meta: SearchCardsMeta;
};

export type SearchMembershipsMeta = {
  __typename?: 'SearchMembershipsMeta';
  currentPage: Scalars['Int']['output'];
  cursor?: Maybe<Scalars['String']['output']>;
  nextPage?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchMembershipsResult = {
  __typename?: 'SearchMembershipsResult';
  memberships: Array<Membership>;
  meta: SearchMembershipsMeta;
};

export type SearchOrganizationResult = {
  __typename?: 'SearchOrganizationResult';
  organization: Organization;
};

export type SearchSingleExpenseReportResult = {
  __typename?: 'SearchSingleExpenseReportResult';
  expenseReport: ExpenseReport;
};

export type SearchSingleRequestExpenseReportResult = {
  __typename?: 'SearchSingleRequestExpenseReportResult';
  requestExpenseReport: RequestExpenseReport;
};

export type SearchSingleSupplierInvoiceResult = {
  __typename?: 'SearchSingleSupplierInvoiceResult';
  supplierInvoice: SupplierInvoice;
};

export type SearchSingleSupplierSubscriptionResult = {
  __typename?: 'SearchSingleSupplierSubscriptionResult';
  subscription: SupplierSubscription;
};

export type SearchSupplierInvoicesMeta = {
  __typename?: 'SearchSupplierInvoicesMeta';
  currentPage: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchSupplierInvoicesResult = {
  __typename?: 'SearchSupplierInvoicesResult';
  meta: SearchSupplierInvoicesMeta;
  supplierInvoices: Array<SupplierInvoice>;
};

export type SearchSupplierSubscriptionsMeta = {
  __typename?: 'SearchSupplierSubscriptionsMeta';
  currentPage: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchSupplierSubscriptionsResult = {
  __typename?: 'SearchSupplierSubscriptionsResult';
  meta: SearchSupplierSubscriptionsMeta;
  subscriptions: Array<SupplierSubscription>;
};

export type SearchTransactionsMeta = {
  __typename?: 'SearchTransactionsMeta';
  currentPage: Scalars['Int']['output'];
  cursor?: Maybe<Scalars['String']['output']>;
  nextPage?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
  prevPage?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type SearchTransactionsResult = {
  __typename?: 'SearchTransactionsResult';
  meta: SearchTransactionsMeta;
  transactions: Array<Transaction>;
};

export enum Side {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type SingleExpenseReportsSearch = {
  id: Scalars['String']['input'];
};

export type SingleMembershipsSearch = {
  id: Scalars['String']['input'];
};

export type SingleReceivableInvoicesSearch = {
  id: Scalars['String']['input'];
};

export type SingleRequestExpenseReportsSearch = {
  id: Scalars['String']['input'];
};

export type SingleSupplierInvoicesSearch = {
  id: Scalars['String']['input'];
};

export type SingleSupplierSubscriptionsSearch = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export enum SolutionInstanceStatus {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Enabled = 'ENABLED',
  Failed = 'FAILED',
  MarkedForDeletion = 'MARKED_FOR_DELETION',
  MarkedForEnablement = 'MARKED_FOR_ENABLEMENT',
  /** Supported invoice collector is not in-house integration or has not been installed yet - we don't know its status */
  NotAvailable = 'NOT_AVAILABLE',
  Pending = 'PENDING'
}

export type Sort = {
  direction?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
};

export enum Status {
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Reversed = 'REVERSED'
}

export type StatusHistory = {
  __typename?: 'StatusHistory';
  createdAt: Scalars['String']['output'];
  status: StatusHistoryStatus;
};

export enum StatusHistoryStatus {
  Authorized = 'AUTHORIZED',
  Settled = 'SETTLED'
}

export enum SubjectType {
  AccountRemuneration = 'ACCOUNT_REMUNERATION',
  BillingTransfer = 'BILLING_TRANSFER',
  Card = 'CARD',
  CardAcquirerPayout = 'CARD_ACQUIRER_PAYOUT',
  Cashback = 'CASHBACK',
  Check = 'CHECK',
  DirectDebit = 'DIRECT_DEBIT',
  DirectDebitCollection = 'DIRECT_DEBIT_COLLECTION',
  DirectDebitHold = 'DIRECT_DEBIT_HOLD',
  EsimSubscriptionAddonPurchase = 'ESIM_SUBSCRIPTION_ADDON_PURCHASE',
  F24Payment = 'F24_PAYMENT',
  FinancingIncome = 'FINANCING_INCOME',
  FinancingInstallment = 'FINANCING_INSTALLMENT',
  Income = 'INCOME',
  NrcPayment = 'NRC_PAYMENT',
  PagopaPayment = 'PAGOPA_PAYMENT',
  SwiftIncome = 'SWIFT_INCOME',
  Transfer = 'TRANSFER',
  WalletToWallet = 'WALLET_TO_WALLET'
}

export enum SubscriptionPaymentMethod {
  PaymentMethodCard = 'PAYMENT_METHOD_CARD',
  PaymentMethodDirectDebit = 'PAYMENT_METHOD_DIRECT_DEBIT',
  PaymentMethodUnspecified = 'PAYMENT_METHOD_UNSPECIFIED'
}

export type SuggestedCategory = {
  __typename?: 'SuggestedCategory';
  id?: Maybe<Scalars['ID']['output']>;
  transactionID: Scalars['String']['output'];
};

export type SupplierInvoice = {
  __typename?: 'SupplierInvoice';
  analyzedAt?: Maybe<Scalars['String']['output']>;
  approvalWorkflow?: Maybe<SupplierInvoiceApprovalWorkflow>;
  attachmentCategory: SupplierInvoiceAttachmentCategory;
  attachmentId: Scalars['String']['output'];
  availableActions?: Maybe<AvailableActions>;
  createdAt: Scalars['String']['output'];
  declinedNote?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discrepancies?: Maybe<Array<Discrepancy>>;
  displayAttachment?: Maybe<Attachment>;
  displayAttachmentId?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  einvoiceFormat?: Maybe<Scalars['String']['output']>;
  einvoicingLifecycleEvents?: Maybe<Array<EinvoicingLifecycleEvent>>;
  fileName: Scalars['String']['output'];
  hasDiscrepancies?: Maybe<Scalars['Boolean']['output']>;
  hasDuplicates: Scalars['Boolean']['output'];
  hasSuggestedCreditNotes: Scalars['Boolean']['output'];
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initiatorId?: Maybe<Scalars['String']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isAttachmentInvoice: Scalars['Boolean']['output'];
  isAttachmentNonFinancial?: Maybe<Scalars['Boolean']['output']>;
  isCreditNote: Scalars['Boolean']['output'];
  isEinvoice: Scalars['Boolean']['output'];
  issueDate?: Maybe<Scalars['String']['output']>;
  issuerName?: Maybe<Scalars['String']['output']>;
  markedAsRead?: Maybe<Scalars['Boolean']['output']>;
  matchedTransactions?: Maybe<Array<MatchedTransaction>>;
  meta?: Maybe<SupplierInvoiceMeta>;
  organizationId: Scalars['String']['output'];
  payableAmount?: Maybe<Amount>;
  paymentDate?: Maybe<Scalars['String']['output']>;
  paymentMeans?: Maybe<Array<SupplierInvoicePaymentMean>>;
  relatedInvoices?: Maybe<Array<RelatedInvoice>>;
  requestTransfer?: Maybe<SupplierInvoiceRequestTransfer>;
  /** @deprecated Use requestTransfer.id instead */
  requestTransferId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use requestTransfer.initiatorId instead */
  requestTransferInitiatorId?: Maybe<Scalars['String']['output']>;
  scheduledDate?: Maybe<Scalars['String']['output']>;
  selfInvoiceId?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  sourceType?: Maybe<Scalars['String']['output']>;
  status: SupplierInvoiceStatus;
  suggestedTransactionIds?: Maybe<Array<Scalars['String']['output']>>;
  suggestedTransactions?: Maybe<Array<Transaction>>;
  supplierId?: Maybe<Scalars['String']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
  supplierSnapshot?: Maybe<SupplierSnapshot>;
  taxes?: Maybe<Array<InvoiceTax>>;
  thread?: Maybe<Thread>;
  tinNumber?: Maybe<Scalars['String']['output']>;
  totalAmount?: Maybe<Amount>;
  totalAmountCreditNotes?: Maybe<Amount>;
  totalAmountExcludingTaxes?: Maybe<Amount>;
  totalTaxAmount?: Maybe<Amount>;
  transferIds?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['String']['output'];
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type SupplierInvoiceApprovalWorkflow = {
  __typename?: 'SupplierInvoiceApprovalWorkflow';
  approverIds: Array<Scalars['ID']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastApprovedBy?: Maybe<Scalars['String']['output']>;
  supplierInvoiceId: Scalars['ID']['output'];
  supplierInvoiceRequestId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  verifiedBy?: Maybe<Scalars['String']['output']>;
};

export enum SupplierInvoiceAttachmentCategory {
  CardReceipt = 'CARD_RECEIPT',
  CreditCardReceipt = 'CREDIT_CARD_RECEIPT',
  CreditNote = 'CREDIT_NOTE',
  ExpenseReceipt = 'EXPENSE_RECEIPT',
  Invoice = 'INVOICE',
  OtherFinancialDocument = 'OTHER_FINANCIAL_DOCUMENT',
  OtherNonFinancialDocument = 'OTHER_NON_FINANCIAL_DOCUMENT',
  Unknown = 'UNKNOWN'
}

export enum SupplierInvoiceDocumentTypeFilter {
  Duplicates = 'DUPLICATES',
  NonFinancialDocuments = 'NON_FINANCIAL_DOCUMENTS'
}

export enum SupplierInvoiceDueDateFilter {
  Future = 'FUTURE',
  MissingDate = 'MISSING_DATE',
  PastAndToday = 'PAST_AND_TODAY'
}

export enum SupplierInvoiceFriendlyDateFilter {
  PastMonth = 'PAST_MONTH',
  PastWeek = 'PAST_WEEK',
  ThisMonth = 'THIS_MONTH',
  ThisWeek = 'THIS_WEEK',
  Today = 'TODAY',
  Yesterday = 'YESTERDAY'
}

export type SupplierInvoiceMeta = {
  __typename?: 'SupplierInvoiceMeta';
  accountingRecordedAt?: Maybe<Scalars['String']['output']>;
  accountingRecordedSource?: Maybe<Scalars['String']['output']>;
  autoScheduledAt?: Maybe<Scalars['String']['output']>;
  connector?: Maybe<Scalars['String']['output']>;
  emailedBy?: Maybe<Scalars['String']['output']>;
  emailedTo?: Maybe<Scalars['String']['output']>;
  integrationName?: Maybe<Scalars['String']['output']>;
  integrationType?: Maybe<Scalars['String']['output']>;
  matchedSupplierId?: Maybe<Scalars['String']['output']>;
  performanceStartDate?: Maybe<Scalars['String']['output']>;
  qrCodeExtracted?: Maybe<QrCodeExtracted>;
  resolvedBy?: Maybe<Membership>;
  resolvedById?: Maybe<Scalars['String']['output']>;
};

export type SupplierInvoicePaymentMean = {
  __typename?: 'SupplierInvoicePaymentMean';
  autoSettled: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  payeeName?: Maybe<Scalars['String']['output']>;
  type: SupplierInvoicePaymentMeanType;
};

export enum SupplierInvoicePaymentMeanType {
  Card = 'CARD',
  DirectDebit = 'DIRECT_DEBIT',
  OnlinePayment = 'ONLINE_PAYMENT',
  Other = 'OTHER',
  Transfer = 'TRANSFER',
  Unknown = 'UNKNOWN'
}

export enum SupplierInvoiceQueryField {
  Amount = 'AMOUNT',
  FileName = 'FILE_NAME',
  InvoiceNumber = 'INVOICE_NUMBER',
  SupplierName = 'SUPPLIER_NAME'
}

export type SupplierInvoiceRequestTransfer = {
  __typename?: 'SupplierInvoiceRequestTransfer';
  id: Scalars['String']['output'];
  initiatorId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum SupplierInvoiceStatus {
  Archived = 'ARCHIVED',
  AwaitingPayment = 'AWAITING_PAYMENT',
  Discarded = 'DISCARDED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Scheduled = 'SCHEDULED',
  ToApprove = 'TO_APPROVE',
  ToPay = 'TO_PAY',
  ToReview = 'TO_REVIEW'
}

export enum SupplierInvoiceView {
  ApAdvancedSection = 'AP_ADVANCED_SECTION',
  ApSimplifiedCompleted = 'AP_SIMPLIFIED_COMPLETED',
  ApSimplifiedToDo = 'AP_SIMPLIFIED_TO_DO',
  CounterEinvoicesToReview = 'COUNTER_EINVOICES_TO_REVIEW',
  DocumentReviewSection = 'DOCUMENT_REVIEW_SECTION',
  DocumentReviewSectionPendingReview = 'DOCUMENT_REVIEW_SECTION_PENDING_REVIEW',
  DocumentReviewSectionResolved = 'DOCUMENT_REVIEW_SECTION_RESOLVED',
  General = 'GENERAL',
  PayByInvoice = 'PAY_BY_INVOICE'
}

export type SupplierInvoicesFilters = {
  approverIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachmentCategory?: InputMaybe<Array<SupplierInvoiceAttachmentCategory>>;
  attachmentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAtFrom?: InputMaybe<Scalars['String']['input']>;
  createdAtTo?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<Array<SupplierInvoiceDocumentTypeFilter>>;
  dueDate?: InputMaybe<Array<SupplierInvoiceDueDateFilter>>;
  excludeCreditNotes?: InputMaybe<Scalars['Boolean']['input']>;
  hasDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isEinvoice?: InputMaybe<Scalars['Boolean']['input']>;
  issueDate?: InputMaybe<Array<SupplierInvoiceFriendlyDateFilter>>;
  markedAsRead?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  matchedTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  missingData?: InputMaybe<Scalars['Boolean']['input']>;
  payableAmount?: InputMaybe<Array<PayableAmountFilter>>;
  paymentDate?: InputMaybe<Array<SupplierInvoiceFriendlyDateFilter>>;
  source?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<SupplierInvoiceStatus>>;
  supplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedAtFrom?: InputMaybe<Scalars['String']['input']>;
  updatedAtTo?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<SupplierInvoiceView>;
};

export type SupplierInvoicesPagination = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierInvoicesSearch = {
  filters?: InputMaybe<SupplierInvoicesFilters>;
  pagination?: InputMaybe<SupplierInvoicesPagination>;
  query?: InputMaybe<Scalars['String']['input']>;
  queryFields?: InputMaybe<Array<SupplierInvoiceQueryField>>;
  sort?: InputMaybe<Sort>;
};

export type SupplierSnapshot = {
  __typename?: 'SupplierSnapshot';
  currency?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastTransaction?: Maybe<QontoAppSystemsTransactionsFirstpartyV8_Transaction>;
  lastTransactionId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: SupplierStatus;
  tin?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export enum SupplierStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Unarchived = 'UNARCHIVED'
}

export type SupplierSubscription = {
  __typename?: 'SupplierSubscription';
  amount: Amount;
  bankAccount: BankAccount;
  bankAccountId: Scalars['String']['output'];
  counterpartyName: Scalars['String']['output'];
  frequency: Frequency;
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  nextPaymentDate: Scalars['String']['output'];
  paymentMethod: SubscriptionPaymentMethod;
  recentTransactionIds: Array<Scalars['String']['output']>;
  recentTransactions: Array<Transaction>;
  transactionIds: Array<Scalars['String']['output']>;
  transactions: Array<Transaction>;
};

export type SupplierSubscriptionMeta = {
  __typename?: 'SupplierSubscriptionMeta';
  counterpartyName: Scalars['String']['output'];
  eligible: Scalars['Boolean']['output'];
  isCounterpartyBlocked: Scalars['Boolean']['output'];
};

export type SupplierSubscriptionsPagination = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierSubscriptionsSearch = {
  pagination?: InputMaybe<SupplierSubscriptionsPagination>;
  sort?: InputMaybe<Sort>;
};

export type SupportedInvoiceCollector = {
  __typename?: 'SupportedInvoiceCollector';
  counterpartyName: Scalars['String']['output'];
  integrationName: Scalars['String']['output'];
  integrationSlug: Scalars['String']['output'];
  solutionInstanceStatus: SolutionInstanceStatus;
  type: SupportedInvoiceCollectorType;
};

export enum SupportedInvoiceCollectorType {
  /** Right now this corresponds to Twin's Invoice Collector */
  InvoiceCollector = 'INVOICE_COLLECTOR',
  /** Invoice collector built by Qonto as Tray integration */
  InHouseCollector = 'IN_HOUSE_COLLECTOR',
  /** The transaction's counterparty is not supported */
  NotAvailable = 'NOT_AVAILABLE'
}

export type SwiftIncome = {
  __typename?: 'SwiftIncome';
  amount: Amount;
  emitterAccountIdentifier?: Maybe<Scalars['String']['output']>;
  emitterAddress?: Maybe<Scalars['String']['output']>;
  emitterBankIdentifier?: Maybe<Scalars['String']['output']>;
  emitterName?: Maybe<Scalars['String']['output']>;
  emitterNameAddress?: Maybe<Scalars['String']['output']>;
  enrichmentData?: Maybe<EnrichmentData>;
  exchangeRate?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  localAmount: Amount;
  reference?: Maybe<Scalars['String']['output']>;
};

export type TaxFinancialAccount = {
  __typename?: 'TaxFinancialAccount';
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  rate: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type Team = {
  __typename?: 'Team';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Thread = {
  __typename?: 'Thread';
  attachedToId: Scalars['ID']['output'];
  attachedToType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  messages: Array<Message>;
  organizationId: Scalars['ID']['output'];
  participants: Array<Participant>;
};

export type ThreadsSearch = {
  attachedToIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Thumbnail = {
  __typename?: 'Thumbnail';
  fileUrl: Scalars['String']['output'];
};

export type Transaction = {
  __typename?: 'Transaction';
  accountRemuneration?: Maybe<AccountRemuneration>;
  accountRemunerationId?: Maybe<Scalars['String']['output']>;
  activityTag?: Maybe<ActivityTag>;
  amount: Amount;
  attachmentIds: Array<Scalars['String']['output']>;
  attachmentLost: Scalars['Boolean']['output'];
  attachmentRequested: Scalars['Boolean']['output'];
  attachmentRequestedAt?: Maybe<Scalars['String']['output']>;
  attachmentRequestedById?: Maybe<Scalars['String']['output']>;
  attachmentRequired: Scalars['Boolean']['output'];
  attachmentSuggestionIds: Array<Scalars['String']['output']>;
  attachments: Array<Attachment>;
  authorizationType?: Maybe<AuthorizationType>;
  automaticallyAddedAttachmentIds: Array<Scalars['String']['output']>;
  bankAccount?: Maybe<BankAccount>;
  bankAccountId: Scalars['String']['output'];
  billingTransfer?: Maybe<BillingTransfer>;
  billingTransferId?: Maybe<Scalars['String']['output']>;
  card?: Maybe<Card>;
  cardAcquirerPayout?: Maybe<CardAcquirerPayout>;
  cardId?: Maybe<Scalars['String']['output']>;
  cardTransaction?: Maybe<CardTransaction>;
  cardTransactionMovementId?: Maybe<Scalars['String']['output']>;
  cardTransactionStatus?: Maybe<CardTransactionStatus>;
  cashback?: Maybe<Cashback>;
  cashbackId?: Maybe<Scalars['String']['output']>;
  category?: Maybe<CashFlowCategory>;
  categoryAssignment?: Maybe<CategoryAssignment>;
  check?: Maybe<Check>;
  checkId?: Maybe<Scalars['String']['output']>;
  childTransactions: Array<Transaction>;
  cleanCounterpartyName?: Maybe<Scalars['String']['output']>;
  counterparty?: Maybe<Counterparty>;
  counterpartyName: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  declinedReason?: Maybe<DeclinedReason>;
  deferredDebitCardRepayment?: Maybe<DeferredDebitCardRepayment>;
  deferredDebitCardRepaymentDetails?: Maybe<DeferredDebitCardRepaymentDetails>;
  description?: Maybe<Scalars['String']['output']>;
  directDebit?: Maybe<DirectDebit>;
  directDebitCollection?: Maybe<DirectDebitCollection>;
  directDebitCollectionId?: Maybe<Scalars['String']['output']>;
  directDebitHold?: Maybe<DirectDebitHold>;
  directDebitHoldId?: Maybe<Scalars['String']['output']>;
  directDebitId?: Maybe<Scalars['String']['output']>;
  displayAt: Scalars['String']['output'];
  disputes: Array<Dispute>;
  emittedAt: Scalars['String']['output'];
  enrichmentData: EnrichmentData;
  excludedFromAnalytics: Scalars['Boolean']['output'];
  f24Payment?: Maybe<F24Payment>;
  financingInstallment?: Maybe<FinancingInstallment>;
  financingInstallmentId?: Maybe<Scalars['String']['output']>;
  fx: Scalars['Boolean']['output'];
  fxPaymentPurpose?: Maybe<Scalars['String']['output']>;
  fxPaymentPurposeUnstructured?: Maybe<Scalars['String']['output']>;
  fxRate?: Maybe<Scalars['Float']['output']>;
  hasAttachment: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  income?: Maybe<Income>;
  incomeId?: Maybe<Scalars['String']['output']>;
  initiator?: Maybe<LegacyMembership>;
  initiatorId?: Maybe<Scalars['String']['output']>;
  isAtm: Scalars['Boolean']['output'];
  isEnriched: Scalars['Boolean']['output'];
  isExternalTransaction: Scalars['Boolean']['output'];
  isPos: Scalars['Boolean']['output'];
  isProxied?: Maybe<Scalars['Boolean']['output']>;
  labelIds: Array<Scalars['String']['output']>;
  labels: Array<Label>;
  localAmount?: Maybe<Amount>;
  mergedFees?: Maybe<RelatedFees>;
  mergedFeesId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  nrcPayment?: Maybe<NrcPayment>;
  nrcPaymentId?: Maybe<Scalars['String']['output']>;
  operationMethod: OperationMethod;
  operationType: OperationType;
  organizationId: Scalars['String']['output'];
  overdraftInterestPayment?: Maybe<OverdraftInterestPayment>;
  pagopaPayment?: Maybe<PagopaPayment>;
  pagopaPaymentId?: Maybe<Scalars['String']['output']>;
  parentTransactions: Array<Transaction>;
  providerObjectId: Scalars['String']['output'];
  qualifiedForAccounting: Scalars['Boolean']['output'];
  rawCounterpartyName?: Maybe<Scalars['String']['output']>;
  /** @deprecated This was part of the V1 which is being cleaned up on the clients, we don't need to aggregate this anymore as the data is not used */
  relatedFees?: Maybe<RelatedFees>;
  relatedMovementId?: Maybe<Scalars['String']['output']>;
  relatedTransactionId?: Maybe<Scalars['String']['output']>;
  ribaPayment?: Maybe<RibaPayment>;
  ribaPaymentId?: Maybe<Scalars['String']['output']>;
  settledAt?: Maybe<Scalars['String']['output']>;
  settledBalance?: Maybe<Amount>;
  side: Side;
  slug: Scalars['String']['output'];
  status: Status;
  statusHistory: Array<StatusHistory>;
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<SubjectType>;
  suggestedCategory?: Maybe<SuggestedCategory>;
  supplierInvoices: Array<SupplierInvoice>;
  supplierSubscription?: Maybe<SupplierSubscription>;
  supplierSubscriptionMeta?: Maybe<SupplierSubscriptionMeta>;
  supportedInvoiceCollector?: Maybe<SupportedInvoiceCollector>;
  swiftIncome?: Maybe<SwiftIncome>;
  swiftIncomeId?: Maybe<Scalars['String']['output']>;
  thread?: Maybe<Thread>;
  transfer?: Maybe<Transfer>;
  transferId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  vat: Vat;
  walletToWallet?: Maybe<WalletToWallet>;
  walletToWalletId?: Maybe<Scalars['String']['output']>;
};

export type TransactionsSearch = {
  bankAccountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filterGroup?: InputMaybe<FilterGroupOne>;
  pagination?: InputMaybe<Pagination>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
};

export type Transfer = {
  __typename?: 'Transfer';
  amount: Scalars['Float']['output'];
  amountCents: Scalars['Int']['output'];
  amountCurrency: Scalars['String']['output'];
  amountV2: Amount;
  attachmentIds: Array<Scalars['String']['output']>;
  attachmentVisible: Scalars['Boolean']['output'];
  beneficiary?: Maybe<Beneficiary>;
  beneficiaryId?: Maybe<Scalars['ID']['output']>;
  bic: Scalars['String']['output'];
  cancelable: Scalars['Boolean']['output'];
  clientsSortDateLast?: Maybe<Scalars['String']['output']>;
  clientsSortDateNext?: Maybe<Scalars['String']['output']>;
  confirmationFileUrl?: Maybe<Scalars['String']['output']>;
  counterparty?: Maybe<TransferCounterparty>;
  createdAt: Scalars['String']['output'];
  cutoffAt?: Maybe<Scalars['String']['output']>;
  declinedReason?: Maybe<Scalars['String']['output']>;
  editable: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  enrichmentData?: Maybe<EnrichmentData>;
  fixedAmount?: Maybe<FixedAmountType>;
  fx: Scalars['Boolean']['output'];
  fxPaymentPurpose?: Maybe<Scalars['String']['output']>;
  fxPaymentPurposeUnstructured?: Maybe<Scalars['String']['output']>;
  fxRate?: Maybe<Scalars['Float']['output']>;
  fxSettlementStatus?: Maybe<Scalars['String']['output']>;
  iban: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  initiatorId?: Maybe<Scalars['ID']['output']>;
  instant: Scalars['Boolean']['output'];
  internal: Scalars['Boolean']['output'];
  internalInOrganization: Scalars['Boolean']['output'];
  labelIds: Array<Scalars['String']['output']>;
  lastRecursionDate?: Maybe<Scalars['String']['output']>;
  localAmount: Scalars['Float']['output'];
  localAmountCents: Scalars['Int']['output'];
  localAmountCurrency: Scalars['String']['output'];
  localAmountV2: Amount;
  nextRecursionDate?: Maybe<Scalars['String']['output']>;
  notEditableReason?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  noteVisible: Scalars['Boolean']['output'];
  notifyByEmail: Scalars['Boolean']['output'];
  operationType: Scalars['String']['output'];
  proofPdfUrl?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Purpose>;
  qontoBankAccount: Scalars['Boolean']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  scheduledDate?: Maybe<Scalars['String']['output']>;
  sequentialId?: Maybe<Scalars['Int']['output']>;
  settlementDate?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  standingEndingDate?: Maybe<Scalars['String']['output']>;
  standingFrequency?: Maybe<Scalars['String']['output']>;
  standingOn: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
  vatAmount?: Maybe<Scalars['String']['output']>;
  vatAmountV2?: Maybe<Amount>;
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export type TransferCounterparty = {
  __typename?: 'TransferCounterparty';
  accountIdentifier?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<Scalars['String']['output']>;
  bankIdentifier?: Maybe<Scalars['String']['output']>;
  branchIdentifier?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type UserAvatar = {
  __typename?: 'UserAvatar';
  fileUrl: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  thumbUrl: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type Vat = {
  __typename?: 'Vat';
  items: Array<VatItem>;
  status?: Maybe<VatStatus>;
  totalAmount: Amount;
};

export type VatItem = {
  __typename?: 'VatItem';
  amount?: Maybe<Amount>;
  amountExcludingVat?: Maybe<Amount>;
  id: Scalars['String']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  transactionId: Scalars['String']['output'];
};

export enum VatStatus {
  VatAuto = 'VAT_AUTO',
  VatConfirmed = 'VAT_CONFIRMED',
  VatDetecting = 'VAT_DETECTING',
  VatDetectionError = 'VAT_DETECTION_ERROR',
  VatInheritedFromBeneficiary = 'VAT_INHERITED_FROM_BENEFICIARY',
  VatManual = 'VAT_MANUAL',
  VatNotFound = 'VAT_NOT_FOUND',
  VatOverridden = 'VAT_OVERRIDDEN',
  VatSuggested = 'VAT_SUGGESTED'
}

export type Vehicle = {
  __typename?: 'Vehicle';
  electric?: Maybe<Scalars['Boolean']['output']>;
  power?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type WalletToWallet = {
  __typename?: 'WalletToWallet';
  amount: Scalars['Float']['output'];
  amountCents: Scalars['Int']['output'];
  amountCurrency: Scalars['String']['output'];
  amountV2: Amount;
  id: Scalars['ID']['output'];
  operationSubtype?: Maybe<Scalars['String']['output']>;
  operationType: Scalars['String']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  vatAmount?: Maybe<Scalars['Float']['output']>;
  vatAmountCents?: Maybe<Scalars['Int']['output']>;
  vatAmountV2?: Maybe<Amount>;
  vatRate?: Maybe<Scalars['Float']['output']>;
};

export type SearchSingleSupplierSubscriptionQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SearchSingleSupplierSubscriptionQuery = { __typename?: 'Query', searchSingleSupplierSubscription: { __typename?: 'SearchSingleSupplierSubscriptionResult', subscription: { __typename?: 'SupplierSubscription', id: string, counterpartyName: string, frequency: Frequency, nextPaymentDate: string, paymentMethod: SubscriptionPaymentMethod, logoUrl?: string | null, amount: { __typename?: 'Amount', value: string, currency: string }, bankAccount: { __typename?: 'BankAccount', bankName?: string | null, name: string, logo?: { __typename?: 'Logo', small: string, medium: string } | null }, recentTransactions: Array<{ __typename?: 'Transaction', id: string, emittedAt: string, isExternalTransaction: boolean, amount: { __typename?: 'Amount', value: string, currency: string }, card?: { __typename?: 'Card', id: string, nickname: string, embossedName?: string | null, last4: string, cardLevel: CardLevel, cardDesign?: string | null, status: CardStatus, hasOnlyUserLiftableLocks: boolean, holder?: { __typename?: 'LegacyMembership', id: string, fullName: string } | null } | null }> } } };

export type SearchSupplierSubscriptionsQueryVariables = Exact<{
  pagination: SupplierSubscriptionsPagination;
  sort: Sort;
}>;


export type SearchSupplierSubscriptionsQuery = { __typename?: 'Query', searchSupplierSubscriptions: { __typename?: 'SearchSupplierSubscriptionsResult', meta: { __typename?: 'SearchSupplierSubscriptionsMeta', totalCount: number, totalPages: number, currentPage: number, perPage: number, nextPage?: number | null, prevPage?: number | null }, subscriptions: Array<{ __typename?: 'SupplierSubscription', id: string, counterpartyName: string, frequency: Frequency, nextPaymentDate: string, paymentMethod: SubscriptionPaymentMethod, logoUrl?: string | null, amount: { __typename?: 'Amount', value: string, currency: string }, bankAccount: { __typename?: 'BankAccount', bankName?: string | null, name: string, logo?: { __typename?: 'Logo', small: string, medium: string } | null }, recentTransactions: Array<{ __typename?: 'Transaction', id: string, emittedAt: string, isExternalTransaction: boolean, amount: { __typename?: 'Amount', value: string, currency: string }, card?: { __typename?: 'Card', id: string, nickname: string, embossedName?: string | null, last4: string, cardLevel: CardLevel, cardDesign?: string | null, status: CardStatus, hasOnlyUserLiftableLocks: boolean, holder?: { __typename?: 'LegacyMembership', id: string, fullName: string } | null } | null }> }> } };

export type GetProjectMembershipQueryVariables = Exact<{
  input: SingleMembershipsSearch;
}>;


export type GetProjectMembershipQuery = { __typename?: 'Query', getSingleMembership?: { __typename?: 'Membership', id: string, organizationId: string, userId?: string | null, status: MembershipStatus, role: MembershipRole, teamId?: string | null, teamName?: string | null, invitation?: { __typename?: 'Invite', id: string, recipientId: string, firstName: string, lastName: string, fullName: string, email: string, flow: InviteFlow } | null, kyc: { __typename?: 'MembershipKycStatus', membershipId: string, kycStatus: KycStatus }, avatar?: { __typename?: 'UserAvatar', userId: string, fileUrl: string, thumbUrl: string, isDefault: boolean } | null, person?: { __typename?: 'Person', id: string, displayName?: string | null, firstName: string, lastName: string, fullName: string, userId: string } | null, user?: { __typename?: 'User', id: string, email: string } | null } | null };

export type ListAccountancyPracticeObligationsQueryVariables = Exact<{
  input?: InputMaybe<QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeObligationsRequestInput>;
}>;


export type ListAccountancyPracticeObligationsQuery = { __typename?: 'Query', listAccountancyPracticeObligations?: { __typename?: 'QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeObligationsResponse', obligations: Array<{ __typename?: 'QontoAccountingObligationsFirstpartyV2_Obligation', id: string, organizationId: string, type: QontoAccountingObligationsFirstpartyV2_ObligationType, obligationSubtype: QontoAccountingObligationsFirstpartyV2_ObligationSubtype, startsAt: string, endsAt: string, filingDueDate: string, status: QontoAccountingObligationsFirstpartyV2_ObligationStatus, organization?: { __typename?: 'QontoRegistrationApiOrganizationsFirstpartyV5_Organization', id: string, name: string } | null }>, meta: { __typename?: 'QontoCommon_PaginationMeta', currentPage: number, nextPage?: number | null, prevPage?: number | null, totalPages: number, totalCount: number, perPage: number } } | null };

export type GetMembershipAvatarQueryVariables = Exact<{
  membershipId: Scalars['String']['input'];
}>;


export type GetMembershipAvatarQuery = { __typename?: 'Query', getSingleMembership?: { __typename?: 'Membership', id: string, avatar?: { __typename?: 'UserAvatar', fileUrl: string, thumbUrl: string } | null } | null };

export type ListAccountancyPracticeConversationsQueryVariables = Exact<{
  input?: InputMaybe<QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeConversationsRequestInput>;
}>;


export type ListAccountancyPracticeConversationsQuery = { __typename?: 'Query', listAccountancyPracticeConversations?: { __typename?: 'QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeConversationsResponse', conversations: Array<{ __typename?: 'QontoAccountingAccountancyPracticesFirstpartyV2_Conversation', conversationId: string, organizationId: string, title: string, closedAt?: string | null, lastMessageAt?: string | null, isLastMessageSeen: boolean, lastMessageText: string, isLastMessageFromAccountant?: boolean | null, organization?: { __typename?: 'QontoRegistrationApiOrganizationsFirstpartyV5_Organization', id: string, name: string, company?: { __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_Company', legalForm?: string | null } | null, stakeholders?: { __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_OrganizationStakeholders', stakeholders: Array<{ __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_Stakeholder', firstName: string, lastName: string }> } | null } | null }>, meta: { __typename?: 'QontoCommon_PaginationMeta', currentPage: number, totalPages: number, totalCount: number, perPage: number } } | null };

export type GetLedgerEntriesQueryVariables = Exact<{
  input?: InputMaybe<QontoAccountingEntriesFirstpartyV2_GetEntriesRequestInput>;
}>;


export type GetLedgerEntriesQuery = { __typename?: 'Query', getLedgerEntries?: { __typename?: 'QontoAccountingEntriesFirstpartyV2_GetEntriesResponse', entries: Array<{ __typename?: 'QontoAccountingEntriesFirstpartyV2_LedgerEntryEnriched', id: string, organizationId: string, recordDate: string, documentType: string, counterPartyName: string, entryTitle?: string | null, reference?: string | null, status: QontoAccountingEntriesFirstpartyV2_EntryStatus, lastVerifiedAttemptAt?: string | null, createdAt: string, updatedAt?: string | null, documentIncludingTaxAmount: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string }, accountingTaxAmount?: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string } | null, accountingIncludingTaxAmount: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string }, journal: { __typename?: 'QontoAccountingEntriesFirstpartyV2_Journal', id: string, code: string, name: string, type: string, isDeleted?: boolean | null, createdAt: string, updatedAt: string }, lines: Array<{ __typename?: 'QontoAccountingEntriesFirstpartyV2_LedgerEntryLineEnriched', id: string, way: string, taxRatePercent?: string | null, amount: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string }, taxBaseAmount?: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string } | null, account?: { __typename?: 'QontoAccountingEntriesFirstpartyV2_Account', id: string, code: string, label: string, category: string, isAuxiliary: boolean } | null, auxiliaryAccount?: { __typename?: 'QontoAccountingEntriesFirstpartyV2_Account', id: string, code: string, label: string, category: string, isAuxiliary: boolean } | null }>, displayedAccounts: Array<{ __typename?: 'QontoAccountingEntriesFirstpartyV2_Account', id: string, code: string, label: string, category: string, isAuxiliary: boolean }>, integrationStatus?: { __typename?: 'QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntry', id: string, state: QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryState, ackValidation: boolean, rejectionLog?: string | null, createdAt: string, rejectionType?: { __typename?: 'QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryRejectionType', label: string, howToFix?: string | null } | null } | null, reconciliations: Array<{ __typename?: 'QontoAccountingEntriesFirstpartyV2_ReconciliationItem', type: QontoAccountingEntriesFirstpartyV2_ReconciliationItemType }> }>, meta: { __typename?: 'QontoAccountingEntriesFirstpartyV2_Meta', currentPage: number, nextPage?: number | null, prevPage?: number | null, totalPages: number, totalCount: number, perPage: number } } | null };

export type GetJournalsQueryVariables = Exact<{
  includeAccount: Scalars['Boolean']['input'];
  includeBankAccount: Scalars['Boolean']['input'];
  includeDeleted: Scalars['Boolean']['input'];
}>;


export type GetJournalsQuery = { __typename?: 'Query', getJournals: { __typename?: 'QontoAccountingJournalsFirstpartyV2_ListJournalsResponse', journals: Array<{ __typename?: 'QontoAccountingJournalsFirstpartyV2_Journal', id: string, code: string, name: string, type: string, deletedAt?: string | null, bankAccount?: { __typename?: 'BankAccount', id: string, iban: string, bic: string, name: string, logo?: { __typename?: 'Logo', small: string } | null } | null, account?: { __typename?: 'QontoAccountingAccountsFirstpartyV2_Account', id: string, code: string, label: string } | null }> } };

export type GetSoloLedgerEntriesQueryVariables = Exact<{
  input?: InputMaybe<QontoAccountingEntriesFirstpartyV2_GetEntriesRequestInput>;
}>;


export type GetSoloLedgerEntriesQuery = { __typename?: 'Query', getLedgerEntries?: { __typename?: 'QontoAccountingEntriesFirstpartyV2_GetEntriesResponse', entries: Array<{ __typename?: 'QontoAccountingEntriesFirstpartyV2_LedgerEntryEnriched', id: string, organizationId: string, recordDate: string, documentType: string, counterPartyName: string, entryTitle?: string | null, reference?: string | null, status: QontoAccountingEntriesFirstpartyV2_EntryStatus, createdAt: string, updatedAt?: string | null, cashFlow: QontoAccountingEntriesFirstpartyV2_CashFlow, documentIncludingTaxAmount: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string }, accountingTaxAmount?: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string } | null, accountingIncludingTaxAmount: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string }, journal: { __typename?: 'QontoAccountingEntriesFirstpartyV2_Journal', id: string, code: string, name: string, type: string, isDeleted?: boolean | null, createdAt: string, updatedAt: string }, lines: Array<{ __typename?: 'QontoAccountingEntriesFirstpartyV2_LedgerEntryLineEnriched', id: string, way: string, taxRatePercent?: string | null, lineType?: QontoAccountingEntriesFirstpartyV2_LineType | null, categoryKey?: string | null, taxDeductibilityRatePercent?: string | null, amount: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string }, taxBaseAmount?: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string } | null, account?: { __typename?: 'QontoAccountingEntriesFirstpartyV2_Account', id: string, code: string, label: string, category: string, isAuxiliary: boolean } | null, auxiliaryAccount?: { __typename?: 'QontoAccountingEntriesFirstpartyV2_Account', id: string, code: string, label: string, category: string, isAuxiliary: boolean } | null }>, displayedAccounts: Array<{ __typename?: 'QontoAccountingEntriesFirstpartyV2_Account', id: string, code: string, label: string, category: string, isAuxiliary: boolean }>, integrationStatus?: { __typename?: 'QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntry', id: string, state: QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryState, ackValidation: boolean, rejectionLog?: string | null, createdAt: string, rejectionType?: { __typename?: 'QontoAccountingIntegrationsEntriesFirstpartyV1_LedgerEntryRejectionType', label: string, howToFix?: string | null } | null } | null, reconciliations: Array<{ __typename?: 'QontoAccountingEntriesFirstpartyV2_ReconciliationItem', type: QontoAccountingEntriesFirstpartyV2_ReconciliationItemType }> }>, meta: { __typename?: 'QontoAccountingEntriesFirstpartyV2_Meta', currentPage: number, nextPage?: number | null, prevPage?: number | null, totalPages: number, totalCount: number, perPage: number } } | null };

export type SubscriptionChangeEstimateQueryVariables = Exact<{
  input?: InputMaybe<QontoPricingSubscriptionsFirstpartyV6_EstimateSubscriptionChangeRequestInput>;
}>;


export type SubscriptionChangeEstimateQuery = { __typename?: 'Query', subscriptionChangeEstimate: { __typename?: 'QontoPricingSubscriptionsFirstpartyV6_EstimateSubscriptionChangeResponse', basketId: string, isEligibleForVoucherCode: boolean, billingMilestones: Array<{ __typename?: 'QontoPricingSubscriptionsFirstpartyV6_BillingMilestone', date: string, isNegative: boolean, subtitle?: string | null, billingTags: Array<string>, amount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } }>, currentCoreSubscription: { __typename?: 'QontoPricingSubscriptionsFirstpartyV6_CurrentCoreSubscription', productId: string, marketingContent: { __typename?: 'QontoPricingCatalogFirstpartyV1_PlanChangeProductContent', productId: string, brandName: string, features: Array<{ __typename?: 'QontoPricingCatalogFirstpartyV1_ProductFeature', name: string, isUpsell: boolean }> } }, errors: Array<{ __typename?: 'QontoPricingSubscriptionsFirstpartyV6_Blocker', code: string, detail: string, additionalData: Record<string, unknown> }>, priceBreakdown: { __typename?: 'QontoPricingSubscriptionsFirstpartyV6_PriceBreakdown', blocks: Array<{ __typename?: 'QontoPricingSubscriptionsFirstpartyV6_PriceBreakdownBlock', section?: string | null, items: Array<{ __typename?: 'QontoPricingSubscriptionsFirstpartyV6_PriceBreakdownItem', title: string, subTitle?: string | null, isNegative: boolean, amount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } }> }>, total: { __typename?: 'QontoPricingSubscriptionsFirstpartyV6_PriceBreakdownTotal', title: string, isNegative: boolean, amount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } } }, suggestedSubscriptions: Array<{ __typename?: 'QontoPricingSubscriptionsFirstpartyV6_SubscriptionTargetItem', productId: string, productType: QontoPricingCommonV1_ProductType, productCode: string, productGroupCode: string, recurrence: QontoPricingCommonV1_SubscriptionRecurrence, isRequired: boolean, isComparable: boolean, flow: Array<string>, discontinuedProduct: boolean, basePrice: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string }, discountedPrice?: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } | null, specialOffers: Array<{ __typename?: 'QontoPricingSubscriptionsFirstpartyV6_SpecialOffer', type: QontoPricingSubscriptionsFirstpartyV6_SpecialOffer_Type, endDate: string, properties: any, price: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } }>, marketingContent: { __typename?: 'QontoPricingCatalogFirstpartyV1_PlanChangeProductContent', productId: string, brandName: string, features: Array<{ __typename?: 'QontoPricingCatalogFirstpartyV1_ProductFeature', name: string, isUpsell: boolean }> } }>, targetSubscriptions: Array<{ __typename?: 'QontoPricingSubscriptionsFirstpartyV6_SubscriptionTargetItem', productId: string, productType: QontoPricingCommonV1_ProductType, productCode: string, productGroupCode: string, recurrence: QontoPricingCommonV1_SubscriptionRecurrence, isRequired: boolean, isComparable: boolean, flow: Array<string>, discontinuedProduct: boolean, basePrice: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string }, discountedPrice?: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } | null, specialOffers: Array<{ __typename?: 'QontoPricingSubscriptionsFirstpartyV6_SpecialOffer', type: QontoPricingSubscriptionsFirstpartyV6_SpecialOffer_Type, endDate: string, properties: any, price: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } }>, marketingContent: { __typename?: 'QontoPricingCatalogFirstpartyV1_PlanChangeProductContent', productId: string, brandName: string, features: Array<{ __typename?: 'QontoPricingCatalogFirstpartyV1_ProductFeature', name: string, isUpsell: boolean }> } }>, warnings: Array<{ __typename?: 'QontoPricingSubscriptionsFirstpartyV6_Warning', code: string, detail: string, additionalData: Record<string, unknown> }> } };

export type SearchCashFlowTransactionsQueryVariables = Exact<{
  input?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsRequestInput>;
}>;


export type SearchCashFlowTransactionsQuery = { __typename?: 'Query', searchTransactionsV2: { __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsResponse', meta: { __typename?: 'QontoCommon_PaginationMeta', totalCount: number, totalPages: number, currentPage: number, perPage: number, nextPage?: number | null, prevPage?: number | null }, transactions: Array<{ __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_Transaction', id: string, bankAccountId: string, counterpartyName: string, rawCounterpartyName: string, description?: string | null, emittedAt: string, operationMethod: QontoAppSystemsTransactionsFirstpartyV8_OperationMethod, side: QontoAppSystemsTransactionsFirstpartyV8_Side, amount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string }, category?: { __typename?: 'CashFlowCategory', id: string } | null, matchedExpectedTransactions: Array<{ __typename?: 'QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_MatchedExpectedTransaction', transactionId: string, id: string, counterpartyName: string, side: QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_TransactionSide, providerObjectType: QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_ProviderObjectType, providerObjectId: string, feedback?: QontoCashFlowManagementCashFlowCategoriesUpcomingTransactionsFirstpartyV3_FeedbackType | null, amount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } }> }> } };

export type ListRecentAttachmentsQueryVariables = Exact<{
  processingStatuses?: InputMaybe<Array<QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProcessingStatus> | QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProcessingStatus>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListRecentAttachmentsQuery = { __typename?: 'Query', listAttachments: { __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsResponse', attachments: Array<{ __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment', id: string, attachmentType: QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_AttachmentType, createdAt: string, creationSource?: QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_CreationSource | null, name?: string | null, status?: QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProcessingStatus | null, initiator?: { __typename?: 'Membership', person?: { __typename?: 'Person', fullName: string } | null, user?: { __typename?: 'User', email: string } | null } | null, file: { __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_File', fileName?: string | null } }>, meta: { __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsResponse_Meta', currentPage: number, nextPage?: number | null, prevPage?: number | null, totalPages: number, totalCount: number, perPage: number } } };

export type ListStorageAttachmentsQueryVariables = Exact<{
  types?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListStorageAttachmentsQuery = { __typename?: 'Query', listAttachments: { __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsResponse', attachments: Array<{ __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment', id: string, attachmentType: QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_AttachmentType, createdAt: string, creationSource?: QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_CreationSource | null, name?: string | null, status?: QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProcessingStatus | null, file: { __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_File', fileName?: string | null } }>, meta: { __typename?: 'QontoCashFlowManagementAttachmentsFirstpartyV4_ListAttachmentsResponse_Meta', currentPage: number, nextPage?: number | null, prevPage?: number | null, totalPages: number, totalCount: number, perPage: number } } };

export type GetEsimDataPackagesQueryVariables = Exact<{
  input: QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesRequestInput;
}>;


export type GetEsimDataPackagesQuery = { __typename?: 'Query', getEsimDataPackages: { __typename?: 'QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesResponse', dataPackages: Array<{ __typename?: 'QontoCardsIssuingEsimFirstpartyV1_DataPackage', id: string, status: QontoCardsIssuingEsimFirstpartyV1_DataPackageStatus, activatedAt?: string | null, expiresAt?: string | null, holder?: { __typename?: 'QontoSpendManagementMembershipsMembershipsFirstpartyV1_Membership', id: string, person?: { __typename?: 'Person', displayName?: string | null, lastName: string } | null, invitation?: { __typename?: 'Invite', fullName: string } | null } | null, initiator?: { __typename?: 'QontoSpendManagementMembershipsMembershipsFirstpartyV1_Membership', person?: { __typename?: 'Person', firstName: string, lastName: string } | null } | null, plan: { __typename?: 'QontoCardsIssuingEsimFirstpartyV1_DataPlan', allowance: { __typename?: 'QontoCardsIssuingEsimFirstpartyV1_DataValue', value: string, unit: QontoCardsIssuingEsimFirstpartyV1_DataUnit }, validity: { __typename?: 'QontoCardsIssuingEsimFirstpartyV1_DataPlanValidity', value: string, unit: QontoCardsIssuingEsimFirstpartyV1_DataPlanValidityUnit }, coverageZone: { __typename?: 'QontoCardsIssuingEsimFirstpartyV1_CoverageZone', id: string, name: string, type: QontoCardsIssuingEsimFirstpartyV1_CoverageZoneType, countryCode: Array<string> } }, usage: { __typename?: 'QontoCardsIssuingEsimFirstpartyV1_DataValue', value: string, unit: QontoCardsIssuingEsimFirstpartyV1_DataUnit } }>, meta: { __typename?: 'QontoCommon_PaginationMeta', currentPage: number, perPage: number, prevPage?: number | null, nextPage?: number | null, totalCount: number, totalPages: number } } };

export type ListAccountancyPracticeAccountingSetupsQueryVariables = Exact<{
  input?: InputMaybe<QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeAccountingSetupsRequestInput>;
}>;


export type ListAccountancyPracticeAccountingSetupsQuery = { __typename?: 'Query', listAccountancyPracticeAccountingSetups?: { __typename?: 'QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeAccountingSetupsResponse', items: Array<{ __typename?: 'QontoAccountingAccountancyPracticesFirstpartyV2_AccountancyPracticeAccountingSetupListItem', accountingSetup: { __typename?: 'QontoAccountingAccountingSetupsFirstpartyV2_AccountingSetup', id: string, accountancyPracticeId: string, organizationId: string, status: QontoAccountingAccountingSetupsFirstpartyV2_AccountingSetupStatus, activatedAt?: string | null, activatedBy?: string | null, vatRegime: QontoAccountingAccountingSetupsFirstpartyV2_VatRegime, vatExigibility: QontoAccountingAccountingSetupsFirstpartyV2_VatExigibility, taxRegime: QontoAccountingAccountingSetupsFirstpartyV2_TaxRegime, firstAccountingPeriodStartAt?: string | null, firstAccountingPeriodEndAt?: string | null, archivedAt?: string | null, createdAt: string, updatedAt: string, taxMemoAttachmentId?: string | null, paymentIban?: string | null, rofVat?: string | null, rofCorporateTax?: string | null, rofTaxReturnPackage?: string | null, rofCfe?: string | null, hasCompletedDeclaration: boolean, periodDatesValidatedAt?: string | null, accountancyPracticeOrganization?: { __typename?: 'QontoRegistrationApiOrganizationsFirstpartyV5_Organization', id: string, name: string, slug: string, status: QontoRegistrationApiOrganizationsFirstpartyV5_OrganizationStatus, createdAt: string, suspensionReason?: QontoRegistrationApiOrganizationsFirstpartyV5_SuspensionReason | null, company?: { __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_Company', legalName: string, legalForm?: string | null, legalCode?: string | null, legalSector?: string | null, legalNumber?: string | null, legalRegistrationDate?: string | null, legalCountry: string, tradeName?: string | null, contactEmail: string, activityDescription?: string | null, websiteUrl?: string | null, legalTvaNumber?: string | null, organizationId?: string | null, addresses: Array<{ __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_Address', firstLine?: string | null, secondLine?: string | null, thirdLine?: string | null, zipcode?: string | null, city?: string | null, country?: string | null, type: QontoRegistrationApiCompanyFirstpartyV1_AddressType }>, financialDetail?: { __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_FinancialDetail', estimatedYearlyIncome?: string | null, annualTurnover?: string | null, yearlyTransactionVolume?: string | null, maxSinglePaymentAmount?: string | null, estimatedAnnualTurnover?: string | null } | null, taxResidence?: { __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_TaxResidence', country?: string | null, taxIdentificationNumber?: string | null } | null } | null, stakeholders?: { __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_OrganizationStakeholders', organizationId: string, stakeholders: Array<{ __typename?: 'QontoRegistrationApiCompanyFirstpartyV1_Stakeholder', firstName: string, lastName: string }> } | null } | null }, onboardingSteps: Array<{ __typename?: 'QontoAccountingAccountancyPracticesFirstpartyV2_OnboardingStepProgress', stepCode: string, status: QontoAccountingOnboardingFirstpartyV2_OnboardingStepStatus }> }>, meta: { __typename?: 'QontoCommon_PaginationMeta', currentPage: number, nextPage?: number | null, prevPage?: number | null, totalPages: number, totalCount: number, perPage: number } } | null };

export type ListObligationOperationsQueryVariables = Exact<{
  input?: InputMaybe<QontoAccountingObligationsFirstpartyV2_ListOperationsRequestInput>;
  includeCategoryAllocations: Scalars['Boolean']['input'];
}>;


export type ListObligationOperationsQuery = { __typename?: 'Query', listObligationOperations?: { __typename?: 'QontoAccountingObligationsFirstpartyV2_ListOperationsResponse', operations: Array<{ __typename?: 'QontoAccountingObligationsFirstpartyV2_Operation', id: string, type: QontoAccountingObligationsFirstpartyV2_OperationType, title: string, date: string, direction: QontoAccountingObligationsFirstpartyV2_OperationDirection, action: QontoAccountingObligationsFirstpartyV2_OperationAction, isVerified: boolean, attachmentId?: string | null, internalReferenceId?: string | null, amount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string }, accountingAmount?: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } | null, matchedResources: { __typename?: 'QontoAccountingObligationsFirstpartyV2_OperationMatchedResources', documents: number, transactions: number }, metadata?: { __typename?: 'QontoAccountingObligationsFirstpartyV2_OperationMetadata', attachmentLost?: boolean | null, attachmentRequired?: boolean | null } | null, transactionCategoryAllocations?: { __typename?: 'QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_Transaction', transactionId: string, categoryAllocations: Array<{ __typename?: 'QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_CategoryAllocation', categoryId: string, source: QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_AllocationSource, amount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } }> } | null, documentCategoryAllocations?: { __typename?: 'QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_Document', attachmentId: string, categoryAllocations: Array<{ __typename?: 'QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_CategoryAllocation', categoryId: string, source: QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_AllocationSource, amount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } }> } | null }>, meta: { __typename?: 'QontoCommon_PaginationMeta', currentPage: number, perPage: number, prevPage?: number | null, nextPage?: number | null, totalCount: number, totalPages: number } } | null };

export type GetSingleReceivableInvoiceQueryVariables = Exact<{
  input?: InputMaybe<SingleReceivableInvoicesSearch>;
  includePaymentLinkDetails: Scalars['Boolean']['input'];
  includeInvoiceSubscription: Scalars['Boolean']['input'];
  includeDirectDebitMandate: Scalars['Boolean']['input'];
}>;


export type GetSingleReceivableInvoiceQuery = { __typename?: 'Query', getSingleReceivableInvoice?: { __typename?: 'ReceivableInvoice', id: string, attachmentId: string, invoiceNumber: string, number?: string | null, locale?: string | null, issueDate?: string | null, dueDate?: string | null, currency?: string | null, status: ReceivableInvoiceStatus, einvoicingStatus?: ReceivableInvoiceEinvoicingStatus | null, fileName?: string | null, reference?: string | null, beneficiaryName?: string | null, contactEmail?: string | null, termsAndConditions?: string | null, purchaseOrder?: string | null, referralLink?: string | null, intermediaryBankBic?: string | null, iban?: string | null, bic?: string | null, header?: string | null, footer?: string | null, overdue: boolean, isPdfGenerated: boolean, isHiddenFromClientPortal: boolean, directDebitEnabled: boolean, hasDuplicates: boolean, imported: boolean, isEinvoice: boolean, isDeposit: boolean, createdAt?: string | null, updatedAt?: string | null, paidAt?: string | null, nextReminderDate?: string | null, performanceDate?: string | null, performanceStartDate?: string | null, performanceEndDate?: string | null, accountingRecordedAt?: string | null, importAnalyzedAt?: string | null, invoiceType?: ReceivableInvoiceType | null, organizationId?: string | null, customerId?: string | null, bankAccountId?: string | null, quoteId?: string | null, invoiceSubscriptionId?: string | null, directDebitSubscriptionId?: string | null, directDebitCollectionMandateId?: string | null, depositInvoiceId?: string | null, receivableInvoicingUploadId?: string | null, termsConditionsUploadId?: string | null, previousPartialInvoiceId?: string | null, lastPartialInvoiceId?: string | null, receivableCreditNoteIds?: Array<string> | null, balanceInvoiceIds?: Array<string> | null, partialInvoiceIds?: Array<string> | null, subtotalBeforeDiscount?: { __typename?: 'Amount', value: string, currency: string } | null, subtotal?: { __typename?: 'Amount', value: string, currency: string } | null, vatAmount?: { __typename?: 'Amount', value: string, currency: string } | null, amountDue?: { __typename?: 'Amount', value: string, currency: string } | null, amountPaid?: { __typename?: 'Amount', value: string, currency: string } | null, depositAmount?: { __typename?: 'Amount', value: string, currency: string } | null, stampDutyAmount?: { __typename?: 'Amount', value: string, currency: string } | null, payment?: { __typename?: 'ReceivableInvoicePayment', conditions?: string | null, method?: string | null } | null, discount?: { __typename?: 'ReceivableInvoiceDiscount', type?: string | null, value?: string | null, amount?: { __typename?: 'Amount', value: string, currency: string } | null } | null, welfareFund?: { __typename?: 'ReceivableInvoiceWelfareFund', type?: string | null, rate?: string | null } | null, withholdingTax?: { __typename?: 'ReceivableInvoiceWithholdingTax', type?: string | null, rate?: string | null, reason?: string | null } | null, progress?: { __typename?: 'ReceivableInvoiceProgress', mode?: string | null, cumulativePercentage?: string | null, remainingSubtotalBeforeDiscountPercentage?: string | null, cumulativeAmount?: { __typename?: 'Amount', value: string, currency: string } | null, remainingSubtotalBeforeDiscount?: { __typename?: 'Amount', value: string, currency: string } | null } | null, customerSnapshot?: { __typename?: 'ReceivableInvoiceCustomerSnapshot', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, address?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null, kind?: ReceivableInvoiceCustomerKind | null, tinNumber?: string | null, vatNumber?: string | null, locale?: string | null, currency?: string | null, billingAddress?: { __typename?: 'ReceivableInvoiceBillingAddress', streetAddress?: string | null, city?: string | null, zipCode?: string | null, countryCode?: string | null } | null } | null, organizationSnapshot?: { __typename?: 'ReceivableInvoiceOrganizationSnapshot', id: string, slug?: string | null, legalName?: string | null, legalForm?: string | null, legalNumber?: string | null, legalCountry?: string | null, vatNumber?: string | null, districtCourt?: string | null, companyLeadership?: string | null, commercialRegisterNumber?: string | null, vatPaymentCondition?: string | null, transactionType?: string | null, taxNumber?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressZipcode?: string | null, addressCity?: string | null, addressCountry?: string | null, type?: string | null, contactEmail?: string | null, locale?: string | null, legalCapitalShare?: { __typename?: 'Amount', value: string, currency: string } | null } | null, paymentLink?: { __typename?: 'ReceivableInvoicePaymentLink', methods?: Array<string> | null } | null, sections?: Array<{ __typename?: 'ReceivableInvoiceSection', id: string, title?: string | null, description?: string | null, items?: Array<{ __typename?: 'ReceivableInvoiceSectionItem', id: string, title?: string | null, description?: string | null, quantity?: string | null, unit?: string | null, vatRate?: string | null, vatExemptionCode?: string | null, productId?: string | null, createdAt?: string | null, updatedAt?: string | null, unitPrice?: { __typename?: 'Amount', value: string, currency: string } | null, totalVat?: { __typename?: 'Amount', value: string, currency: string } | null, totalAmount?: { __typename?: 'Amount', value: string, currency: string } | null, subtotal?: { __typename?: 'Amount', value: string, currency: string } | null, discount?: { __typename?: 'ReceivableInvoiceDiscount', type?: string | null, value?: string | null, amount?: { __typename?: 'Amount', value: string, currency: string } | null } | null, progress?: { __typename?: 'ReceivableInvoiceSectionItemProgress', type?: string | null, percentage?: string | null, cumulativePercentage?: string | null, remainingPercentage?: string | null, amount?: { __typename?: 'Amount', value: string, currency: string } | null, cumulativeAmount?: { __typename?: 'Amount', value: string, currency: string } | null, remainingAmount?: { __typename?: 'Amount', value: string, currency: string } | null } | null, links?: Array<{ __typename?: 'ReceivableInvoiceSectionItemLink', title?: string | null, url?: string | null }> | null }> | null }> | null, einvoicingLifecycleEvents?: Array<{ __typename?: 'ReceivableInvoiceEinvoicingLifecycleEvent', type?: string | null, status?: string | null, message?: string | null, createdAt?: string | null, reasonCode?: string | null }> | null, debtCollection?: { __typename?: 'ReceivableInvoiceDebtCollection', id: string, status: string, actionNeeded: boolean } | null, paymentLinkDetails?: { __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLink', id: string, name: string, status: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkStatus, recurrenceType: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkRecurrenceType, createdAt: string, expirationDate?: string | null, organizationName?: string | null, debitorName?: string | null, latestPaymentMethod?: QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod | null, potentialPaymentMethods: Array<QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentMethod>, amount: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string }, paymentInitiator: { __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentInitiator', resourceId: string, resourceType: QontoCardsAcceptancePaymentLinksFirstpartyV4_ResourceType, resourceNumber?: string | null }, settings?: { __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkSettings', redirectUrl?: string | null, limit?: number | null } | null, items: Array<{ __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_PaymentLinkItem', id?: string | null, title: string, type?: QontoCardsAcceptancePaymentLinksFirstpartyV4_ItemType | null, description?: string | null, quantity: number, measureUnit?: string | null, vatRate: string, unitPrice: { __typename?: 'QontoCommon_CurrencyAmount', currency: string, value: string } }>, recurrenceSettings?: { __typename?: 'QontoCardsAcceptancePaymentLinksFirstpartyV4_RecurrenceSettings', frequencyRecurrence: QontoCardsAcceptancePaymentLinksFirstpartyV4_FrequencyRecurrence, frequencyValue: number, times?: number | null } | null } | null, invoiceSubscription?: { __typename?: 'ReceivableInvoiceSubscription', id: string, startDate?: string | null, endDate?: string | null, nextInvoiceDate?: string | null, currency?: string | null, invoiceStatus?: ReceivableInvoiceSubscriptionInvoiceStatus | null, customerName?: string | null, paymentTermsDays?: number | null, purchaseOrder?: string | null, beneficiaryName?: string | null, termsAndConditions?: string | null, status?: ReceivableInvoiceSubscriptionStatus | null, createdAt?: string | null, updatedAt?: string | null, header?: string | null, footer?: string | null, directDebitEnabled?: boolean | null, isEinvoice?: boolean | null, organizationId?: string | null, customerId?: string | null, bankAccountId?: string | null, discount?: { __typename?: 'ReceivableInvoiceSubscriptionDiscount', type?: string | null, value?: string | null } | null, frequency?: { __typename?: 'ReceivableInvoiceSubscriptionFrequency', value?: number | null, recurrence?: ReceivableInvoiceSubscriptionRecurrence | null } | null, emailTemplate?: { __typename?: 'ReceivableInvoiceSubscriptionEmailTemplate', emailTitle?: string | null, emailBody?: string | null, sendTo?: Array<string> | null, copyToSelf?: boolean | null } | null, payment?: { __typename?: 'ReceivableInvoiceSubscriptionPayment', conditions?: string | null, method?: string | null } | null, welfareFund?: { __typename?: 'ReceivableInvoiceSubscriptionWelfareFund', type?: string | null, rate?: string | null } | null, withholdingTax?: { __typename?: 'ReceivableInvoiceSubscriptionWithholdingTax', type?: string | null, rate?: string | null, reason?: string | null } | null, stampDutyAmount?: { __typename?: 'Amount', value: string, currency: string } | null, amountDue?: { __typename?: 'Amount', value: string, currency: string } | null, paymentLink?: { __typename?: 'ReceivableInvoiceSubscriptionPaymentLink', methods?: Array<string> | null } | null, sections?: Array<{ __typename?: 'ReceivableInvoiceSubscriptionSection', id: string, title?: string | null, items?: Array<{ __typename?: 'ReceivableInvoiceSubscriptionSectionItem', id: string, title?: string | null, description?: string | null, quantity?: string | null, unit?: string | null, vatRate?: string | null, vatExemptionCode?: string | null, productId?: string | null, createdAt?: string | null, updatedAt?: string | null, unitPrice?: { __typename?: 'Amount', value: string, currency: string } | null, discount?: { __typename?: 'ReceivableInvoiceSubscriptionDiscount', type?: string | null, value?: string | null } | null, links?: Array<{ __typename?: 'ReceivableInvoiceSubscriptionSectionItemLink', title?: string | null, url?: string | null }> | null }> | null }> | null } | null, directDebitCollectionMandate?: { __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_Mandate', id: string, status: QontoTransfersSddCollectionsOrchestratorCommonFirstpartyV1_MandateStatus, uniqueMandateReference: string, creditorIdentifier: string, mandateSignatureDate: string, type: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateType, recurrenceType: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_MandateRecurrenceType, link: string, clientIbanLastDigits: string, clientBic: string, organizationId: string, clientId: string, clientSnapshot: { __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_ClientSnapshot', id: string, name: string, firstName: string, lastName: string, kind: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ClientKind, email: string, locale: string, address: string, city: string, zipCode: string, provinceCode: string, countryCode: string }, organizationSnapshot: { __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_OrganizationSnapshot', id: string, name: string, logoUrl: string, addressLine_1: string, addressLine_2: string, addressLine_3: string, city: string, zipCode: string, country: string }, paymentInfo?: { __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_PaymentInfo', notifyClient: boolean, scheduleCustomUnit: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleUnit, interval: number, scheduleTotalCollectionCount: number, scheduleType: QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_ScheduleType, firstPayment: { __typename?: 'QontoTransfersSddCollectionsOrchestratorMandatesFirstpartyV1_BatchGetMandatesResponse_FirstPayment', collectionDate: string, isOverdue?: boolean | null, reference: string, amount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } } } | null } | null } | null };

export type SearchDocumentsToReviewQueryVariables = Exact<{
  filters?: InputMaybe<SupplierInvoicesFilters>;
  pagination?: InputMaybe<SupplierInvoicesPagination>;
  sort?: InputMaybe<Sort>;
}>;


export type SearchDocumentsToReviewQuery = { __typename?: 'Query', searchSupplierInvoices: { __typename?: 'SearchSupplierInvoicesResult', supplierInvoices: Array<{ __typename?: 'SupplierInvoice', id: string, issuerName?: string | null, invoiceNumber?: string | null, status: SupplierInvoiceStatus, source: string, attachmentCategory: SupplierInvoiceAttachmentCategory, createdAt: string, meta?: { __typename?: 'SupplierInvoiceMeta', integrationType?: string | null, integrationName?: string | null, connector?: string | null, emailedBy?: string | null, resolvedBy?: { __typename?: 'Membership', id: string, person?: { __typename?: 'Person', id: string, fullName: string } | null } | null } | null, supplierSnapshot?: { __typename?: 'SupplierSnapshot', id: string, name: string } | null, totalAmount?: { __typename?: 'Amount', value: string, currency: string } | null }>, meta: { __typename?: 'SearchSupplierInvoicesMeta', currentPage: number, nextPage?: number | null, prevPage?: number | null, totalPages: number, totalCount: number, perPage: number } } };

export type SearchSingleSupplierInvoiceQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SearchSingleSupplierInvoiceQuery = { __typename?: 'Query', searchSingleSupplierInvoice: { __typename?: 'SearchSingleSupplierInvoiceResult', supplierInvoice: { __typename?: 'SupplierInvoice', id: string, attachmentId: string, issuerName?: string | null, invoiceNumber?: string | null, fileName: string, status: SupplierInvoiceStatus, source: string, attachmentCategory: SupplierInvoiceAttachmentCategory, markedAsRead?: boolean | null, createdAt: string, supplierSnapshot?: { __typename?: 'SupplierSnapshot', id: string, name: string } | null, meta?: { __typename?: 'SupplierInvoiceMeta', integrationType?: string | null, integrationName?: string | null, connector?: string | null, emailedBy?: string | null } | null, totalAmount?: { __typename?: 'Amount', value: string, currency: string } | null, suggestedTransactions?: Array<{ __typename?: 'Transaction', id: string, counterpartyName: string, emittedAt: string, operationMethod: OperationMethod, amount: { __typename?: 'Amount', value: string, currency: string } }> | null } } };

export type CountSupplierInvoicesQueryVariables = Exact<{
  view?: InputMaybe<SupplierInvoiceView>;
}>;


export type CountSupplierInvoicesQuery = { __typename?: 'Query', searchSupplierInvoices: { __typename?: 'SearchSupplierInvoicesResult', supplierInvoices: Array<{ __typename?: 'SupplierInvoice', id: string }>, meta: { __typename?: 'SearchSupplierInvoicesMeta', totalCount: number } } };

export type CountSupplierInvoicesByFiltersQueryVariables = Exact<{
  filters?: InputMaybe<SupplierInvoicesFilters>;
}>;


export type CountSupplierInvoicesByFiltersQuery = { __typename?: 'Query', searchSupplierInvoices: { __typename?: 'SearchSupplierInvoicesResult', supplierInvoices: Array<{ __typename?: 'SupplierInvoice', id: string }>, meta: { __typename?: 'SearchSupplierInvoicesMeta', totalCount: number } } };

export type SearchSupplierInvoicesListQueryVariables = Exact<{
  filters?: InputMaybe<SupplierInvoicesFilters>;
  pagination?: InputMaybe<SupplierInvoicesPagination>;
  sort?: InputMaybe<Sort>;
  query?: InputMaybe<Scalars['String']['input']>;
  queryFields?: InputMaybe<Array<SupplierInvoiceQueryField> | SupplierInvoiceQueryField>;
}>;


export type SearchSupplierInvoicesListQuery = { __typename?: 'Query', searchSupplierInvoices: { __typename?: 'SearchSupplierInvoicesResult', supplierInvoices: Array<{ __typename?: 'SupplierInvoice', id: string, organizationId: string, supplierId?: string | null, initiatorId?: string | null, status: SupplierInvoiceStatus, source: string, sourceType?: string | null, fileName: string, invoiceNumber?: string | null, issuerName?: string | null, iban?: string | null, declinedNote?: string | null, createdAt: string, updatedAt: string, analyzedAt?: string | null, issueDate?: string | null, dueDate?: string | null, paymentDate?: string | null, scheduledDate?: string | null, attachmentId: string, displayAttachmentId?: string | null, attachmentCategory: SupplierInvoiceAttachmentCategory, isAttachmentInvoice: boolean, isAttachmentNonFinancial?: boolean | null, isEinvoice: boolean, isCreditNote: boolean, hasDuplicates: boolean, hasDiscrepancies?: boolean | null, hasSuggestedCreditNotes: boolean, selfInvoiceId?: string | null, transferIds?: Array<string> | null, suggestedTransactionIds?: Array<string> | null, totalAmount?: { __typename?: 'Amount', value: string, currency: string } | null, payableAmount?: { __typename?: 'Amount', value: string, currency: string } | null, totalAmountCreditNotes?: { __typename?: 'Amount', value: string, currency: string } | null, supplierSnapshot?: { __typename?: 'SupplierSnapshot', id: string, name: string, iban?: string | null, email?: string | null, currency?: string | null, status: SupplierStatus, tin?: string | null, vatNumber?: string | null, lastTransaction?: { __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_Transaction', enrichment?: { __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichment', logo?: { __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_Logo', small: string, medium: string } | null } | null } | null } | null, meta?: { __typename?: 'SupplierInvoiceMeta', integrationName?: string | null, integrationType?: string | null, connector?: string | null, emailedBy?: string | null } | null, approvalWorkflow?: { __typename?: 'SupplierInvoiceApprovalWorkflow', approverIds: Array<string>, verifiedBy?: string | null, lastApprovedBy?: string | null, supplierInvoiceRequestId: string } | null, requestTransfer?: { __typename?: 'SupplierInvoiceRequestTransfer', id: string, initiatorId: string, type: string } | null, availableActions?: { __typename?: 'AvailableActions', delete: boolean, archive: boolean, unarchive: boolean, pay: boolean, reasons?: { __typename?: 'AvailableActionsReasons', delete?: Array<string> | null, pay?: Array<string> | null, archive?: Array<string> | null, unarchive?: Array<string> | null } | null } | null, relatedInvoices?: Array<{ __typename?: 'RelatedInvoice', id: string, invoiceNumber?: string | null, attachmentId: string, fileName: string, totalAmount?: { __typename?: 'Amount', value: string, currency: string } | null }> | null, matchedTransactions?: Array<{ __typename?: 'MatchedTransaction', transactionId: string, subjectId: string, subjectType: string }> | null }>, meta: { __typename?: 'SearchSupplierInvoicesMeta', currentPage: number, nextPage?: number | null, prevPage?: number | null, totalPages: number, totalCount: number, perPage: number } } };

export type GetSuggestedInvoicesForBillPayQueryVariables = Exact<{
  filters?: InputMaybe<SupplierInvoicesFilters>;
  pagination?: InputMaybe<SupplierInvoicesPagination>;
  sort?: InputMaybe<Sort>;
}>;


export type GetSuggestedInvoicesForBillPayQuery = { __typename?: 'Query', searchSupplierInvoices: { __typename?: 'SearchSupplierInvoicesResult', supplierInvoices: Array<{ __typename?: 'SupplierInvoice', id: string, issuerName?: string | null, dueDate?: string | null, issueDate?: string | null, source: string, isEinvoice: boolean, einvoiceFormat?: string | null, payableAmount?: { __typename?: 'Amount', currency: string, value: string } | null, supplierSnapshot?: { __typename?: 'SupplierSnapshot', name: string } | null, meta?: { __typename?: 'SupplierInvoiceMeta', integrationName?: string | null, integrationType?: string | null, connector?: string | null, emailedBy?: string | null } | null, displayAttachment?: { __typename?: 'Attachment', thumbnail?: { __typename?: 'Thumbnail', fileUrl: string } | null } | null }> } };

export type SearchTransactionsV2QueryVariables = Exact<{
  input?: InputMaybe<QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsRequestInput>;
}>;


export type SearchTransactionsV2Query = { __typename?: 'Query', searchTransactionsV2: { __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsResponse', meta: { __typename?: 'QontoCommon_PaginationMeta', totalCount: number, totalPages: number, currentPage: number, perPage: number, nextPage?: number | null, prevPage?: number | null }, transactions: Array<{ __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_Transaction', organizationId: string, bankAccountId: string, id: string, activityTag: QontoAppSystemsTransactionsFirstpartyV8_ActivityTag, counterpartyName: string, emittedAt: string, fx: boolean, rawCounterpartyName: string, operationMethod: QontoAppSystemsTransactionsFirstpartyV8_OperationMethod, operationType: QontoAppSystemsTransactionsFirstpartyV8_OperationType, description?: string | null, note?: string | null, settledAt?: string | null, side: QontoAppSystemsTransactionsFirstpartyV8_Side, slug: string, status: QontoAppSystemsTransactionsFirstpartyV8_TransactionStatus, subjectType: QontoAppSystemsTransactionsFirstpartyV8_SubjectType, declinedReason: QontoAppSystemsTransactionsFirstpartyV8_DeclinedReason, qualifiedForAccounting: boolean, attachmentIds: Array<string>, excludedFromAnalytics: boolean, isExternalTransaction: boolean, accountRemuneration?: { __typename?: 'AccountRemuneration', id: string, remuneratedMonthStartDate: string } | null, cashback?: { __typename?: 'Cashback', referenceMonthStartDate: string } | null, deferredDebitCardRepayment?: { __typename?: 'DeferredDebitCardRepayment', id: string, paidAt?: string | null, repaymentStatus: DdcStatus, scheduledAt?: string | null } | null, deferredDebitCardRepaymentDetails?: { __typename?: 'DeferredDebitCardRepaymentDetails', id: string, movementId: string, periodStart: string, periodEnd: string, totalTransactionsCount: number, capitalAmount: { __typename?: 'Amount', value: string, currency: string }, accumulatedFeesAmount: { __typename?: 'Amount', value: string, currency: string } } | null, overdraftInterestPayment?: { __typename?: 'OverdraftInterestPayment', periodStartDate: string, periodEndDate: string } | null, disputes: Array<{ __typename?: 'Dispute', claim: { __typename?: 'Claim', id: string, status: string, type: string } }>, amount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string }, billingTransfer?: { __typename?: 'BillingTransfer', operationSubtype: string, operationType: string, enrichmentData: { __typename?: 'BillingTransferEnrichmentData', isRecurring: boolean, quantity?: number | null, recurrence?: string | null, productName?: string | null } } | null, category?: { __typename?: 'CashFlowCategory', id: string, source: string, ruleId?: string | null } | null, categories?: { __typename?: 'QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_Transaction', transactionId: string, categoryAllocations: Array<{ __typename?: 'QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_CategoryAllocation', categoryId: string, amountProRataPercentage?: number | null, source: QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_AllocationSource, category?: { __typename?: 'QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_CategoryDetails', id: string, name: string, nameKey?: string | null } | null, amount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } }>, documentAllocations: Array<{ __typename?: 'QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_TransactionDocumentAllocation', attachmentId: string, categoryAllocations: Array<{ __typename?: 'QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_CategoryAllocation', categoryId: string, amountProRataPercentage?: number | null, source: QontoCashFlowManagementCashFlowCategoriesAllocationsFirstpartyV1_AllocationSource, category?: { __typename?: 'QontoCashFlowManagementCashFlowCategoriesCategoriesFirstpartyV1_CategoryDetails', id: string, name: string, nameKey?: string | null } | null, amount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } }> }> } | null, initiator?: { __typename?: 'QontoSpendManagementMembershipsMembershipsFirstpartyV1_Membership', id: string, role: QontoSpendManagementMembershipsMembershipsFirstpartyV1_MembershipRole, teamId?: string | null, teamName?: string | null, person?: { __typename?: 'Person', id: string, displayName?: string | null, fullName: string, firstName: string, lastName: string, userId: string } | null, avatar?: { __typename?: 'UserAvatar', fileUrl: string, thumbUrl: string } | null, user?: { __typename?: 'User', email: string } | null, kyc: { __typename?: 'MembershipKycStatus', kycStatus: KycStatus } } | null, enrichment?: { __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichment', isEnriched: boolean, logo?: { __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_Logo', small: string, medium: string } | null } | null, localAmount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string }, vatDetails: { __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_VatDetails', status: QontoAppSystemsTransactionsFirstpartyV8_VatStatus, totalAmount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string }, items: Array<{ __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_VatItem', id: string, rate?: number | null, amount?: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } | null, amountExcludingVat?: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } | null }> }, suggestedCategory?: { __typename?: 'SuggestedCategory', id?: string | null } | null, settledBalance?: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string } | null, statusHistory: Array<{ __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_StatusHistory', status: QontoAppSystemsTransactionsFirstpartyV8_StatusHistoryStatus, createdAt: string }>, attachmentStatus?: { __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_TransactionAttachmentStatus', attachmentLost: boolean, attachmentRequired: boolean, attachmentSuggestionIds: Array<string>, automaticallyAddedAttachmentIds: Array<string> } | null, attachmentRequest?: { __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_AttachmentRequest', requested: boolean, requestedAt?: string | null } | null, childTransactions: Array<{ __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_Transaction', id: string, counterpartyName: string, emittedAt: string, operationMethod: QontoAppSystemsTransactionsFirstpartyV8_OperationMethod, operationType: QontoAppSystemsTransactionsFirstpartyV8_OperationType, side: QontoAppSystemsTransactionsFirstpartyV8_Side, status: QontoAppSystemsTransactionsFirstpartyV8_TransactionStatus, fx: boolean, amount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string }, localAmount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string }, enrichment?: { __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichment', logo?: { __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_Logo', small: string } | null } | null }>, parentTransactions: Array<{ __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_Transaction', id: string, counterpartyName: string, emittedAt: string, operationMethod: QontoAppSystemsTransactionsFirstpartyV8_OperationMethod, operationType: QontoAppSystemsTransactionsFirstpartyV8_OperationType, side: QontoAppSystemsTransactionsFirstpartyV8_Side, status: QontoAppSystemsTransactionsFirstpartyV8_TransactionStatus, fx: boolean, amount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string }, localAmount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string }, enrichment?: { __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichment', logo?: { __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_Logo', small: string } | null } | null }>, mergedFees?: { __typename?: 'RelatedFees', feePaymentSums: { __typename?: 'FeePaymentSums', completedAmountIsZero: boolean, unsettledAmountIsZero: boolean, completedAmount: { __typename?: 'Amount', value: string, currency: string }, completedAmountVatIncluded: { __typename?: 'Amount', value: string, currency: string }, completedVatAmount: { __typename?: 'Amount', value: string, currency: string }, unsettledAmount: { __typename?: 'Amount', value: string, currency: string }, unsettledAmountVatIncluded: { __typename?: 'Amount', value: string, currency: string }, unsettledVatAmount: { __typename?: 'Amount', value: string, currency: string } }, fees: Array<{ __typename?: 'Fee', id: string, eventType: string, feeLabel: string, feeStatus: FeeStatus, feeType: FeeType, vatRate: number, amount: { __typename?: 'Amount', value: string, currency: string }, totalAmount: { __typename?: 'Amount', value: string, currency: string }, totalAmountVatIncluded: { __typename?: 'Amount', value: string, currency: string }, vatAmount: { __typename?: 'Amount', value: string, currency: string }, feePaymentSums: { __typename?: 'FeePaymentSums', completedAmountIsZero: boolean, unsettledAmountIsZero: boolean, completedAmount: { __typename?: 'Amount', value: string, currency: string }, completedAmountVatIncluded: { __typename?: 'Amount', value: string, currency: string }, completedVatAmount: { __typename?: 'Amount', value: string, currency: string }, unsettledAmount: { __typename?: 'Amount', value: string, currency: string }, unsettledAmountVatIncluded: { __typename?: 'Amount', value: string, currency: string }, unsettledVatAmount: { __typename?: 'Amount', value: string, currency: string } } }> } | null, supportedInvoiceCollector?: { __typename?: 'SupportedInvoiceCollector', type: SupportedInvoiceCollectorType, solutionInstanceStatus: SolutionInstanceStatus, integrationName: string, integrationSlug: string } | null, financingInstallment?: { __typename?: 'FinancingInstallment', createdAt: string, currentInstallmentNumber: number, totalInstallmentsNumber: number, accumulatedFeesAmount: { __typename?: 'Amount', value: string, currency: string }, capitalAmount: { __typename?: 'Amount', value: string, currency: string }, interestAmount: { __typename?: 'Amount', value: string, currency: string } } | null, attachments: Array<{ __typename?: 'Attachment', slug: string, id: string, downloadUrl: string, createdAt: string, attachmentType: string, thumbnail?: { __typename?: 'Thumbnail', fileUrl: string } | null, file?: { __typename?: 'AttachedFile', name: string, contentType: string, size: string, url: string } | null, probativeAttachment?: { __typename?: 'ProbativeAttachment', status: string, fileContentType: string, fileName: string, fileSize: string, fileUrl: string, downloadUrl: string } | null }>, supplierInvoices: Array<{ __typename?: 'SupplierInvoice', attachmentId: string }>, supplierSubscription?: { __typename?: 'SupplierSubscription', id: string } | null, supplierSubscriptionMeta?: { __typename?: 'SupplierSubscriptionMeta', eligible: boolean } | null, bankAccount?: { __typename?: 'BankAccount', id: string, bankName?: string | null, bic: string, iban: string, name: string, logo?: { __typename?: 'Logo', small: string, medium: string } | null } | null, cardAcquirerPayout?: { __typename?: 'CardAcquirerPayout', id: string, reference: string } | null, cardTransaction?: { __typename?: 'CardTransaction', movementId: string, status: string, computedStatus: string, refusalReasonGroup?: string | null } | null, check?: { __typename?: 'Check', id: string, rlmc?: string | null, emittedDate?: string | null, cmc7: { __typename?: 'Cmc7', a: string, b: string, c: string } } | null, directDebitCollection?: { __typename?: 'DirectDebitCollection', id: string, collectionDate: string, debitorIban: string, debitorBic?: string | null, debitorName: string, uniqueMandateReference: string, reference?: string | null, rTransactionType?: string | null, onHoldRate?: string | null, onHoldReleaseDate?: string | null, onHoldAmount?: { __typename?: 'Amount', value: string, currency: string } | null } | null, directDebitHold?: { __typename?: 'DirectDebitHold', id: string, onHoldRate: string, releaseDate: string, releasedAt?: string | null, amount: { __typename?: 'Amount', value: string, currency: string } } | null, income?: { __typename?: 'Income', id: string, emitterIban: string, emitterBic: string, emitterName: string, reference: string } | null, counterparty?: { __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_Counterparty', iban?: string | null, bic?: string | null } | null, pagopaPayment?: { __typename?: 'PagopaPayment', movementId: string, noticeNumber?: string | null, fiscalCode?: string | null, iuv?: string | null, creditorName?: string | null } | null, f24Payment?: { __typename?: 'F24Payment', proxied: boolean } | null, nrcPayment?: { __typename?: 'NrcPayment', movementId: string, nrc: string, taxCode: string, taxDescription: string } | null, ribaPayment?: { __typename?: 'RibaPayment', id: string, reference: string, ribaNumber: string } | null, swiftIncome?: { __typename?: 'SwiftIncome', id: string, emitterAccountIdentifier?: string | null, emitterBankIdentifier?: string | null, emitterName?: string | null, reference?: string | null, exchangeRate?: number | null } | null, card?: { __typename?: 'Card', id: string, last4: string, nickname: string, cardDesign?: string | null, cardType: CardType, cardLevel: CardLevel, status: CardStatus, holder?: { __typename?: 'LegacyMembership', id: string, fullName: string, firstName: string, lastName: string } | null, appearance?: { __typename?: 'CardAppearance', assets: { __typename?: 'CardAppearanceAssets', frontSmall: string } } | null } | null, labels: Array<{ __typename?: 'Label', id: string, name: string, listId: string, labelList: { __typename?: 'LabelList', id: string, name: string, color: string, rank: number } }>, thread?: { __typename?: 'Thread', id: string, attachedToId: string, attachedToType: string, createdAt: string, messages: Array<{ __typename?: 'Message', id: string, createdAt: string, content: string, author?: { __typename?: 'Participant', id: string, lastReadAt?: string | null, membership: { __typename?: 'LegacyMembership', fullName: string, email: string, role: string, avatar: { __typename?: 'AvatarFile', url: string }, avatarThumb: { __typename?: 'AvatarFile', url: string }, team?: { __typename?: 'Team', id: string, name: string } | null } } | null }>, participants: Array<{ __typename?: 'Participant', id: string, lastReadAt?: string | null, membershipId: string, membership: { __typename?: 'LegacyMembership', firstName: string, fullName: string, email: string, role: string, avatar: { __typename?: 'AvatarFile', url: string }, avatarThumb: { __typename?: 'AvatarFile', url: string }, team?: { __typename?: 'Team', id: string, name: string } | null } }> } | null, transfer?: { __typename?: 'Transfer', status: string, id: string, cancelable: boolean, operationType: string, fx: boolean, declinedReason?: string | null, qontoBankAccount: boolean, iban: string, bic: string, reference?: string | null, fxRate?: number | null, localAmountCurrency: string, fxPaymentPurpose?: string | null, proofPdfUrl?: string | null, beneficiary?: { __typename?: 'Beneficiary', name: string, accountNumber?: string | null, routingNumber?: string | null, sortCode?: string | null, accountType: string, iban?: string | null, bic?: string | null, hidden: boolean, country?: string | null, currency: string, creditBankAccountId?: string | null } | null, counterparty?: { __typename?: 'TransferCounterparty', name?: string | null, accountIdentifier?: string | null, bankIdentifier?: string | null, accountType?: string | null } | null } | null, directDebit?: { __typename?: 'DirectDebit', emitterBic?: string | null, emitterIban?: string | null, emitterName?: string | null, governmentOrder?: boolean | null, id: string, reference?: string | null, refundRequestedAt?: string | null, refundable: boolean, mandate?: { __typename?: 'QontoTransfersSddMandatesFirstpartyV2_Mandate', umr?: string | null } | null } | null, walletToWallet?: { __typename?: 'WalletToWallet', id: string, operationType: string, operationSubtype?: string | null } | null }> } };

export type SearchChildTransactionLinksV2QueryVariables = Exact<{
  parentTransactionId?: InputMaybe<Scalars['String']['input']>;
  linkTypes?: InputMaybe<Array<QontoAppSystemsTransactionsFirstpartyV8_LinkType> | QontoAppSystemsTransactionsFirstpartyV8_LinkType>;
  pagination?: InputMaybe<QontoCommon_PaginationInputInput>;
}>;


export type SearchChildTransactionLinksV2Query = { __typename?: 'Query', searchChildTransactionLinksV2: { __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_GetChildTransactionLinksResponse', links: Array<{ __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_TransactionLink', transaction: { __typename?: 'QontoAppSystemsTransactionsFirstpartyV8_Transaction', id: string, side: QontoAppSystemsTransactionsFirstpartyV8_Side, emittedAt: string, counterpartyName: string, attachmentIds: Array<string>, amount: { __typename?: 'QontoCommon_CurrencyAmount', value: string, currency: string }, enrichment?: { __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_TransactionEnrichment', logo?: { __typename?: 'QontoAppSystemsApiEnrichmentsFirstpartyV1_Logo', small: string } | null } | null } }>, meta: { __typename?: 'QontoCommon_PaginationMeta', currentPage: number, nextPage?: number | null, prevPage?: number | null, totalCount: number } } };

export type SearchTransactionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  pagination: Pagination;
  sort?: InputMaybe<Sort>;
  filterGroup?: InputMaybe<FilterGroupOne>;
  bankAccountIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SearchTransactionsQuery = { __typename?: 'Query', searchTransactions: { __typename?: 'SearchTransactionsResult', meta: { __typename?: 'SearchTransactionsMeta', totalCount: number, totalPages: number, currentPage: number, perPage: number, nextPage?: number | null, prevPage?: number | null }, transactions: Array<{ __typename?: 'Transaction', id: string, activityTag?: ActivityTag | null, counterpartyName: string, emittedAt: string, fx: boolean, rawCounterpartyName?: string | null, operationMethod: OperationMethod, operationType: OperationType, description?: string | null, note?: string | null, settledAt?: string | null, side: Side, slug: string, status: Status, subjectType?: SubjectType | null, qualifiedForAccounting: boolean, attachmentLost: boolean, attachmentRequired: boolean, attachmentIds: Array<string>, attachmentSuggestionIds: Array<string>, automaticallyAddedAttachmentIds: Array<string>, attachmentRequested: boolean, attachmentRequestedAt?: string | null, excludedFromAnalytics: boolean, isEnriched: boolean, accountRemuneration?: { __typename?: 'AccountRemuneration', id: string, remuneratedMonthStartDate: string } | null, cashback?: { __typename?: 'Cashback', referenceMonthStartDate: string } | null, deferredDebitCardRepayment?: { __typename?: 'DeferredDebitCardRepayment', id: string, paidAt?: string | null, repaymentStatus: DdcStatus, scheduledAt?: string | null } | null, deferredDebitCardRepaymentDetails?: { __typename?: 'DeferredDebitCardRepaymentDetails', id: string, movementId: string, periodStart: string, periodEnd: string, totalTransactionsCount: number, capitalAmount: { __typename?: 'Amount', value: string, currency: string }, accumulatedFeesAmount: { __typename?: 'Amount', value: string, currency: string } } | null, overdraftInterestPayment?: { __typename?: 'OverdraftInterestPayment', periodStartDate: string, periodEndDate: string } | null, disputes: Array<{ __typename?: 'Dispute', claim: { __typename?: 'Claim', id: string, status: string, type: string } }>, amount: { __typename?: 'Amount', value: string, currency: string }, billingTransfer?: { __typename?: 'BillingTransfer', operationSubtype: string, operationType: string } | null, categoryAssignment?: { __typename?: 'CategoryAssignment', id: string, source: string, ruleId?: string | null } | null, initiator?: { __typename?: 'LegacyMembership', id: string, fullName: string, firstName: string, lastName: string, email: string, role: string, avatar: { __typename?: 'AvatarFile', url: string }, avatarThumb: { __typename?: 'AvatarFile', url: string }, team?: { __typename?: 'Team', id: string, name: string } | null } | null, enrichmentData: { __typename?: 'EnrichmentData', logo?: { __typename?: 'Logo', small: string, medium: string } | null }, localAmount?: { __typename?: 'Amount', value: string, currency: string } | null, vat: { __typename?: 'Vat', status?: VatStatus | null, totalAmount: { __typename?: 'Amount', value: string, currency: string }, items: Array<{ __typename?: 'VatItem', id: string, transactionId: string, rate?: number | null, amount?: { __typename?: 'Amount', value: string, currency: string } | null, amountExcludingVat?: { __typename?: 'Amount', value: string, currency: string } | null }> }, suggestedCategory?: { __typename?: 'SuggestedCategory', id?: string | null } | null, settledBalance?: { __typename?: 'Amount', value: string, currency: string } | null, statusHistory: Array<{ __typename?: 'StatusHistory', status: StatusHistoryStatus, createdAt: string }>, mergedFees?: { __typename?: 'RelatedFees', feePaymentSums: { __typename?: 'FeePaymentSums', completedAmountIsZero: boolean, unsettledAmountIsZero: boolean, completedAmount: { __typename?: 'Amount', value: string, currency: string }, completedAmountVatIncluded: { __typename?: 'Amount', value: string, currency: string }, completedVatAmount: { __typename?: 'Amount', value: string, currency: string }, unsettledAmount: { __typename?: 'Amount', value: string, currency: string }, unsettledAmountVatIncluded: { __typename?: 'Amount', value: string, currency: string }, unsettledVatAmount: { __typename?: 'Amount', value: string, currency: string } }, fees: Array<{ __typename?: 'Fee', id: string, eventType: string, feeLabel: string, feeStatus: FeeStatus, feeType: FeeType, vatRate: number, amount: { __typename?: 'Amount', value: string, currency: string }, totalAmount: { __typename?: 'Amount', value: string, currency: string }, totalAmountVatIncluded: { __typename?: 'Amount', value: string, currency: string }, vatAmount: { __typename?: 'Amount', value: string, currency: string }, feePaymentSums: { __typename?: 'FeePaymentSums', completedAmountIsZero: boolean, unsettledAmountIsZero: boolean, completedAmount: { __typename?: 'Amount', value: string, currency: string }, completedAmountVatIncluded: { __typename?: 'Amount', value: string, currency: string }, completedVatAmount: { __typename?: 'Amount', value: string, currency: string }, unsettledAmount: { __typename?: 'Amount', value: string, currency: string }, unsettledAmountVatIncluded: { __typename?: 'Amount', value: string, currency: string }, unsettledVatAmount: { __typename?: 'Amount', value: string, currency: string } } }> } | null, supportedInvoiceCollector?: { __typename?: 'SupportedInvoiceCollector', type: SupportedInvoiceCollectorType, solutionInstanceStatus: SolutionInstanceStatus, integrationName: string, integrationSlug: string } | null, financingInstallment?: { __typename?: 'FinancingInstallment', createdAt: string, currentInstallmentNumber: number, totalInstallmentsNumber: number, accumulatedFeesAmount: { __typename?: 'Amount', value: string, currency: string }, capitalAmount: { __typename?: 'Amount', value: string, currency: string }, interestAmount: { __typename?: 'Amount', value: string, currency: string } } | null, attachments: Array<{ __typename?: 'Attachment', slug: string, id: string, downloadUrl: string, createdAt: string, attachmentType: string, thumbnail?: { __typename?: 'Thumbnail', fileUrl: string } | null, file?: { __typename?: 'AttachedFile', name: string, contentType: string, size: string, url: string } | null, probativeAttachment?: { __typename?: 'ProbativeAttachment', status: string, fileContentType: string, fileName: string, fileSize: string, fileUrl: string, downloadUrl: string } | null }>, bankAccount?: { __typename?: 'BankAccount', id: string, bic: string, name: string, logo?: { __typename?: 'Logo', small: string, medium: string } | null } | null, card?: { __typename?: 'Card', id: string, last4: string, nickname: string, cardDesign?: string | null, cardType: CardType, cardLevel: CardLevel, holder?: { __typename?: 'LegacyMembership', id: string, fullName: string, firstName: string, lastName: string } | null, appearance?: { __typename?: 'CardAppearance', assets: { __typename?: 'CardAppearanceAssets', frontSmall: string } } | null } | null, labels: Array<{ __typename?: 'Label', id: string, name: string, listId: string, labelList: { __typename?: 'LabelList', id: string, name: string, color: string, rank: number } }>, thread?: { __typename?: 'Thread', id: string, attachedToId: string, attachedToType: string, createdAt: string, messages: Array<{ __typename?: 'Message', id: string, createdAt: string, content: string, author?: { __typename?: 'Participant', id: string, lastReadAt?: string | null, membership: { __typename?: 'LegacyMembership', fullName: string, email: string, role: string, avatar: { __typename?: 'AvatarFile', url: string }, avatarThumb: { __typename?: 'AvatarFile', url: string }, team?: { __typename?: 'Team', id: string, name: string } | null } } | null }>, participants: Array<{ __typename?: 'Participant', id: string, lastReadAt?: string | null, membershipId: string, membership: { __typename?: 'LegacyMembership', firstName: string, fullName: string, email: string, role: string, avatar: { __typename?: 'AvatarFile', url: string }, avatarThumb: { __typename?: 'AvatarFile', url: string }, team?: { __typename?: 'Team', id: string, name: string } | null } }> } | null, transfer?: { __typename?: 'Transfer', status: string } | null, directDebit?: { __typename?: 'DirectDebit', emitterBic?: string | null, emitterIban?: string | null, emitterName?: string | null, governmentOrder?: boolean | null, id: string, reference?: string | null, refundRequestedAt?: string | null, refundable: boolean, mandate?: { __typename?: 'QontoTransfersSddMandatesFirstpartyV2_Mandate', umr?: string | null } | null } | null }> } };

export type SearchMembershipsQueryVariables = Exact<{
  input: MembershipsSearch;
}>;


export type SearchMembershipsQuery = { __typename?: 'Query', searchMemberships: { __typename?: 'SearchMembershipsResult', memberships: Array<{ __typename?: 'Membership', id: string, organizationId: string, userId?: string | null, status: MembershipStatus, role: MembershipRole, teamId?: string | null, teamName?: string | null, invitation?: { __typename?: 'Invite', id: string, recipientId: string, firstName: string, lastName: string, fullName: string, email: string, flow: InviteFlow } | null, kyc: { __typename?: 'MembershipKycStatus', membershipId: string, kycStatus: KycStatus }, avatar?: { __typename?: 'UserAvatar', userId: string, fileUrl: string, thumbUrl: string, isDefault: boolean } | null, person?: { __typename?: 'Person', id: string, displayName?: string | null, firstName: string, lastName: string, fullName: string, userId: string } | null, user?: { __typename?: 'User', id: string, email: string } | null }>, meta: { __typename?: 'SearchMembershipsMeta', currentPage: number, nextPage?: number | null, prevPage?: number | null, totalPages: number, totalCount: number, perPage: number, cursor?: string | null } } };

export type GetSingleMembershipQueryVariables = Exact<{
  input: SingleMembershipsSearch;
}>;


export type GetSingleMembershipQuery = { __typename?: 'Query', getSingleMembership?: { __typename?: 'Membership', id: string, organizationId: string, userId?: string | null, status: MembershipStatus, role: MembershipRole, teamId?: string | null, teamName?: string | null, invitation?: { __typename?: 'Invite', id: string, recipientId: string, firstName: string, lastName: string, fullName: string, email: string, flow: InviteFlow } | null, kyc: { __typename?: 'MembershipKycStatus', membershipId: string, kycStatus: KycStatus }, avatar?: { __typename?: 'UserAvatar', userId: string, fileUrl: string, thumbUrl: string, isDefault: boolean } | null, person?: { __typename?: 'Person', id: string, displayName?: string | null, firstName: string, lastName: string, fullName: string, userId: string } | null, user?: { __typename?: 'User', id: string, email: string } | null } | null };

export type SearchOrganizationSlugQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchOrganizationSlugQuery = { __typename?: 'Query', searchOrganization: { __typename?: 'SearchOrganizationResult', organization: { __typename?: 'Organization', slug: string } } };

export type SearchOrganizationQueryVariables = Exact<{
  input?: InputMaybe<OrganizationsSearch>;
  includeFinancialDetail: Scalars['Boolean']['input'];
}>;


export type SearchOrganizationQuery = { __typename?: 'Query', searchOrganization: { __typename?: 'SearchOrganizationResult', organization: { __typename?: 'Organization', id: string, name: string, slug: string, status: OrganizationStatus, createdAt: string, suspensionReason?: string | null, avatar: { __typename?: 'OrganizationAvatar', url?: string | null, thumbUrl?: string | null, isDefault?: boolean | null }, company: { __typename?: 'Company', legalName: string, legalCountry: string, legalForm?: string | null, legalNumber?: string | null, legalSector?: string | null, legalCode?: string | null, legalRegistrationDate?: string | null, legalTvaNumber?: string | null, tradeName?: string | null, contactEmail: string, websiteUrl?: string | null, activityDescription?: string | null, addresses?: Array<{ __typename?: 'Address', type: CompanyAddressType, firstLine?: string | null, secondLine?: string | null, thirdLine?: string | null, zipCode?: string | null, city?: string | null, country?: string | null } | null> | null, taxResidence?: { __typename?: 'CompanyTaxResidence', country?: string | null, taxIdentificationNumber?: string | null } | null, financialDetail?: { __typename?: 'FinancialDetail', annualTurnover?: string | null, estimatedAnnualTurnover?: string | null, estimatedYearlyIncome?: string | null, maxSinglePaymentAmount?: string | null, yearlyTransactionVolume?: string | null } | null }, customer: { __typename?: 'Customer', contractSignedAt?: string | null, natureOfOperations?: Array<string | null> | null }, kyb?: { __typename?: 'OrganizationKyb', kybStatus: KybStatus, flexKybStatus?: FlexKybStatus | null, unreferenced: boolean, ongoingKycKybUpdateProcessId?: string | null, typeformUrl?: string | null, associationTypeformFileFilledAt?: string | null } | null, features?: { __typename?: 'OrganizationFeature', features?: Array<string | null> | null } | null, onboardingPartner?: { __typename?: 'OnboardingPartner', code: string, type: OnboardingPartnerType } | null } } };

export type FetchExpenseReportQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FetchExpenseReportQuery = { __typename?: 'Query', expenseReport: { __typename?: 'SearchSingleExpenseReportResult', expenseReport: { __typename?: 'ExpenseReport', id: string, title: string, status: string, updatedAt: string, feedback?: string | null, overlappingTrip?: boolean | null, amount: { __typename?: 'Amount', value: string, currency: string }, totalVatAmount: { __typename?: 'Amount', value: string, currency: string }, items: Array<{ __typename?: 'ExpenseItem', id: string, type: string, attachmentId?: string | null, merchantName?: string | null, distanceMeters?: number | null, vatRate?: number | null, date?: string | null, note: string, createdAt: string, updatedAt: string, amount: { __typename?: 'Amount', value: string, currency: string }, attachment?: { __typename?: 'Attachment', file?: { __typename?: 'AttachedFile', contentType: string, url: string } | null } | null, vatAmount?: { __typename?: 'Amount', value: string, currency: string } | null, multiVat: Array<{ __typename?: 'ExpenseItemMultiVat', rate?: number | null, amount?: { __typename?: 'Amount', value: string, currency: string } | null, amountExcludingVat?: { __typename?: 'Amount', value: string, currency: string } | null }>, days?: Array<{ __typename?: 'PerDiemDay', date: string }> | null }> } }, myBankDetails: { __typename?: 'MyBankDetailsResult', bankDetails?: { __typename?: 'MyBankDetails', iban: string } | null } };

export type FetchExpenseReportRequestQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FetchExpenseReportRequestQuery = { __typename?: 'Query', searchSingleRequestExpenseReport: { __typename?: 'SearchSingleRequestExpenseReportResult', requestExpenseReport: { __typename?: 'RequestExpenseReport', id: string, vatRate?: number | null, approverId?: string | null, iban?: string | null, note: string, organizationId: string, reference: string, requestType: string, processedAt?: string | null, declinedNote?: string | null, status: string, requestId: string, approvalWorkflowStateId?: string | null, lastStep: boolean, amount: { __typename?: 'Amount', currency: string, value: string }, vatAmount?: { __typename?: 'Amount', currency: string, value: string } | null, attachments: Array<{ __typename?: 'Attachment', id: string, file?: { __typename?: 'AttachedFile', contentType: string, url: string } | null, probativeAttachment?: { __typename?: 'ProbativeAttachment', status: string, fileName: string, fileContentType: string, fileSize: string, fileUrl: string, downloadUrl: string } | null }>, membership: { __typename?: 'Membership', id: string, person?: { __typename?: 'Person', fullName: string, displayName?: string | null } | null }, expenseReport: { __typename?: 'ExpenseReport', id: string, title: string, status: string, initiatorID: string, feedback?: string | null, overlappingTrip?: boolean | null, createdAt: string, updatedAt: string, amount: { __typename?: 'Amount', currency: string, value: string }, totalVatAmount: { __typename?: 'Amount', currency: string, value: string }, items: Array<{ __typename?: 'ExpenseItem', id: string, type: string, merchantName?: string | null, distanceMeters?: number | null, vatRate?: number | null, date?: string | null, note: string, createdAt: string, updatedAt: string, amount: { __typename?: 'Amount', value: string, currency: string }, attachment?: { __typename?: 'Attachment', id: string, file?: { __typename?: 'AttachedFile', contentType: string, url: string } | null, probativeAttachment?: { __typename?: 'ProbativeAttachment', fileContentType: string, fileUrl: string, status: string, downloadUrl: string } | null } | null, vatAmount?: { __typename?: 'Amount', value: string, currency: string } | null, multiVat: Array<{ __typename?: 'ExpenseItemMultiVat', rate?: number | null, amount?: { __typename?: 'Amount', value: string, currency: string } | null, amountExcludingVat?: { __typename?: 'Amount', value: string, currency: string } | null }> }> } } }, myBankDetails: { __typename?: 'MyBankDetailsResult', bankDetails?: { __typename?: 'MyBankDetails', iban: string } | null } };


export const SearchSingleSupplierSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchSingleSupplierSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSingleSupplierSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"counterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"nextPaymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExternalTransaction"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"embossedName"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"cardLevel"}},{"kind":"Field","name":{"kind":"Name","value":"cardDesign"}},{"kind":"Field","name":{"kind":"Name","value":"holder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hasOnlyUserLiftableLocks"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchSingleSupplierSubscriptionQuery, SearchSingleSupplierSubscriptionQueryVariables>;
export const SearchSupplierSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchSupplierSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierSubscriptionsPagination"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Sort"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSupplierSubscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"counterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"nextPaymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isExternalTransaction"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"embossedName"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"cardLevel"}},{"kind":"Field","name":{"kind":"Name","value":"cardDesign"}},{"kind":"Field","name":{"kind":"Name","value":"holder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"hasOnlyUserLiftableLocks"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchSupplierSubscriptionsQuery, SearchSupplierSubscriptionsQueryVariables>;
export const GetProjectMembershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProjectMembership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SingleMembershipsSearch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSingleMembership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"flow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kyc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipId"}},{"kind":"Field","name":{"kind":"Name","value":"kycStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"teamName"}}]}}]}}]} as unknown as DocumentNode<GetProjectMembershipQuery, GetProjectMembershipQueryVariables>;
export const ListAccountancyPracticeObligationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listAccountancyPracticeObligations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeObligationsRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAccountancyPracticeObligations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"obligations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"obligationSubtype"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"filingDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}}]} as unknown as DocumentNode<ListAccountancyPracticeObligationsQuery, ListAccountancyPracticeObligationsQueryVariables>;
export const GetMembershipAvatarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getMembershipAvatar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSingleMembership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GetMembershipAvatarQuery, GetMembershipAvatarQueryVariables>;
export const ListAccountancyPracticeConversationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listAccountancyPracticeConversations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeConversationsRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAccountancyPracticeConversations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessageAt"}},{"kind":"Field","name":{"kind":"Name","value":"isLastMessageSeen"}},{"kind":"Field","name":{"kind":"Name","value":"lastMessageText"}},{"kind":"Field","name":{"kind":"Name","value":"isLastMessageFromAccountant"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"legalForm"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stakeholders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stakeholders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}}]} as unknown as DocumentNode<ListAccountancyPracticeConversationsQuery, ListAccountancyPracticeConversationsQueryVariables>;
export const GetLedgerEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLedgerEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QontoAccountingEntriesFirstpartyV2_GetEntriesRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLedgerEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"recordDate"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"counterPartyName"}},{"kind":"Field","name":{"kind":"Name","value":"entryTitle"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastVerifiedAttemptAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"documentIncludingTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountingTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountingIncludingTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"journal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"way"}},{"kind":"Field","name":{"kind":"Name","value":"taxRatePercent"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxBaseAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"isAuxiliary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"auxiliaryAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"isAuxiliary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayedAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"isAuxiliary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integrationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"ackValidation"}},{"kind":"Field","name":{"kind":"Name","value":"rejectionLog"}},{"kind":"Field","name":{"kind":"Name","value":"rejectionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"howToFix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reconciliations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetLedgerEntriesQuery, GetLedgerEntriesQueryVariables>;
export const GetJournalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getJournals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeAccount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeBankAccount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDeleted"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getJournals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"includeDeleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDeleted"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"journals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"deletedAt"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDeleted"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"bankAccount"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeBankAccount"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"bic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAccount"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetJournalsQuery, GetJournalsQueryVariables>;
export const GetSoloLedgerEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSoloLedgerEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QontoAccountingEntriesFirstpartyV2_GetEntriesRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLedgerEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"recordDate"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"counterPartyName"}},{"kind":"Field","name":{"kind":"Name","value":"entryTitle"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"cashFlow"}},{"kind":"Field","name":{"kind":"Name","value":"documentIncludingTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountingTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountingIncludingTaxAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"journal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"way"}},{"kind":"Field","name":{"kind":"Name","value":"taxRatePercent"}},{"kind":"Field","name":{"kind":"Name","value":"lineType"}},{"kind":"Field","name":{"kind":"Name","value":"categoryKey"}},{"kind":"Field","name":{"kind":"Name","value":"taxDeductibilityRatePercent"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxBaseAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"isAuxiliary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"auxiliaryAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"isAuxiliary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayedAccounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"isAuxiliary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"integrationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"ackValidation"}},{"kind":"Field","name":{"kind":"Name","value":"rejectionLog"}},{"kind":"Field","name":{"kind":"Name","value":"rejectionType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"howToFix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reconciliations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetSoloLedgerEntriesQuery, GetSoloLedgerEntriesQueryVariables>;
export const SubscriptionChangeEstimateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubscriptionChangeEstimate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QontoPricingSubscriptionsFirstpartyV6_EstimateSubscriptionChangeRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionChangeEstimate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"basketId"}},{"kind":"Field","name":{"kind":"Name","value":"billingMilestones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"isNegative"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"billingTags"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentCoreSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"marketingContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isUpsell"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isEligibleForVoucherCode"}},{"kind":"Field","name":{"kind":"Name","value":"priceBreakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subTitle"}},{"kind":"Field","name":{"kind":"Name","value":"isNegative"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"isNegative"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestedSubscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"productCode"}},{"kind":"Field","name":{"kind":"Name","value":"productGroupCode"}},{"kind":"Field","name":{"kind":"Name","value":"recurrence"}},{"kind":"Field","name":{"kind":"Name","value":"basePrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountedPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialOffers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"properties"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketingContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isUpsell"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isComparable"}},{"kind":"Field","name":{"kind":"Name","value":"flow"}},{"kind":"Field","name":{"kind":"Name","value":"discontinuedProduct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetSubscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"productCode"}},{"kind":"Field","name":{"kind":"Name","value":"productGroupCode"}},{"kind":"Field","name":{"kind":"Name","value":"recurrence"}},{"kind":"Field","name":{"kind":"Name","value":"basePrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discountedPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"specialOffers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"properties"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"marketingContent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"brandName"}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isUpsell"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isComparable"}},{"kind":"Field","name":{"kind":"Name","value":"flow"}},{"kind":"Field","name":{"kind":"Name","value":"discontinuedProduct"}}]}},{"kind":"Field","name":{"kind":"Name","value":"warnings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"additionalData"}}]}}]}}]}}]} as unknown as DocumentNode<SubscriptionChangeEstimateQuery, SubscriptionChangeEstimateQueryVariables>;
export const SearchCashFlowTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchCashFlowTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchTransactionsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"counterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"rawCounterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"emittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"operationMethod"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matchedExpectedTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"counterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"providerObjectType"}},{"kind":"Field","name":{"kind":"Name","value":"providerObjectId"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchCashFlowTransactionsQuery, SearchCashFlowTransactionsQueryVariables>;
export const ListRecentAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListRecentAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processingStatuses"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QontoCashFlowManagementAttachmentsFirstpartyV4_Attachment_ProcessingStatus"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAttachments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"processingStatuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processingStatuses"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"creationSource"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"initiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}}]} as unknown as DocumentNode<ListRecentAttachmentsQuery, ListRecentAttachmentsQueryVariables>;
export const ListStorageAttachmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListStorageAttachments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"types"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAttachments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"types"},"value":{"kind":"Variable","name":{"kind":"Name","value":"types"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"creationSource"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}}]} as unknown as DocumentNode<ListStorageAttachmentsQuery, ListStorageAttachmentsQueryVariables>;
export const GetEsimDataPackagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEsimDataPackages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QontoCardsIssuingEsimFirstpartyV1_GetDataPackagesRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEsimDataPackages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataPackages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"holder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"validity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coverageZone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"usage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}}]}}]}}]}}]} as unknown as DocumentNode<GetEsimDataPackagesQuery, GetEsimDataPackagesQueryVariables>;
export const ListAccountancyPracticeAccountingSetupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"listAccountancyPracticeAccountingSetups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QontoAccountingAccountancyPracticesFirstpartyV2_ListAccountancyPracticeAccountingSetupsRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listAccountancyPracticeAccountingSetups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountingSetup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountancyPracticeId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"activatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"activatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"vatRegime"}},{"kind":"Field","name":{"kind":"Name","value":"vatExigibility"}},{"kind":"Field","name":{"kind":"Name","value":"taxRegime"}},{"kind":"Field","name":{"kind":"Name","value":"firstAccountingPeriodStartAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstAccountingPeriodEndAt"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"taxMemoAttachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentIban"}},{"kind":"Field","name":{"kind":"Name","value":"rofVat"}},{"kind":"Field","name":{"kind":"Name","value":"rofCorporateTax"}},{"kind":"Field","name":{"kind":"Name","value":"rofTaxReturnPackage"}},{"kind":"Field","name":{"kind":"Name","value":"rofCfe"}},{"kind":"Field","name":{"kind":"Name","value":"hasCompletedDeclaration"}},{"kind":"Field","name":{"kind":"Name","value":"periodDatesValidatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"accountancyPracticeOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"suspensionReason"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"legalName"}},{"kind":"Field","name":{"kind":"Name","value":"legalForm"}},{"kind":"Field","name":{"kind":"Name","value":"legalCode"}},{"kind":"Field","name":{"kind":"Name","value":"legalSector"}},{"kind":"Field","name":{"kind":"Name","value":"legalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"legalRegistrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"legalCountry"}},{"kind":"Field","name":{"kind":"Name","value":"tradeName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"activityDescription"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"legalTvaNumber"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstLine"}},{"kind":"Field","name":{"kind":"Name","value":"secondLine"}},{"kind":"Field","name":{"kind":"Name","value":"thirdLine"}},{"kind":"Field","name":{"kind":"Name","value":"zipcode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimatedYearlyIncome"}},{"kind":"Field","name":{"kind":"Name","value":"annualTurnover"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyTransactionVolume"}},{"kind":"Field","name":{"kind":"Name","value":"maxSinglePaymentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedAnnualTurnover"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxResidence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"taxIdentificationNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"stakeholders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"stakeholders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"onboardingSteps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stepCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}}]} as unknown as DocumentNode<ListAccountancyPracticeAccountingSetupsQuery, ListAccountancyPracticeAccountingSetupsQueryVariables>;
export const ListObligationOperationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ListObligationOperations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QontoAccountingObligationsFirstpartyV2_ListOperationsRequestInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeCategoryAllocations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listObligationOperations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accountingAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"direction"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"isVerified"}},{"kind":"Field","name":{"kind":"Name","value":"matchedResources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"}},{"kind":"Field","name":{"kind":"Name","value":"transactions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"internalReferenceId"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachmentLost"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentRequired"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionCategoryAllocations"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCategoryAllocations"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"categoryAllocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentCategoryAllocations"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeCategoryAllocations"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"categoryAllocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}}]}}]}}]}}]} as unknown as DocumentNode<ListObligationOperationsQuery, ListObligationOperationsQueryVariables>;
export const GetSingleReceivableInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSingleReceivableInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SingleReceivableInvoicesSearch"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includePaymentLinkDetails"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeInvoiceSubscription"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDirectDebitMandate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSingleReceivableInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"issueDate"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"einvoicingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiaryName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrder"}},{"kind":"Field","name":{"kind":"Name","value":"referralLink"}},{"kind":"Field","name":{"kind":"Name","value":"intermediaryBankBic"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"bic"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"overdue"}},{"kind":"Field","name":{"kind":"Name","value":"isPdfGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"isHiddenFromClientPortal"}},{"kind":"Field","name":{"kind":"Name","value":"directDebitEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"hasDuplicates"}},{"kind":"Field","name":{"kind":"Name","value":"imported"}},{"kind":"Field","name":{"kind":"Name","value":"isEinvoice"}},{"kind":"Field","name":{"kind":"Name","value":"isDeposit"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"nextReminderDate"}},{"kind":"Field","name":{"kind":"Name","value":"performanceDate"}},{"kind":"Field","name":{"kind":"Name","value":"performanceStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"performanceEndDate"}},{"kind":"Field","name":{"kind":"Name","value":"accountingRecordedAt"}},{"kind":"Field","name":{"kind":"Name","value":"importAnalyzedAt"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceType"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"quoteId"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceSubscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"directDebitSubscriptionId"}},{"kind":"Field","name":{"kind":"Name","value":"directDebitCollectionMandateId"}},{"kind":"Field","name":{"kind":"Name","value":"depositInvoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"receivableInvoicingUploadId"}},{"kind":"Field","name":{"kind":"Name","value":"termsConditionsUploadId"}},{"kind":"Field","name":{"kind":"Name","value":"previousPartialInvoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"lastPartialInvoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"receivableCreditNoteIds"}},{"kind":"Field","name":{"kind":"Name","value":"balanceInvoiceIds"}},{"kind":"Field","name":{"kind":"Name","value":"partialInvoiceIds"}},{"kind":"Field","name":{"kind":"Name","value":"subtotalBeforeDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountDue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountPaid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stampDutyAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"method"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"welfareFund"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"withholdingTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativeAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainingSubtotalBeforeDiscount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainingSubtotalBeforeDiscountPercentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customerSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"tinNumber"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"legalName"}},{"kind":"Field","name":{"kind":"Name","value":"legalForm"}},{"kind":"Field","name":{"kind":"Name","value":"legalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"legalCountry"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}},{"kind":"Field","name":{"kind":"Name","value":"districtCourt"}},{"kind":"Field","name":{"kind":"Name","value":"companyLeadership"}},{"kind":"Field","name":{"kind":"Name","value":"commercialRegisterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"legalCapitalShare"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatPaymentCondition"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"taxNumber"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"addressZipcode"}},{"kind":"Field","name":{"kind":"Name","value":"addressCity"}},{"kind":"Field","name":{"kind":"Name","value":"addressCountry"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"methods"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}},{"kind":"Field","name":{"kind":"Name","value":"vatExemptionCode"}},{"kind":"Field","name":{"kind":"Name","value":"totalVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subtotal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"progress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"percentage"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cumulativePercentage"}},{"kind":"Field","name":{"kind":"Name","value":"cumulativeAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainingAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"remainingPercentage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"einvoicingLifecycleEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"reasonCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"actionNeeded"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentLinkDetails"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includePaymentLinkDetails"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"recurrenceType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}},{"kind":"Field","name":{"kind":"Name","value":"debitorName"}},{"kind":"Field","name":{"kind":"Name","value":"latestPaymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"potentialPaymentMethods"}},{"kind":"Field","name":{"kind":"Name","value":"paymentInitiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"resourceType"}},{"kind":"Field","name":{"kind":"Name","value":"resourceNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"measureUnit"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recurrenceSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frequencyRecurrence"}},{"kind":"Field","name":{"kind":"Name","value":"frequencyValue"}},{"kind":"Field","name":{"kind":"Name","value":"times"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invoiceSubscription"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeInvoiceSubscription"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"nextInvoiceDate"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceStatus"}},{"kind":"Field","name":{"kind":"Name","value":"customerName"}},{"kind":"Field","name":{"kind":"Name","value":"paymentTermsDays"}},{"kind":"Field","name":{"kind":"Name","value":"purchaseOrder"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiaryName"}},{"kind":"Field","name":{"kind":"Name","value":"termsAndConditions"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"header"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"directDebitEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"isEinvoice"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"frequency"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"recurrence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emailTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailTitle"}},{"kind":"Field","name":{"kind":"Name","value":"emailBody"}},{"kind":"Field","name":{"kind":"Name","value":"sendTo"}},{"kind":"Field","name":{"kind":"Name","value":"copyToSelf"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"method"}}]}},{"kind":"Field","name":{"kind":"Name","value":"welfareFund"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"withholdingTax"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stampDutyAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountDue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"methods"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}},{"kind":"Field","name":{"kind":"Name","value":"vatExemptionCode"}},{"kind":"Field","name":{"kind":"Name","value":"productId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"directDebitCollectionMandate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDirectDebitMandate"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueMandateReference"}},{"kind":"Field","name":{"kind":"Name","value":"creditorIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"mandateSignatureDate"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"recurrenceType"}},{"kind":"Field","name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"clientIbanLastDigits"}},{"kind":"Field","name":{"kind":"Name","value":"clientBic"}},{"kind":"Field","name":{"kind":"Name","value":"clientSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"provinceCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine_1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine_2"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine_3"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectionDate"}},{"kind":"Field","name":{"kind":"Name","value":"isOverdue"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifyClient"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleCustomUnit"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleTotalCollectionCount"}},{"kind":"Field","name":{"kind":"Name","value":"scheduleType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}}]}}]}}]}}]} as unknown as DocumentNode<GetSingleReceivableInvoiceQuery, GetSingleReceivableInvoiceQueryVariables>;
export const SearchDocumentsToReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchDocumentsToReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierInvoicesFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierInvoicesPagination"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSupplierInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issuerName"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentCategory"}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationType"}},{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"connector"}},{"kind":"Field","name":{"kind":"Name","value":"emailedBy"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}}]} as unknown as DocumentNode<SearchDocumentsToReviewQuery, SearchDocumentsToReviewQueryVariables>;
export const SearchSingleSupplierInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchSingleSupplierInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSingleSupplierInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierInvoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"issuerName"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentCategory"}},{"kind":"Field","name":{"kind":"Name","value":"markedAsRead"}},{"kind":"Field","name":{"kind":"Name","value":"supplierSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationType"}},{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"connector"}},{"kind":"Field","name":{"kind":"Name","value":"emailedBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suggestedTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"counterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"emittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"operationMethod"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchSingleSupplierInvoiceQuery, SearchSingleSupplierInvoiceQueryVariables>;
export const CountSupplierInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"countSupplierInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"view"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierInvoiceView"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSupplierInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"view"},"value":{"kind":"Variable","name":{"kind":"Name","value":"view"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"1"}},{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"IntValue","value":"1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<CountSupplierInvoicesQuery, CountSupplierInvoicesQueryVariables>;
export const CountSupplierInvoicesByFiltersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"countSupplierInvoicesByFilters"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierInvoicesFilters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSupplierInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"perPage"},"value":{"kind":"IntValue","value":"1"}},{"kind":"ObjectField","name":{"kind":"Name","value":"page"},"value":{"kind":"IntValue","value":"1"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<CountSupplierInvoicesByFiltersQuery, CountSupplierInvoicesByFiltersQueryVariables>;
export const SearchSupplierInvoicesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchSupplierInvoicesList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierInvoicesFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierInvoicesPagination"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Sort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queryFields"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierInvoiceQueryField"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSupplierInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"queryFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queryFields"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"supplierId"}},{"kind":"Field","name":{"kind":"Name","value":"initiatorId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"sourceType"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"issuerName"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"declinedNote"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"analyzedAt"}},{"kind":"Field","name":{"kind":"Name","value":"issueDate"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"paymentDate"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledDate"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"displayAttachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentCategory"}},{"kind":"Field","name":{"kind":"Name","value":"isAttachmentInvoice"}},{"kind":"Field","name":{"kind":"Name","value":"isAttachmentNonFinancial"}},{"kind":"Field","name":{"kind":"Name","value":"isEinvoice"}},{"kind":"Field","name":{"kind":"Name","value":"isCreditNote"}},{"kind":"Field","name":{"kind":"Name","value":"hasDuplicates"}},{"kind":"Field","name":{"kind":"Name","value":"hasDiscrepancies"}},{"kind":"Field","name":{"kind":"Name","value":"hasSuggestedCreditNotes"}},{"kind":"Field","name":{"kind":"Name","value":"selfInvoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountCreditNotes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tin"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastTransaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enrichment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"integrationType"}},{"kind":"Field","name":{"kind":"Name","value":"connector"}},{"kind":"Field","name":{"kind":"Name","value":"emailedBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approvalWorkflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approverIds"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastApprovedBy"}},{"kind":"Field","name":{"kind":"Name","value":"supplierInvoiceRequestId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestTransfer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiatorId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"availableActions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete"}},{"kind":"Field","name":{"kind":"Name","value":"archive"}},{"kind":"Field","name":{"kind":"Name","value":"unarchive"}},{"kind":"Field","name":{"kind":"Name","value":"pay"}},{"kind":"Field","name":{"kind":"Name","value":"reasons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete"}},{"kind":"Field","name":{"kind":"Name","value":"pay"}},{"kind":"Field","name":{"kind":"Name","value":"archive"}},{"kind":"Field","name":{"kind":"Name","value":"unarchive"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transferIds"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedTransactionIds"}},{"kind":"Field","name":{"kind":"Name","value":"matchedTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"subjectId"}},{"kind":"Field","name":{"kind":"Name","value":"subjectType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}}]}}]}}]} as unknown as DocumentNode<SearchSupplierInvoicesListQuery, SearchSupplierInvoicesListQueryVariables>;
export const GetSuggestedInvoicesForBillPayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSuggestedInvoicesForBillPay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierInvoicesFilters"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierInvoicesPagination"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Sort"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSupplierInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issuerName"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"issueDate"}},{"kind":"Field","name":{"kind":"Name","value":"payableAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"isEinvoice"}},{"kind":"Field","name":{"kind":"Name","value":"einvoiceFormat"}},{"kind":"Field","name":{"kind":"Name","value":"supplierSnapshot"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"integrationType"}},{"kind":"Field","name":{"kind":"Name","value":"connector"}},{"kind":"Field","name":{"kind":"Name","value":"emailedBy"}}]}},{"kind":"Field","name":{"kind":"Name","value":"displayAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSuggestedInvoicesForBillPayQuery, GetSuggestedInvoicesForBillPayQueryVariables>;
export const SearchTransactionsV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchTransactionsV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QontoAppSystemsTransactionsFirstpartyV8_SearchTransactionsRequestInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchTransactionsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"bankAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"accountRemuneration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"remuneratedMonthStartDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cashback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceMonthStartDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deferredDebitCardRepayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"repaymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deferredDebitCardRepaymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"movementId"}},{"kind":"Field","name":{"kind":"Name","value":"capitalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accumulatedFeesAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periodStart"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"totalTransactionsCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"overdraftInterestPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"periodEndDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disputes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"claim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingTransfer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operationSubtype"}},{"kind":"Field","name":{"kind":"Name","value":"operationType"}},{"kind":"Field","name":{"kind":"Name","value":"enrichmentData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isRecurring"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"recurrence"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"ruleId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"categoryAllocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameKey"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountProRataPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentAllocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"categoryAllocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nameKey"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountProRataPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kyc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kycStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"teamName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"activityTag"}},{"kind":"Field","name":{"kind":"Name","value":"counterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"emittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"enrichment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isEnriched"}}]}},{"kind":"Field","name":{"kind":"Name","value":"localAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fx"}},{"kind":"Field","name":{"kind":"Name","value":"vatDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountExcludingVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rawCounterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"operationMethod"}},{"kind":"Field","name":{"kind":"Name","value":"operationType"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"settledAt"}},{"kind":"Field","name":{"kind":"Name","value":"settledBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subjectType"}},{"kind":"Field","name":{"kind":"Name","value":"declinedReason"}},{"kind":"Field","name":{"kind":"Name","value":"qualifiedForAccounting"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachmentLost"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentRequired"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentSuggestionIds"}},{"kind":"Field","name":{"kind":"Name","value":"automaticallyAddedAttachmentIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requested"}},{"kind":"Field","name":{"kind":"Name","value":"requestedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"childTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"counterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"emittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"operationMethod"}},{"kind":"Field","name":{"kind":"Name","value":"operationType"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fx"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"localAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enrichment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentTransactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"counterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"emittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"operationMethod"}},{"kind":"Field","name":{"kind":"Name","value":"operationType"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fx"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"localAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"enrichment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mergedFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feePaymentSums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedAmountIsZero"}},{"kind":"Field","name":{"kind":"Name","value":"completedAmountVatIncluded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmountIsZero"}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmountVatIncluded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"feeLabel"}},{"kind":"Field","name":{"kind":"Name","value":"feeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"feeType"}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountVatIncluded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feePaymentSums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedAmountIsZero"}},{"kind":"Field","name":{"kind":"Name","value":"completedAmountVatIncluded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmountIsZero"}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmountVatIncluded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"excludedFromAnalytics"}},{"kind":"Field","name":{"kind":"Name","value":"supportedInvoiceCollector"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"solutionInstanceStatus"}},{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"integrationSlug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financingInstallment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accumulatedFeesAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"capitalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currentInstallmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"interestAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalInstallmentsNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"probativeAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fileContentType"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attachmentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierSubscriptionMeta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eligible"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bankAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bankName"}},{"kind":"Field","name":{"kind":"Name","value":"bic"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cardAcquirerPayout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cardTransaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"movementId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"computedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"refusalReasonGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"check"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cmc7"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"a"}},{"kind":"Field","name":{"kind":"Name","value":"b"}},{"kind":"Field","name":{"kind":"Name","value":"c"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rlmc"}},{"kind":"Field","name":{"kind":"Name","value":"emittedDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"directDebitCollection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collectionDate"}},{"kind":"Field","name":{"kind":"Name","value":"debitorIban"}},{"kind":"Field","name":{"kind":"Name","value":"debitorBic"}},{"kind":"Field","name":{"kind":"Name","value":"debitorName"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueMandateReference"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"rTransactionType"}},{"kind":"Field","name":{"kind":"Name","value":"onHoldAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onHoldRate"}},{"kind":"Field","name":{"kind":"Name","value":"onHoldReleaseDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"directDebitHold"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onHoldRate"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}},{"kind":"Field","name":{"kind":"Name","value":"releasedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"income"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emitterIban"}},{"kind":"Field","name":{"kind":"Name","value":"emitterBic"}},{"kind":"Field","name":{"kind":"Name","value":"emitterName"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"counterparty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"bic"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isExternalTransaction"}},{"kind":"Field","name":{"kind":"Name","value":"pagopaPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"movementId"}},{"kind":"Field","name":{"kind":"Name","value":"noticeNumber"}},{"kind":"Field","name":{"kind":"Name","value":"fiscalCode"}},{"kind":"Field","name":{"kind":"Name","value":"iuv"}},{"kind":"Field","name":{"kind":"Name","value":"creditorName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"f24Payment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"proxied"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nrcPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"movementId"}},{"kind":"Field","name":{"kind":"Name","value":"nrc"}},{"kind":"Field","name":{"kind":"Name","value":"taxCode"}},{"kind":"Field","name":{"kind":"Name","value":"taxDescription"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ribaPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"ribaNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"swiftIncome"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emitterAccountIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"emitterBankIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"emitterName"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"exchangeRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"holder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cardDesign"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"cardLevel"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"appearance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frontSmall"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"labelList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachedToId"}},{"kind":"Field","name":{"kind":"Name","value":"attachedToType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastReadAt"}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastReadAt"}},{"kind":"Field","name":{"kind":"Name","value":"membershipId"}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transfer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cancelable"}},{"kind":"Field","name":{"kind":"Name","value":"operationType"}},{"kind":"Field","name":{"kind":"Name","value":"fx"}},{"kind":"Field","name":{"kind":"Name","value":"declinedReason"}},{"kind":"Field","name":{"kind":"Name","value":"qontoBankAccount"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"bic"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"fxRate"}},{"kind":"Field","name":{"kind":"Name","value":"localAmountCurrency"}},{"kind":"Field","name":{"kind":"Name","value":"fxPaymentPurpose"}},{"kind":"Field","name":{"kind":"Name","value":"proofPdfUrl"}},{"kind":"Field","name":{"kind":"Name","value":"beneficiary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountNumber"}},{"kind":"Field","name":{"kind":"Name","value":"routingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"sortCode"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"bic"}},{"kind":"Field","name":{"kind":"Name","value":"hidden"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"creditBankAccountId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"counterparty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accountIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"bankIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"accountType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"directDebit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emitterBic"}},{"kind":"Field","name":{"kind":"Name","value":"emitterIban"}},{"kind":"Field","name":{"kind":"Name","value":"emitterName"}},{"kind":"Field","name":{"kind":"Name","value":"governmentOrder"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mandate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"umr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"refundRequestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"refundable"}}]}},{"kind":"Field","name":{"kind":"Name","value":"walletToWallet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"operationType"}},{"kind":"Field","name":{"kind":"Name","value":"operationSubtype"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchTransactionsV2Query, SearchTransactionsV2QueryVariables>;
export const SearchChildTransactionLinksV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchChildTransactionLinksV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentTransactionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QontoAppSystemsTransactionsFirstpartyV8_LinkType"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QontoCommon_PaginationInputInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchChildTransactionLinksV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"parentTransactionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentTransactionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"linkTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkTypes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transaction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"counterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"enrichment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]} as unknown as DocumentNode<SearchChildTransactionLinksV2Query, SearchChildTransactionLinksV2QueryVariables>;
export const SearchTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Sort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filterGroup"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterGroupOne"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchTransactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"filterGroup"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filterGroup"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"bankAccountIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bankAccountIds"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountRemuneration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"remuneratedMonthStartDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cashback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referenceMonthStartDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deferredDebitCardRepayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"paidAt"}},{"kind":"Field","name":{"kind":"Name","value":"repaymentStatus"}},{"kind":"Field","name":{"kind":"Name","value":"scheduledAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deferredDebitCardRepaymentDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"movementId"}},{"kind":"Field","name":{"kind":"Name","value":"capitalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accumulatedFeesAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"periodStart"}},{"kind":"Field","name":{"kind":"Name","value":"periodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"totalTransactionsCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"overdraftInterestPayment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"periodStartDate"}},{"kind":"Field","name":{"kind":"Name","value":"periodEndDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"disputes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"claim"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingTransfer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operationSubtype"}},{"kind":"Field","name":{"kind":"Name","value":"operationType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoryAssignment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"ruleId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"initiator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"activityTag"}},{"kind":"Field","name":{"kind":"Name","value":"counterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"emittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"enrichmentData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"localAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fx"}},{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountExcludingVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rawCounterpartyName"}},{"kind":"Field","name":{"kind":"Name","value":"operationMethod"}},{"kind":"Field","name":{"kind":"Name","value":"operationType"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"settledAt"}},{"kind":"Field","name":{"kind":"Name","value":"settledBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"side"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"statusHistory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subjectType"}},{"kind":"Field","name":{"kind":"Name","value":"qualifiedForAccounting"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentLost"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentRequired"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentSuggestionIds"}},{"kind":"Field","name":{"kind":"Name","value":"automaticallyAddedAttachmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentRequested"}},{"kind":"Field","name":{"kind":"Name","value":"attachmentRequestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"mergedFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feePaymentSums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedAmountIsZero"}},{"kind":"Field","name":{"kind":"Name","value":"completedAmountVatIncluded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmountIsZero"}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmountVatIncluded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"fees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"feeLabel"}},{"kind":"Field","name":{"kind":"Name","value":"feeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"feeType"}},{"kind":"Field","name":{"kind":"Name","value":"totalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalAmountVatIncluded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}},{"kind":"Field","name":{"kind":"Name","value":"feePaymentSums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedAmountIsZero"}},{"kind":"Field","name":{"kind":"Name","value":"completedAmountVatIncluded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"completedVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmountIsZero"}},{"kind":"Field","name":{"kind":"Name","value":"unsettledAmountVatIncluded"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unsettledVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"excludedFromAnalytics"}},{"kind":"Field","name":{"kind":"Name","value":"isEnriched"}},{"kind":"Field","name":{"kind":"Name","value":"supportedInvoiceCollector"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"solutionInstanceStatus"}},{"kind":"Field","name":{"kind":"Name","value":"integrationName"}},{"kind":"Field","name":{"kind":"Name","value":"integrationSlug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financingInstallment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accumulatedFeesAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"capitalAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currentInstallmentNumber"}},{"kind":"Field","name":{"kind":"Name","value":"interestAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalInstallmentsNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"probativeAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fileContentType"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachmentType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bankAccount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bic"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"small"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"nickname"}},{"kind":"Field","name":{"kind":"Name","value":"holder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cardDesign"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"cardLevel"}},{"kind":"Field","name":{"kind":"Name","value":"appearance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frontSmall"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"labelList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}},{"kind":"Field","name":{"kind":"Name","value":"listId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"thread"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"attachedToId"}},{"kind":"Field","name":{"kind":"Name","value":"attachedToType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastReadAt"}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastReadAt"}},{"kind":"Field","name":{"kind":"Name","value":"membershipId"}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transfer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"directDebit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emitterBic"}},{"kind":"Field","name":{"kind":"Name","value":"emitterIban"}},{"kind":"Field","name":{"kind":"Name","value":"emitterName"}},{"kind":"Field","name":{"kind":"Name","value":"governmentOrder"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mandate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"umr"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"refundRequestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"refundable"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchTransactionsQuery, SearchTransactionsQueryVariables>;
export const SearchMembershipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchMemberships"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MembershipsSearch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchMemberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"flow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kyc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipId"}},{"kind":"Field","name":{"kind":"Name","value":"kycStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"teamName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"nextPage"}},{"kind":"Field","name":{"kind":"Name","value":"prevPage"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}},{"kind":"Field","name":{"kind":"Name","value":"cursor"}}]}}]}}]}}]} as unknown as DocumentNode<SearchMembershipsQuery, SearchMembershipsQueryVariables>;
export const GetSingleMembershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSingleMembership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SingleMembershipsSearch"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSingleMembership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recipientId"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"flow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kyc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"membershipId"}},{"kind":"Field","name":{"kind":"Name","value":"kycStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"thumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"teamName"}}]}}]}}]} as unknown as DocumentNode<GetSingleMembershipQuery, GetSingleMembershipQueryVariables>;
export const SearchOrganizationSlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchOrganizationSlug"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<SearchOrganizationSlugQuery, SearchOrganizationSlugQueryVariables>;
export const SearchOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationsSearch"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeFinancialDetail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"suspensionReason"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"legalName"}},{"kind":"Field","name":{"kind":"Name","value":"legalCountry"}},{"kind":"Field","name":{"kind":"Name","value":"legalForm"}},{"kind":"Field","name":{"kind":"Name","value":"legalNumber"}},{"kind":"Field","name":{"kind":"Name","value":"legalSector"}},{"kind":"Field","name":{"kind":"Name","value":"legalCode"}},{"kind":"Field","name":{"kind":"Name","value":"legalRegistrationDate"}},{"kind":"Field","name":{"kind":"Name","value":"legalTvaNumber"}},{"kind":"Field","name":{"kind":"Name","value":"tradeName"}},{"kind":"Field","name":{"kind":"Name","value":"contactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"activityDescription"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"firstLine"}},{"kind":"Field","name":{"kind":"Name","value":"secondLine"}},{"kind":"Field","name":{"kind":"Name","value":"thirdLine"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}},{"kind":"Field","name":{"kind":"Name","value":"taxResidence"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"taxIdentificationNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"financialDetail"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeFinancialDetail"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"annualTurnover"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedAnnualTurnover"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedYearlyIncome"}},{"kind":"Field","name":{"kind":"Name","value":"maxSinglePaymentAmount"}},{"kind":"Field","name":{"kind":"Name","value":"yearlyTransactionVolume"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contractSignedAt"}},{"kind":"Field","name":{"kind":"Name","value":"natureOfOperations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"kyb"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kybStatus"}},{"kind":"Field","name":{"kind":"Name","value":"flexKybStatus"}},{"kind":"Field","name":{"kind":"Name","value":"unreferenced"}},{"kind":"Field","name":{"kind":"Name","value":"ongoingKycKybUpdateProcessId"}},{"kind":"Field","name":{"kind":"Name","value":"typeformUrl"}},{"kind":"Field","name":{"kind":"Name","value":"associationTypeformFileFilledAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"features"}}]}},{"kind":"Field","name":{"kind":"Name","value":"onboardingPartner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchOrganizationQuery, SearchOrganizationQueryVariables>;
export const FetchExpenseReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchExpenseReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"expenseReport"},"name":{"kind":"Name","value":"searchSingleExpenseReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expenseReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"overlappingTrip"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachmentId"}},{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountExcludingVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantName"}},{"kind":"Field","name":{"kind":"Name","value":"distanceMeters"}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"days"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}}]}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"myBankDetails"},"name":{"kind":"Name","value":"getMyBankDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iban"}}]}}]}}]}}]} as unknown as DocumentNode<FetchExpenseReportQuery, FetchExpenseReportQueryVariables>;
export const FetchExpenseReportRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fetchExpenseReportRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSingleRequestExpenseReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestExpenseReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}},{"kind":"Field","name":{"kind":"Name","value":"vatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"approverId"}},{"kind":"Field","name":{"kind":"Name","value":"attachments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"probativeAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"fileContentType"}},{"kind":"Field","name":{"kind":"Name","value":"fileSize"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"iban"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"requestType"}},{"kind":"Field","name":{"kind":"Name","value":"processedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedNote"}},{"kind":"Field","name":{"kind":"Name","value":"membership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}},{"kind":"Field","name":{"kind":"Name","value":"approvalWorkflowStateId"}},{"kind":"Field","name":{"kind":"Name","value":"lastStep"}},{"kind":"Field","name":{"kind":"Name","value":"expenseReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalVatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"initiatorID"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"}},{"kind":"Field","name":{"kind":"Name","value":"overlappingTrip"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"probativeAttachment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileContentType"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"amountExcludingVat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"merchantName"}},{"kind":"Field","name":{"kind":"Name","value":"distanceMeters"}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"myBankDetails"},"name":{"kind":"Name","value":"getMyBankDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bankDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"iban"}}]}}]}}]}}]} as unknown as DocumentNode<FetchExpenseReportRequestQuery, FetchExpenseReportRequestQueryVariables>;